import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { decodeJWT, generateDeviceIdentifier, getConsentDateInLocalTimeFormatWithTimeZone, saveUserConsent, login, impersonationLogin, setItemInSessionStorage, getOTPBySMSURL, getOTPByEmailURL, loginWithOTP, updateUser, resetPasswordWithCurrent, getOTPByChallengeURL, getOTPChallengeValidationURL, logout, setCookie, consentTemplateV2, getUser, legalTextConsent } from '@digital-retail/fa-auth-sdk';
import * as React from 'react';
import React__default, { createContext, forwardRef, createElement, Children, useContext, Component, useImperativeHandle, useEffect, useRef, useReducer, useCallback, useMemo, useLayoutEffect, useState, createRef, cloneElement, Fragment as Fragment$1, isValidElement } from 'react';
import clsx from 'clsx';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var LABELS = {
    ALERT_MESSAGE_TO_CONTINUE_WITHOUT_LOGIN: 'Continuarás navegando sin iniciar sesión.',
    BACK_BUTTON: 'Otra forma de verificación',
    CONFIRM: 'Confirmar',
    CONFIRM_LOGIN: 'Confirma tu inicio de sesión',
    EMAIL_OTP_MODAL_TITLE: 'Ingresa el código verificador enviado a:',
    EMAIL_OTP_MODAL_CONTET: 'Te enviaremos un código a',
    EMAIL_LABEL: 'Correo electrónico',
    EMAIL_PLACEHOLDER: 'Ingresa tu correo electrónico',
    EMPTY_EMAIL_ERROR: 'Ingresa un correo electrónico',
    EMPTY_PASSWORD_ERROR: 'Ingresa una contraseña',
    ERROR_MODAL_TITLE: 'El tiempo de espera se agotó',
    ERROR_MODAL_CONTENT: 'Por favor, presiona reenviar para recibir un nuevo código.',
    ERROR_TOAST_MESSAGE: 'Error al validar código. Vuelve a intentar.',
    FORWARD: 'Reenviar',
    EXCEED_LIMIT_ERROR: 'Superaste el límite de intentos. Prueba más tarde.',
    CORREO: 'Correo',
    INVALID_OTP_ERROR: 'Ingresa un código válido.',
    LOGIN_HEADER_TITLE: 'Inicia sesión',
    LOGIN_HEADER_SUBTITLE: 'Compra más rápido y revisa los detalles de tus compras',
    NOT_REGISTERED: '¿No tienes cuenta?',
    OR: 'o',
    OTP_MODAL_TITLE: 'Elige un método de verificación:',
    PASSWORD_LABEL: 'Contraseña',
    PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
    PHONE: 'SMS',
    PHONE_OTP_MODAL_CONTET: 'Te enviaremos un código al celular registrado en tu cuenta.',
    REBRANDING: {
        LOGIN_HEADER_TITLE: '¡Qué bueno tenerte de vuelta!',
        LOGIN_HEADER_TITLE_1: 'Inicia sesión para comprar',
        SIMPLE_PASSWORD_HEADER_TITLE: '¡Un paso más y listo!',
        SIMPLE_PASSWORD_HEADER_SUBTITLE: [
            'Crea una contraseña para falabella.com',
            'y acepta nuestras políticas de seguridad.',
        ],
        NOT_REGISTERED: '¿Aún no tienes cuenta?',
        CONSENTS: {
            BUTTON_SUBMIT: 'Continuar',
            MODAL_SUBTITLE: '¡Ayúdanos a ofrecerte lo mejor!',
            MODAL_SUBTITLE_PE: 'Actualizamos nuestros términos y condiciones',
            MODAL_SUBTITLE_PE_LINE_1: 'Actualizamos nuestros',
            MODAL_SUBTITLE_PE_LINE_2: 'términos y condiciones',
            MODAL_DESCRIPTION_TEXT: 'Te invitamos a aceptar las nuevas políticas de privacidad para continuar.',
            MODAL_DESCRIPTION_TEXT_PE_LINE_1: 'Te invitamos a aceptar los nuevos términos y condiciones de',
            MODAL_DESCRIPTION_TEXT_PE_LINE_2: 'falabella.com para continuar. Los cambios tienen relación con la',
            MODAL_DESCRIPTION_TEXT_PE_LINE_3: 'información sobre el envío de boletas de algunos vendedores y',
            MODAL_DESCRIPTION_TEXT_PE_LINE_4: 'las instrucciones de retiro de tus pedidos.',
            MODAL_DESCRIPTION_TEXT_PE_LINE_1_MOBILE: 'Te invitamos a aceptar los nuevos términos y ',
            MODAL_DESCRIPTION_TEXT_PE_LINE_2_MOBILE: 'condiciones de falabella.com para continuar. Los',
            MODAL_DESCRIPTION_TEXT_PE_LINE_3_MOBILE_FIRST: 'cambios tienen relación con la ',
            MODAL_DESCRIPTION_TEXT_PE_LINE_3_MOBILE_SECOND: 'información sobre',
            MODAL_DESCRIPTION_TEXT_PE_LINE_4_MOBILE: 'el envío de boletas de algunos vendedores y las',
            MODAL_DESCRIPTION_TEXT_PE_LINE_5_MOBILE: 'instrucciones de retiro de tus pedidos.',
            MODAL_SUBMIT_NEW: 'Aceptar',
            OPTIONAL_CONSENTS_ITEM_COMMUNICATIONS: 'Recibas comunicaciones y ofertas de los mejores productos y marcas.',
            OPTIONAL_CONSENTS_ITEM_DIGITAL_MARKETING: 'Veas publicidad digital dirigida con promociones y productos especiales para ti.',
            OPTIONAL_CONSENTS_DESCRIPTION: 'Te invitamos a aceptar las nuevas politicas de privacidad para recibir publicidad de empresas con las que Falabella se relaciona para que:',
            OPTIONAL_CONSENTS_BOTTOM_TEXT_PREFIX: 'Para mas detalles revisa la',
            OPTIONAL_CONSENTS_BOTTOM_TEXT_SUFFIX: 'politica de privacidad',
        },
    },
    RESEND_CODE: 'Reenviar código',
    RESUBMIT_CODE_IN: 'Volver a enviar código en',
    SESSION_STORAGE: {
        EMAIL: 'email',
    },
    SIGN_IN: 'Ingresar',
    SIGN_UP: 'Regístrate',
    SMS_OTP_MODAL_TITLE: 'Ingresa el código verificador enviado a tu celular:',
    SUCCESS_TOAST_MESSAGE: 'Sesión iniciada con éxito.',
    OTP_MESSAGE: '¿Olvidaste tu contraseña? No te preocupes, pide un código verificador por ',
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var isArray$c = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType$1 = typeof Element !== 'undefined';
function equal$1(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$c(a)
      , arrB = isArray$c(b)
      , i
      , length
      , key;
    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal$1(a[i], b[i])) return false;
      return true;
    }
    if (arrA != arrB) return false;
    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length)
      return false;
    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    if (hasElementType$1 && a instanceof Element && b instanceof Element)
      return a === b;
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      } else {
        if (!equal$1(a[key], b[key])) return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
var reactFastCompare$1 = function exportedEqual(a, b) {
  try {
    return equal$1(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    throw error;
  }
};

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};
function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}
function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);
	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}
function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}
function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}
function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}
function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}
function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}
deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}
	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};
var deepmerge_1 = deepmerge;

var freeGlobal$3 = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$4 = freeGlobal$3;

var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;
var root$a = freeGlobal$4 || freeSelf$2 || Function('return this')();
var root$b = root$a;

var Symbol$7 = root$b.Symbol;
var Symbol$8 = Symbol$7;

var objectProto$r = Object.prototype;
var hasOwnProperty$m = objectProto$r.hasOwnProperty;
var nativeObjectToString$3 = objectProto$r.toString;
var symToStringTag$3 = Symbol$8 ? Symbol$8.toStringTag : undefined;
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$m.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

var objectProto$q = Object.prototype;
var nativeObjectToString$2 = objectProto$q.toString;
function objectToString$3(value) {
  return nativeObjectToString$2.call(value);
}

var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';
var symToStringTag$2 = Symbol$8 ? Symbol$8.toStringTag : undefined;
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$2(value)
    : objectToString$3(value);
}

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var getPrototype = overArg$2(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

function isObjectLike$7(value) {
  return value != null && typeof value == 'object';
}

var objectTag$6 = '[object Object]';
var funcProto$5 = Function.prototype,
    objectProto$p = Object.prototype;
var funcToString$5 = funcProto$5.toString;
var hasOwnProperty$l = objectProto$p.hasOwnProperty;
var objectCtorString = funcToString$5.call(Object);
function isPlainObject(value) {
  if (!isObjectLike$7(value) || baseGetTag$6(value) != objectTag$6) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$l.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$5.call(Ctor) == objectCtorString;
}

function listCacheClear$3() {
  this.__data__ = [];
  this.size = 0;
}

function eq$4(value, other) {
  return value === other || (value !== value && other !== other);
}

function assocIndexOf$6(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var arrayProto$2 = Array.prototype;
var splice$2 = arrayProto$2.splice;
function listCacheDelete$3(key) {
  var data = this.__data__,
      index = assocIndexOf$6(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$2.call(data, index, 1);
  }
  --this.size;
  return true;
}

function listCacheGet$3(key) {
  var data = this.__data__,
      index = assocIndexOf$6(data, key);
  return index < 0 ? undefined : data[index][1];
}

function listCacheHas$3(key) {
  return assocIndexOf$6(this.__data__, key) > -1;
}

function listCacheSet$3(key, value) {
  var data = this.__data__,
      index = assocIndexOf$6(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

function ListCache$6(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$6.prototype.clear = listCacheClear$3;
ListCache$6.prototype['delete'] = listCacheDelete$3;
ListCache$6.prototype.get = listCacheGet$3;
ListCache$6.prototype.has = listCacheHas$3;
ListCache$6.prototype.set = listCacheSet$3;

function stackClear$2() {
  this.__data__ = new ListCache$6;
  this.size = 0;
}

function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

function stackGet$2(key) {
  return this.__data__.get(key);
}

function stackHas$2(key) {
  return this.__data__.has(key);
}

function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var asyncTag$1 = '[object AsyncFunction]',
    funcTag$5 = '[object Function]',
    genTag$3 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';
function isFunction$5(value) {
  if (!isObject$7(value)) {
    return false;
  }
  var tag = baseGetTag$6(value);
  return tag == funcTag$5 || tag == genTag$3 || tag == asyncTag$1 || tag == proxyTag$1;
}

var coreJsData$3 = root$b['__core-js_shared__'];
var coreJsData$4 = coreJsData$3;

var maskSrcKey$2 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$4 && coreJsData$4.keys && coreJsData$4.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());
function isMasked$3(func) {
  return !!maskSrcKey$2 && (maskSrcKey$2 in func);
}

var funcProto$4 = Function.prototype;
var funcToString$4 = funcProto$4.toString;
function toSource$4(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var reRegExpChar$2 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$2 = /^\[object .+?Constructor\]$/;
var funcProto$3 = Function.prototype,
    objectProto$o = Object.prototype;
var funcToString$3 = funcProto$3.toString;
var hasOwnProperty$k = objectProto$o.hasOwnProperty;
var reIsNative$2 = RegExp('^' +
  funcToString$3.call(hasOwnProperty$k).replace(reRegExpChar$2, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);
function baseIsNative$3(value) {
  if (!isObject$7(value) || isMasked$3(value)) {
    return false;
  }
  var pattern = isFunction$5(value) ? reIsNative$2 : reIsHostCtor$2;
  return pattern.test(toSource$4(value));
}

function getValue$3(object, key) {
  return object == null ? undefined : object[key];
}

function getNative$9(object, key) {
  var value = getValue$3(object, key);
  return baseIsNative$3(value) ? value : undefined;
}

var Map$6 = getNative$9(root$b, 'Map');
var Map$7 = Map$6;

var nativeCreate$6 = getNative$9(Object, 'create');
var nativeCreate$7 = nativeCreate$6;

function hashClear$3() {
  this.__data__ = nativeCreate$7 ? nativeCreate$7(null) : {};
  this.size = 0;
}

function hashDelete$3(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';
var objectProto$n = Object.prototype;
var hasOwnProperty$j = objectProto$n.hasOwnProperty;
function hashGet$3(key) {
  var data = this.__data__;
  if (nativeCreate$7) {
    var result = data[key];
    return result === HASH_UNDEFINED$5 ? undefined : result;
  }
  return hasOwnProperty$j.call(data, key) ? data[key] : undefined;
}

var objectProto$m = Object.prototype;
var hasOwnProperty$i = objectProto$m.hasOwnProperty;
function hashHas$3(key) {
  var data = this.__data__;
  return nativeCreate$7 ? (data[key] !== undefined) : hasOwnProperty$i.call(data, key);
}

var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';
function hashSet$3(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$7 && value === undefined) ? HASH_UNDEFINED$4 : value;
  return this;
}

function Hash$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$3.prototype.clear = hashClear$3;
Hash$3.prototype['delete'] = hashDelete$3;
Hash$3.prototype.get = hashGet$3;
Hash$3.prototype.has = hashHas$3;
Hash$3.prototype.set = hashSet$3;

function mapCacheClear$3() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$3,
    'map': new (Map$7 || ListCache$6),
    'string': new Hash$3
  };
}

function isKeyable$3(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

function getMapData$6(map, key) {
  var data = map.__data__;
  return isKeyable$3(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

function mapCacheDelete$3(key) {
  var result = getMapData$6(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

function mapCacheGet$3(key) {
  return getMapData$6(this, key).get(key);
}

function mapCacheHas$3(key) {
  return getMapData$6(this, key).has(key);
}

function mapCacheSet$3(key, value) {
  var data = getMapData$6(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

function MapCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$5.prototype.clear = mapCacheClear$3;
MapCache$5.prototype['delete'] = mapCacheDelete$3;
MapCache$5.prototype.get = mapCacheGet$3;
MapCache$5.prototype.has = mapCacheHas$3;
MapCache$5.prototype.set = mapCacheSet$3;

var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$6) {
    var pairs = data.__data__;
    if (!Map$7 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$5(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

function Stack$3(entries) {
  var data = this.__data__ = new ListCache$6(entries);
  this.size = data.size;
}
Stack$3.prototype.clear = stackClear$2;
Stack$3.prototype['delete'] = stackDelete$2;
Stack$3.prototype.get = stackGet$2;
Stack$3.prototype.has = stackHas$2;
Stack$3.prototype.set = stackSet$2;

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var defineProperty$3 = (function() {
  try {
    var func = getNative$9(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());
var defineProperty$4 = defineProperty$3;

function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$4) {
    defineProperty$4(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var objectProto$l = Object.prototype;
var hasOwnProperty$h = objectProto$l.hasOwnProperty;
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$h.call(object, key) && eq$4(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$3(object, key, value);
  }
}

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$3(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var argsTag$5 = '[object Arguments]';
function baseIsArguments$2(value) {
  return isObjectLike$7(value) && baseGetTag$6(value) == argsTag$5;
}

var objectProto$k = Object.prototype;
var hasOwnProperty$g = objectProto$k.hasOwnProperty;
var propertyIsEnumerable$3 = objectProto$k.propertyIsEnumerable;
var isArguments$3 = baseIsArguments$2(function() { return arguments; }()) ? baseIsArguments$2 : function(value) {
  return isObjectLike$7(value) && hasOwnProperty$g.call(value, 'callee') &&
    !propertyIsEnumerable$3.call(value, 'callee');
};
var isArguments$4 = isArguments$3;

var isArray$a = Array.isArray;
var isArray$b = isArray$a;

function stubFalse$1() {
  return false;
}

var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root$b.Buffer : undefined;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;
var isBuffer$3 = nativeIsBuffer || stubFalse$1;
var isBuffer$4 = isBuffer$3;

var MAX_SAFE_INTEGER$3 = 9007199254740991;
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;
  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint$1.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var MAX_SAFE_INTEGER$2 = 9007199254740991;
function isLength$4(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    funcTag$4 = '[object Function]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$5 = '[object Object]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$4 = '[object WeakMap]';
var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$6 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] =
typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] =
typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] =
typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] =
typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$4] = typedArrayTags$1[arrayTag$3] =
typedArrayTags$1[arrayBufferTag$4] = typedArrayTags$1[boolTag$4] =
typedArrayTags$1[dataViewTag$6] = typedArrayTags$1[dateTag$4] =
typedArrayTags$1[errorTag$3] = typedArrayTags$1[funcTag$4] =
typedArrayTags$1[mapTag$7] = typedArrayTags$1[numberTag$4] =
typedArrayTags$1[objectTag$5] = typedArrayTags$1[regexpTag$4] =
typedArrayTags$1[setTag$7] = typedArrayTags$1[stringTag$4] =
typedArrayTags$1[weakMapTag$4] = false;
function baseIsTypedArray$2(value) {
  return isObjectLike$7(value) &&
    isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$6(value)];
}

function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}

var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$4.process;
var nodeUtil$1 = (function() {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());
var nodeUtil$2 = nodeUtil$1;

var nodeIsTypedArray$1 = nodeUtil$2 && nodeUtil$2.isTypedArray;
var isTypedArray$3 = nodeIsTypedArray$1 ? baseUnary$2(nodeIsTypedArray$1) : baseIsTypedArray$2;
var isTypedArray$4 = isTypedArray$3;

var objectProto$j = Object.prototype;
var hasOwnProperty$f = objectProto$j.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$b(value),
      isArg = !isArr && isArguments$4(value),
      isBuff = !isArr && !isArg && isBuffer$4(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$4(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$2(value.length, String) : [],
      length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$f.call(value, key)) &&
        !(skipIndexes && (
           key == 'length' ||
           (isBuff && (key == 'offset' || key == 'parent')) ||
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           isIndex$3(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var objectProto$i = Object.prototype;
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$i;
  return value === proto;
}

var nativeKeys$2 = overArg$2(Object.keys, Object);
var nativeKeys$3 = nativeKeys$2;

var objectProto$h = Object.prototype;
var hasOwnProperty$e = objectProto$h.hasOwnProperty;
function baseKeys$2(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys$3(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$e.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

function isArrayLike$2(value) {
  return value != null && isLength$4(value.length) && !isFunction$5(value);
}

function keys$4(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$2(object) : baseKeys$2(object);
}

function baseAssign(object, source) {
  return object && copyObject(source, keys$4(source), object);
}

function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var objectProto$g = Object.prototype;
var hasOwnProperty$d = objectProto$g.hasOwnProperty;
function baseKeysIn(object) {
  if (!isObject$7(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$2(object),
      result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$d.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

function keysIn(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$2(object, true) : baseKeysIn(object);
}

function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root$b.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

function stubArray$2() {
  return [];
}

var objectProto$f = Object.prototype;
var propertyIsEnumerable$2 = objectProto$f.propertyIsEnumerable;
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;
var getSymbols$2 = !nativeGetSymbols$2 ? stubArray$2 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$2(nativeGetSymbols$2(object), function(symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};
var getSymbols$3 = getSymbols$2;

function copySymbols(source, object) {
  return copyObject(source, getSymbols$3(source), object);
}

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray$2 : function(object) {
  var result = [];
  while (object) {
    arrayPush$2(result, getSymbols$3(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$b(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

function getAllKeys$2(object) {
  return baseGetAllKeys$2(object, keys$4, getSymbols$3);
}

function getAllKeysIn(object) {
  return baseGetAllKeys$2(object, keysIn, getSymbolsIn$1);
}

var DataView$2 = getNative$9(root$b, 'DataView');
var DataView$3 = DataView$2;

var Promise$3 = getNative$9(root$b, 'Promise');
var Promise$4 = Promise$3;

var Set$3 = getNative$9(root$b, 'Set');
var Set$4 = Set$3;

var WeakMap$3 = getNative$9(root$b, 'WeakMap');
var WeakMap$4 = WeakMap$3;

var mapTag$6 = '[object Map]',
    objectTag$4 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$3 = '[object WeakMap]';
var dataViewTag$5 = '[object DataView]';
var dataViewCtorString$1 = toSource$4(DataView$3),
    mapCtorString$1 = toSource$4(Map$7),
    promiseCtorString$1 = toSource$4(Promise$4),
    setCtorString$1 = toSource$4(Set$4),
    weakMapCtorString$1 = toSource$4(WeakMap$4);
var getTag$2 = baseGetTag$6;
if ((DataView$3 && getTag$2(new DataView$3(new ArrayBuffer(1))) != dataViewTag$5) ||
    (Map$7 && getTag$2(new Map$7) != mapTag$6) ||
    (Promise$4 && getTag$2(Promise$4.resolve()) != promiseTag$1) ||
    (Set$4 && getTag$2(new Set$4) != setTag$6) ||
    (WeakMap$4 && getTag$2(new WeakMap$4) != weakMapTag$3)) {
  getTag$2 = function(value) {
    var result = baseGetTag$6(value),
        Ctor = result == objectTag$4 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$4(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1: return dataViewTag$5;
        case mapCtorString$1: return mapTag$6;
        case promiseCtorString$1: return promiseTag$1;
        case setCtorString$1: return setTag$6;
        case weakMapCtorString$1: return weakMapTag$3;
      }
    }
    return result;
  };
}
var getTag$3 = getTag$2;

var objectProto$e = Object.prototype;
var hasOwnProperty$c = objectProto$e.hasOwnProperty;
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);
  if (length && typeof array[0] == 'string' && hasOwnProperty$c.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var Uint8Array$2 = root$b.Uint8Array;
var Uint8Array$3 = Uint8Array$2;

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$3(result).set(new Uint8Array$3(arrayBuffer));
  return result;
}

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var symbolProto$4 = Symbol$8 ? Symbol$8.prototype : undefined,
    symbolValueOf$1 = symbolProto$4 ? symbolProto$4.valueOf : undefined;
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$5 = '[object Symbol]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer(object);
    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);
    case dataViewTag$4:
      return cloneDataView(object, isDeep);
    case float32Tag$2: case float64Tag$2:
    case int8Tag$2: case int16Tag$2: case int32Tag$2:
    case uint8Tag$2: case uint8ClampedTag$2: case uint16Tag$2: case uint32Tag$2:
      return cloneTypedArray(object, isDeep);
    case mapTag$5:
      return new Ctor;
    case numberTag$3:
    case stringTag$3:
      return new Ctor(object);
    case regexpTag$3:
      return cloneRegExp(object);
    case setTag$5:
      return new Ctor;
    case symbolTag$5:
      return cloneSymbol(object);
  }
}

var objectCreate = Object.create;
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$7(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());
var baseCreate$1 = baseCreate;

function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype$2(object))
    ? baseCreate$1(getPrototype$1(object))
    : {};
}

var mapTag$4 = '[object Map]';
function baseIsMap(value) {
  return isObjectLike$7(value) && getTag$3(value) == mapTag$4;
}

var nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap;
var isMap = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

var setTag$4 = '[object Set]';
function baseIsSet(value) {
  return isObjectLike$7(value) && getTag$3(value) == setTag$4;
}

var nodeIsSet = nodeUtil$2 && nodeUtil$2.isSet;
var isSet = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$3 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$4 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] =
cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] =
cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$3] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$3] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$4] =
cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] =
cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$3] =
cloneableTags[weakMapTag$2] = false;
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$7(value)) {
    return value;
  }
  var isArr = isArray$b(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$3(value),
        isFunc = tag == funcTag$3 || tag == genTag$2;
    if (isBuffer$4(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$3 || tag == argsTag$3 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack$3);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys$2)
    : (isFlat ? keysIn : keys$4);
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var CLONE_SYMBOLS_FLAG$1 = 4;
function clone$1(value) {
  return baseClone$1(value, CLONE_SYMBOLS_FLAG$1);
}

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var symbolTag$3 = '[object Symbol]';
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$7(value) && baseGetTag$6(value) == symbolTag$3);
}

var FUNC_ERROR_TEXT$2 = 'Expected a function';
function memoize$3(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$3.Cache || MapCache$5);
  return memoized;
}
memoize$3.Cache = MapCache$5;

var MAX_MEMOIZE_SIZE$1 = 500;
function memoizeCapped$2(func) {
  var result = memoize$3(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

var rePropName$2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$2 = /\\(\\)?/g;
var stringToPath$3 = memoizeCapped$2(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 ) {
    result.push('');
  }
  string.replace(rePropName$2, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$2, '$1') : (number || match));
  });
  return result;
});
var stringToPath$4 = stringToPath$3;

var INFINITY$4 = 1 / 0;
function toKey$6(value) {
  if (typeof value == 'string' || isSymbol$5(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$4) ? '-0' : result;
}

var INFINITY$3 = 1 / 0;
var symbolProto$3 = Symbol$8 ? Symbol$8.prototype : undefined,
    symbolToString$3 = symbolProto$3 ? symbolProto$3.toString : undefined;
function baseToString$3(value) {
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$b(value)) {
    return arrayMap$2(value, baseToString$3) + '';
  }
  if (isSymbol$5(value)) {
    return symbolToString$3 ? symbolToString$3.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

function toString$8(value) {
  return value == null ? '' : baseToString$3(value);
}

function toPath(value) {
  if (isArray$b(value)) {
    return arrayMap$2(value, toKey$6);
  }
  return isSymbol$5(value) ? [value] : copyArray(stringToPath$4(toString$8(value)));
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== 'undefined') {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {}
  }
}

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$5=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$2=b$1?Symbol.for("react.provider"):60109,k=b$1?Symbol.for("react.context"):60110,l$3=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n=b$1?Symbol.for("react.forward_ref"):60112,p$5=b$1?Symbol.for("react.suspense"):60113,q=b$1?
Symbol.for("react.suspense_list"):60120,r$3=b$1?Symbol.for("react.memo"):60115,t$3=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$3=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$3:case m$1:case e$1:case g$1:case f$5:case p$5:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t$3:case r$3:case h$2:return a;default:return u}}case d:return u}}}function A$1(a){return z(a)===m$1}reactIs_production_min.AsyncMode=l$3;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h$2;reactIs_production_min.Element=c$1;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e$1;reactIs_production_min.Lazy=t$3;reactIs_production_min.Memo=r$3;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g$1;reactIs_production_min.StrictMode=f$5;reactIs_production_min.Suspense=p$5;reactIs_production_min.isAsyncMode=function(a){return A$1(a)||z(a)===l$3};reactIs_production_min.isConcurrentMode=A$1;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h$2};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e$1};reactIs_production_min.isLazy=function(a){return z(a)===t$3};
reactIs_production_min.isMemo=function(a){return z(a)===r$3};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g$1};reactIs_production_min.isStrictMode=function(a){return z(a)===f$5};reactIs_production_min.isSuspense=function(a){return z(a)===p$5};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$5||a===p$5||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t$3||a.$$typeof===r$3||a.$$typeof===h$2||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w$1||a.$$typeof===x$3||a.$$typeof===y$1||a.$$typeof===v$1)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== "production") {
  (function() {
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}
function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;
        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;
            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
  return undefined;
}
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty$2 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty$2(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;

var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(value) {
  return baseClone$1(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
var isFunction$4 = function isFunction(obj) {
  return typeof obj === 'function';
};
var isObject$6 = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
var isEmptyChildren = function isEmptyChildren(children) {
  return Children.count(children) === 0;
};
var isPromise = function isPromise(value) {
  return isObject$6(value) && isFunction$4(value.then);
};
function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
function getIn$1(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }
  var path = toPath(key);
  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }
  return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
  var res = clone$1(obj);
  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);
  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn$1(obj, pathArray.slice(0, i + 1));
    if (currentObj && (isObject$6(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone$1(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }
  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }
  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  }
  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }
  return res;
}
function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }
  if (response === void 0) {
    response = {};
  }
  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];
    if (isObject$6(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }
  return response;
}
var FormikContext = createContext(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}
function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends$5({}, state, {
        values: msg.payload
      });
    case 'SET_TOUCHED':
      return _extends$5({}, state, {
        touched: msg.payload
      });
    case 'SET_ERRORS':
      if (reactFastCompare$1(state.errors, msg.payload)) {
        return state;
      }
      return _extends$5({}, state, {
        errors: msg.payload
      });
    case 'SET_STATUS':
      return _extends$5({}, state, {
        status: msg.payload
      });
    case 'SET_ISSUBMITTING':
      return _extends$5({}, state, {
        isSubmitting: msg.payload
      });
    case 'SET_ISVALIDATING':
      return _extends$5({}, state, {
        isValidating: msg.payload
      });
    case 'SET_FIELD_VALUE':
      return _extends$5({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });
    case 'SET_FIELD_TOUCHED':
      return _extends$5({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });
    case 'SET_FIELD_ERROR':
      return _extends$5({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });
    case 'RESET_FORM':
      return _extends$5({}, state, msg.payload);
    case 'SET_FORMIK_STATE':
      return msg.payload(state);
    case 'SUBMIT_ATTEMPT':
      return _extends$5({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });
    case 'SUBMIT_FAILURE':
      return _extends$5({}, state, {
        isSubmitting: false
      });
    case 'SUBMIT_SUCCESS':
      return _extends$5({}, state, {
        isSubmitting: false
      });
    default:
      return state;
  }
}
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose$2(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);
  var props = _extends$5({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);
  var initialValues = useRef(props.initialValues);
  var initialErrors = useRef(props.initialErrors || emptyErrors);
  var initialTouched = useRef(props.initialTouched || emptyTouched);
  var initialStatus = useRef(props.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});
  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning(false) : void 0;
    }, []);
  }
  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  var _React$useReducer = useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];
  var runValidateHandler = useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);
      if (maybePromisedErrors == null) {
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }
          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  var runValidationSchema = useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction$4(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }
          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction$4(fieldRegistry.current[f].validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn$1(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')];
    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }
        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }
        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]);
  var runAllValidations = useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]);
  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }
    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }
      return combinedErrors;
    });
  });
  useEffect(function () {
    if (validateOnMount && isMounted.current === true && reactFastCompare$1(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;
    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };
    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  useEffect(function () {
    if (isMounted.current === true && !reactFastCompare$1(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }
      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare$1(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare$1(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare$1(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    if (fieldRegistry.current[name] && isFunction$4(fieldRegistry.current[name].validate)) {
      var value = getIn$1(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);
      if (isPromise(maybePromise)) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }
    return Promise.resolve();
  });
  var registerField = useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction$4(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = useCallback(function (eventOrTextValue, maybePath) {
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed;
    if (!isString(eventOrTextValue)) {
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }
      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;
      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }
      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type)
      ? getValueForCheckbox(getIn$1(state.values, field), checked, value) : options && multiple
      ? getSelectedValues(options) : value;
    }
    if (field) {
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }
    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }
    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;
    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }
    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function (stateOrCb) {
    if (isFunction$4(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
      if (isActuallyValid) {
        var promiseOrUndefined;
        try {
          promiseOrUndefined = executeSubmit();
          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }
        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }
          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            });
            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        dispatch({
          type: 'SUBMIT_FAILURE'
        });
        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }
      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction$4(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction$4(e.stopPropagation)) {
      e.stopPropagation();
    }
    if (process.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      var activeElement = getActiveElement();
      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }
    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction$4(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction$4(e.stopPropagation)) {
      e.stopPropagation();
    }
    resetForm();
  });
  var getFieldMeta = useCallback(function (name) {
    return {
      value: getIn$1(state.values, name),
      error: getIn$1(state.errors, name),
      touched: !!getIn$1(state.touched, name),
      initialValue: getIn$1(initialValues.current, name),
      initialTouched: !!getIn$1(initialTouched.current, name),
      initialError: getIn$1(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function (nameOrOptions) {
    var isAnObject = isObject$6(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn$1(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };
    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;
      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }
    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function () {
    return !reactFastCompare$1(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction$4(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);
  var ctx = _extends$5({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });
  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef;
  useImperativeHandle(innerRef, function () {
    return formikbag;
  });
  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0;
    }, []);
  }
  return createElement(FormikProvider, {
    value: formikbag
  }, component ? createElement(component, formikbag) : render ? render(formikbag) : children
  ? isFunction$4(children) ? children(formikbag) : !isEmptyChildren(children) ? Children.only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
  var errors = {};
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }
    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;
      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }
      var err = _ref5;
      if (!getIn$1(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }
  return errors;
}
function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }
  if (context === void 0) {
    context = {};
  }
  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};
  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);
      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }
  return data;
}
function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
function getValueForCheckbox(currentValue, checked, valueProp) {
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  }
  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;
  if (!Array.isArray(currentValue)) {
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  }
  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  }
  if (!isValueInArray) {
    return currentArrayOfValues;
  }
  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
}
var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
function useEventCallback(fn) {
  var ref = useRef(fn);
  useIsomorphicLayoutEffect$1(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}
function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = isObject$6(propsOrFieldName);
  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  useEffect(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }
    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);
  if (process.env.NODE_ENV !== "production") {
    !formik ? process.env.NODE_ENV !== "production" ? warning(false, 'useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component') : warning(false) : void 0;
  }
  !fieldName ? process.env.NODE_ENV !== "production" ? warning(false, 'Invalid field name. Either pass `useField` a string or an object containing a `name` key.') : warning(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}
var Form = forwardRef(function (props, ref) {
  var action = props.action,
      rest = _objectWithoutPropertiesLoose$2(props, ["action"]);
  var _action = action != null ? action : '#';
  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;
  return createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';
function connect(Comp) {
  var C = function C(props) {
    return createElement(FormikConsumer, null, function (formik) {
      !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + Comp.name) : warning(false) : void 0;
      return createElement(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };
  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component';
  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return hoistNonReactStatics_cjs(C, Comp
  );
}
var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends$5({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};
var FieldArrayInner = function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);
  function FieldArrayInner(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn;
        var values = setIn(prevState.values, name, fn(getIn$1(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn$1(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn$1(prevState.touched, name)) : undefined;
        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }
        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }
        return _extends$5({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };
    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [cloneDeep(value)]);
      }, false, false);
    };
    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };
    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };
    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };
    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };
    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };
    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };
    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };
    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };
    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };
    _this.unshift = function (value) {
      var length = -1;
      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];
        if (length < 0) {
          length = arr.length;
        }
        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];
        if (length < 0) {
          length = arr.length;
        }
        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];
        if (length < 0) {
          length = arr.length;
        }
        return arr;
      });
      return length;
    };
    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };
    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };
    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };
    _this.remove = _this.remove.bind(_assertThisInitialized$1(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized$1(_this));
    return _this;
  }
  var _proto = FieldArrayInner.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !reactFastCompare$1(getIn$1(prevProps.formik.values, prevProps.name), getIn$1(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };
  _proto.remove = function remove(index) {
    var result;
    this.updateArrayField(
    function (array) {
      var copy = array ? copyArrayLike(array) : [];
      if (!result) {
        result = copy[index];
      }
      if (isFunction$4(copy.splice)) {
        copy.splice(index, 1);
      }
      return copy;
    }, true, true);
    return result;
  };
  _proto.pop = function pop() {
    var result;
    this.updateArrayField(
    function (array) {
      var tmp = array;
      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }
      return tmp;
    }, true, true);
    return result;
  };
  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };
    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose$2(_this$props2$formik, ["validate", "validationSchema"]);
    var props = _extends$5({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });
    return component ? createElement(component, props) : render ? render(props) : children
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? Children.only(children) : null : null;
  };
  return FieldArrayInner;
}(Component);
FieldArrayInner.defaultProps = {
  validateOnChange: true
};
connect(FieldArrayInner);
var ErrorMessageImpl = function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);
  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = ErrorMessageImpl.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn$1(this.props.formik.errors, this.props.name) !== getIn$1(props.formik.errors, this.props.name) || getIn$1(this.props.formik.touched, this.props.name) !== getIn$1(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose$2(_this$props, ["component", "formik", "render", "children", "name"]);
    var touch = getIn$1(formik.touched, name);
    var error = getIn$1(formik.errors, name);
    return !!touch && !!error ? render ? isFunction$4(render) ? render(error) : null : children ? isFunction$4(children) ? children(error) : null : component ? createElement(component, rest, error) : error : null;
  };
  return ErrorMessageImpl;
}(Component);
connect(ErrorMessageImpl);
var FastFieldInner = function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);
  function FastFieldInner(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ? process.env.NODE_ENV !== "production" ? warning(false, "<FastField render> has been deprecated. Please use a child callback function instead: <FastField name={" + name + "}>{props => ...}</FastField> instead.") : warning(false) : void 0;
    !!(component && render) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored') : warning(false) : void 0;
    !!(is && children && isFunction$4(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <FastField as> and <FastField children> as a function in the same <FastField> component; <FastField as> will be ignored.') : warning(false) : void 0;
    !!(component && children && isFunction$4(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.') : warning(false) : void 0;
    !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored') : warning(false) : void 0;
    return _this;
  }
  var _proto = FastFieldInner.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn$1(props.formik.values, this.props.name) !== getIn$1(this.props.formik.values, this.props.name) || getIn$1(props.formik.errors, this.props.name) !== getIn$1(this.props.formik.errors, this.props.name) || getIn$1(props.formik.touched, this.props.name) !== getIn$1(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };
  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose$2(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);
    var restOfFormik = _objectWithoutPropertiesLoose$2(formik, ["validate", "validationSchema"]);
    var field = formik.getFieldProps(_extends$5({
      name: name
    }, props));
    var meta = {
      value: getIn$1(formik.values, name),
      error: getIn$1(formik.errors, name),
      touched: !!getIn$1(formik.touched, name),
      initialValue: getIn$1(formik.initialValues, name),
      initialTouched: !!getIn$1(formik.initialTouched, name),
      initialError: getIn$1(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };
    if (render) {
      return render(bag);
    }
    if (isFunction$4(children)) {
      return children(bag);
    }
    if (component) {
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose$2(props, ["innerRef"]);
        return createElement(component, _extends$5({
          ref: innerRef
        }, field, rest), children);
      }
      return createElement(component, _extends$5({
        field: field,
        form: formik
      }, props), children);
    }
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose$2(props, ["innerRef"]);
      return createElement(asElement, _extends$5({
        ref: _innerRef
      }, field, _rest), children);
    }
    return createElement(asElement, _extends$5({}, field, props), children);
  };
  return FastFieldInner;
}(Component);
connect(FastFieldInner);

var map;
try {
  map = Map;
} catch (_) { }
var set;
try {
  set = Set;
} catch (_) { }
function baseClone (src, circulars, clones) {
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }
  if (src instanceof Date) {
    return new Date(src.getTime())
  }
  if (src instanceof RegExp) {
    return new RegExp(src)
  }
  if (Array.isArray(src)) {
    return src.map(clone)
  }
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
    }
    return obj
  }
  return src
}
function clone (src) {
  return baseClone(src, [], [])
}

const toString$7 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString$2 = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString$2.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$7.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');
    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }
    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

var objectProto$d = Object.prototype;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$b.call(object, key);
}
var _baseHas = baseHas$1;

var isArray$9 = Array.isArray;
var isArray_1 = isArray$9;

var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$2;

var freeGlobal$1 = _freeGlobal;
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
var root$9 = freeGlobal$1 || freeSelf$1 || Function('return this')();
var _root = root$9;

var root$8 = _root;
var Symbol$6 = root$8.Symbol;
var _Symbol = Symbol$6;

var Symbol$5 = _Symbol;
var objectProto$c = Object.prototype;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
var nativeObjectToString$1 = objectProto$c.toString;
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : undefined;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;

var objectProto$b = Object.prototype;
var nativeObjectToString = objectProto$b.toString;
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$2;

var Symbol$4 = _Symbol,
    getRawTag = _getRawTag,
    objectToString$1 = _objectToString;
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : undefined;
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString$1(value);
}
var _baseGetTag = baseGetTag$5;

function isObjectLike$6(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike$6;

var baseGetTag$4 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;
var symbolTag$2 = '[object Symbol]';
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$5(value) && baseGetTag$4(value) == symbolTag$2);
}
var isSymbol_1 = isSymbol$4;

var isArray$8 = isArray_1,
    isSymbol$3 = isSymbol_1;
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;
function isKey$4(value, object) {
  if (isArray$8(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
    (object != null && value in Object(object));
}
var _isKey = isKey$4;

function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$5;

var baseGetTag$3 = _baseGetTag,
    isObject$4 = isObject_1;
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
function isFunction$3(value) {
  if (!isObject$4(value)) {
    return false;
  }
  var tag = baseGetTag$3(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;

var root$7 = _root;
var coreJsData$2 = root$7['__core-js_shared__'];
var _coreJsData = coreJsData$2;

var coreJsData$1 = _coreJsData;
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());
function isMasked$2(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}
var _isMasked = isMasked$2;

var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource$3;

var isFunction$2 = isFunction_1,
    isMasked$1 = _isMasked,
    isObject$3 = isObject_1,
    toSource$2 = _toSource;
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype,
    objectProto$a = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
var reIsNative$1 = RegExp('^' +
  funcToString$1.call(hasOwnProperty$9).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);
function baseIsNative$2(value) {
  if (!isObject$3(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}
var _baseIsNative = baseIsNative$2;

function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue$2;

var baseIsNative$1 = _baseIsNative,
    getValue$1 = _getValue;
function getNative$8(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : undefined;
}
var _getNative = getNative$8;

var getNative$7 = _getNative;
var nativeCreate$5 = getNative$7(Object, 'create');
var _nativeCreate = nativeCreate$5;

var nativeCreate$4 = _nativeCreate;
function hashClear$2() {
  this.__data__ = nativeCreate$4 ? nativeCreate$4(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$2;

function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$2;

var nativeCreate$3 = _nativeCreate;
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';
var objectProto$9 = Object.prototype;
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$3) {
    var result = data[key];
    return result === HASH_UNDEFINED$3 ? undefined : result;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet$2;

var nativeCreate$2 = _nativeCreate;
var objectProto$8 = Object.prototype;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$2 ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
}
var _hashHas = hashHas$2;

var nativeCreate$1 = _nativeCreate;
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$2 : value;
  return this;
}
var _hashSet = hashSet$2;

var hashClear$1 = _hashClear,
    hashDelete$1 = _hashDelete,
    hashGet$1 = _hashGet,
    hashHas$1 = _hashHas,
    hashSet$1 = _hashSet;
function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype['delete'] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;
var _Hash = Hash$2;

function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$2;

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}
var eq_1 = eq$3;

var eq$2 = eq_1;
function assocIndexOf$5(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$5;

var assocIndexOf$4 = _assocIndexOf;
var arrayProto$1 = Array.prototype;
var splice$1 = arrayProto$1.splice;
function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$4(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$2;

var assocIndexOf$3 = _assocIndexOf;
function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet$2;

var assocIndexOf$2 = _assocIndexOf;
function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$2;

var assocIndexOf$1 = _assocIndexOf;
function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$2;

var listCacheClear$1 = _listCacheClear,
    listCacheDelete$1 = _listCacheDelete,
    listCacheGet$1 = _listCacheGet,
    listCacheHas$1 = _listCacheHas,
    listCacheSet$1 = _listCacheSet;
function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype['delete'] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;
var _ListCache = ListCache$5;

var getNative$6 = _getNative,
    root$6 = _root;
var Map$5 = getNative$6(root$6, 'Map');
var _Map = Map$5;

var Hash$1 = _Hash,
    ListCache$4 = _ListCache,
    Map$4 = _Map;
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1,
    'map': new (Map$4 || ListCache$4),
    'string': new Hash$1
  };
}
var _mapCacheClear = mapCacheClear$2;

function isKeyable$2(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}
var _isKeyable = isKeyable$2;

var isKeyable$1 = _isKeyable;
function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$1(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}
var _getMapData = getMapData$5;

var getMapData$4 = _getMapData;
function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$2;

var getMapData$3 = _getMapData;
function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$2;

var getMapData$2 = _getMapData;
function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$2;

var getMapData$1 = _getMapData;
function mapCacheSet$2(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$2;

var mapCacheClear$1 = _mapCacheClear,
    mapCacheDelete$1 = _mapCacheDelete,
    mapCacheGet$1 = _mapCacheGet,
    mapCacheHas$1 = _mapCacheHas,
    mapCacheSet$1 = _mapCacheSet;
function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype['delete'] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;
var _MapCache = MapCache$4;

var MapCache$3 = _MapCache;
var FUNC_ERROR_TEXT$1 = 'Expected a function';
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache$3);
  return memoized;
}
memoize$2.Cache = MapCache$3;
var memoize_1 = memoize$2;

var memoize$1 = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 ) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});
var _stringToPath = stringToPath$2;

function arrayMap$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$1;

var Symbol$3 = _Symbol,
    arrayMap = _arrayMap,
    isArray$7 = isArray_1,
    isSymbol$2 = isSymbol_1;
var INFINITY$2 = 1 / 0;
var symbolProto$2 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString$1 = symbolProto$2 ? symbolProto$2.toString : undefined;
function baseToString$2(value) {
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$7(value)) {
    return arrayMap(value, baseToString$2) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}
var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;
function toString$6(value) {
  return value == null ? '' : baseToString$1(value);
}
var toString_1 = toString$6;

var isArray$6 = isArray_1,
    isKey$3 = _isKey,
    stringToPath$1 = _stringToPath,
    toString$5 = toString_1;
function castPath$3(value, object) {
  if (isArray$6(value)) {
    return value;
  }
  return isKey$3(value, object) ? [value] : stringToPath$1(toString$5(value));
}
var _castPath = castPath$3;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;
var argsTag$2 = '[object Arguments]';
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$3 = isObjectLike_1;
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;
var isArguments$2 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments$2;

var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$2;

var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;

var isSymbol$1 = isSymbol_1;
var INFINITY$1 = 1 / 0;
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}
var _toKey = toKey$5;

var castPath$2 = _castPath,
    isArguments$1 = isArguments_1,
    isArray$5 = isArray_1,
    isIndex$1 = _isIndex,
    isLength$2 = isLength_1,
    toKey$4 = _toKey;
function hasPath$2(object, path, hasFunc) {
  path = castPath$2(path, object);
  var index = -1,
      length = path.length,
      result = false;
  while (++index < length) {
    var key = toKey$4(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$1(key, length) &&
    (isArray$5(object) || isArguments$1(object));
}
var _hasPath = hasPath$2;

var baseHas = _baseHas,
    hasPath$1 = _hasPath;
function has$3(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}
var has_1 = has$3;

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    if (typeof options === 'function') {
      this.fn = options;
      return;
    }
    if (!has_1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }
  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$4({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }
}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};
function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);
  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }
        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }
        nestedErrors.push(err);
      }
      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort);
          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }
        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }
        callback(null, value);
      }
    });
  }
}

var getNative$5 = _getNative;
var defineProperty$1 = (function() {
  try {
    var func = getNative$5(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());
var _defineProperty = defineProperty$1;

var defineProperty = _defineProperty;
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$2;

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;

var isBuffer$2 = {exports: {}};

function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;
var freeExports = exports && !exports.nodeType && exports;
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root.Buffer : undefined;
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;
}(isBuffer$2, isBuffer$2.exports));

var baseGetTag$1 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$2 = isObjectLike_1;
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) &&
    isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;

function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;
var freeExports = exports && !exports.nodeType && exports;
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal.process;
var nodeUtil = (function() {
  try {
    var types = freeModule && freeModule.require && freeModule.require('util').types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());
module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments = isArguments_1,
    isArray$4 = isArray_1,
    isBuffer$1 = isBuffer$2.exports,
    isIndex = _isIndex,
    isTypedArray$1 = isTypedArray_1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$4(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) &&
        !(skipIndexes && (
           key == 'length' ||
           (isBuff && (key == 'offset' || key == 'parent')) ||
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;

var objectProto$5 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;
  return value === proto;
}
var _isPrototype = isPrototype$1;

function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;

var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;

var isFunction$1 = isFunction_1,
    isLength = isLength_1;
function isArrayLike$1(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
var isArrayLike_1 = isArrayLike$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike = isArrayLike_1;
function keys$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$3;

var baseFor = _baseFor,
    keys$2 = keys_1;
function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$2);
}
var _baseForOwn = baseForOwn$2;

var ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}
var _stackClear = stackClear$1;

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;

function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;

function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;

var ListCache$2 = _ListCache,
    Map$3 = _Map,
    MapCache$2 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$2) {
    var pairs = data.__data__;
    if (!Map$3 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;

var ListCache$1 = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;
function Stack$2(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED$1);
  return this;
}
var _setCacheAdd = setCacheAdd$1;

function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;

function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];
    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}
var _equalArrays = equalArrays$2;

var root$5 = _root;
var Uint8Array$1 = root$5.Uint8Array;
var _Uint8Array = Uint8Array$1;

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$1;

var Symbol$2 = _Symbol,
    Uint8Array = _Uint8Array,
    eq$1 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq$1(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == (other + '');
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;

function arrayPush$1(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$1;

var arrayPush = _arrayPush,
    isArray$3 = isArray_1;
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$3(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;

function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$1 = keys_1;
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$3.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];
    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}
var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$4 = _root;
var DataView$1 = getNative$4(root$4, 'DataView');
var _DataView = DataView$1;

var getNative$3 = _getNative,
    root$3 = _root;
var Promise$2 = getNative$3(root$3, 'Promise');
var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$2 = _root;
var Set$2 = getNative$2(root$2, 'Set');
var _Set = Set$2;

var getNative$1 = _getNative,
    root$1 = _root;
var WeakMap$2 = getNative$1(root$1, 'WeakMap');
var _WeakMap = WeakMap$2;

var DataView = _DataView,
    Map$2 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag = _baseGetTag,
    toSource$1 = _toSource;
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
var dataViewCtorString = toSource$1(DataView),
    mapCtorString = toSource$1(Map$2),
    promiseCtorString = toSource$1(Promise$1),
    setCtorString = toSource$1(Set$1),
    weakMapCtorString = toSource$1(WeakMap$1);
var getTag$1 = baseGetTag;
if ((DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map$2 && getTag$1(new Map$2) != mapTag) ||
    (Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$1(new Set$1) != setTag) ||
    (WeakMap$1 && getTag$1(new WeakMap$1) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray$2 = isArray_1,
    isBuffer = isBuffer$2.exports,
    isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';
var objectProto$1 = Object.prototype;
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object),
      othIsArr = isArray$2(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$2.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$2.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$1 = isObjectLike_1;
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$1(value) && !isObjectLike$1(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;

var Stack = _Stack,
    baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;

var isObject$2 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$2(value);
}
var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys = keys_1;
function getMatchData$1(object) {
  var result = keys(object),
      length = result.length;
  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;

var castPath$1 = _castPath,
    toKey$3 = _toKey;
function baseGet$3(object, path) {
  path = castPath$1(path, object);
  var index = 0,
      length = path.length;
  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}
var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;
function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}
var get_1 = get$2;

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get$1 = get_1,
    hasIn = hasIn_1,
    isKey$2 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$2(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get$1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;

function identity$1(value) {
  return value;
}
var identity_1 = identity$1;

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}
var _baseProperty = baseProperty$1;

var baseGet$1 = _baseGet;
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey$1 = _isKey,
    toKey$1 = _toKey;
function property$1(path) {
  return isKey$1(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}
var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity = identity_1,
    isArray$1 = isArray_1,
    property = property_1;
function baseIteratee$2(value) {
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$2;

var baseAssignValue$1 = _baseAssignValue,
    baseForOwn$1 = _baseForOwn,
    baseIteratee$1 = _baseIteratee;
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$1(iteratee);
  baseForOwn$1(object, function(value, key, object) {
    baseAssignValue$1(result, key, iteratee(value, key, object));
  });
  return result;
}
var mapValues_1 = mapValues;

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key]
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;
  return (this._values[key] = value)
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache: Cache,
  split: split,
  normalizePath: normalizePath,
  setter: function (path) {
    var parts = normalizePath(path);
    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;
        while (index < len - 1) {
          var part = parts[index];
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }
          data = data[parts[index++]];
        }
        data[parts[index]] = value;
      })
    )
  },
  getter: function (path, safe) {
    var parts = normalizePath(path);
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length;
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];
          else return
        }
        return data
      })
    )
  },
  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },
  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  },
};
function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}
function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}
function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}
function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}
Reference.prototype.__isYupRef = true;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose$1(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = mapValues_1(_extends$3({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }
    let ctx = _extends$3({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);
    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }
      return;
    }
    let result;
    try {
      var _ref2;
      result = test.call(ctx, value, ctx);
      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }
    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }
  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);
function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    }
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const description = [];
    for (const item of this.list) description.push(item);
    for (const [, ref] of this.refs) description.push(ref.describe());
    return description;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }
  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }
  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }
  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$2({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  }
  get _type() {
    return this.type;
  }
  _typeCheck(_value) {
    return true;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }
    const next = Object.create(Object.getPrototypeOf(this));
    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends$2({}, this.exclusiveTests);
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(_extends$2({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = _extends$2({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError);
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends$2({
      value
    }, options));
    let result = resolvedSchema._cast(value, options);
    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }
    return result;
  }
  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault();
    }
    return value;
  }
  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, _extends$2({
        assert: false
      }, options));
    }
    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }
  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends$2({}, options, {
      value
    }));
    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }
  validateSync(value, options) {
    let schema = this.resolve(_extends$2({}, options, {
      value
    }));
    let result;
    schema._validate(value, _extends$2({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault() {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }
  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }
  _isPresent(value) {
    return value != null;
  }
  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,
      test(value) {
        return value !== undefined;
      }
    });
  }
  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,
      test(value) {
        return this.schema._isPresent(value);
      }
    }));
  }
  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }
  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',
      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',
      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }
  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }
}
BaseSchema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends$2({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;
for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;
BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

const isAbsent = value => value == null;

function create$2() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
  }
  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
}
create$2.prototype = BooleanSchema.prototype;

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let isTrimmed = value => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$1() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }
  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }
  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }
    });
  }
  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }
    });
  }
  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },
      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  }
  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }
  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$1.prototype = StringSchema.prototype;

var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;
  if (struct = isoReg.exec(date)) {
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0;
    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1;
    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0;
    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }
      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;
  return timestamp;
}

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value);
        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }
  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      test(value) {
        return isAbsent(value) || value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      test(value) {
        return isAbsent(value) || value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}
var _arrayReduce = arrayReduce$1;

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}
var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;
var deburredLetters = {
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};
var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$4 = toString_1;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;
var rsCombo$2 = '[' + rsComboRange$3 + ']';
var reComboMark = RegExp(rsCombo$2, 'g');
function deburr$1(string) {
  string = toString$4(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
var deburr_1 = deburr$1;

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}
var _hasUnicodeWord = hasUnicodeWord$1;

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$3 = toString_1,
    unicodeWords = _unicodeWords;
function words$1(string, pattern, guard) {
  string = toString$3(string);
  pattern = guard ? undefined : pattern;
  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;
var rsApos = "['\u2019]";
var reApos = RegExp(rsApos, 'g');
function createCompounder$2(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}
var _createCompounder = createCompounder$2;

var createCompounder$1 = _createCompounder;
var snakeCase = createCompounder$1(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});
var snakeCase_1 = snakeCase;

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}
var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}
var _castSlice = castSlice$1;

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';
var rsZWJ$1 = '\\u200d';
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$2;

function asciiToArray$1(string) {
  return string.split('');
}
var _asciiToArray = asciiToArray$1;

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}
var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$2 = toString_1;
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);
    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;
    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);
    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;
var upperFirst$1 = createCaseFirst('toUpperCase');
var upperFirst_1 = upperFirst$1;

var toString$1 = toString_1,
    upperFirst = upperFirst_1;
function capitalize$1(string) {
  return upperFirst(toString$1(string).toLowerCase());
}
var capitalize_1 = capitalize$1;

var capitalize = capitalize_1,
    createCompounder = _createCompounder;
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});
var camelCase_1 = camelCase;

var baseAssignValue = _baseAssignValue,
    baseForOwn = _baseForOwn,
    baseIteratee = _baseIteratee;
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}
var mapKeys_1 = mapKeys;

var toposort$2 = {exports: {}};

toposort$2.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};
toposort$2.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });
  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }
  return sorted
  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }
    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }
    if (visited[i]) return;
    visited[i] = true;
    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);
    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}
function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}
function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}
var toposort$1 = toposort$2.exports;

function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }
  for (const key in fields) if (has_1(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort$1.array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
let isObject$1 = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }
        if (this.isType(value)) return value;
        return null;
      });
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _typeCheck(value) {
    return isObject$1(value) || typeof value === 'function';
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);
    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));
    let intermediateValue = {};
    let innerOptions = _extends$1({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = has_1(value, prop);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];
        innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ?
        field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from];
    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;
    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }
        errors.push(err);
      }
      if (!recursive || !isObject$1(value)) {
        callback(errors[0] || null, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];
        if (field && 'validate' in field) {
          field.validate(value[key], _extends$1({}, opts, {
            path,
            from,
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }
        cb(null);
      });
      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = _extends$1({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }
    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }
  getDefaultFromShape() {
    let dft = {};
    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });
    return dft;
  }
  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    }
    if (!this._nodes.length) {
      return undefined;
    }
    return this.getDefaultFromShape();
  }
  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));
    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }
    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }
  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};
    for (const key of keys) {
      delete fields[key];
    }
    return next.withMutation(() => next.shape(fields));
  }
  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;
      if (has_1(obj, from)) {
        newObj = _extends$1({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_1(obj, (_, key) => fn(key)));
  }
  camelCase() {
    return this.transformKeys(camelCase_1);
  }
  snakeCase() {
    return this.transformKeys(snakeCase_1);
  }
  constantCase() {
    return this.transformKeys(key => snakeCase_1(key).toUpperCase());
  }
  describe() {
    let base = super.describe();
    base.fields = mapValues_1(this.fields, value => value.describe());
    return base;
  }
}
function create(spec) {
  return new ObjectSchema(spec);
}
create.prototype = ObjectSchema.prototype;

// GENERAL
var Tenant;
(function (Tenant) {
    Tenant["Chile"] = "cl";
    Tenant["Peru"] = "pe";
    Tenant["Colombia"] = "co";
})(Tenant || (Tenant = {}));
var LOGIN_HEADER_TITLE = 'Inicia sesión';
var LOGIN_HEADER_SUBTITLE = 'Compra más rápido y revisa los detalles de tus compras';
var SIGN_IN = 'Ingresar';
var CART_ID = 'cartId';
var MAIL = 'mail';
var SMS = 'sms';
var BACKSPACE = 'Backspace';
var TAB = 'Tab';
var ARROW_LEFT = 'ArrowLeft';
var ARROW_RIGHT = 'ArrowRight';
var CHANGE_PASSWORD = 'Cambiar contraseña';
var CONTINUE = 'Continuar';
var SODIMAC_ONLY = 'SODIMAC_ONLY';
var MISC = 'MISC';
var PASSWORD_PLACEHOLDER = 'Ingresa tu contraseña';
var PASSWORD_TOOLTIP = 'Mostrar/Ocultar';
var SIMPLE_PASSWORD_PLACEHOLDER = 'Ingresa una contraseña';
var PASSWORD_ACTUAL_LABEL = 'Contraseña actual';
var PASSWORD_NEW_LABEL = 'Nueva Contraseña';
var OTP_CODE_PLACEHOLDER = 'Ingresa tu código verificador';
var EMPTY_PASSWORD_ERROR = 'Ingresa una contraseña';
var EMPTY_OTP_CODE_ERROR = 'Ingresa un código verificador';
var OTP_CODE_INVALID_ERROR = 'Código verificador incorrecto';
var EMPTY_OTP_CODE_MIN_LENGTH = 'Ingresa un código verificador (mínimo 4 caracteres)';
var INVALID_CHALLENGE_OTP = 'INVALID_CHALLENGE_OTP';
var CHALLENGE_TOKEN_EXPIRED = 'CHALLENGE_TOKEN_EXPIRED';
var CHALLENGE_OTP_LIMIT_REACHED = 'CHALLENGE_OTP_LIMIT_REACHED';
var DEFAULT_LOGOS = {
    DEFAULT_FALABELLA_LOGO: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt9a6cb2faab703fa5/65a68ebb130790558acbf0cb/falabella.com_green_icon.svg',
    DEFAULT_SODIMAC_LOGO: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3f19c95d322c66f6/6368d9c930ae7a6f07ce68c2/logo-sodimac.svg',
    DEFAULT_TOTTUS_LOGO: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte6b59a954056bc79/6368d9c95d822f441dec0cd7/logo-tottus.svg',
};
var REBRANDING = {
    LOGIN_HEADER_TITLE: '¡Qué bueno tenerte de vuelta!',
    LOGIN_HEADER_TITLE_1: '¡Hola!',
    LOGIN_HEADER_TITLE_2: 'Inicia sesión para comprar',
    SIMPLE_PASSWORD_HEADER_TITLE: '¡Un paso más y listo!',
    SIMPLE_PASSWORD_HEADER_SUBTITLE: [
        'Crea una contraseña para falabella.com',
        'y acepta nuestras políticas de seguridad.',
    ],
    NOT_REGISTERED: '¿Aún no tienes cuenta?',
    CONSENTS: {
        BUTTON_SUBMIT: 'Continuar',
        MODAL_SUBTITLE: '¡Ayúdanos a ofrecerte lo mejor!',
        MODAL_SUBTITLE_PE: 'Actualizamos nuestros términos y condiciones',
        MODAL_SUBTITLE_PE_LINE_1: 'Actualizamos nuestros',
        MODAL_SUBTITLE_PE_LINE_2: 'términos y condiciones',
        MODAL_DESCRIPTION_TEXT: 'Te invitamos a aceptar las nuevas políticas de privacidad para continuar.',
        MODAL_DESCRIPTION_TEXT_CO_LINE_1: 'Te invitamos a conocer y aceptar la nueva autorizacion de',
        MODAL_DESCRIPTION_TEXT_CO_LINE_2: 'tratamiento de datos personales, para recibir publicidad de',
        MODAL_DESCRIPTION_TEXT_CO_LINE_3: 'empresas con las que Falabella.com se relaciona.',
        MODAL_DESCRIPTION_TEXT_PE_LINE_1: 'Te invitamos a aceptar los nuevos términos y condiciones de',
        MODAL_DESCRIPTION_TEXT_PE_LINE_2: 'falabella.com para continuar. Los cambios tienen relación con la',
        MODAL_DESCRIPTION_TEXT_PE_LINE_3: 'información sobre el envío de boletas de algunos vendedores y',
        MODAL_DESCRIPTION_TEXT_PE_LINE_4: 'las instrucciones de retiro de tus pedidos.',
        MODAL_DESCRIPTION_TEXT_PE_LINE_1_MOBILE: 'Te invitamos a aceptar los nuevos términos y ',
        MODAL_DESCRIPTION_TEXT_PE_LINE_2_MOBILE: 'condiciones de falabella.com para continuar. Los',
        MODAL_DESCRIPTION_TEXT_PE_LINE_3_MOBILE_FIRST: 'cambios tienen relación con la ',
        MODAL_DESCRIPTION_TEXT_PE_LINE_3_MOBILE_SECOND: 'información sobre',
        MODAL_DESCRIPTION_TEXT_PE_LINE_4_MOBILE: 'el envío de boletas de algunos vendedores y las',
        MODAL_DESCRIPTION_TEXT_PE_LINE_5_MOBILE: 'instrucciones de retiro de tus pedidos.',
        MODAL_SUBMIT_NEW: 'Aceptar',
        OPTIONAL_CONSENTS_ITEM_COMMUNICATIONS: 'Recibas comunicaciones y ofertas de los mejores productos y marcas.',
        OPTIONAL_CONSENTS_ITEM_DIGITAL_MARKETING: 'Veas publicidad digital dirigida con promociones y productos especiales para ti.',
        OPTIONAL_CONSENTS_DESCRIPTION: 'Te invitamos a aceptar las nuevas politicas de privacidad para recibir publicidad de empresas con las que Falabella se relaciona para que:',
        OPTIONAL_CONSENTS_BOTTOM_TEXT_PREFIX: 'Para mas detalles revisa la',
        OPTIONAL_CONSENTS_BOTTOM_TEXT_SUFFIX: 'politica de privacidad',
    },
};
var USER_PERSONAL_DATA_ERROR = {
    FIRST_NAME_EMPTY: 'Ingresa un nombre (mínimo 4 caracteres)',
    FIRST_NAME_EMPTY_PERU: 'Ingresa un nombre (mínimo 2 caracteres)',
    FIRST_NAME_INVALID: 'Ingresa un nombre válido',
    FIRST_NAME_LENGTH: 'El nombre debe contener mas de 4 caracteres',
    FIRST_NAME_LENGTH_PERU: 'El nombre debe contener mas de 2 caracteres',
    LAST_NAME_EMPTY: 'Ingresa un apellido (mínimo 4 caracteres)',
    LAST_NAME_EMPTY_PERU: 'Ingresa un apellido (mínimo 2 caracteres)',
    LAST_NAME_INVALID: 'Ingresa un apellido válido',
    LAST_NAME_LENGTH: 'El apellido debe contener mas de 4 caracteres',
    LAST_NAME_LENGTH_PERU: 'El apellido debe contener mas de 2 caracteres',
    RUT_EMPTY: 'Ingresa un RUT',
    RUT_INVALID: 'Ingresa un RUT válido',
    DNI_EMPTY: 'Ingresa un DNI',
    DNI_INVALID: 'Ingresa un DNI válido',
    CE_EMPTY: 'Ingresa un Carnet de Extranjería',
    CE_INVALID: 'Ingresa un Carnet de Extranjería válido',
    COLOMBIA: {
        CE_EMPTY: 'Ingresa una Cédula de Extranjería',
        CE_INVALID: 'Ingresa una Cédula de Extranjería válida',
    },
    CC_EMPTY: 'Ingresa una Cédula de Ciudadanía',
    CC_INVALID: 'Ingresa una Cédula de Cuidadanía válida',
    PHONE_EMPTY: 'Ingresa un numero de teléfono (8 caracteres)',
    PHONE_EMPTY_PERU: 'Ingresa un numero de teléfono (9 caracteres)',
    PHONE_EMPTY_COLOMBIA: 'Ingresa un numero de teléfono (10 caracteres)',
    PHONE_LENGTH: 'El telefono debe contener 8 dígitos',
    PHONE_LENGTH_PERU: 'El telefono debe contener 9 dígitos',
    PHONE_LENGTH_COLOMBIA: 'El telefono debe contener 10 dígitos',
};
var ModalSizes;
(function (ModalSizes) {
    ModalSizes[ModalSizes["DEFAULT"] = 500] = "DEFAULT";
    ModalSizes[ModalSizes["CONSENTS"] = 570] = "CONSENTS";
})(ModalSizes || (ModalSizes = {}));
var ConsentsTemplatesCategoryType;
(function (ConsentsTemplatesCategoryType) {
    ConsentsTemplatesCategoryType["CMR_POINTS_PROGRAM"] = "TyC";
    ConsentsTemplatesCategoryType["PRIVACY_POLICY"] = "PdP-eco";
    ConsentsTemplatesCategoryType["TERMS_AND_CONDITIONS_RETAIL"] = "TyC-Retail-eco";
    ConsentsTemplatesCategoryType["THIRD_PARTY_CONSENTS"] = "OPTIN-TERCEROS";
})(ConsentsTemplatesCategoryType || (ConsentsTemplatesCategoryType = {}));
var ConsentTemplateStatus;
(function (ConsentTemplateStatus) {
    ConsentTemplateStatus["ACEPTED"] = "1";
    ConsentTemplateStatus["NOT_ACEPTED"] = "2";
})(ConsentTemplateStatus || (ConsentTemplateStatus = {}));
var ScreenSizes;
(function (ScreenSizes) {
    ScreenSizes[ScreenSizes["MOBILE_SMALL"] = 320] = "MOBILE_SMALL";
    ScreenSizes[ScreenSizes["MOBILE_MEDIUM"] = 375] = "MOBILE_MEDIUM";
    ScreenSizes[ScreenSizes["MOBILE_LARGE"] = 425] = "MOBILE_LARGE";
    ScreenSizes[ScreenSizes["TAILWIND_SM"] = 640] = "TAILWIND_SM";
    ScreenSizes[ScreenSizes["TABLET"] = 768] = "TABLET";
    ScreenSizes[ScreenSizes["LAPTOP"] = 1024] = "LAPTOP";
    ScreenSizes[ScreenSizes["DESKTOP"] = 1440] = "DESKTOP";
})(ScreenSizes || (ScreenSizes = {}));
var Time;
(function (Time) {
    Time[Time["TWO_WEEKS"] = 1209600] = "TWO_WEEKS";
})(Time || (Time = {}));
var COOKIES = {
    OPTIONAL_CONSENTS_MODAL: {
        EXPIRY: Time.TWO_WEEKS,
        NAME: 'OPTIONAL_CONSENTS_MODAL',
        VALUE: 'not_show',
    },
    KIOSKO_INFO: 'KIOSKO_INFO',
    KIOSKO_MODULO: 'KIOSKO_MODULO',
    KIOSKO_STORE_ID: 'KIOSKO_STORE_ID',
};

var IconArrowDown = function (_a, svgRef) {
    _a.size; var props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: jsx("path", { d: "M0.559469 0.272562C0.842706 -0.0106752 1.28726 -0.0342782 1.59738 0.201753L1.67841 0.272562L7.83257 6.42672L13.9867 0.272563C14.27 -0.0106748 14.7145 -0.034278 15.0246 0.201753L15.1057 0.272562C15.3889 0.555799 15.4125 1.00035 15.1765 1.31048L15.1057 1.3915L7.83257 8.6646L0.559469 1.3915C0.250483 1.08251 0.250483 0.581548 0.559469 0.272562Z", fill: "#BBBBBB" }) })));
};
var ArrowDown = React__default.forwardRef(IconArrowDown);

var IconArrowLeft = function (_a, svgRef) {
    _a.size; var props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 17", 
        // stroke="currentColor"
        width: 16, height: 17, ref: svgRef }, props, { children: jsx("path", { d: "M16 7.54183H3.8L9.4 2.17516L8 0.833496L0 8.50016L8 16.1668L9.4 14.8252L3.8 9.4585H16V7.54183Z", fill: "currentColor" }) })));
};
var ArrowLeft = React__default.forwardRef(IconArrowLeft);

var IconArrowUp = function (_a, svgRef) {
    _a.size; var props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: jsx("path", { d: "M15.1065 8.39736C14.8233 8.6806 14.3788 8.7042 14.0686 8.46817L13.9876 8.39736L7.83345 2.2432L1.67929 8.39736C1.39605 8.6806 0.951497 8.7042 0.641374 8.46817L0.56035 8.39736C0.277112 8.11412 0.25351 7.66957 0.489541 7.35945L0.56035 7.27842L7.83345 0.00532314L15.1065 7.27842C15.4155 7.58741 15.4155 8.08837 15.1065 8.39736Z", fill: "#BBBBBB" }) })));
};
var ArrowUp = React__default.forwardRef(IconArrowUp);

var IconCheckCircle = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? 'gray' : _c, props = __rest(_a, ["size", "color"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: color, width: size, height: size, ref: svgRef }, props, { children: jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" }) })));
};
var CheckCircle = React__default.forwardRef(IconCheckCircle);

var IconExclamationCircle = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", width: size, height: size, ref: svgRef }, props, { children: jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }) })));
};
var ExclamationCircle = React__default.forwardRef(IconExclamationCircle);

var IconExclamationFilled = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 36 36", stroke: "currentColor", width: size, height: size, ref: svgRef }, props, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 0.5C8.33502 0.5 0.5 8.33502 0.5 18C0.5 27.665 8.33502 35.5 18 35.5C27.665 35.5 35.5 27.665 35.5 18C35.5 8.33502 27.665 0.5 18 0.5ZM18 13.625C19.2081 13.625 20.1875 12.6456 20.1875 11.4375C20.1875 10.2294 19.2081 9.25 18 9.25C16.7919 9.25 15.8125 10.2294 15.8125 11.4375C15.8125 12.6456 16.7919 13.625 18 13.625ZM18 15.8125C16.7919 15.8125 15.8125 16.7919 15.8125 18V24.5625C15.8125 25.7706 16.7919 26.75 18 26.75C19.2081 26.75 20.1875 25.7706 20.1875 24.5625V18C20.1875 16.7919 19.2081 15.8125 18 15.8125Z", fill: "currentColor" }) })));
};
var ExclamationFilled = React__default.forwardRef(IconExclamationFilled);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var IconEye = function (_a, svgRef) {
    _a.size; var props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 22 18", 
        // stroke="currentColor"
        width: 22, height: 18, ref: svgRef }, props, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.811 0.159912C16.0875 0.159912 21.5419 6.80848 21.5419 8.59134C21.5419 10.3742 16.0875 17.0228 10.811 17.0228C5.53598 17.0228 0.0800781 10.3742 0.0800781 8.59134C0.0800781 6.80848 5.53598 0.159912 10.811 0.159912ZM10.811 1.41696C6.03573 1.41696 1.33253 7.55198 1.24055 8.60054C1.33253 9.63071 6.03573 15.7657 10.811 15.7657C15.5755 15.7657 20.2649 9.66136 20.383 8.59134C20.2649 7.52132 15.5755 1.41696 10.811 1.41696ZM10.8116 4.06167C13.2307 4.06167 15.1975 6.09441 15.1975 8.59165C15.1975 11.0889 13.2307 13.1216 10.8116 13.1216C8.39255 13.1216 6.42572 11.0889 6.42572 8.59165C6.42572 6.09441 8.39255 4.06167 10.8116 4.06167ZM10.8116 5.32025C9.0318 5.32025 7.58466 6.78732 7.58466 8.59165C7.58466 10.396 9.0318 11.863 10.8116 11.863C12.5914 11.863 14.0385 10.396 14.0385 8.59165C14.0385 6.78732 12.5914 5.32025 10.8116 5.32025Z", fill: "currentColor" }) })));
};
var Eye = React__default.forwardRef(IconEye);

var IconEyeOff = function (_a, svgRef) {
    var props = __rest(_a, []);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 21", 
        // stroke="currentColor"
        width: "24", height: "21", ref: svgRef }, props, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.96835 0.47998L21.9442 19.716L21.032 20.64L17.9323 17.4984C15.8995 18.8995 13.8583 19.6656 12.0002 19.6656C6.2192 19.6656 0.23999 12.4853 0.23999 10.56C0.23999 9.4327 2.3249 6.56326 5.00958 4.39942L2.0561 1.40566L2.96835 0.47998ZM5.92855 5.33014C3.30099 7.40662 1.56721 9.97198 1.53025 10.565C1.60081 11.6621 6.80216 18.3569 12.0002 18.3569C13.8734 18.3569 15.6777 17.4665 17.0167 16.5727L14.9032 14.4273C14.0683 15.0741 13.067 15.4421 12.0002 15.4421C9.34572 15.4421 7.18689 13.2513 7.18689 10.56C7.18689 9.47974 7.54809 8.46166 8.18482 7.61662L5.92855 5.33014ZM11.9998 1.45522C17.7825 1.45522 23.76 8.63554 23.76 10.5608C23.76 11.5134 22.4529 13.2925 21.334 14.5256L20.8972 15.0061L19.948 14.1207L20.3848 13.6403C21.8196 12.0577 22.4513 10.8515 22.4714 10.5558C22.4009 9.46042 17.1978 2.76394 11.9998 2.76394C11.3009 2.76394 10.5634 2.88826 9.81075 3.13354L9.19754 3.33178L8.80106 2.0869L9.41595 1.88698C10.2963 1.5997 11.1649 1.45522 11.9998 1.45522ZM9.09708 8.5423C8.69555 9.13198 8.47715 9.82918 8.47715 10.56C8.47715 12.5306 10.0581 14.1317 12.0002 14.1317C12.7209 14.1317 13.408 13.9099 13.991 13.5017L9.09708 8.5423Z", fill: "currentColor" }) }))
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   fill="none"
    //   viewBox="0 0 24 21"
    // >
    //   <path d="M2.96835 0.47998L21.9442 19.716L21.032 20.64L17.9323 17.4984C15.8995 18.8995 13.8583 19.6656 12.0002 19.6656C6.2192 19.6656 0.23999 12.4853 0.23999 10.56C0.23999 9.4327 2.3249 6.56326 5.00958 4.39942L2.0561 1.40566L2.96835 0.47998ZM5.92855 5.33014C3.30099 7.40662 1.56721 9.97198 1.53025 10.565C1.60081 11.6621 6.80216 18.3569 12.0002 18.3569C13.8734 18.3569 15.6777 17.4665 17.0167 16.5727L14.9032 14.4273C14.0683 15.0741 13.067 15.4421 12.0002 15.4421C9.34572 15.4421 7.18689 13.2513 7.18689 10.56C7.18689 9.47974 7.54809 8.46166 8.18482 7.61662L5.92855 5.33014ZM11.9998 1.45522C17.7825 1.45522 23.76 8.63554 23.76 10.5608C23.76 11.5134 22.4529 13.2925 21.334 14.5256L20.8972 15.0061L19.948 14.1207L20.3848 13.6403C21.8196 12.0577 22.4513 10.8515 22.4714 10.5558C22.4009 9.46042 17.1978 2.76394 11.9998 2.76394C11.3009 2.76394 10.5634 2.88826 9.81075 3.13354L9.19754 3.33178L8.80106 2.0869L9.41595 1.88698C10.2963 1.5997 11.1649 1.45522 11.9998 1.45522ZM9.09708 8.5423C8.69555 9.13198 8.47715 9.82918 8.47715 10.56C8.47715 12.5306 10.0581 14.1317 12.0002 14.1317C12.7209 14.1317 13.408 13.9099 13.991 13.5017L9.09708 8.5423Z" />
    // </svg>
    );
};
var EyeOff = React__default.forwardRef(IconEyeOff);

var IconFalabellaLogo = function (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_a, svgRef) {
    _a.size; var props = __rest(_a, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 14 32", stroke: "none", 
        // width="14" height="32"
        // width={size}
        ref: svgRef }, props, { children: jsx("path", { d: "M12.801 18.932q-0.498 0-0.843-0.364t-0.345-0.862 0.345-0.862 0.843-0.364 0.843 0.364 0.345 0.862-0.345 0.862-0.843 0.364zM13.912 0.959l-0.383-0.038t-0.651 0.038q-0.383 0.077-0.651 0.249t-0.537 0.479q-0.498 0.498-0.747 1.322t-0.556 2.204l-1.456 7.204-0.23 1.073h4.369l-0.192 0.613h-4.292l-2.529 12.071q-0.268 1.303-0.632 2.414t-1.322 2.031q-0.651 0.651-1.475 1.016t-1.705 0.364h-0.422l0.077-0.422h0.383q0.498-0.077 0.843-0.268t0.651-0.575q0.46-0.613 0.728-1.341t0.575-2.108l2.759-13.183h-3.947l0.153-0.613h3.909l0.268-1.15 1.188-6.017q0.268-1.303 0.651-2.414t1.303-2.031q0.651-0.651 1.475-1.016t1.705-0.364l0.268 0.019t0.498 0.019l-0.077 0.422z" }) })));
};
var FalabellaLogo = React__default.forwardRef(IconFalabellaLogo);

var FPayIcon = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsxs("svg", __assign({ width: size, height: size, ref: svgRef }, props, { viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { d: "M55.6992 13.3346H36.737C34.4931 13.3346 32.5444 13.6122 31.0191 14.3224C29.5171 14.9818 28.2582 15.9083 27.3147 17.0205C26.3648 18.1947 25.711 19.461 25.3429 20.9509C24.958 22.4189 24.7627 23.941 24.7627 25.5455V59.531C24.7627 60.1064 24.9003 60.4906 25.1628 60.6698C25.4485 60.8715 25.8166 60.953 26.3192 60.953H28.4775C29.9092 60.8578 32.9646 60.1064 32.9646 55.6886V40.0089H53.204C53.8202 40.0089 54.1627 39.8895 54.3276 39.5949C54.4876 39.3197 54.5652 38.9492 54.5652 38.4464V34.5782C54.5652 33.9244 54.4876 33.5209 54.3276 33.3272C54.1627 33.1287 53.8202 33.0012 53.204 33.0012H32.9646V25.075C32.9646 23.6279 33.3231 22.5085 34.0465 21.7515C34.7083 21.0219 35.9239 20.6264 37.6445 20.6264H55.6992C56.2994 20.6264 56.6755 20.5368 56.8476 20.2891C57.0533 20.0978 57.1429 19.6668 57.1429 19.0664V14.8519C57.1429 14.3224 57.0533 13.9149 56.8724 13.6832C56.7236 13.3911 56.3402 13.3346 55.6992 13.3346Z", fill: "#4DB000" }), jsx("path", { d: "M0 11.7671V20.9521C0 14.4619 5.79512 9.20074 12.943 9.20074C12.9528 9.20074 12.9627 9.20148 12.9726 9.20148C12.9767 9.20148 12.9824 9.20074 12.9866 9.20074H21.7685C25.5263 9.20074 28.5708 6.43641 28.5708 3.02507V1.49797C28.5708 0.670164 27.8327 0 26.9218 0H12.9602C5.80252 0 0 5.26792 0 11.7671Z", fill: "#4DB000" }), jsx("path", { d: "M0 22.8966V25.9046C0 26.7488 0.335615 27.5003 0.857521 27.99C1.2475 28.3531 1.73896 28.5724 2.27537 28.5724H2.93572C6.24475 28.5724 8.9275 25.4259 8.9275 21.544V12.4717C8.9275 10.8496 10.046 9.53438 11.4283 9.52502H11.4022C5.10526 9.52502 0 15.5111 0 22.8966Z", fill: "#007934" }), jsx("path", { d: "M11.7672 79.9995H20.9519C14.4625 79.9995 9.20114 74.2045 9.20114 67.0558C9.20114 67.0459 9.20189 67.0377 9.20189 67.0278L9.20114 67.0122V58.2307C9.20114 54.4741 6.43639 51.4285 3.02546 51.4285H1.49854C0.670831 51.4285 0 52.1675 0 53.0776V67.0385C0 74.1971 5.26804 79.9995 11.7672 79.9995Z", fill: "#FAB513" }), jsx("path", { d: "M22.8964 80H25.904C26.749 80 27.5013 79.6643 27.9893 79.1423C28.354 78.7522 28.5716 78.2607 28.5716 77.7256V77.0637C28.5716 73.7547 25.4254 71.0714 21.5439 71.0714H12.4717C10.8489 71.0714 9.53377 69.9527 9.52526 68.5715C9.52526 68.5802 9.52441 68.5875 9.52441 68.5962C9.52441 74.8944 15.5116 80 22.8964 80Z", fill: "#FF6600" }), jsx("path", { d: "M68.2306 0.000976562H59.0459C65.5353 0.000976562 70.7967 5.796 70.7967 12.9439C70.7967 12.9439 70.7959 12.9637 70.7959 12.9735C70.7959 12.9735 70.7967 12.9834 70.7967 12.9884V21.7706C70.7967 25.5264 73.5614 28.572 76.9723 28.572H78.5C79.327 28.572 79.9978 27.8331 79.9978 26.9229V12.962C79.9978 5.80423 74.7298 0.000976562 68.2306 0.000976562Z", fill: "#0071CE" }), jsx("path", { d: "M57.102 0.000976562H54.0943C53.2494 0.000976562 52.497 0.336638 52.0091 0.859341C51.6452 1.24865 51.4268 1.74018 51.4268 2.27521V2.93711C51.4268 6.24587 54.5729 8.92898 58.4545 8.92898H67.5267C69.1495 8.92898 70.4646 10.0476 70.4731 11.4294C70.4731 11.4207 70.4739 11.4127 70.4739 11.4127C70.4739 5.10622 64.4867 0.000976562 57.102 0.000976562Z", fill: "#003595" }), jsx("path", { d: "M79.9975 68.2322V59.0471C79.9975 65.5373 74.2026 70.7985 67.0549 70.7985C67.0451 70.7985 67.0352 70.7978 67.0253 70.7978C67.0204 70.7978 67.0154 70.7985 67.0113 70.7985H58.2296C54.4719 70.7985 51.4268 73.5628 51.4268 76.9742V78.5013C51.4268 79.3291 52.1648 79.9993 53.0765 79.9993H67.0368C74.1943 79.9993 79.9975 74.7313 79.9975 68.2322Z", fill: "#E20041" }), jsx("path", { d: "M79.9996 57.104V54.0962C79.9996 53.252 79.664 52.4996 79.1413 52.0117C78.7521 51.6478 78.2606 51.4285 77.7242 51.4285H77.0639C73.7548 51.4285 71.0714 54.5748 71.0714 58.4566V67.5284C71.0714 69.1505 69.9536 70.4657 68.5713 70.475C68.58 70.475 68.5887 70.4759 68.5974 70.4759C74.8943 70.4759 79.9996 64.4892 79.9996 57.104Z", fill: "#9F2842" })] })));
};
React__default.forwardRef(FPayIcon);

var IconSpinner = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 47 47", width: size, height: size, ref: svgRef, fill: "none" }, props, { children: [jsx("path", { d: "M45.66 23.4378C45.602 35.7207 35.628 45.66 23.33 45.66C10.9972 45.66 1 35.6628 1 23.33C1 11.0378 10.9335 1.06494 23.2106 1", stroke: "#F0F0F0", strokeWidth: "1.54", strokeLinecap: "round", strokeLinejoin: "round" }), jsx("path", { d: "M23.4378 1C35.7207 1.05798 45.66 11.0332 45.66 23.33C45.66 35.6628 35.6628 45.66 23.33 45.66C11.039 45.66 1.0661 35.7265 1 23.4494", stroke: "currentColor", strokeWidth: "1.54" })] })));
};
var Spinner = React__default.forwardRef(IconSpinner);

var WarningIcon = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 21 21", ref: svgRef }, props, { fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { d: "M9.84998 4.81251H11.15V12.9375H9.84998V4.81251Z", fill: "#F7B500" }), jsx("path", { d: "M11.475 15.3749C11.475 15.9134 11.0385 16.3499 10.5 16.3499C9.96154 16.3499 9.52502 15.9134 9.52502 15.3749C9.52502 14.8364 9.96154 14.3999 10.5 14.3999C11.0385 14.3999 11.475 14.8364 11.475 15.3749Z", fill: "#F7B500" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.75 10.5C0.75 5.1375 5.1375 0.75 10.5 0.75C15.8625 0.75 20.25 5.1375 20.25 10.5C20.25 15.8625 15.8625 20.25 10.5 20.25C5.1375 20.25 0.75 15.8625 0.75 10.5ZM18.95 10.5C18.95 5.78753 15.2125 2.05003 10.5 2.05003C5.78753 2.05003 2.05003 5.78753 2.05003 10.5C2.05003 15.2125 5.78753 18.95 10.5 18.95C15.2125 18.95 18.95 15.2125 18.95 10.5Z", fill: "#F7B500" })] })));
};
React__default.forwardRef(WarningIcon);

var IconX = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 17 17", width: size, height: size, ref: svgRef }, props, { children: jsx("path", { d: "M1.4082 0.5L8.50064 7.59107L15.5903 0.500048L16.5 1.4097L9.40893 8.49936L16.5 15.5918L15.5902 16.5L8.50064 9.40899L1.40827 16.5L0.5 15.5917L7.59101 8.49936L0.500048 1.40976L1.4082 0.5Z", fill: "currentColor" }) })));
};
var X$1 = React__default.forwardRef(IconX);

var IconXCircle = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", width: size, height: size, ref: svgRef }, props, { children: jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" }) })));
};
var XCircle = React__default.forwardRef(IconXCircle);

var IconPoweredFalabellaDotCom$1 = function (props, svgRef) {
    return (jsx("svg", __assign({ width: "157", height: "25", ref: svgRef, viewBox: "0 0 157 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M60.5414 6.70918C63.0064 7.53048 64.5261 9.31108 65.1242 11.8295C65.6968 14.2372 65.0598 16.5443 63.6299 18.3812C61.7426 20.8008 57.0277 21.8742 54.1035 19.5143L53.9968 20.4753H50.8371V15.8679V4.23505C50.8371 2.17158 52.5008 0.5 54.5508 0.5V7.68724C55.9078 6.39224 58.3034 5.94751 60.5414 6.70918ZM58.3983 17.3622C59.9247 17.1884 60.9514 16.2853 61.397 14.8216C62.0204 12.4293 60.6854 9.47979 57.1801 9.84102C55.4605 10.1051 54.6355 11.3882 54.6355 11.3882V15.8662C55.6096 17.0606 56.9548 17.5275 58.3983 17.3622ZM10.4936 4.08508H6.88667C5.64822 4.08508 4.64188 5.09551 4.64188 6.3411V8.51874H8.83159V12.0732H4.64188V20.765C4.64188 22.8284 2.97818 24.5 0.928223 24.5V6.50296C0.928223 3.20413 3.58639 0.530657 6.86633 0.530657H10.4936V4.08508ZM31.676 20.506H27.9624V4.2725C27.9624 2.20902 29.6261 0.537458 31.676 0.537458V20.506ZM87.4078 20.506H83.6941V4.2725C83.6941 2.20902 85.3578 0.537458 87.4078 0.537458V20.506ZM89.9321 20.506H93.6457V0.537458C91.5958 0.537458 89.9321 2.20902 89.9321 4.2725V20.506ZM74.7505 20.8656C69.1597 20.8656 66.8421 16.9584 67.0742 12.9678C67.2555 9.86663 69.6273 6.33605 74.5252 6.33605C80.0669 6.33605 82.2913 11.3882 81.4849 15.1284H71.0742C71.2825 16.5324 72.6362 17.5003 74.4608 17.623C76.648 17.7695 78.0576 16.1184 78.0576 16.1184L80.8784 17.6162C79.501 19.9216 77.3104 20.8656 74.7505 20.8656ZM74.5184 9.58207C71.8908 9.56503 71.0877 11.8091 71.1013 12.4481H77.8153C77.8763 11.8858 77.3392 9.59911 74.5184 9.58207ZM25.4702 7.0601C24.6366 7.0601 23.8726 7.35148 23.2711 7.8337C21.4448 6.50803 18.7731 5.81792 15.8235 6.82155C13.3737 7.63773 11.8625 9.40813 11.2678 11.9112C10.6986 14.3053 11.3322 16.6005 12.7536 18.422C14.624 20.8177 19.2796 21.8861 22.1885 19.579L22.4816 20.5059H25.4719V10.5361L25.4702 7.0601ZM21.8023 16.0092C20.757 17.2241 19.3898 17.5002 17.9531 17.3366C16.4368 17.1628 15.4152 16.3432 14.9713 14.8863C14.3513 12.5093 15.6795 9.50016 19.1627 9.85969C21.0772 10.1579 21.8006 11.5585 21.8006 11.5585V16.0092H21.8023ZM108.316 7.83715C108.917 7.35323 109.681 7.06355 110.515 7.06355H110.516V10.5396V20.5094H107.526L107.233 19.5824C104.324 21.8895 99.6686 20.8212 97.7982 18.4254C96.3768 16.6039 95.7432 14.3087 96.3124 11.9147C96.9071 9.41158 98.4183 7.64119 100.868 6.825C103.818 5.82138 106.489 6.51148 108.316 7.83715ZM102.998 17.34C104.434 17.5036 105.802 17.2276 106.847 16.0127H106.845V11.562C106.845 11.562 106.122 10.1613 104.207 9.86314C100.724 9.50361 99.3959 12.5128 100.016 14.8898C100.46 16.3466 101.481 17.1662 102.998 17.34ZM46.1425 7.8337C44.3162 6.50803 41.6445 5.81792 38.6949 6.82155C36.2451 7.63773 34.7339 9.40813 34.1392 11.9112C33.57 14.3053 34.2036 16.6005 35.625 18.422C37.4954 20.8177 42.151 21.8861 45.0599 19.579L45.353 20.5059H48.3433V10.5361V7.0584C47.508 7.0601 46.7456 7.34978 46.1425 7.8337ZM44.6737 16.0092C43.6283 17.2241 42.2611 17.5002 40.8245 17.3366C39.3082 17.1628 38.2866 16.3432 37.8427 14.8863C37.2226 12.5093 38.5509 9.50016 42.0341 9.85969C43.9485 10.1579 44.672 11.5585 44.672 11.5585V16.0092H44.6737ZM126.476 14.7399C126.476 11.4666 128.959 8.9959 132.253 8.9959C135.558 8.9959 138.05 11.4649 138.052 14.7399C138.052 18.0285 135.558 20.506 132.253 20.506C128.959 20.506 126.476 18.0285 126.476 14.7399ZM129.452 14.7382C129.452 16.4711 130.628 17.7286 132.251 17.7286C133.861 17.7286 135.075 16.4438 135.075 14.7382C135.075 13.0479 133.862 11.7733 132.251 11.7733C130.655 11.7733 129.452 13.0479 129.452 14.7382ZM151.739 8.99587C150.033 8.86467 148.575 9.75413 147.761 10.2602C146.828 9.50365 145.788 8.99587 144.458 8.99587C141.981 8.99587 139.453 10.4919 139.453 10.4919V20.2453H142.343V12.1601C142.809 11.821 143.651 11.775 144.122 11.775C145.11 11.775 146.262 12.5537 146.262 13.8692V20.2453H149.152V13.1365C149.152 12.5639 148.996 12.2725 148.996 12.2725C150.924 11.1905 153.181 12.0153 153.181 13.8692V20.2453H156.071V13.8249C156.07 10.7066 153.672 9.14411 151.739 8.99587ZM121.474 11.7733C120.102 11.7733 118.943 12.9405 118.718 14.2746C117.99 13.5607 117.032 13.0819 115.967 12.9541C116.704 10.6078 118.884 8.99412 121.605 8.99412C124.021 8.99412 125.685 10.3556 125.685 10.3556L124.207 12.69C124.207 12.69 123.082 11.7733 121.474 11.7733ZM124.285 16.7471C124.285 16.7471 123.179 17.7269 121.476 17.7269C120.995 17.7269 120.541 17.5821 120.143 17.3367C120.151 17.456 120.158 17.5753 120.158 17.6962C120.158 18.5925 119.912 19.4309 119.485 20.1482C120.139 20.38 120.853 20.506 121.608 20.506C124.314 20.506 125.832 18.9299 125.832 18.9299L124.285 16.7471ZM118.066 17.6979C118.066 19.1744 116.876 20.3713 115.408 20.3713C113.939 20.3713 112.749 19.1744 112.749 17.6979C112.749 16.2213 113.939 15.0244 115.408 15.0244C116.876 15.0244 118.066 16.2213 118.066 17.6979Z", fill: "#FF7100" }) })));
};
var PoweredByFalabellaDotCom = React__default.forwardRef(IconPoweredFalabellaDotCom$1);

var IconPoweredFalabellaDotCom = function (props, svgRef) {
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "157", height: "25", viewBox: "0 0 187 28", fill: "none", style: {
            position: 'relative',
            bottom: 3,
        } }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M71.8541 7.24407C74.8253 8.20226 76.657 10.2796 77.3779 13.2178C78.0681 16.0268 77.3003 18.7185 75.5768 20.8615C73.3019 23.6843 67.6188 24.9367 64.0942 22.1834L63.9656 23.3046H60.1571V17.9293V4.35758C60.1571 1.95018 62.1624 0 64.6333 0V8.38515C66.269 6.87431 69.1565 6.35546 71.8541 7.24407ZM69.2709 19.6727C71.1108 19.4699 72.3483 18.4163 72.8853 16.7087C73.6368 13.9176 72.0277 10.4765 67.8026 10.8979C65.7299 11.206 64.7355 12.7029 64.7355 12.7029V17.9273C65.9096 19.3208 67.531 19.8655 69.2709 19.6727ZM11.5295 4.18248H7.18195C5.6892 4.18248 4.47621 5.36133 4.47621 6.81451V9.35511H9.52623V13.5019H4.47621V23.6424C4.47621 26.0498 2.4709 28 0 28V7.00336C0 3.1547 3.204 0.0356369 7.15743 0.0356369H11.5295V4.18248ZM37.0615 23.3402H32.5853V4.40104C32.5853 1.99364 34.5906 0.043477 37.0615 0.043477V23.3402ZM104.237 23.3402H99.761V4.40104C99.761 1.99364 101.766 0.043477 104.237 0.043477V23.3402ZM107.28 23.3402H111.756V0.043477C109.285 0.043477 107.28 1.99364 107.28 4.40104V23.3402ZM88.9809 23.7598C82.2421 23.7598 79.4486 19.2014 79.7283 14.5457C79.9468 10.9276 82.8057 6.8086 88.7093 6.8086C95.3889 6.8086 98.0701 12.7028 97.0981 17.0664H84.5496C84.8008 18.7044 86.4324 19.8336 88.6317 19.9767C91.268 20.1477 92.967 18.2214 92.967 18.2214L96.3671 19.9688C94.7069 22.6585 92.0665 23.7598 88.9809 23.7598ZM88.7011 10.5956C85.5339 10.5758 84.566 13.1939 84.5823 13.9393H92.675C92.7485 13.2833 92.1012 10.6155 88.7011 10.5956ZM29.5814 7.65382C28.5767 7.65382 27.6557 7.99376 26.9308 8.55635C24.7294 7.00973 21.5091 6.2046 17.9539 7.3755C15.001 8.32772 13.1795 10.3932 12.4628 13.3135C11.7766 16.1065 12.5404 18.7843 14.2536 20.9094C16.5081 23.7045 22.1197 24.9509 25.6259 22.2592L25.9792 23.3407H29.5834V11.7092L29.5814 7.65382ZM25.1603 18.0945C23.9004 19.5119 22.2524 19.8339 20.5207 19.6431C18.6931 19.4403 17.4617 18.4841 16.9267 16.7844C16.1793 14.0113 17.7803 10.5006 21.9788 10.92C24.2863 11.2679 25.1583 12.902 25.1583 12.902V18.0945H25.1603ZM129.438 8.56009C130.163 7.99552 131.084 7.65756 132.089 7.65756H132.091V11.713V23.3444H128.487L128.133 22.263C124.627 24.9546 119.016 23.7082 116.761 20.9132C115.048 18.7881 114.284 16.1103 114.97 13.3172C115.687 10.3969 117.509 8.33147 120.461 7.37924C124.017 6.20834 127.237 7.01347 129.438 8.56009ZM123.028 19.6468C124.76 19.8377 126.408 19.5156 127.668 18.0982H127.666V12.9057C127.666 12.9057 126.794 11.2716 124.486 10.9238C120.288 10.5043 118.687 14.015 119.434 16.7882C119.969 18.4879 121.201 19.4441 123.028 19.6468ZM54.4985 8.55635C52.2972 7.00973 49.0769 6.2046 45.5216 7.3755C42.5688 8.32772 40.7473 10.3932 40.0305 13.3135C39.3444 16.1065 40.1081 18.7843 41.8214 20.9094C44.0758 23.7045 49.6874 24.9509 53.1936 22.2592L53.5469 23.3407H57.1512V11.7092V7.65183C56.1444 7.65381 55.2255 7.99177 54.4985 8.55635ZM52.7281 18.0945C51.4681 19.5119 49.8202 19.8339 48.0885 19.6431C46.2608 19.4403 45.0295 18.4841 44.4945 16.7844C43.7471 14.0113 45.348 10.5006 49.5465 10.92C51.8541 11.2679 52.726 12.902 52.726 12.902V18.0945H52.7281ZM151.327 16.6134C151.327 12.7946 154.321 9.91204 158.291 9.91204C162.275 9.91204 165.279 12.7926 165.281 16.6134C165.281 20.4501 162.275 23.3406 158.291 23.3406C154.321 23.3406 151.327 20.4501 151.327 16.6134ZM154.915 16.6114C154.915 18.6332 156.332 20.1002 158.289 20.1002C160.229 20.1002 161.693 18.6013 161.693 16.6114C161.693 14.6394 160.231 13.1524 158.289 13.1524C156.365 13.1524 154.915 14.6394 154.915 16.6114ZM181.778 9.91212C179.722 9.75905 177.964 10.7968 176.984 11.3872C175.859 10.5045 174.605 9.91212 173.002 9.91212C170.016 9.91212 166.969 11.6575 166.969 11.6575V23.0365H170.453V13.6037C171.015 13.2081 172.03 13.1545 172.597 13.1545C173.788 13.1545 175.176 14.063 175.176 15.5977V23.0365H178.66V14.7428C178.66 14.0749 178.472 13.7349 178.472 13.7349C180.796 12.4726 183.516 13.4348 183.516 15.5977V23.0365H187V15.546C186.998 11.908 184.108 10.0851 181.778 9.91212ZM145.299 13.1522C143.645 13.1522 142.248 14.514 141.977 16.0705C141.099 15.2376 139.945 14.679 138.66 14.5299C139.549 11.7925 142.177 9.9099 145.456 9.9099C148.368 9.9099 150.374 11.4983 150.374 11.4983L148.593 14.2218C148.593 14.2218 147.237 13.1522 145.299 13.1522ZM148.687 18.9547C148.687 18.9547 147.353 20.0978 145.301 20.0978C144.721 20.0978 144.174 19.9288 143.694 19.6426C143.704 19.7817 143.712 19.9209 143.712 20.062C143.712 21.1077 143.416 22.0857 142.902 22.9227C143.69 23.193 144.55 23.3401 145.46 23.3401C148.722 23.3401 150.551 21.5013 150.551 21.5013L148.687 18.9547ZM141.19 20.0642C141.19 21.7869 139.756 23.1833 137.986 23.1833C136.217 23.1833 134.782 21.7869 134.782 20.0642C134.782 18.3416 136.217 16.9452 137.986 16.9452C139.756 16.9452 141.19 18.3416 141.19 20.0642Z", fill: "#AAD500" }) })));
};
var PoweredByFalabellaDotComGreen = React__default.forwardRef(IconPoweredFalabellaDotCom);

var IconUserCrossCheck = function (_a, svgRef) {
    _a.size; __rest(_a, ["size"]);
    return (jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "85", height: "84", viewBox: "0 0 85 84", fill: "none" }, { children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M75.8519 13.0603C76.8773 14.0852 76.8778 15.7473 75.8529 16.7727L68.8566 23.7727C67.8319 24.7979 66.1701 24.7985 65.1447 23.774L60.941 19.574C59.9154 18.5493 59.9146 16.8872 60.9393 15.8617C61.964 14.8361 63.626 14.8354 64.6516 15.86L66.9987 18.205L72.1396 13.0613C73.1645 12.0359 74.8265 12.0355 75.8519 13.0603Z", fill: "#333333" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.5 27.125C39.1173 27.125 36.375 29.8673 36.375 33.25C36.375 36.6327 39.1173 39.375 42.5 39.375C45.8827 39.375 48.625 36.6327 48.625 33.25C48.625 29.8673 45.8827 27.125 42.5 27.125ZM31.125 33.25C31.125 26.9678 36.2178 21.875 42.5 21.875C48.7822 21.875 53.875 26.9678 53.875 33.25C53.875 39.5322 48.7822 44.625 42.5 44.625C36.2178 44.625 31.125 39.5322 31.125 33.25Z", fill: "#333333" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.7613 48.125H50.2387C54.7592 48.1271 58.8501 50.8072 60.6563 54.9511C61.2356 56.2801 60.6278 57.8271 59.2989 58.4063C57.9699 58.9856 56.4229 58.3779 55.8437 57.0489C54.8717 54.819 52.6712 53.3766 50.2387 53.375H34.7625C34.7621 53.375 34.7629 53.375 34.7625 53.375C32.3301 53.3766 30.1283 54.819 29.1563 57.0489C28.5771 58.3779 27.0301 58.9856 25.7011 58.4063C24.3721 57.8271 23.7644 56.2801 24.3437 54.9511C26.1499 50.8072 30.2408 48.1271 34.7613 48.125Z", fill: "#333333" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.4941 13.125C26.5496 13.1282 13.625 26.0547 13.625 42C13.625 57.9472 26.5528 70.875 42.5 70.875C58.4453 70.875 71.3719 57.9503 71.375 42.0057C71.3616 39.1299 70.9102 36.273 70.0362 33.5333C69.5956 32.1521 70.3581 30.6753 71.7392 30.2347C73.1204 29.7941 74.5972 30.5566 75.0378 31.9377C76.0746 35.1878 76.6098 38.5769 76.625 41.9883L76.625 42C76.625 60.8467 61.3467 76.125 42.5 76.125C23.6533 76.125 8.375 60.8467 8.375 42C8.375 23.1533 23.6533 7.875 42.5 7.875H42.5117C45.9231 7.89016 49.3122 8.42538 52.5623 9.46216C53.9434 9.90276 54.7059 11.3796 54.2653 12.7608C53.8247 14.1419 52.3479 14.9044 50.9667 14.4638C48.2269 13.5898 45.3699 13.1384 42.4941 13.125Z", fill: "#333333" })] })));
};
var UserCrossCheck = React__default.forwardRef(IconUserCrossCheck);

var IconWarningCircle = function (_a, svgRef) {
    _a.size; __rest(_a, ["size"]);
    return (jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26", fill: "none" }, { children: [jsxs("g", __assign({ clipPath: "url(#clip0_4247_3439)" }, { children: [jsx("path", { d: "M12.1666 5.70835H13.8333V16.125H12.1666V5.70835Z", fill: "#F7B500" }), jsx("path", { d: "M14.25 19.2499C14.25 19.9402 13.6904 20.4999 13 20.4999C12.3097 20.4999 11.75 19.9402 11.75 19.2499C11.75 18.5595 12.3097 17.9999 13 17.9999C13.6904 17.9999 14.25 18.5595 14.25 19.2499Z", fill: "#F7B500" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.5 13C0.5 6.125 6.125 0.5 13 0.5C19.875 0.5 25.5 6.125 25.5 13C25.5 19.875 19.875 25.5 13 25.5C6.125 25.5 0.5 19.875 0.5 13ZM23.8334 13C23.8334 6.95837 19.0417 2.16671 13 2.16671C6.95837 2.16671 2.16671 6.95837 2.16671 13C2.16671 19.0417 6.95837 23.8334 13 23.8334C19.0417 23.8334 23.8334 19.0417 23.8334 13Z", fill: "#F7B500" })] })), jsx("defs", { children: jsx("clipPath", __assign({ id: "clip0_4247_3439" }, { children: jsx("rect", { width: "26", height: "26", fill: "white" }) })) })] })));
};
var WarningCircle = React__default.forwardRef(IconWarningCircle);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$m = ".alert-module_falw-alert-container__-nMkS{align-items:center;background-color:#f0f0f0;color:#333;display:flex;font-size:14px;line-height:16.4px;padding:10px}.alert-module_falw-alert-container__-nMkS>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(12px*(1 - var(--tw-space-x-reverse)));margin-right:calc(12px*var(--tw-space-x-reverse))}.alert-module_falw-alert-container__-nMkS{border-radius:4px}.alert-module_falw-alert-container__-nMkS *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.alert-module_falw-alert-container__-nMkS *,.alert-module_falw-alert-container__-nMkS :after,.alert-module_falw-alert-container__-nMkS :before{box-sizing:border-box}.alert-module_falw-alert-container__-nMkS blockquote,.alert-module_falw-alert-container__-nMkS dd,.alert-module_falw-alert-container__-nMkS dl,.alert-module_falw-alert-container__-nMkS figure,.alert-module_falw-alert-container__-nMkS h1,.alert-module_falw-alert-container__-nMkS h2,.alert-module_falw-alert-container__-nMkS h3,.alert-module_falw-alert-container__-nMkS h4,.alert-module_falw-alert-container__-nMkS h5,.alert-module_falw-alert-container__-nMkS h6,.alert-module_falw-alert-container__-nMkS hr,.alert-module_falw-alert-container__-nMkS p,.alert-module_falw-alert-container__-nMkS pre{margin:0}.alert-module_falw-alert-container__-nMkS b{font-weight:700}.alert-module_falw-alert-container__-nMkS.alert-module_falw-alert-type-success__5tHgN{background-color:#f3f9e5}.alert-module_falw-alert-container__-nMkS.alert-module_falw-alert-type-warning__VGfPE{background-color:#fff9e9}.alert-module_falw-alert-container__-nMkS .alert-module_falw-icon-container__ymGIq{align-self:baseline;display:flex}.alert-module_falw-alert-container__-nMkS .alert-module_falw-icon-center-container__piVQA{align-self:center;display:flex}.alert-module_falw-alert-container__-nMkS .alert-module_falw-icon-style-danger__WSRiL{color:#d60303}.alert-module_falw-alert-container__-nMkS .alert-module_falw-icon-style-success__VMq5Y{color:#186f07}.alert-module_falw-alert-container__-nMkS .alert-module_falw-icon-style-warning__1dtpG{color:#f7b500}.alert-module_falw-alert-container-rebranded__DED39{margin-top:10px!important}.alert-module_falw-alert-container-rebranded__DED39>div:nth-child(2){margin-left:13px!important}";
var styles$m = {"falw-alert-container":"alert-module_falw-alert-container__-nMkS","falw-alert-type-success":"alert-module_falw-alert-type-success__5tHgN","falw-alert-type-warning":"alert-module_falw-alert-type-warning__VGfPE","falw-icon-container":"alert-module_falw-icon-container__ymGIq","falw-icon-center-container":"alert-module_falw-icon-center-container__piVQA","falw-icon-style-danger":"alert-module_falw-icon-style-danger__WSRiL","falw-icon-style-success":"alert-module_falw-icon-style-success__VMq5Y","falw-icon-style-warning":"alert-module_falw-icon-style-warning__1dtpG","falw-alert-container-rebranded":"alert-module_falw-alert-container-rebranded__DED39"};
styleInject(css_248z$m);

var getAlertIcon = function (icon, type, isRebrandingEnabled, centerIcons) {
    if (isRebrandingEnabled === void 0) { isRebrandingEnabled = false; }
    if (centerIcons === void 0) { centerIcons = false; }
    var size = (function () {
        if (centerIcons)
            return 32;
        return isRebrandingEnabled ? 19.2 : 20;
    })();
    if (icon) {
        return icon;
    }
    switch (type) {
        case 'danger':
            return jsx(XCircle, { size: size });
        case 'success':
            return jsx(CheckCircle, { size: size });
        case 'warning':
            return jsx(ExclamationCircle, { size: size });
    }
};
var Alert$1 = function (props) {
    var children = props.children, type = props.type, icon = props.icon, centerIcons = props.centerIcons;
    return (jsxs("div", __assign({ className: clsx(styles$m['falw-alert-container'], styles$m["falw-alert-type-".concat(type)], props.isRebrandingEnabled && styles$m['falw-alert-container-rebranded']) }, { children: [type || icon ? (jsx("div", __assign({ className: clsx(styles$m[centerIcons ? 'falw-icon-center-container' : 'falw-icon-container'], styles$m["falw-icon-style-".concat(type)]) }, { children: getAlertIcon(icon, type, props.isRebrandingEnabled, props.centerIcons) }))) : null, jsx("div", { children: children })] })));
};

var defaultState = {
    enabled: false,
    cartId: '',
    siteName: 'marketplace',
    ecommName: '',
    defaultColor: '',
    multiSite: false,
};
var WhiteLabelContext = createContext(defaultState);

var css_248z$l = ".button-module_falw-btn__AAtLY{align-items:center;border-style:solid;border-width:0;cursor:pointer;display:inline-flex;justify-content:center}.button-module_falw-btn__AAtLY>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(8px*(1 - var(--tw-space-x-reverse)));margin-right:calc(8px*var(--tw-space-x-reverse))}.button-module_falw-btn__AAtLY{border-radius:.375rem;font-size:14px;font-weight:700;letter-spacing:.05em;padding-left:24px;padding-right:24px;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1)}.button-module_falw-btn__AAtLY:focus{outline:2px solid transparent;outline-offset:2px}.button-module_falw-btn__AAtLY:disabled{pointer-events:none}.button-module_falw-btn__AAtLY{height:45px;letter-spacing:1px;line-height:17px}.button-module_falw-btn__AAtLY *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.button-module_falw-btn__AAtLY *,.button-module_falw-btn__AAtLY :after,.button-module_falw-btn__AAtLY :before{box-sizing:border-box}.button-module_falw-btn__AAtLY blockquote,.button-module_falw-btn__AAtLY dd,.button-module_falw-btn__AAtLY dl,.button-module_falw-btn__AAtLY figure,.button-module_falw-btn__AAtLY h1,.button-module_falw-btn__AAtLY h2,.button-module_falw-btn__AAtLY h3,.button-module_falw-btn__AAtLY h4,.button-module_falw-btn__AAtLY h5,.button-module_falw-btn__AAtLY h6,.button-module_falw-btn__AAtLY hr,.button-module_falw-btn__AAtLY p,.button-module_falw-btn__AAtLY pre{margin:0}.button-module_falw-btn__AAtLY b{font-weight:700}.button-module_falw-btn__AAtLY span,.button-module_falw-btn__AAtLY svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.button-module_falw-btn__AAtLY:disabled{background-color:#bbb!important;border-width:0!important;--tw-text-opacity:1!important;color:rgb(255 255 255/var(--tw-text-opacity))!important}.button-module_falw-btn__AAtLY.button-module_falw-btn-block__RMbJC{width:100%}.button-module_falw-btn__AAtLY.button-module_falw-btn-uppercased__XmCQa{text-transform:uppercase}.button-module_falw-btn__AAtLY.button-module_falw-btn-color-default__PYucH{--tw-bg-opacity:1;background-color:rgb(209 213 219/var(--tw-bg-opacity))}.button-module_falw-btn__AAtLY.button-module_falw-btn-color-default__PYucH:hover{--tw-bg-opacity:1;background-color:rgb(156 163 175/var(--tw-bg-opacity))}.button-module_falw-btn__AAtLY.button-module_falw-btn-color-default__PYucH:active{--tw-bg-opacity:1;background-color:rgb(107 114 128/var(--tw-bg-opacity))}.button-module_falw-btn__AAtLY.button-module_falw-btn-color-primary__JyUjj{background-color:#8fca00}.button-module_falw-btn__AAtLY.button-module_falw-btn-color-primary__JyUjj:hover{background-color:#9ad900}.button-module_falw-btn__AAtLY.button-module_falw-btn-color-primary__JyUjj:active{background-color:#84bb00}button.button-module_falw-btn-rebranded__oGf32{border-radius:23px;font-weight:400;line-height:23px;max-height:100%!important}button.button-module_falw-btn-rebranded__oGf32 span,button.button-module_falw-btn-rebranded__oGf32 svg{color:#fff;font-size:19px}button.button-module_falw-btn-rebranded__oGf32:disabled{background-color:#8b8b8b!important}button.button-module_falw-btn-rebranded__oGf32:disabled span{color:#fff!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary__JyUjj{background-color:#343e49!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary__JyUjj span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary__JyUjj svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary__JyUjj:hover{background-color:#3a4652}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary__JyUjj:active{background-color:#2e3640}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-default__F817m{background-color:#343e49!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-default__F817m span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-default__F817m svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-default__F817m:hover{background-color:#3a4652}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-default__F817m:active{background-color:#2e3640}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-celebremos__2y73q{background-color:#343e49!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-celebremos__2y73q span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-celebremos__2y73q svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-celebremos__2y73q:hover{background-color:#3a4652}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-celebremos__2y73q:active{background-color:#2e3640}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-carters__fQha4{background-color:#096588}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-carters__fQha4 span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-carters__fQha4 svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-carters__fQha4 button:enabled{background-color:#343e49}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-carters__fQha4:hover{background-color:#0a7096}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-carters__fQha4:active{background-color:#085a7a}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-americanino__VkZcY{background-color:#c81a25}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-americanino__VkZcY span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-americanino__VkZcY svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-americanino__VkZcY button:enabled{background-color:#343e49}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-americanino__VkZcY:hover{background-color:#d61c28}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-americanino__VkZcY:active{background-color:#ba1822}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-aldo__v94XE{background-color:#3300ad}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-aldo__v94XE span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-aldo__v94XE svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-aldo__v94XE button:enabled{background-color:#343e49}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-aldo__v94XE:hover{background-color:#3800bc}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-aldo__v94XE:active{background-color:#2e009e}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-crateandbarrel__d9C1o:enabled{background-color:#333}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-marketplace__RncdJ:enabled{background-color:#343e49}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-sodimac__nLAY0{background-color:#0072ce!important;border-radius:4px}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-sodimac__nLAY0 span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-sodimac__nLAY0 svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-sodimac__nLAY0:hover{background-color:#007add}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-sodimac__nLAY0:active{background-color:#006abf}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-sodimac__nLAY0:disabled{background-color:#0072ce!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33{background-color:#19ce4d!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33 .button-module_login-button-text__zCALB,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33 .button-module_login-button-text__zCALB:active,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33 .button-module_login-button-text__zCALB:disabled,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33 .button-module_login-button-text__zCALB:hover{color:#013f48!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33:hover{background-color:#1bdc52}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33:active{background-color:#17c048}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-tottus__t6s33:disabled{background-color:#19ce4d!important}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-secondary__CB863{background-color:#495867;border-color:#495867}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-secondary__CB863 span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-secondary__CB863 svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-secondary__CB863:hover{background-color:#495867}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-whitelable__-SwyE{background-color:#4f6172;border-color:#4f6172}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-whitelable__-SwyE span,button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-whitelable__-SwyE svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-whitelable__-SwyE:hover{background-color:#55697b}button.button-module_falw-btn-rebranded__oGf32.button-module_falw-btn-color-primary-whitelable__-SwyE:active{background-color:#495969}";
var styles$l = {"falw-btn":"button-module_falw-btn__AAtLY","falw-btn-block":"button-module_falw-btn-block__RMbJC","falw-btn-uppercased":"button-module_falw-btn-uppercased__XmCQa","falw-btn-color-default":"button-module_falw-btn-color-default__PYucH","falw-btn-color-primary":"button-module_falw-btn-color-primary__JyUjj","falw-btn-rebranded":"button-module_falw-btn-rebranded__oGf32","falw-btn-color-primary-default":"button-module_falw-btn-color-primary-default__F817m","falw-btn-color-primary-celebremos":"button-module_falw-btn-color-primary-celebremos__2y73q","falw-btn-color-primary-carters":"button-module_falw-btn-color-primary-carters__fQha4","falw-btn-color-primary-americanino":"button-module_falw-btn-color-primary-americanino__VkZcY","falw-btn-color-primary-aldo":"button-module_falw-btn-color-primary-aldo__v94XE","falw-btn-color-primary-crateandbarrel":"button-module_falw-btn-color-primary-crateandbarrel__d9C1o","falw-btn-color-primary-marketplace":"button-module_falw-btn-color-primary-marketplace__RncdJ","falw-btn-color-primary-sodimac":"button-module_falw-btn-color-primary-sodimac__nLAY0","falw-btn-color-primary-tottus":"button-module_falw-btn-color-primary-tottus__t6s33","login-button-text":"button-module_login-button-text__zCALB","falw-btn-color-secondary":"button-module_falw-btn-color-secondary__CB863","falw-btn-color-primary-whitelable":"button-module_falw-btn-color-primary-whitelable__-SwyE"};
styleInject(css_248z$l);

var Button = function (props) {
    var block = props.block, _a = props.color, color = _a === void 0 ? 'default' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, Icon = props.icon, id = props.id, label = props.label, onClick = props.onClick, style = props.style, _c = props.type, type = _c === void 0 ? 'button' : _c, _d = props.uppercased, uppercased = _d === void 0 ? false : _d, _e = props.isRebrandingEnabled, isRebrandingEnabled = _e === void 0 ? false : _e;
    var whitelabel = useContext(WhiteLabelContext);
    var siteName = whitelabel.enabled ? "-".concat(whitelabel.siteName) : '';
    return (jsxs("button", __assign({ id: id, type: type, className: clsx(styles$l['falw-btn'], styles$l["falw-btn-color-".concat(color).concat(siteName)], block && styles$l['falw-btn-block'], uppercased && styles$l['falw-btn-uppercased'], isRebrandingEnabled && styles$l['falw-btn-rebranded']), style: style, disabled: disabled, onClick: onClick }, { children: [Icon, jsx("span", __assign({ className: clsx(styles$l['login-button-text']), style: { letterSpacing: '0px' } }, { children: label }))] })));
};

var css_248z$k = ".buttonNew-module_falw-btn__5ZRdy{align-items:center;border-style:solid;border-width:0;cursor:pointer;display:inline-flex;justify-content:center}.buttonNew-module_falw-btn__5ZRdy>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(8px*(1 - var(--tw-space-x-reverse)));margin-right:calc(8px*var(--tw-space-x-reverse))}.buttonNew-module_falw-btn__5ZRdy{border-radius:.375rem;font-size:14px;font-weight:700;letter-spacing:.05em;padding-left:24px;padding-right:24px;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1)}.buttonNew-module_falw-btn__5ZRdy:focus{outline:2px solid transparent;outline-offset:2px}.buttonNew-module_falw-btn__5ZRdy:disabled{pointer-events:none}.buttonNew-module_falw-btn__5ZRdy{height:45px;letter-spacing:1px;line-height:17px}.buttonNew-module_falw-btn__5ZRdy *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.buttonNew-module_falw-btn__5ZRdy *,.buttonNew-module_falw-btn__5ZRdy :after,.buttonNew-module_falw-btn__5ZRdy :before{box-sizing:border-box}.buttonNew-module_falw-btn__5ZRdy blockquote,.buttonNew-module_falw-btn__5ZRdy dd,.buttonNew-module_falw-btn__5ZRdy dl,.buttonNew-module_falw-btn__5ZRdy figure,.buttonNew-module_falw-btn__5ZRdy h1,.buttonNew-module_falw-btn__5ZRdy h2,.buttonNew-module_falw-btn__5ZRdy h3,.buttonNew-module_falw-btn__5ZRdy h4,.buttonNew-module_falw-btn__5ZRdy h5,.buttonNew-module_falw-btn__5ZRdy h6,.buttonNew-module_falw-btn__5ZRdy hr,.buttonNew-module_falw-btn__5ZRdy p,.buttonNew-module_falw-btn__5ZRdy pre{margin:0}.buttonNew-module_falw-btn__5ZRdy b{font-weight:700}.buttonNew-module_falw-btn__5ZRdy span,.buttonNew-module_falw-btn__5ZRdy svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.buttonNew-module_falw-btn__5ZRdy:disabled{background-color:#bbb!important;border-width:0!important;--tw-text-opacity:1!important;color:rgb(255 255 255/var(--tw-text-opacity))!important}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-block__68NWw{width:100%}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-uppercased__tffvW{text-transform:uppercase}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-default__ZNeNn{--tw-bg-opacity:1;background-color:rgb(209 213 219/var(--tw-bg-opacity))}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-default__ZNeNn:hover{--tw-bg-opacity:1;background-color:rgb(156 163 175/var(--tw-bg-opacity))}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-default__ZNeNn:active{--tw-bg-opacity:1;background-color:rgb(107 114 128/var(--tw-bg-opacity))}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary__PqmH4{background-color:#8fca00}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary__PqmH4:hover{background-color:#9ad900}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary__PqmH4:active{background-color:#84bb00}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT{background-color:#0072ce!important;border-radius:4px}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT:hover{background-color:#007add}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT:active{background-color:#006abf}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT:disabled{background-color:#0072ce!important}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE{background-color:#19ce4d!important}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR,.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR:active,.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR:disabled,.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR:hover{color:#013f48!important}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE:hover{background-color:#1bdc52}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE:active{background-color:#17c048}.buttonNew-module_falw-btn__5ZRdy.buttonNew-module_falw-btn-color-primary-tottus__cv4CE:disabled{background-color:#19ce4d!important}button.buttonNew-module_falw-btn-rebranded__ARmh3{border-radius:23px;font-weight:400;line-height:23px;width:95%!important}button.buttonNew-module_falw-btn-rebranded__ARmh3 span,button.buttonNew-module_falw-btn-rebranded__ARmh3 svg{color:#636363;font-size:19px}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary__PqmH4{background-color:#343e49}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary__PqmH4 span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary__PqmH4 svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity));font-size:20px;font-weight:700}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary__PqmH4:hover{background-color:#3a4652}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary__PqmH4:active{background-color:#2e3640}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-default__70RUP{background-color:#343e49}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-default__70RUP span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-default__70RUP svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity));font-size:20px;font-weight:700}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-default__70RUP:hover{background-color:#3a4652}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-default__70RUP:active{background-color:#2e3640}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT{background-color:#0072ce!important;border-radius:4px}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT:hover{background-color:#007add}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT:active{background-color:#006abf}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-sodimac__uu4uT:disabled{background-color:#0072ce!important}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE{background-color:#19ce4d!important}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR:active,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR:disabled,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE .buttonNew-module_login-button-text__1DnVR:hover{color:#013f48!important}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE:hover{background-color:#1bdc52}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE:active{background-color:#17c048}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-tottus__cv4CE:disabled{background-color:#19ce4d!important}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-carters__EhLk7{background-color:#096588}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-carters__EhLk7 span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-carters__EhLk7 svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-carters__EhLk7:hover{background-color:#0a7096}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-carters__EhLk7:active{background-color:#085a7a}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-americanino__bZYw9{background-color:#c81a25!important}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-americanino__bZYw9 span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-americanino__bZYw9 svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-americanino__bZYw9:hover{background-color:#d61c28}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-americanino__bZYw9:active{background-color:#ba1822}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-aldo__j10tM{background-color:#3300ad}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-aldo__j10tM span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-aldo__j10tM svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-aldo__j10tM:hover{background-color:#3800bc}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-aldo__j10tM:active{background-color:#2e009e}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-secondary__kwV1-{background-color:#495867;border-color:#495867}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-secondary__kwV1- span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-secondary__kwV1- svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-secondary__kwV1-:hover{background-color:#495867}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-whitelable__mgByp{background-color:#4f6172;border-color:#4f6172}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-whitelable__mgByp span,button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-whitelable__mgByp svg{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-whitelable__mgByp:hover{background-color:#55697b}button.buttonNew-module_falw-btn-rebranded__ARmh3.buttonNew-module_falw-btn-color-primary-whitelable__mgByp:active{background-color:#495969}button.buttonNew-module_falw-btn-rebranded__ARmh3:disabled{background-color:#8b8b8b!important}button.buttonNew-module_falw-btn-rebranded__ARmh3:disabled span{color:#fff!important;font-family:Lato,Sans-serif;font-weight:700;size:20px}";
var styles$k = {"falw-btn":"buttonNew-module_falw-btn__5ZRdy","falw-btn-block":"buttonNew-module_falw-btn-block__68NWw","falw-btn-uppercased":"buttonNew-module_falw-btn-uppercased__tffvW","falw-btn-color-default":"buttonNew-module_falw-btn-color-default__ZNeNn","falw-btn-color-primary":"buttonNew-module_falw-btn-color-primary__PqmH4","falw-btn-color-primary-sodimac":"buttonNew-module_falw-btn-color-primary-sodimac__uu4uT","falw-btn-color-primary-tottus":"buttonNew-module_falw-btn-color-primary-tottus__cv4CE","login-button-text":"buttonNew-module_login-button-text__1DnVR","falw-btn-rebranded":"buttonNew-module_falw-btn-rebranded__ARmh3","falw-btn-color-primary-default":"buttonNew-module_falw-btn-color-primary-default__70RUP","falw-btn-color-primary-carters":"buttonNew-module_falw-btn-color-primary-carters__EhLk7","falw-btn-color-primary-americanino":"buttonNew-module_falw-btn-color-primary-americanino__bZYw9","falw-btn-color-primary-aldo":"buttonNew-module_falw-btn-color-primary-aldo__j10tM","falw-btn-color-secondary":"buttonNew-module_falw-btn-color-secondary__kwV1-","falw-btn-color-primary-whitelable":"buttonNew-module_falw-btn-color-primary-whitelable__mgByp"};
styleInject(css_248z$k);

var ButtonNew = function (_a) {
    var block = _a.block, _b = _a.color, color = _b === void 0 ? 'default' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, Icon = _a.icon, id = _a.id, label = _a.label, onClick = _a.onClick, style = _a.style, _d = _a.type, type = _d === void 0 ? 'button' : _d, _e = _a.uppercased, uppercased = _e === void 0 ? false : _e, _f = _a.isRebrandingEnabled, isRebrandingEnabled = _f === void 0 ? false : _f;
    var whitelabel = useContext(WhiteLabelContext);
    var siteName = whitelabel.enabled ? "-".concat(whitelabel.siteName) : '';
    return (jsxs("button", __assign({ id: id, type: type, className: clsx(styles$k['falw-btn'], styles$k["falw-btn-color-".concat(color).concat(siteName)], block && styles$k['falw-btn-block'], uppercased && styles$k['falw-btn-uppercased'], isRebrandingEnabled && styles$k['falw-btn-rebranded']), style: style, disabled: disabled, onClick: onClick }, { children: [Icon, jsx("span", __assign({ style: { letterSpacing: '0px' } }, { children: label }))] })));
};

var css_248z$j = ".pure-material-switch{align-self:center;color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.87);display:inline-block;font-family:var(--pure-material-font,\"Roboto\",\"Segoe UI\",BlinkMacSystemFont,system-ui,-apple-system);font-size:16px;line-height:1.5;position:relative;z-index:0}.pure-material-switch>input{align-self:center;appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:50%;display:block;height:40px;margin:0;opacity:0;outline:none;pointer-events:none;position:absolute;right:6px;top:-8px;transform:scale(1);transition:opacity .3s .1s,transform .2s .1s;width:40px;z-index:-1}.pure-material-switch>span{cursor:pointer;display:inline-block;width:100%}.pure-material-switch>span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:7px;content:\"\";display:inline-block;float:right;height:14px;margin:5px 0 5px 10px;transition:background-color .2s,opacity .2s;vertical-align:top;width:36px}.pure-material-switch>span:after{background-color:#f8f8f8;border-radius:50%;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);content:\"\";height:20px;position:absolute;right:16px;top:1px;transition:background-color .2s,transform .2s;width:20px}.pure-material-switch>input:checked{background-color:#8fca00!important;right:-10px}.pure-material-switch>input:checked+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:checked+span:after{background-color:#8fca00;transform:translateX(16px)}.pure-material-switch:hover>input{opacity:.04}.pure-material-switch>input:focus{opacity:.12}.pure-material-switch:hover>input:focus{opacity:.16}.pure-material-switch>input:active{opacity:1;transform:scale(0);transition:transform 0s,opacity 0s}.pure-material-switch>input:active+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:disabled{opacity:0}.pure-material-switch>input:disabled+span{color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);cursor:default}.pure-material-switch>input:disabled+span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38)}.pure-material-switch>input:checked:disabled+span:before{background-color:#8fca00;opacity:.6}.square-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-checkbox+label,.square-checkbox+label:before{cursor:pointer;position:relative}.square-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:2px solid #bfc4c9;box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);content:\"\";display:inline-block;padding:10px;vertical-align:middle}.square-checkbox:checked+label:before{border:2px solid #343e49}.square-checkbox:checked+label:after{border:solid #343e49;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.square-round-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-round-checkbox+label{cursor:pointer;position:relative}.square-round-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:1px solid #bfc4c9;border-radius:6px;content:\"\";cursor:pointer;display:inline-block;padding:10px;position:relative;vertical-align:middle}.square-round-checkbox:checked+label:before{background-color:#343e49;border:2px solid #343e49}.square-round-checkbox:checked+label:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.consents-module_falw-consents-root__HlARz{align-items:center;display:flex;flex-direction:column;position:relative}.consents-module_falw-consents-root__HlARz>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(24px*var(--tw-space-y-reverse));margin-top:calc(24px*(1 - var(--tw-space-y-reverse)))}.consents-module_falw-consents-root__HlARz{padding:0 20px 40px;text-align:center}.consents-module_falw-consents-root__HlARz *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.consents-module_falw-consents-root__HlARz *,.consents-module_falw-consents-root__HlARz :after,.consents-module_falw-consents-root__HlARz :before{box-sizing:border-box}.consents-module_falw-consents-root__HlARz blockquote,.consents-module_falw-consents-root__HlARz dd,.consents-module_falw-consents-root__HlARz dl,.consents-module_falw-consents-root__HlARz figure,.consents-module_falw-consents-root__HlARz h1,.consents-module_falw-consents-root__HlARz h2,.consents-module_falw-consents-root__HlARz h3,.consents-module_falw-consents-root__HlARz h4,.consents-module_falw-consents-root__HlARz h5,.consents-module_falw-consents-root__HlARz h6,.consents-module_falw-consents-root__HlARz hr,.consents-module_falw-consents-root__HlARz p,.consents-module_falw-consents-root__HlARz pre{margin:0}.consents-module_falw-consents-root__HlARz b{font-weight:700}.consents-module_falw-consents-root__HlARz svg{color:#8fca00}.consents-module_falw-consents-root__HlARz p{color:#4a4a4a;font-size:14px;padding:0 17px}.consents-module_falw-consents-root__HlARz .consents-module_spinner-wrapper__UQjBr{align-items:center;color:#8fca00;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes consents-module_spin__4HOhH{to{transform:rotate(1turn)}}.consents-module_falw-consents-root__HlARz .consents-module_spinner-wrapper__UQjBr .consents-module_spinner__AwX4i{animation:consents-module_spin__4HOhH 1s linear infinite}.consents-module_falw-consents-root__HlARz .consents-module_consent-title__BevaC p{font-size:20px}.consents-module_falw-consents-root__HlARz .consents-module_consent-label__0cvf-{text-align:left}.consents-module_falw-consents-root__HlARz .consents-module_consent-label__0cvf- a{color:#4a8431;font-size:14px;font-weight:600;text-decoration-line:underline}.consents-module_falw-consents-root__HlARz .consents-module_consent-button__3l9-P{cursor:pointer;text-align:left}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA{width:100%}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(16px*var(--tw-space-y-reverse));margin-top:calc(16px*(1 - var(--tw-space-y-reverse)))}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA.consents-module_disabled__BEZVl{opacity:.3}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD{display:flex}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-label__0cvf-{color:#4a8431;flex-grow:1;font-size:14px;text-align:left;text-decoration-line:underline;text-decoration:none}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-label__0cvf- a{cursor:pointer}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-button__3l9-P{color:#4a8431;flex-grow:1;font-size:14px;text-align:left}.consents-module_falw-consents-root__HlARz .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-control__TgC-H{display:flex}@media (max-width:640px){.consents-module_falw-consents-root-rebranded__rVy42{padding:20px}}.consents-module_falw-consents-root-rebranded__rVy42 svg{color:#343e49}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil{width:100%}@media (min-width:768px){.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil{padding-inline:40px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil.consents-module_pe__YH368{padding-inline:30px}}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-subtitle__FQW-v{align-items:center;display:flex;justify-content:center}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-subtitle__FQW-v.consents-module_mobile-pe__aFODm{display:block;line-height:32px;margin-bottom:32px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-subtitle__FQW-v p{color:#131313;font-size:22px;font-weight:400;padding:0}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-subtitle__FQW-v p.consents-module_pe__YH368{font-size:22px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3{margin-top:14px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3.consents-module_pe__YH368{padding-inline:7px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3 .consents-module_consents-modal-description-text__-NqxS{color:#131313;font-size:14px;font-weight:400}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3 .consents-module_consents-modal-description-text__-NqxS .consents-module_center__D5vi1{text-align:center}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3 p{color:#131313;font-size:16px;font-weight:400;line-height:24px;padding:0;text-align:left}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3 p span,.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_consents-body-container__oCuil .consents-module_consents-modal-description-text-container__8udy3 p.consents-module_strong__uU-cN{font-size:15px;font-weight:700}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA{margin-top:30px!important}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD:nth-child(3){margin-top:25px!important}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD{align-items:flex-start;padding-left:14px;padding-right:14px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-label__0cvf-{color:#4a4a4a!important;font-family:Lato,Sans-serif;font-size:14px;font-weight:400;margin-left:9px}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-label__0cvf- a{color:#4a4a4a!important;font-size:14px;font-weight:400}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-button__3l9-P{align-items:center;background-color:#fff;border:0;border-radius:4px;box-shadow:0 0 10px 1px #e0e0e0;color:#333;display:flex;height:50px;justify-content:space-between;line-height:17px;padding:0 20px;text-decoration:none}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-button__3l9-P :first-letter{text-transform:uppercase}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_form-content__OzNdA .consents-module_consent-item__j8vJD .consents-module_consent-button__3l9-P .consents-module_caret__wkKOO{height:20px;width:10px}@media (max-width:640px){.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_actions-wrapper__xBPAd{margin-top:56px!important}}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_actions-wrapper__xBPAd.consents-module_mt-30__glBxM{margin-top:30px!important}.consents-module_falw-consents-root-rebranded__rVy42 .consents-module_spinner-wrapper__UQjBr .consents-module_spinner__AwX4i{color:#343e49!important}";
var styles$j = {"falw-consents-root":"consents-module_falw-consents-root__HlARz","spinner-wrapper":"consents-module_spinner-wrapper__UQjBr","spinner":"consents-module_spinner__AwX4i","spin":"consents-module_spin__4HOhH","consent-title":"consents-module_consent-title__BevaC","consent-label":"consents-module_consent-label__0cvf-","consent-button":"consents-module_consent-button__3l9-P","form-content":"consents-module_form-content__OzNdA","disabled":"consents-module_disabled__BEZVl","consent-item":"consents-module_consent-item__j8vJD","consent-control":"consents-module_consent-control__TgC-H","falw-consents-root-rebranded":"consents-module_falw-consents-root-rebranded__rVy42","consents-body-container":"consents-module_consents-body-container__oCuil","pe":"consents-module_pe__YH368","consents-modal-subtitle":"consents-module_consents-modal-subtitle__FQW-v","mobile-pe":"consents-module_mobile-pe__aFODm","consents-modal-description-text-container":"consents-module_consents-modal-description-text-container__8udy3","consents-modal-description-text":"consents-module_consents-modal-description-text__-NqxS","center":"consents-module_center__D5vi1","strong":"consents-module_strong__uU-cN","caret":"consents-module_caret__wkKOO","actions-wrapper":"consents-module_actions-wrapper__xBPAd","mt-30":"consents-module_mt-30__glBxM"};
styleInject(css_248z$j);

function isBrowser$1() {
    return (!!window &&
        !!window.localStorage &&
        !!window.sessionStorage &&
        !!window.location &&
        !!window.document);
}
var screenDimension = function () {
    var currentWidth = window === null || window === void 0 ? void 0 : window.screen.width;
    var isMobile = false;
    var device = 'MOBILE_SMALL';
    if (currentWidth < ScreenSizes.LAPTOP) {
        isMobile = true;
    }
    if (currentWidth > ScreenSizes.MOBILE_SMALL && currentWidth <= ScreenSizes.MOBILE_MEDIUM) {
        device = 'MOBILE_MEDIUM';
    }
    if (currentWidth > ScreenSizes.MOBILE_MEDIUM && currentWidth <= ScreenSizes.MOBILE_LARGE) {
        device = 'MOBILE_LARGE';
    }
    if (currentWidth > ScreenSizes.MOBILE_LARGE && currentWidth <= ScreenSizes.TABLET) {
        device = 'TABLET';
    }
    if (currentWidth >= ScreenSizes.LAPTOP && currentWidth < ScreenSizes.DESKTOP) {
        device = 'LAPTOP';
    }
    if (currentWidth >= ScreenSizes.DESKTOP) {
        device = 'DESKTOP';
    }
    return {
        isMobile: isMobile,
        size: currentWidth,
        device: device,
    };
};

var LOGIN_WIZARD_DATA = 'lw-data';
// TODO check if i can remove
var Experience;
(function (Experience) {
    Experience["CATALYST"] = "CATALYST";
})(Experience || (Experience = {}));
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop$1 = function () { };
var sodimacOnlySubdomains = ['sodimac.com.mx'];
function sodimacDomainMatches() {
    var _a;
    if (!isBrowser$1())
        return MISC;
    var origin = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin;
    var matches = sodimacOnlySubdomains.some(function (subdomain) { return origin.includes(subdomain); });
    return matches ? SODIMAC_ONLY : MISC;
}
var getSodimacBusinessScopeConfig = function (tenant) {
    var upperCaseTenant = tenant.toUpperCase();
    var isSodimac = sodimacDomainMatches() === SODIMAC_ONLY;
    var tenantCode;
    var commerceConfigInUrl;
    var optionalConsentKey;
    var mandatoryConsentKey;
    if (isSodimac) {
        tenantCode = "SO".concat(upperCaseTenant);
        commerceConfigInUrl = 'sodimac-commerce-config';
        optionalConsentKey = "ConsentTemplateRegistro_SOD_B2C_".concat(upperCaseTenant);
        mandatoryConsentKey = "TyC-BU_consentTemplateRegistro_SOD_B2C_".concat(upperCaseTenant);
    }
    else {
        tenantCode = "FA".concat(upperCaseTenant);
        commerceConfigInUrl = 'commerce-config';
        optionalConsentKey = "ConsentTemplateRegistro3erCheck_FAL_".concat(upperCaseTenant);
        mandatoryConsentKey = "TyC-BU_consentTemplateRegistroTyC_FAL_".concat(upperCaseTenant);
    }
    return {
        tenantCode: tenantCode,
        isSodimac: isSodimac,
        commerceConfigInUrl: commerceConfigInUrl,
        optionalConsentKey: optionalConsentKey,
        mandatoryConsentKey: mandatoryConsentKey,
    };
};
var getCookie = function (name) {
    var nameLenPlus = name.length + 1;
    return (document.cookie
        .split(';')
        .map(function (c) { return c.trim(); })
        .filter(function (cookie) {
        return cookie.substring(0, nameLenPlus) === "".concat(name, "=");
    })
        .map(function (cookie) {
        return decodeURIComponent(cookie.substring(nameLenPlus));
    })[0] || null);
};
var getEmailFromSessionStorage = function () {
    var _a, _b;
    if (window === null || window === void 0 ? void 0 : window.sessionStorage) {
        return (_b = ((_a = sessionStorage.getItem('CATALYST_EMAIL_ID')) !== null && _a !== void 0 ? _a : sessionStorage.getItem('email'))) === null || _b === void 0 ? void 0 : _b.replace(/"/g, '');
    }
    return '';
};
var getUserNameFromCookie = function () {
    var _a;
    return (_a = getCookie('CATALYST_DATA_COOKIE')) === null || _a === void 0 ? void 0 : _a.split('*')[0];
};
var getSiteName = function (baseUrl) {
    var _a, _b;
    if (baseUrl === void 0) { baseUrl = ''; }
    var url = baseUrl || ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin);
    var domainMap = {
        'sodimac.cl': 'sodimac',
        'sodimac.com.pe': 'sodimac',
        'sodimac.com.mx': 'sodimac',
        'tottus.cl': 'tottus',
        'tottus.com.pe': 'tottus',
    };
    if (!url)
        return 'falabella';
    for (var key in domainMap) {
        if ((_b = url === null || url === void 0 ? void 0 : url.toString()) === null || _b === void 0 ? void 0 : _b.includes(key)) {
            return domainMap[key];
        }
    }
    return 'falabella';
};
var getRegisterUserLinkCommerce = function (baseUrl, tenant, isKioskoFlow) {
    if (baseUrl === void 0) { baseUrl = window === null || window === void 0 ? void 0 : window.location.origin; }
    if (tenant === void 0) { tenant = 'cl'; }
    if (isKioskoFlow === void 0) { isKioskoFlow = false; }
    var domain = getSiteName(baseUrl);
    var registrationUrl = "".concat(baseUrl, "/").concat(domain, "-").concat(tenant, "/myaccount/registration");
    if (isKioskoFlow) {
        registrationUrl += '?fromAgent=agent';
    }
    return registrationUrl;
};
var getRecoverPasswordLinkCommerce = function (baseUrl, tenant) {
    if (baseUrl === void 0) { baseUrl = window === null || window === void 0 ? void 0 : window.location.origin; }
    if (tenant === void 0) { tenant = 'cl'; }
    var domain = getSiteName(baseUrl);
    return "".concat(baseUrl, "/").concat(domain, "-").concat(tenant, "/myaccount/passwordRecoverySearch");
};
var getLockedPasswordLinkCommerce = function (baseUrl, tenant) {
    if (baseUrl === void 0) { baseUrl = window === null || window === void 0 ? void 0 : window.location.origin; }
    if (tenant === void 0) { tenant = 'cl'; }
    var domain = getSiteName(baseUrl);
    return "".concat(baseUrl, "/").concat(domain, "-").concat(tenant, "/myaccount/passwordRecovery?locked=true");
};
var storeLoginData = function (identityValidator, passwordRequired) {
    if (window === null || window === void 0 ? void 0 : window.sessionStorage) {
        sessionStorage.setItem(LOGIN_WIZARD_DATA, JSON.stringify({ identityValidator: identityValidator, passwordRequired: passwordRequired }));
    }
};
var getIsKiosko = function () {
    var kioskoModule = getCookie(COOKIES.KIOSKO_MODULO);
    var kioskoStoreId = getCookie(COOKIES.KIOSKO_STORE_ID);
    var kioskoInfo = getCookie(COOKIES.KIOSKO_INFO);
    return (kioskoModule && kioskoStoreId) || kioskoInfo;
};
var track = function (events, variables) {
    if (variables === void 0) { variables = {}; }
    if (typeof window === 'undefined')
        return;
    try {
        window.s = window.s || { tl: noop$1 };
        window._satellite = window._satellite || { track: noop$1 };
        window.s = __assign(__assign(__assign({}, window.s), { events: events }), variables);
        window._satellite = __assign(__assign(__assign({}, window._satellite), { events: events }), variables);
        window._satellite.track(events, variables);
        window.s.tl(events, variables);
    }
    catch (error) {
        return;
    }
};
var isOptionalConsentModalCookie = function () {
    var optionalCosentModalCookie = getCookie(COOKIES.OPTIONAL_CONSENTS_MODAL.NAME);
    return optionalCosentModalCookie === COOKIES.OPTIONAL_CONSENTS_MODAL.VALUE;
};
var tenantId = function (tenant) {
    var siteName = getSiteName();
    var tenantLookup = {
        falabella: 'marketplace',
        sodimac: 'marketplacesodimac',
        tottus: 'marketplacetottus',
    };
    if (!siteName || !tenant)
        return 'marketplace-cl';
    if (tenant.toLowerCase() === 'mx') {
        return "".concat(siteName, "-").concat(tenant);
    }
    var prefix = tenantLookup[siteName] || tenantLookup.falabella;
    return "".concat(prefix, "-").concat(tenant);
};
function decodeIDToken(idToken) {
    if (!idToken || typeof idToken !== 'string')
        return {};
    try {
        var _a = decodeJWT(idToken), user = _a.user, sessionStatus = _a.session.status;
        return { user: user, sessionStatus: sessionStatus };
    }
    catch (_b) {
        return {};
    }
}
var getUserCountryFromSessionStorage = function () {
    var _a;
    if (typeof window !== 'undefined' && window.sessionStorage) {
        var rawData = sessionStorage.getItem('userData');
        if (!rawData)
            return null;
        try {
            var session = JSON.parse(rawData);
            var idToken = session === null || session === void 0 ? void 0 : session.idToken;
            if (!idToken)
                return null;
            var user = decodeIDToken(idToken).user;
            return (_a = user.document.country) !== null && _a !== void 0 ? _a : null;
        }
        catch (error) {
            console.error('Failed to retrieve country from sessionStorage:', error);
        }
    }
    return null;
};

var ConsentsIntroMessage = function (_a) {
    var tenant = _a.tenant, isRebrandingEnabled = _a.isRebrandingEnabled, isMobile = _a.isMobile, isOnlyOptional = _a.isOnlyOptional;
    //
    var handleRebrandedContent = function (_tenant, _isOnlyOptional) {
        var resultNode = (jsxs(React__default.Fragment, { children: [jsx("span", { children: "Para poder continuar te invitamos a " }), jsx("b", { children: "aceptar los t\u00E9rminos y condiciones" }), jsx("span", { children: " de nuestra nueva plataforma." })] }));
        if (_tenant === Tenant.Chile) {
            if (isOnlyOptional) {
                resultNode = (jsx("div", __assign({ className: styles$j['consents-modal-description-text-container'] }, { children: jsx("span", __assign({ className: styles$j['consents-modal-description-text'] }, { children: REBRANDING.CONSENTS.OPTIONAL_CONSENTS_DESCRIPTION })) })));
            }
            else {
                resultNode = (jsx("div", __assign({ className: styles$j['consents-modal-description-text-container'] }, { children: jsx("span", __assign({ className: styles$j['consents-modal-description-text'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT })) })));
            }
        }
        else if (_tenant === Tenant.Peru) {
            resultNode = (jsxs("div", __assign({ className: clsx(styles$j['consents-modal-description-text-container'], tenant === Tenant.Peru && styles$j['pe']) }, { children: [!isMobile && (jsxs(React__default.Fragment, { children: [jsx("p", { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_1 }), jsx("p", { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_2 }), jsx("p", __assign({ className: styles$j['strong'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_3 })), jsx("p", __assign({ className: styles$j['strong'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_4 }))] })), isMobile && (jsxs("p", { children: [REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_1_MOBILE, ' ', REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_2, ' ', jsx("span", { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_3_MOBILE_SECOND }), ' ', jsx("span", __assign({ className: styles$j['strong'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_4_MOBILE })), jsx("span", __assign({ className: styles$j['strong'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_PE_LINE_5_MOBILE }))] }))] })));
        }
        else if (_tenant === Tenant.Colombia) {
            resultNode = (jsx("div", __assign({ className: styles$j['consents-modal-description-text-container'] }, { children: jsx("span", __assign({ className: styles$j['consents-modal-description-text'] }, { children: jsxs(React__default.Fragment, { children: [jsx("p", __assign({ className: styles$j['center'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_CO_LINE_1 })), jsx("p", __assign({ className: styles$j['center'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_CO_LINE_2 })), jsx("p", __assign({ className: styles$j['center'] }, { children: REBRANDING.CONSENTS.MODAL_DESCRIPTION_TEXT_CO_LINE_3 }))] }) })) })));
        }
        return resultNode;
    };
    var renderClassicContent = function () {
        return (jsxs(React__default.Fragment, { children: ["Para poder continuar te invitamos a ", jsx("b", { children: "aceptar los t\u00E9rminos y condiciones" }), " de nuestra nueva plataforma."] }));
    };
    return (jsxs(React__default.Fragment, { children: [isRebrandingEnabled && handleRebrandedContent(tenant), !isRebrandingEnabled && renderClassicContent()] }));
};

var ConsentsIntroTitle = function (_a) {
    var tenant = _a.tenant, isMobile = _a.isMobile;
    return (jsxs(React__default.Fragment, { children: [(tenant === Tenant.Chile || tenant === Tenant.Colombia) && (jsx("div", __assign({ className: styles$j['consents-modal-subtitle'] }, { children: jsx("p", { children: REBRANDING.CONSENTS.MODAL_SUBTITLE }) }))), tenant === Tenant.Peru && (jsxs("div", __assign({ className: clsx(styles$j['consents-modal-subtitle'], isMobile && styles$j['mobile-pe']) }, { children: [!isMobile && (jsxs("p", __assign({ className: styles$j['pe'] }, { children: [REBRANDING.CONSENTS.MODAL_SUBTITLE_PE_LINE_1, ' ', REBRANDING.CONSENTS.MODAL_SUBTITLE_PE_LINE_2] }))), isMobile && (jsxs(React__default.Fragment, { children: [jsx("p", __assign({ className: styles$j['pe'] }, { children: REBRANDING.CONSENTS.MODAL_SUBTITLE_PE_LINE_1 })), jsx("p", __assign({ className: styles$j['pe'] }, { children: REBRANDING.CONSENTS.MODAL_SUBTITLE_PE_LINE_2 }))] }))] })))] }));
};

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,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";

var css_248z$i = ".optionalContentModal-module_optional-items-container-modal__zQ4YV{display:block!important}.optionalContentModal-module_optional-items-container-modal__zQ4YV .optionalContentModal-module_item-content__ag4Z-{display:block;margin-bottom:12px;width:100%}.optionalContentModal-module_optional-items-container-modal__zQ4YV .optionalContentModal-module_item-content__ag4Z- .optionalContentModal-module_item__MXt-A{align-items:center;display:flex;justify-content:space-between}.optionalContentModal-module_optional-items-container-modal__zQ4YV .optionalContentModal-module_item-content__ag4Z- .optionalContentModal-module_item__MXt-A span{color:#4a4a4a;font-size:14px;font-weight:400;line-height:22px;text-align:left}.optionalContentModal-module_optional-bottom-text-container__WzWR-{margin-top:40px!important}.optionalContentModal-module_optional-bottom-text-container__WzWR- p{font-size:14px;font-style:normal;font-weight:500}.optionalContentModal-module_optional-bottom-text-container__WzWR- p span{cursor:pointer;text-decoration-line:underline}";
var styles$i = {"optional-items-container-modal":"optionalContentModal-module_optional-items-container-modal__zQ4YV","item-content":"optionalContentModal-module_item-content__ag4Z-","item":"optionalContentModal-module_item__MXt-A","optional-bottom-text-container":"optionalContentModal-module_optional-bottom-text-container__WzWR-"};
styleInject(css_248z$i);

var IconPercentageBadge = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, ref: svgRef, viewBox: "0 0 48 48", fill: "none", stroke: "currentColor" }, props, { children: jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M26.2247 13.5848L26.6841 13.9834L27.2812 13.8679L30.1727 13.3087L31.1342 16.0924L31.3328 16.6673L31.9076 16.8658L34.6913 17.8274L34.1322 20.7189L34.0167 21.316L34.4153 21.7754L36.3453 23.9999L34.4153 26.2245L34.0167 26.6838L34.1322 27.281L34.6913 30.1725L31.9076 31.134L31.3328 31.3325L31.1342 31.9074L30.1727 34.6911L27.2812 34.1319L26.6841 34.0165L26.2247 34.415L24.0002 36.345L21.7756 34.415L21.3162 34.0165L20.7191 34.1319L17.8276 34.6911L16.8661 31.9074L16.6675 31.3325L16.0927 31.134L13.309 30.1725L13.8681 27.281L13.9836 26.6838L13.585 26.2245L11.655 23.9999L13.585 21.7754L13.9836 21.316L13.8681 20.7189L13.309 17.8274L16.0927 16.8658L16.6675 16.6673L16.8661 16.0924L17.8276 13.3087L20.7191 13.8679L21.3162 13.9834L21.7756 13.5848L24.0002 11.6548L26.2247 13.5848ZM23.6725 10.2842C23.8605 10.1211 24.1398 10.1211 24.3278 10.2842L27.0439 12.6406L30.5742 11.9579C30.8186 11.9107 31.0605 12.0503 31.1418 12.2856L32.3157 15.6843L35.7145 16.8583C35.9497 16.9395 36.0894 17.1815 36.0421 17.4258L35.3594 20.9562L37.7159 23.6722C37.879 23.8602 37.879 24.1396 37.7159 24.3276L35.3594 27.0436L36.0421 30.574C36.0894 30.8184 35.9497 31.0603 35.7145 31.1415L32.3157 32.3155L31.1418 35.7142C31.0605 35.9495 30.8186 36.0892 30.5742 36.0419L27.0439 35.3592L24.3278 37.7156C24.1398 37.8787 23.8605 37.8787 23.6725 37.7156L20.9564 35.3592L17.4261 36.0419C17.1817 36.0892 16.9398 35.9495 16.8585 35.7142L15.6846 32.3155L12.2858 31.1415C12.0506 31.0603 11.9109 30.8184 11.9582 30.574L12.6409 27.0436L10.2844 24.3276C10.1213 24.1396 10.1213 23.8602 10.2844 23.6722L12.6409 20.9562L11.9582 17.4258C11.9109 17.1815 12.0506 16.9395 12.2858 16.8583L15.6846 15.6843L16.8585 12.2856C16.9398 12.0503 17.1817 11.9107 17.4261 11.9579L20.9564 12.6406L23.6725 10.2842ZM29.6921 19.1919C29.9361 18.9478 29.9361 18.552 29.6921 18.308C29.448 18.0639 29.0523 18.0639 28.8082 18.308L18.3082 28.808C18.0641 29.052 18.0641 29.4478 18.3082 29.6919C18.5523 29.9359 18.948 29.9359 19.1921 29.6919L29.6921 19.1919ZM20.4001 21.5499C21.0352 21.5499 21.5501 21.035 21.5501 20.3999C21.5501 19.7648 21.0352 19.2499 20.4001 19.2499C19.765 19.2499 19.2501 19.7648 19.2501 20.3999C19.2501 21.035 19.765 21.5499 20.4001 21.5499ZM20.4001 22.7999C21.7256 22.7999 22.8001 21.7254 22.8001 20.3999C22.8001 19.0744 21.7256 17.9999 20.4001 17.9999C19.0746 17.9999 18.0001 19.0744 18.0001 20.3999C18.0001 21.7254 19.0746 22.7999 20.4001 22.7999ZM28.7501 27.5999C28.7501 28.235 28.2352 28.7499 27.6001 28.7499C26.965 28.7499 26.4501 28.235 26.4501 27.5999C26.4501 26.9648 26.965 26.4499 27.6001 26.4499C28.2352 26.4499 28.7501 26.9648 28.7501 27.5999ZM30.0001 27.5999C30.0001 28.9254 28.9256 29.9999 27.6001 29.9999C26.2746 29.9999 25.2001 28.9254 25.2001 27.5999C25.2001 26.2744 26.2746 25.1999 27.6001 25.1999C28.9256 25.1999 30.0001 26.2744 30.0001 27.5999Z", fill: props.color || '#343E49' }) })));
};
var PercentageBadge = React__default.forwardRef(IconPercentageBadge);

var IconNotificationHorn = function (_a, svgRef) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, ref: svgRef, viewBox: "-5 -5 ".concat(size, " ").concat(size), fill: "none", stroke: "currentColor" }, props, { children: jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M24.4725 7.21411C24.2339 7.15985 23.9827 7.22465 23.8058 7.38662L14.7561 15.679L12.1694 16.5766C10.2882 17.2294 9.32094 19.236 10.0133 21.0495L10.5155 22.3651C11.029 23.7103 12.3143 24.5731 13.7116 24.6648L15.827 30.2061C16.2423 31.2941 17.4987 31.8607 18.6273 31.4691L19.3096 31.2323C20.4382 30.8407 21.0187 29.6366 20.6033 28.5486L20.3522 27.8908L21.0345 27.654C22.6578 27.0907 23.5939 25.5188 23.3774 23.9335L30.2925 24.3787C30.3946 24.385 30.4945 24.3712 30.5873 24.339C30.7176 24.2938 30.8341 24.2124 30.9196 24.1023C31.0662 23.9136 31.1031 23.6661 31.0185 23.4445L24.9918 7.65742C24.9071 7.43575 24.712 7.2688 24.4725 7.21411ZM11.8798 21.8915L11.3776 20.5759C10.9623 19.488 11.5427 18.2839 12.6713 17.8922L14.7183 17.1819L14.9694 17.8397L12.9224 18.55L13.4246 19.8656L15.4716 19.1553L15.9739 20.4708L13.9269 21.1812L14.4291 22.4968L16.4761 21.7864L16.7272 22.4442L14.6802 23.1546C13.5516 23.5462 12.2952 22.9795 11.8798 21.8915ZM18.807 29.9167C19.183 29.7863 19.3766 29.3846 19.2383 29.0222L17.2294 23.7598L15.1823 24.4702L17.1913 29.7325C17.3296 30.0949 17.7487 30.284 18.1247 30.1535L18.807 29.9167ZM20.5319 26.3384L19.8496 26.5752L18.7268 23.6342L21.8742 23.8367C22.1637 24.8745 21.5984 25.9683 20.5319 26.3384ZM18.1785 22.1982L29.2693 22.9123L24.0105 9.13676L15.9958 16.4807L18.1785 22.1982Z", fill: props.color || '#343E49' }) })));
};
var NotificationHorn = React__default.forwardRef(IconNotificationHorn);

var optionalCosentItems = [
    {
        icon: jsx(PercentageBadge, { size: 48 }),
        text: REBRANDING.CONSENTS.OPTIONAL_CONSENTS_ITEM_COMMUNICATIONS,
    },
    {
        icon: jsx(NotificationHorn, { size: 48 }),
        text: REBRANDING.CONSENTS.OPTIONAL_CONSENTS_ITEM_DIGITAL_MARKETING,
    },
];
var OptionalContentModal = function (_a) {
    var consents = _a.consents, onConsentClick = _a.onConsentClick;
    var _b = useState({}), thirdPartyTemplateConsent = _b[0], setThirdPartyTemplateConsent = _b[1];
    var renderItems = function (_items) {
        return (jsx(React__default.Fragment, { children: _items.map(function (_a, index) {
                var icon = _a.icon, text = _a.text;
                return (jsx("div", __assign({ className: styles$i['item-content'] }, { children: jsxs("div", __assign({ className: styles$i['item'] }, { children: [icon, jsx("span", { children: text })] })) }), index));
            }) }));
    };
    var renderBottomText = function (_thirdPartyTemplateConsent) {
        return (jsx(React__default.Fragment, { children: jsxs("p", { children: [REBRANDING.CONSENTS.OPTIONAL_CONSENTS_BOTTOM_TEXT_PREFIX, ' ', jsx("span", __assign({ onClick: function () { return onConsentClick(_thirdPartyTemplateConsent); } }, { children: REBRANDING.CONSENTS.OPTIONAL_CONSENTS_BOTTOM_TEXT_SUFFIX }))] }) }));
    };
    var handlePrivacyPolicy = function (_consents) {
        return _consents.find(function (_a) {
            var templateCategoryType = _a.templateCategoryType;
            return templateCategoryType === ConsentsTemplatesCategoryType.THIRD_PARTY_CONSENTS;
        });
    };
    useEffect(function () {
        var resultConsent = handlePrivacyPolicy(consents);
        setThirdPartyTemplateConsent(resultConsent);
    }, []);
    return (jsxs(React__default.Fragment, { children: [jsx("div", __assign({ className: styles$i['optional-items-container-modal'] }, { children: renderItems(optionalCosentItems) })), jsx("div", __assign({ className: styles$i['optional-bottom-text-container'] }, { children: renderBottomText(thirdPartyTemplateConsent) }))] }));
};

var css_248z$h = ".consentsBannerImage-module_consents-banner-container__shiiH .consentsBannerImage-module_consents-banner__7gmcX{width:auto}.consentsBannerImage-module_consents-banner-container__shiiH .consentsBannerImage-module_consents-banner__7gmcX img{border-radius:5px;height:200px;-o-object-fit:cover;object-fit:cover;width:504px}@media (max-width:639px){.consentsBannerImage-module_consents-banner-container__shiiH .consentsBannerImage-module_consents-banner__7gmcX img{width:100%}}";
var styles$h = {"consents-banner-container":"consentsBannerImage-module_consents-banner-container__shiiH","consents-banner":"consentsBannerImage-module_consents-banner__7gmcX"};
styleInject(css_248z$h);

var StorageType;
(function (StorageType) {
    StorageType["Session"] = "session";
    StorageType["Local"] = "local";
})(StorageType || (StorageType = {}));
var BrowserStorage = /** @class */ (function () {
    function BrowserStorage(type) {
        this.storageName = "".concat(type, "Storage");
    }
    BrowserStorage.prototype.getItem = function (key) {
        if (!isBrowser$1())
            return '';
        return window[this.storageName].getItem(key);
    };
    BrowserStorage.prototype.setItem = function (key, value) {
        if (!isBrowser$1())
            return;
        window[this.storageName].setItem(key, value);
    };
    BrowserStorage.prototype.removeItem = function (key) {
        if (!isBrowser$1())
            return;
        window[this.storageName].removeItem(key);
    };
    BrowserStorage.prototype.clear = function () {
        if (!isBrowser$1())
            return;
        window[this.storageName].clear();
    };
    BrowserStorage.prototype.key = function (index) {
        if (!isBrowser$1())
            return '';
        return window[this.storageName].key(index);
    };
    Object.defineProperty(BrowserStorage.prototype, "length", {
        get: function () {
            return window[this.storageName].length || 0;
        },
        enumerable: false,
        configurable: true
    });
    return BrowserStorage;
}());

var TIMEOUT_MILLISECONDS = 3000;
var MAX_RETRY = 3;
var sessionStorage$1 = new BrowserStorage(StorageType.Session);
function getNamespace() {
    var _a, _b;
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
        return 'web';
    }
    var siteName = getSiteName();
    var isAgentLoggedIn = Boolean(getCookie('AGENT_INFO'));
    if (isAgentLoggedIn)
        return "".concat(siteName !== 'falabella' ? "".concat(siteName, "_") : '', "call_center");
    var isKioskLoggedIn = getIsKiosko();
    if (isKioskLoggedIn)
        return "".concat(siteName !== 'falabella' ? "".concat(siteName, "_") : '', "kiosk");
    if (siteName !== 'falabella') {
        return ((_a = window.matchMedia('(max-width: 767px)')) === null || _a === void 0 ? void 0 : _a.matches)
            ? "".concat(siteName, "_mobile")
            : "".concat(siteName, "_web");
    }
    return ((_b = window.matchMedia('(max-width: 767px)')) === null || _b === void 0 ? void 0 : _b.matches) ? 'mobile' : 'web';
}
function getCommerceConfigKey(tenantCode) {
    var _a, _b;
    var namespace = (_b = (_a = getNamespace()) === null || _a === void 0 ? void 0 : _a.toUpperCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    return "commerceConfig_".concat(tenantCode, "_").concat(namespace);
}
var commerceConfigURL = function (tenantCode, commerceConfigInUrl) {
    var _a, _b;
    if (!isBrowser$1())
        return null;
    var isBetaEnvironment = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) === null || _b === void 0 ? void 0 : _b.includes('beta');
    return "/s/".concat(commerceConfigInUrl, "/v1/").concat(tenantCode).concat(isBetaEnvironment ? '_BETA' : '', "/commerce-config/merged?namespace=").concat(getNamespace());
};
function isErrorStatus(status) {
    return status < 200 || status > 299;
}
function retrieveCommerceConfig(tenantCode, key) {
    var jsonString = sessionStorage$1.getItem(key);
    try {
        var commerceConfig = JSON.parse(jsonString);
        if (commerceConfig.tenant === tenantCode)
            return commerceConfig;
        return undefined;
    }
    catch (error) {
        return undefined;
    }
}
function storeCommerceConfig(tenantCode, commerceConfig, key) {
    if ((commerceConfig === null || commerceConfig === void 0 ? void 0 : commerceConfig.tenant) !== tenantCode)
        return;
    var filteredToggles = getFilteredToggles(commerceConfig);
    var filteredConfigurations = getFilteredConfigurations(commerceConfig);
    var commerceConfigSubSet = {
        tenant: commerceConfig.tenant,
        namespace: commerceConfig.namespace,
        toggles: filteredToggles,
        configurations: filteredConfigurations,
    };
    try {
        sessionStorage$1.setItem(key, JSON.stringify(commerceConfigSubSet));
    }
    catch (error) {
        // Ignore
    }
}
function clearOtherCommerceConfigs(cacheKey) {
    var baseKey = cacheKey.split('_').slice(0, 2).join('_');
    for (var i = sessionStorage$1.length - 1; i >= 0; i--) {
        var key = sessionStorage$1.key(i);
        if (key && key.startsWith(baseKey) && key !== cacheKey) {
            sessionStorage$1.removeItem(key);
        }
    }
}
function fetchCommerceConfig(tenant) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, tenantCode, commerceConfigInUrl, currentKey, storedCommerceConfig, url, abortController, timeoutID, response, commerceConfig;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!tenant)
                        return [2 /*return*/, {}];
                    _a = getSodimacBusinessScopeConfig(tenant), tenantCode = _a.tenantCode, commerceConfigInUrl = _a.commerceConfigInUrl;
                    currentKey = getCommerceConfigKey(tenantCode);
                    storedCommerceConfig = retrieveCommerceConfig(tenantCode, currentKey);
                    if (storedCommerceConfig) {
                        clearOtherCommerceConfigs(currentKey);
                        return [2 /*return*/, storedCommerceConfig];
                    }
                    url = commerceConfigURL(tenantCode, commerceConfigInUrl);
                    abortController = new AbortController();
                    timeoutID = setTimeout(function () { return abortController.abort(); }, TIMEOUT_MILLISECONDS);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            signal: abortController.signal,
                        })];
                case 2:
                    response = _b.sent();
                    clearTimeout(timeoutID);
                    if (isErrorStatus(response.status))
                        return [2 /*return*/, {}];
                    return [4 /*yield*/, response.json()];
                case 3:
                    commerceConfig = _b.sent();
                    storeCommerceConfig(tenantCode, commerceConfig, currentKey);
                    clearOtherCommerceConfigs(currentKey);
                    return [2 /*return*/, commerceConfig];
                case 4:
                    _b.sent();
                    clearTimeout(timeoutID);
                    return [2 /*return*/, {}];
                case 5: return [2 /*return*/];
            }
        });
    });
}
var CommerceConfigContext = createContext({
    isLoading: false,
    commerceConfig: {},
});
var CommerceConfigProvider = function (_a) {
    var children = _a.children, tenant = _a.tenant, countryCode = _a.countryCode, initialCommerceConfig = _a.commerceConfig;
    var _b = useState(initialCommerceConfig || {}), commerceConfig = _b[0], setCommerceConfig = _b[1];
    var _c = useState(false), isLoading = _c[0], setLoading = _c[1];
    var _d = useState(0), retryCount = _d[0], setRetryCount = _d[1];
    var countryInfo = countryCode || tenant;
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((commerceConfig === null || commerceConfig === void 0 ? void 0 : commerceConfig.tenant) || retryCount >= MAX_RETRY)
                            return [2 /*return*/];
                        setLoading(true);
                        return [4 /*yield*/, fetchCommerceConfig(countryInfo)];
                    case 1:
                        response = _a.sent();
                        if (response === null || response === void 0 ? void 0 : response.tenant) {
                            setCommerceConfig(response);
                            setLoading(false);
                        }
                        else {
                            setRetryCount(function (prev) { return prev + 1; });
                            setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData().catch(function (error) {
            console.error('Error fetching commerce config:', error);
            setLoading(false);
        });
    }, [commerceConfig, countryInfo, retryCount]);
    return (jsx(CommerceConfigContext.Provider, __assign({ value: { isLoading: isLoading, commerceConfig: commerceConfig } }, { children: children })));
};

var FUNC_ERROR_TEXT = 'Expected a function';
var HASH_UNDEFINED = '__lodash_hash_undefined__';
var INFINITY = 1 / 0;
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reEscapeChar = /\\(\\)?/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function('return this')();
function getValue(object, key) {
  return object == null ? undefined : object[key];
}
function isHostObject(value) {
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
var coreJsData = root['__core-js_shared__'];
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());
var funcToString = funcProto.toString;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
var objectToString = objectProto.toString;
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);
var Symbol$1 = root.Symbol,
    splice = arrayProto.splice;
var Map$1 = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
}
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear() {
  this.__data__ = [];
}
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  var index = 0,
      length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function baseToString(value) {
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}
var stringToPath = memoize(function(string) {
  string = toString(string);
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}
memoize.Cache = MapCache;
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}
var isArray = Array.isArray;
function isFunction(value) {
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}
function toString(value) {
  return value == null ? '' : baseToString(value);
}
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}
var lodash_get = get;

var useCommerceConfig = function (path) {
    if (path === void 0) { path = ''; }
    var commerceConfig = useContext(CommerceConfigContext).commerceConfig;
    return lodash_get(commerceConfig, path, {});
};
function getFilteredConfigurations(commerceConfig) {
    // Add any configuration keys here that you want to persist from the full commerceConfig
    var allowedConfigurations = ['ALERTS', 'LOGIN_TRANSLATIONS', 'logos', 'loginConfigs'];
    var filteredConfigurations = {};
    for (var _i = 0, allowedConfigurations_1 = allowedConfigurations; _i < allowedConfigurations_1.length; _i++) {
        var configKey = allowedConfigurations_1[_i];
        if (configKey in commerceConfig.configurations) {
            filteredConfigurations[configKey] = commerceConfig.configurations[configKey];
        }
    }
    return filteredConfigurations;
}
function getFilteredToggles(commerceConfig) {
    // Add any toggle keys here that you want to persist from the full commerceConfig
    var allowedToggles = [
        'FEATURE_TOGGLE_HIDE_CONSENT_IMAGE',
        'ENABLE_NEW_OTP_FLOW',
        'ENABLE_SMS_OPTION',
    ];
    var filteredToggles = {};
    for (var _i = 0, allowedToggles_1 = allowedToggles; _i < allowedToggles_1.length; _i++) {
        var toggle = allowedToggles_1[_i];
        if (toggle in commerceConfig.toggles) {
            filteredToggles[toggle] = commerceConfig.toggles[toggle];
        }
    }
    return filteredToggles;
}

var ConsentsBannerImage = function (_a) {
    _a.tenant; var bannerSrc = _a.bannerSrc, altText = _a.altText, titleText = _a.titleText; _a.isRebrandingEnabled;
    var toggles = useCommerceConfig('toggles');
    var shouldHideConsentImage = toggles.FEATURE_TOGGLE_HIDE_CONSENT_IMAGE || false;
    var renderBannerContent = function (_tenant, _bannerSrc) {
        if (shouldHideConsentImage) {
            return null;
        }
        return (jsx("div", __assign({ className: styles$h['consents-banner-container'] }, { children: jsx("div", __assign({ className: styles$h['consents-banner'] }, { children: jsx("img", { src: bannerSrc, alt: altText, title: titleText }) })) })));
    };
    return jsx(React__default.Fragment, { children: renderBannerContent() });
};

var css_248z$g = ".consentsTopActions-module_top-bar__JHGHS{align-items:center;display:flex;justify-content:center;margin-top:12px}@media (min-width:639px){.consentsTopActions-module_top-bar__JHGHS{display:none}}.consentsTopActions-module_top-bar__JHGHS span{background-color:#a9b5c0;border-radius:12px;height:5px;width:40px}.consentsTopActions-module_icon-rebranded__ePmaN{align-items:center;cursor:pointer;display:flex;justify-content:flex-end;padding:0 14px 16px 8px}@media (min-width:639px){.consentsTopActions-module_icon-rebranded__ePmaN{padding:12px 14px 16px 8px}}";
var styles$g = {"top-bar":"consentsTopActions-module_top-bar__JHGHS","icon-rebranded":"consentsTopActions-module_icon-rebranded__ePmaN"};
styleInject(css_248z$g);

var ConsentsTopAction = function (_a) {
    var tenant = _a.tenant, isOnlyOptional = _a.isOnlyOptional, onCloseConsents = _a.onCloseConsents;
    //
    var renderTopContent = function (_tenant, _isOnlyOptional, _onCloseConsents) {
        return (jsxs(React__default.Fragment, { children: [_tenant !== Tenant.Peru && (jsx("div", __assign({ className: styles$g['top-bar'] }, { children: jsx("span", {}) }))), jsx("div", __assign({ className: styles$g['icon-rebranded'] }, { children: _isOnlyOptional && (jsx(X$1, { color: "#333333", onClick: _onCloseConsents, size: 18, id: "close-modal-optional-consent" })) }))] }));
    };
    return (jsx(React__default.Fragment, { children: renderTopContent(tenant, isOnlyOptional, onCloseConsents) }));
};

function groupConsents$1(consents) {
    var groupedConsentMap = {};
    var consentGroups = new Set();
    var ungroupedConsents = [];
    var atomicConsents = consents.filter(function (_a) {
        var templateAtomic = _a.templateAtomic;
        return !!templateAtomic;
    });
    atomicConsents.forEach(function (consent) {
        var templateGroup = consent.templateGroup;
        if (!templateGroup || Number.isNaN(templateGroup)) {
            ungroupedConsents.push([consent]);
            return;
        }
        groupedConsentMap[templateGroup] = __spreadArray(__spreadArray([], (groupedConsentMap[templateGroup] || []), true), [consent], false);
        consentGroups.add(templateGroup);
    });
    var sortedConsentGroups = Array.from(consentGroups).sort(function (a, b) { return Number(a) - Number(b); });
    return __spreadArray(__spreadArray([], sortedConsentGroups.reduce(function (acc, group) { return __spreadArray(__spreadArray([], acc, true), [groupedConsentMap[group]], false); }, []), true), ungroupedConsents, true);
}
var linksRegExp$1 = /(\[[^[\]]+|\][^[\]]+|[^[\]]+)/g;
var typeMap$1 = {
    '[': 'link',
    ']': 'text',
};
function getDisplayTextsWithType$1(text) {
    var matches = "]".concat(text).match(linksRegExp$1);
    return matches.map(function (match) {
        var _a = [match.slice(0, 1), match.slice(1)], typeSymbol = _a[0], displayText = _a[1];
        return [typeMap$1[typeSymbol], displayText];
    });
}
var Consents$1 = function (_a) {
    var catalystBaseUrl = _a.catalystBaseUrl, consents = _a.consents, id = _a.id, onConsentClick = _a.onConsentClick, onConsentsUpdate = _a.onConsentsUpdate, tenant = _a.tenant, isRebrandingEnabled = _a.isRebrandingEnabled, onCloseConsents = _a.onCloseConsents, isOnlyOptional = _a.isOnlyOptional;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(undefined), alert = _c[0], setAlert = _c[1];
    var _d = useState(create({})), schema = _d[0], setSchema = _d[1];
    var _e = useState(false), isOptionalDisable = _e[0], setIsOptionalDisable = _e[1];
    var idAcceptButton = "accept-modal-".concat(!isOnlyOptional ? 'mandatory' : 'optional', "-consent");
    var isMobile = screenDimension().isMobile;
    var combinedConsents = groupConsents$1(consents);
    var siteName = getSiteName();
    useEffect(function () {
        var firstTemplateNames = combinedConsents.map(function (consentGroup) { return consentGroup[0].templateName; });
        var newSchema = consents
            .filter(function (consent) {
            return consent.templateAtomic === true &&
                firstTemplateNames.includes(consent.templateName) &&
                consent.isMandatory;
        })
            .reduce(function (acc, consent) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[consent.templateName] = create$2()
                .required()
                .oneOf([true], 'Debe aceptar el consentimiento'), _a)));
        }, {});
        setSchema(create(newSchema));
    }, [consents]);
    var validate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, optionalConsentKey, mandatoryConsentKey, _isOptionalDisable, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = getSodimacBusinessScopeConfig(tenant), optionalConsentKey = _a.optionalConsentKey, mandatoryConsentKey = _a.mandatoryConsentKey;
                    _isOptionalDisable = isOnlyOptional
                        ? !values[optionalConsentKey]
                        : !values[mandatoryConsentKey];
                    setIsOptionalDisable(_isOptionalDisable);
                    return [4 /*yield*/, schema.validate(values, { abortEarly: false })];
                case 1:
                    _b.sent();
                    return [2 /*return*/, {}];
                case 2:
                    err_1 = _b.sent();
                    return [2 /*return*/, err_1.inner.reduce(function (acc, current) {
                            acc[current.path] = current.message;
                            return acc;
                        }, {})];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var isTemplateSelected = function (templateName, values) {
        var selectedValues = Object.keys(values).filter(function (key) { return values[key] === true; });
        var templateGroupToCheck = combinedConsents.find(function (consentGroup) {
            return consentGroup.some(function (consent) { return consent.templateName === templateName; });
        });
        var firstTemplate = templateGroupToCheck[0];
        return selectedValues.includes(firstTemplate.templateName);
    };
    var submitHandler = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var date, consentsParams, response, errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setAlert(undefined);
                    date = new Date();
                    consentsParams = {
                        consentTemplateId: !isOnlyOptional
                            ? consents.find(function (consent) { return consent.templateAtomic === false; }).templateId
                            : consents.find(function (_consentItem) {
                                return _consentItem.templateCategoryType ===
                                    ConsentsTemplatesCategoryType.THIRD_PARTY_CONSENTS;
                            }).templateId,
                        consentStatusId: ConsentTemplateStatus.ACEPTED,
                        context: {
                            dateTimeChannel: date.toISOString(),
                            experience: 'LOG',
                        },
                        evidence: {
                            deviceIdentifier: generateDeviceIdentifier(),
                            version: '001',
                        },
                        consentDate: getConsentDateInLocalTimeFormatWithTimeZone(),
                    };
                    if (!isOnlyOptional) {
                        Object.assign(consentsParams, {
                            relatedConsentStatus: consents
                                .filter(function (consent) { return (consent === null || consent === void 0 ? void 0 : consent.templateAtomic) === true; })
                                .map(function (template) {
                                return {
                                    consentTemplateId: template.templateId,
                                    consentStatusId: isTemplateSelected(template === null || template === void 0 ? void 0 : template.templateName, values)
                                        ? ConsentTemplateStatus.ACEPTED
                                        : ConsentTemplateStatus.NOT_ACEPTED,
                                    templateCategoryType: template.templateCategoryType,
                                };
                            }),
                        });
                    }
                    return [4 /*yield*/, saveUserConsent({
                            consent: consentsParams,
                            tenantId: tenantId(tenant),
                            catalystBaseUrl: catalystBaseUrl,
                        })];
                case 1:
                    response = _a.sent();
                    if (!onConsentsUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, onConsentsUpdate(response)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    errors = response.errors;
                    if (errors.length > 0) {
                        setAlert({ type: 'warning', children: errors[0].message });
                    }
                    setLoading(false);
                    actions && actions.setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onConsentClickHandler = function (template) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, onConsentClick(template)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getLinkedMessage = function (templates, onConsentClickHandler) {
        return templates.flatMap(function (template) {
            var displayTextsWithType = getDisplayTextsWithType$1(template.displayText);
            return displayTextsWithType.map(function (_a) {
                var type = _a[0], displayText = _a[1];
                if (type === 'text')
                    return displayText;
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                return jsx("a", __assign({ onClick: function () { return onConsentClickHandler(template); } }, { children: displayText }));
            });
        });
    };
    var renderConsentLabel = function (templates) {
        return (jsx("div", __assign({ className: styles$j['consent-label'] }, { children: getLinkedMessage(templates, onConsentClickHandler) })));
    };
    var renderConsentControl = function (_a, formikProps) {
        var _b = _a.templateName, templateName = _b === void 0 ? '' : _b;
        if (formikProps === void 0) { formikProps = {}; }
        return isRebrandingEnabled ? (jsxs("div", __assign({ className: styles$j['consent-control'] }, { children: [jsx("input", __assign({ id: templateName, name: templateName, type: "checkbox" }, formikProps, { className: "square-round-checkbox" })), jsx("label", { htmlFor: templateName })] }))) : (jsx("div", __assign({ className: styles$j['consent-control'] }, { children: jsxs("label", __assign({ htmlFor: templateName, className: "pure-material-switch" }, { children: [jsx("input", __assign({ id: templateName, name: templateName, type: "checkbox" }, formikProps)), jsx("span", { className: styles$j['consent-label'] })] })) })));
    };
    var renderConsentCheckbox = function (templates, getFieldProps) {
        var label = renderConsentLabel(templates);
        var firstTemplateIndex = 0;
        var firstTemplate = templates[firstTemplateIndex];
        var firstTemplateFormikProps = getFieldProps(firstTemplate.templateName);
        var control = renderConsentControl(firstTemplate, firstTemplateFormikProps);
        return (jsx("div", __assign({ className: styles$j['consent-item'] }, { children: isRebrandingEnabled ? (jsxs(Fragment, { children: [control, label] })) : (jsxs(Fragment, { children: [label, control] })) }), "u_l-".concat(firstTemplate.templateName, "-checkbox")));
    };
    var handleRenderForm = function (_tenant, _isOnlyOptional, _getFieldProps) {
        //
        var resultNode = (jsxs(React__default.Fragment, { children: [alert && jsx(Alert$1, __assign({}, alert)), combinedConsents.map(function (templates) {
                    return renderConsentCheckbox(templates, _getFieldProps);
                })] }));
        if (_tenant === Tenant.Chile && _isOnlyOptional) {
            resultNode = (jsx(OptionalContentModal, { consents: consents, isMobile: isMobile, onConsentClick: onConsentClick }));
        }
        return resultNode;
    };
    return (jsxs("div", __assign({ id: "modal-".concat(!isOnlyOptional ? 'mandatory' : 'optional', "-consent") }, { children: [jsx(ConsentsTopAction, { tenant: tenant, isOnlyOptional: isOnlyOptional, onCloseConsents: onCloseConsents }), jsxs("div", __assign({ id: id, className: clsx(styles$j['falw-consents-root'], isRebrandingEnabled && styles$j['falw-consents-root-rebranded'], isRebrandingEnabled && styles$j['falw-consents-root-rebranded']) }, { children: [jsx(ConsentsBannerImage, { tenant: tenant, bannerSrc: siteName === 'sodimac' ? img$2 : img$3, isRebrandingEnabled: isRebrandingEnabled }), jsxs("div", __assign({ className: clsx(styles$j['consents-body-container'], tenant === Tenant.Peru && styles$j['pe']) }, { children: [jsx(ConsentsIntroTitle, { tenant: tenant, isMobile: isMobile }), jsx(ConsentsIntroMessage, { tenant: tenant, isRebrandingEnabled: isRebrandingEnabled, isMobile: isMobile, isOnlyOptional: isOnlyOptional }), loading && (jsx("div", __assign({ className: styles$j['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles$j.spinner }) }))), jsx(Formik, __assign({ initialValues: {}, validate: validate, onSubmit: submitHandler }, { children: function (_a) {
                                    var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty, getFieldProps = _a.getFieldProps;
                                    var disabled = !(isValid && dirty) || isSubmitting || isOptionalDisable;
                                    return (jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$j['form-content'], loading && styles$j.disabled) }, { children: [handleRenderForm(tenant, isOnlyOptional, getFieldProps), jsx("div", __assign({ className: clsx(styles$j['actions-wrapper'], !isOnlyOptional && styles$j['mt-30']) }, { children: jsx(ButtonNew, { type: "submit", label: isRebrandingEnabled ? REBRANDING.CONSENTS.MODAL_SUBMIT_NEW : SIGN_IN, color: "primary", block: true, uppercased: !isRebrandingEnabled, disabled: isOnlyOptional && tenant === Tenant.Chile ? false : disabled, isRebrandingEnabled: isRebrandingEnabled, id: idAcceptButton, onClick: function () {
                                                        track(idAcceptButton);
                                                        if (tenant === Tenant.Chile && isOnlyOptional) {
                                                            submitHandler(null, null);
                                                        }
                                                    } }) }))] })));
                                } }))] }))] }))] })));
};

var css_248z$f = ".legal-text-view-module_falw-legal-text-root__wms0j{flex:1 1 0%;font-size:14px;max-height:600px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.legal-text-view-module_falw-legal-text-root__wms0j *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.legal-text-view-module_falw-legal-text-root__wms0j *,.legal-text-view-module_falw-legal-text-root__wms0j :after,.legal-text-view-module_falw-legal-text-root__wms0j :before{box-sizing:border-box}.legal-text-view-module_falw-legal-text-root__wms0j blockquote,.legal-text-view-module_falw-legal-text-root__wms0j dd,.legal-text-view-module_falw-legal-text-root__wms0j dl,.legal-text-view-module_falw-legal-text-root__wms0j figure,.legal-text-view-module_falw-legal-text-root__wms0j h1,.legal-text-view-module_falw-legal-text-root__wms0j h2,.legal-text-view-module_falw-legal-text-root__wms0j h3,.legal-text-view-module_falw-legal-text-root__wms0j h4,.legal-text-view-module_falw-legal-text-root__wms0j h5,.legal-text-view-module_falw-legal-text-root__wms0j h6,.legal-text-view-module_falw-legal-text-root__wms0j hr,.legal-text-view-module_falw-legal-text-root__wms0j p,.legal-text-view-module_falw-legal-text-root__wms0j pre{margin:0}.legal-text-view-module_falw-legal-text-root__wms0j b{font-weight:700}.legal-text-view-module_legal-text-content__2enZZ{color:#767676;height:526px;line-height:21px;overflow:auto;padding:32px}.legal-text-view-module_legal-text-header__FxVdh{align-items:center;background-color:#f8f8f8;box-shadow:0 4px 4px rgba(0,0,0,.07);color:#767676;display:flex;font-weight:700;height:74px;justify-content:space-between;padding-left:16px;padding-right:16px;text-align:center}.legal-text-view-module_legal-text-header__FxVdh .legal-text-view-module_header-ctrl__bIeCh{width:32px}.legal-text-view-module_legal-text-header__FxVdh .legal-text-view-module_header-ctrl__bIeCh button{background-color:transparent;border-style:solid;border-width:0;color:#767676;cursor:pointer;padding:4px}.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-content__2enZZ{font-size:16px;line-height:19px;padding:35px 30px}@media (max-width:640px){.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-content__2enZZ{height:auto;padding:31px 20px}}.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-header__FxVdh{font-size:16px;justify-content:flex-start;line-height:19px;padding-left:17px;padding-right:17px}.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-header__FxVdh .legal-text-view-module_header-ctrl__bIeCh{margin-right:19px}.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-header__FxVdh .legal-text-view-module_header-ctrl__bIeCh button{color:#333;height:auto;margin:0;width:auto}.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-header__FxVdh .legal-text-view-module_header-ctrl__bIeCh button svg{width:16px}.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-header__FxVdh span{align-items:center;display:flex;height:100%;justify-content:flex-start;max-height:24px;text-align:left}@media (max-width:640px){.legal-text-view-module_falw-legal-text-root-rebranded__AxY-g .legal-text-view-module_legal-text-header__FxVdh span{max-height:35px}}";
var styles$f = {"falw-legal-text-root":"legal-text-view-module_falw-legal-text-root__wms0j","legal-text-content":"legal-text-view-module_legal-text-content__2enZZ","legal-text-header":"legal-text-view-module_legal-text-header__FxVdh","header-ctrl":"legal-text-view-module_header-ctrl__bIeCh","falw-legal-text-root-rebranded":"legal-text-view-module_falw-legal-text-root-rebranded__AxY-g"};
styleInject(css_248z$f);

var LegalText = function (_a) {
    var html = _a.html, title = _a.title, onBack = _a.onBack, id = _a.id, props = __rest(_a, ["html", "title", "onBack", "id"]);
    return (jsxs("div", __assign({ id: id, className: clsx(styles$f['falw-legal-text-root'], props.isRebrandingEnabled && styles$f['falw-legal-text-root-rebranded']) }, { children: [jsxs("div", __assign({ className: styles$f['legal-text-header'] }, { children: [jsx("div", __assign({ className: styles$f['header-ctrl'] }, { children: jsx("button", __assign({ onClick: onBack }, { children: jsx(ArrowLeft, { size: 16 }) })) })), jsx("span", { children: title }), !props.isRebrandingEnabled && jsx("div", { className: styles$f['header-ctrl'] })] })), jsx("div", { className: styles$f['legal-text-content'], dangerouslySetInnerHTML: { __html: html } })] })));
};

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = [].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead';
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain';
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  }
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;
      do {
        if (next && parent.isSameNode(next)) {
          return true;
        }
        next = next.parentNode || next.host;
      } while (next);
    }
  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument :
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    element.assignedSlot ||
    element.parentNode || (
    isShadowRoot(element) ? element.host : null) ||
    getDocumentElement(element)
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode);
    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
};
function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
}
var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
}
var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
}
var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {});
  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper;
        if (!areValidElements(reference, popper)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
popperGenerator();

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = popperGenerator({
  defaultModifiers: defaultModifiers
});

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    if (hasElementType && a instanceof Element) return false;
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        continue;
      }
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    return true;
  }
  return a !== a && b !== b;
}
var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function useGetLatest(val) {
  var ref = React.useRef(val);
  ref.current = val;
  return React.useCallback(function () {
    return ref.current;
  }, []);
}
var noop = function noop() {
};
function useControlledState(_ref) {
  var initial = _ref.initial,
      value = _ref.value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange;
  if (initial === undefined && value === undefined) {
    throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
  }
  var _React$useState = React.useState(initial),
      state = _React$useState[0],
      setState = _React$useState[1];
  var getLatest = useGetLatest(state);
  var set = React.useCallback(function (updater) {
    var state = getLatest();
    var updatedState = typeof updater === 'function' ? updater(state) : updater;
    if (typeof updatedState.persist === 'function') updatedState.persist();
    setState(updatedState);
    if (typeof onChange === 'function') onChange(updatedState);
  }, [getLatest, onChange]);
  var isControlled = value !== undefined;
  return [isControlled ? value : state, isControlled ? onChange : set];
}
function generateBoundingClientRect(x, y) {
  if (x === void 0) {
    x = 0;
  }
  if (y === void 0) {
    y = 0;
  }
  return function () {
    return {
      width: 0,
      height: 0,
      top: y,
      right: x,
      bottom: y,
      left: x,
      x: 0,
      y: 0,
      toJSON: function toJSON() {
        return null;
      }
    };
  };
}
var _excluded = ["styles", "attributes"];
var virtualElement = {
  getBoundingClientRect: generateBoundingClientRect()
};
var defaultConfig = {
  closeOnOutsideClick: true,
  closeOnTriggerHidden: false,
  defaultVisible: false,
  delayHide: 0,
  delayShow: 0,
  followCursor: false,
  interactive: false,
  mutationObserverOptions: {
    attributes: true,
    childList: true,
    subtree: true
  },
  offset: [0, 6],
  trigger: 'hover'
};
function usePopperTooltip(config, popperOptions) {
  var _popperProps$state, _popperProps$state$mo, _popperProps$state$mo2;
  if (config === void 0) {
    config = {};
  }
  if (popperOptions === void 0) {
    popperOptions = {};
  }
  var finalConfig = Object.keys(defaultConfig).reduce(function (config, key) {
    var _extends2;
    return _extends({}, config, (_extends2 = {}, _extends2[key] = config[key] !== undefined ? config[key] : defaultConfig[key], _extends2));
  }, config);
  var defaultModifiers = React.useMemo(function () {
    return [{
      name: 'offset',
      options: {
        offset: finalConfig.offset
      }
    }];
  },
  Array.isArray(finalConfig.offset) ? finalConfig.offset : []);
  var finalPopperOptions = _extends({}, popperOptions, {
    placement: popperOptions.placement || finalConfig.placement,
    modifiers: popperOptions.modifiers || defaultModifiers
  });
  var _React$useState = React.useState(null),
      triggerRef = _React$useState[0],
      setTriggerRef = _React$useState[1];
  var _React$useState2 = React.useState(null),
      tooltipRef = _React$useState2[0],
      setTooltipRef = _React$useState2[1];
  var _useControlledState = useControlledState({
    initial: finalConfig.defaultVisible,
    value: finalConfig.visible,
    onChange: finalConfig.onVisibleChange
  }),
      visible = _useControlledState[0],
      setVisible = _useControlledState[1];
  var timer = React.useRef();
  React.useEffect(function () {
    return function () {
      return clearTimeout(timer.current);
    };
  }, []);
  var _usePopper = usePopper(finalConfig.followCursor ? virtualElement : triggerRef, tooltipRef, finalPopperOptions),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popperProps = _objectWithoutPropertiesLoose(_usePopper, _excluded);
  var update = popperProps.update;
  var getLatest = useGetLatest({
    visible: visible,
    triggerRef: triggerRef,
    tooltipRef: tooltipRef,
    finalConfig: finalConfig
  });
  var isTriggeredBy = React.useCallback(function (trigger) {
    return Array.isArray(finalConfig.trigger) ? finalConfig.trigger.includes(trigger) : finalConfig.trigger === trigger;
  },
  Array.isArray(finalConfig.trigger) ? finalConfig.trigger : [finalConfig.trigger]);
  var hideTooltip = React.useCallback(function () {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(function () {
      return setVisible(false);
    }, finalConfig.delayHide);
  }, [finalConfig.delayHide, setVisible]);
  var showTooltip = React.useCallback(function () {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(function () {
      return setVisible(true);
    }, finalConfig.delayShow);
  }, [finalConfig.delayShow, setVisible]);
  var toggleTooltip = React.useCallback(function () {
    if (getLatest().visible) {
      hideTooltip();
    } else {
      showTooltip();
    }
  }, [getLatest, hideTooltip, showTooltip]);
  React.useEffect(function () {
    if (!getLatest().finalConfig.closeOnOutsideClick) return;
    var handleClickOutside = function handleClickOutside(event) {
      var _event$composedPath;
      var _getLatest = getLatest(),
          tooltipRef = _getLatest.tooltipRef,
          triggerRef = _getLatest.triggerRef;
      var target = (event.composedPath == null ? void 0 : (_event$composedPath = event.composedPath()) == null ? void 0 : _event$composedPath[0]) || event.target;
      if (target instanceof Node) {
        if (tooltipRef != null && triggerRef != null && !tooltipRef.contains(target) && !triggerRef.contains(target)) {
          hideTooltip();
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [getLatest, hideTooltip]);
  React.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('click')) return;
    triggerRef.addEventListener('click', toggleTooltip);
    return function () {
      return triggerRef.removeEventListener('click', toggleTooltip);
    };
  }, [triggerRef, isTriggeredBy, toggleTooltip]);
  React.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('right-click')) return;
    var preventDefaultAndToggle = function preventDefaultAndToggle(event) {
      event.preventDefault();
      toggleTooltip();
    };
    triggerRef.addEventListener('contextmenu', preventDefaultAndToggle);
    return function () {
      return triggerRef.removeEventListener('contextmenu', preventDefaultAndToggle);
    };
  }, [triggerRef, isTriggeredBy, toggleTooltip]);
  React.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('focus')) return;
    triggerRef.addEventListener('focus', showTooltip);
    triggerRef.addEventListener('blur', hideTooltip);
    return function () {
      triggerRef.removeEventListener('focus', showTooltip);
      triggerRef.removeEventListener('blur', hideTooltip);
    };
  }, [triggerRef, isTriggeredBy, showTooltip, hideTooltip]);
  React.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('hover')) return;
    triggerRef.addEventListener('mouseenter', showTooltip);
    triggerRef.addEventListener('mouseleave', hideTooltip);
    return function () {
      triggerRef.removeEventListener('mouseenter', showTooltip);
      triggerRef.removeEventListener('mouseleave', hideTooltip);
    };
  }, [triggerRef, isTriggeredBy, showTooltip, hideTooltip]);
  React.useEffect(function () {
    if (tooltipRef == null || !getLatest().finalConfig.interactive) return;
    tooltipRef.addEventListener('mouseenter', showTooltip);
    tooltipRef.addEventListener('mouseleave', hideTooltip);
    return function () {
      tooltipRef.removeEventListener('mouseenter', showTooltip);
      tooltipRef.removeEventListener('mouseleave', hideTooltip);
    };
  }, [tooltipRef, showTooltip, hideTooltip, getLatest]);
  var isReferenceHidden = popperProps == null ? void 0 : (_popperProps$state = popperProps.state) == null ? void 0 : (_popperProps$state$mo = _popperProps$state.modifiersData) == null ? void 0 : (_popperProps$state$mo2 = _popperProps$state$mo.hide) == null ? void 0 : _popperProps$state$mo2.isReferenceHidden;
  React.useEffect(function () {
    if (finalConfig.closeOnTriggerHidden && isReferenceHidden) hideTooltip();
  }, [finalConfig.closeOnTriggerHidden, hideTooltip, isReferenceHidden]);
  React.useEffect(function () {
    if (!finalConfig.followCursor || triggerRef == null) return;
    function setMousePosition(_ref) {
      var clientX = _ref.clientX,
          clientY = _ref.clientY;
      virtualElement.getBoundingClientRect = generateBoundingClientRect(clientX, clientY);
      update == null ? void 0 : update();
    }
    triggerRef.addEventListener('mousemove', setMousePosition);
    return function () {
      return triggerRef.removeEventListener('mousemove', setMousePosition);
    };
  }, [finalConfig.followCursor, triggerRef, update]);
  React.useEffect(function () {
    if (tooltipRef == null || update == null || finalConfig.mutationObserverOptions == null) return;
    var observer = new MutationObserver(update);
    observer.observe(tooltipRef, finalConfig.mutationObserverOptions);
    return function () {
      return observer.disconnect();
    };
  }, [finalConfig.mutationObserverOptions, tooltipRef, update]);
  var getTooltipProps = function getTooltipProps(args) {
    if (args === void 0) {
      args = {};
    }
    return _extends({}, args, {
      style: _extends({}, args.style, styles.popper)
    }, attributes.popper, {
      'data-popper-interactive': finalConfig.interactive
    });
  };
  var getArrowProps = function getArrowProps(args) {
    if (args === void 0) {
      args = {};
    }
    return _extends({}, args, attributes.arrow, {
      style: _extends({}, args.style, styles.arrow),
      'data-popper-arrow': true
    });
  };
  return _extends({
    getArrowProps: getArrowProps,
    getTooltipProps: getTooltipProps,
    setTooltipRef: setTooltipRef,
    setTriggerRef: setTriggerRef,
    tooltipRef: tooltipRef,
    triggerRef: triggerRef,
    visible: visible
  }, popperProps);
}

var css_248z$e = ".form-field-module_falw-form-field-root__W9BIF{line-height:20px}.form-field-module_falw-form-field-root__W9BIF *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.form-field-module_falw-form-field-root__W9BIF *,.form-field-module_falw-form-field-root__W9BIF :after,.form-field-module_falw-form-field-root__W9BIF :before{box-sizing:border-box}.form-field-module_falw-form-field-root__W9BIF blockquote,.form-field-module_falw-form-field-root__W9BIF dd,.form-field-module_falw-form-field-root__W9BIF dl,.form-field-module_falw-form-field-root__W9BIF figure,.form-field-module_falw-form-field-root__W9BIF h1,.form-field-module_falw-form-field-root__W9BIF h2,.form-field-module_falw-form-field-root__W9BIF h3,.form-field-module_falw-form-field-root__W9BIF h4,.form-field-module_falw-form-field-root__W9BIF h5,.form-field-module_falw-form-field-root__W9BIF h6,.form-field-module_falw-form-field-root__W9BIF hr,.form-field-module_falw-form-field-root__W9BIF p,.form-field-module_falw-form-field-root__W9BIF pre{margin:0}.form-field-module_falw-form-field-root__W9BIF b{font-weight:700}.form-field-module_falw-form-field-root__W9BIF input,.form-field-module_falw-form-field-root__W9BIF label{font-size:14px;line-height:20px}.form-field-module_falw-form-field-root__W9BIF.form-field-module_disabled__DbNd9{opacity:.3}.form-field-module_falw-form-field-root__W9BIF .form-field-module_field-label__vwGDe{color:#333}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD{align-items:baseline;display:flex;position:relative}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y{border-color:#767676;border-style:solid;border-width:0 0 1px;color:#333;padding:8px 0 0;width:100%}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y:focus{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity));outline:2px solid transparent;outline-offset:2px;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y.form-field-module_with-icon__4ht-m{padding-right:40px}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y.form-field-module_field-input-error__SnB99{border-color:#d60303;color:#333}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_icon-wrapper__gsw8v{bottom:0;display:flex;position:absolute;right:0;top:0}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_icon-wrapper__gsw8v button{align-items:center;background-color:transparent;border-color:transparent;cursor:pointer;display:flex;height:100%;padding:0 8px;--tw-text-opacity:1;color:rgb(209 213 219/var(--tw-text-opacity))}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_icon-wrapper__gsw8v button:focus{outline:2px solid transparent;outline-offset:2px}.form-field-module_falw-form-field-root__W9BIF .form-field-module_input-wrapper__9jmiD .form-field-module_icon-wrapper__gsw8v .form-field-module_icon__OfORJ{height:24px;width:24px}.form-field-module_falw-form-field-root__W9BIF .form-field-module_field-error__rgVgW{color:#d60303;font-size:12px;height:24px;padding-top:4px}.form-field-module_falw-form-field-root__W9BIF .form-field-module_field-error__rgVgW.form-field-module_invisible__waF25{visibility:hidden}.form-field-module_falw-form-field-root-rebranded__XSYja{display:flex;flex-direction:column;justify-content:flex-start}.form-field-module_falw-form-field-root-rebranded__XSYja input,.form-field-module_falw-form-field-root-rebranded__XSYja label{line-height:17px}.form-field-module_falw-form-field-root-rebranded__XSYja .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y{padding-bottom:5px;padding-top:14px}.form-field-module_falw-form-field-root-rebranded__XSYja .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y::-moz-placeholder{color:#767676}.form-field-module_falw-form-field-root-rebranded__XSYja .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y::placeholder{color:#767676}.form-field-module_falw-form-field-root-rebranded__XSYja .form-field-module_input-wrapper__9jmiD .form-field-module_field-input__2sh6Y:-internal-autofill-selected{-webkit-box-shadow:inset 0 0 0 1000px #fff}.form-field-module_falw-form-field-root-rebranded__XSYja .form-field-module_input-wrapper__9jmiD .form-field-module_icon-wrapper__gsw8v .form-field-module_icon__OfORJ{color:#bbb;height:20.16px;width:23.52px}.form-field-module_tooltip-container__BaBVb{--tooltipBackground:#fff;--tooltipBorder:#fff;background-color:var(--tooltipBackground);border:1px solid var(--tooltipBorder);box-shadow:0 0 10px rgba(0,0,0,.13);color:#888;display:flex;flex-direction:column;max-width:400px;padding:12px 15px;transition:opacity .3s;z-index:9999}.form-field-module_tooltip-arrow__Uy4uL{height:1rem;position:absolute;width:1rem}.form-field-module_tooltip-arrow__Uy4uL:after,.form-field-module_tooltip-arrow__Uy4uL:before{border-style:solid;content:\"\";display:block;height:0;margin:auto;width:0}.form-field-module_tooltip-arrow__Uy4uL:after{position:absolute}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=bottom] .form-field-module_tooltip-arrow__Uy4uL{left:0;margin-top:-.4rem;top:0}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=bottom] .form-field-module_tooltip-arrow__Uy4uL:before{border-color:transparent transparent var(--tooltipBorder) transparent;border-width:0 .5rem .4rem;position:absolute;top:-1px}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=bottom] .form-field-module_tooltip-arrow__Uy4uL:after{border-color:transparent transparent var(--tooltipBackground) transparent;border-width:0 .5rem .4rem}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=top] .form-field-module_tooltip-arrow__Uy4uL{bottom:0;left:0;margin-bottom:-1rem}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=top] .form-field-module_tooltip-arrow__Uy4uL:before{border-color:var(--tooltipBorder) transparent transparent transparent;border-width:.4rem .5rem 0;position:absolute;top:1px}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=top] .form-field-module_tooltip-arrow__Uy4uL:after{border-color:var(--tooltipBackground) transparent transparent transparent;border-width:.4rem .5rem 0}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=right] .form-field-module_tooltip-arrow__Uy4uL{left:0;margin-left:-.7rem}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=right] .form-field-module_tooltip-arrow__Uy4uL:before{border-color:transparent var(--tooltipBorder) transparent transparent;border-width:.5rem .4rem .5rem 0}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=right] .form-field-module_tooltip-arrow__Uy4uL:after{border-color:transparent var(--tooltipBackground) transparent transparent;border-width:.5rem .4rem .5rem 0;left:6px;top:0}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=left] .form-field-module_tooltip-arrow__Uy4uL{margin-right:-.7rem;right:0}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=left] .form-field-module_tooltip-arrow__Uy4uL:before{border-color:transparent transparent transparent var(--tooltipBorder);border-width:.5rem 0 .5rem .4em}.form-field-module_tooltip-container__BaBVb[data-popper-placement*=left] .form-field-module_tooltip-arrow__Uy4uL:after{border-color:transparent transparent transparent var(--tooltipBackground);border-width:.5rem 0 .5rem .4em;left:3px;top:0}";
var styles$e = {"falw-form-field-root":"form-field-module_falw-form-field-root__W9BIF","disabled":"form-field-module_disabled__DbNd9","field-label":"form-field-module_field-label__vwGDe","input-wrapper":"form-field-module_input-wrapper__9jmiD","field-input":"form-field-module_field-input__2sh6Y","with-icon":"form-field-module_with-icon__4ht-m","field-input-error":"form-field-module_field-input-error__SnB99","icon-wrapper":"form-field-module_icon-wrapper__gsw8v","icon":"form-field-module_icon__OfORJ","field-error":"form-field-module_field-error__rgVgW","invisible":"form-field-module_invisible__waF25","falw-form-field-root-rebranded":"form-field-module_falw-form-field-root-rebranded__XSYja","tooltip-container":"form-field-module_tooltip-container__BaBVb","tooltip-arrow":"form-field-module_tooltip-arrow__Uy4uL"};
styleInject(css_248z$e);

var FormField = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, id = _a.id, Icon = _a.icon, iconClass = _a.iconClass, Tooltip = _a.iconTooltip, label = _a.label, onIconClick = _a.onIconClick, showError = _a.showError, _c = _a.isRebrandingEnabled, isRebrandingEnabled = _c === void 0 ? false : _c, _d = _a.overrideStyle, overrideStyle = _d === void 0 ? '' : _d, prefix = _a.prefix, _e = _a.parser, parser = _e === void 0 ? function (value) { return value; } : _e, _f = _a.handleChange, handleChange = _f === void 0 ? function (value) { return value; } : _f, props = __rest(_a, ["disabled", "id", "icon", "iconClass", "iconTooltip", "label", "onIconClick", "showError", "isRebrandingEnabled", "overrideStyle", "prefix", "parser", "handleChange"]);
    var _g = useField(props), field = _g[0], meta = _g[1], helpers = _g[2];
    var setValue = helpers.setValue;
    var _h = usePopperTooltip(), getArrowProps = _h.getArrowProps, getTooltipProps = _h.getTooltipProps, setTooltipRef = _h.setTooltipRef, setTriggerRef = _h.setTriggerRef, visible = _h.visible;
    var inputId = id ? "".concat(id, "-input") : props.name;
    return (jsxs("div", __assign({ className: clsx(styles$e['falw-form-field-root'], disabled && styles$e['disabled'], isRebrandingEnabled && styles$e['falw-form-field-root-rebranded'], overrideStyle) }, { children: [jsx("label", __assign({ htmlFor: inputId, className: styles$e['field-label'], id: id ? "".concat(id, "-label") : undefined }, { children: label })), jsxs("div", __assign({ className: styles$e['input-wrapper'] }, { children: [prefix ? prefix : null, jsx("input", __assign({ id: inputId }, field, props, { disabled: disabled, onChange: function (event) {
                            handleChange(parser(event.target.value));
                            setValue(parser(event.target.value));
                        }, className: clsx(styles$e['field-input'], meta.error && meta.touched && styles$e['field-input-error'], Icon && styles$e['with-icon']) })), Icon && (jsxs("div", __assign({ className: styles$e['icon-wrapper'] }, { children: [jsx("button", __assign({ id: id ? "".concat(id, "-icon-button") : undefined, type: "button", onClick: onIconClick, ref: setTriggerRef }, { children: jsx(Icon, { className: clsx(styles$e['icon'], iconClass) }) })), visible && Tooltip && (jsxs("div", __assign({ ref: setTooltipRef }, getTooltipProps({ className: styles$e['tooltip-container'] }), { children: [Tooltip, jsx("div", __assign({}, getArrowProps({ className: styles$e['tooltip-arrow'] })))] })))] })))] })), showError && (jsx("div", __assign({ className: clsx(styles$e['field-error'], !meta.error && styles$e['invisible']), id: "".concat(id || props.name, "-help") }, { children: meta.error })))] })));
};

var css_248z$d = ".password-field-module_tooltip__MI-4I{font-size:14px;text-align:center;width:96px}.password-field-module_tooltip__MI-4I *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}";
var styles$d = {"tooltip":"password-field-module_tooltip__MI-4I"};
styleInject(css_248z$d);

var PasswordField = function (props) {
    var _a = useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var togglePasswordView = function () { return setShowPassword(!showPassword); };
    var isAutoCompleteOff = (props === null || props === void 0 ? void 0 : props.autoComplete) === 'off';
    var getSecurePasswordField = function () {
        var textSecurityStyle = showPassword ? '' : 'disc';
        return (jsx(FormField, __assign({}, props, { type: "text", icon: showPassword ? Eye : EyeOff, iconTooltip: jsx("span", __assign({ className: styles$d['tooltip'] }, { children: PASSWORD_TOOLTIP })), onIconClick: togglePasswordView, isRebrandingEnabled: props.isRebrandingEnabled, handleChange: props.handleChange, style: {
                WebkitTextSecurity: textSecurityStyle,
                MozTextSecurity: textSecurityStyle,
                textSecurity: textSecurityStyle,
            } })));
    };
    return (jsxs(Fragment, { children: [!isAutoCompleteOff && (jsx(FormField, __assign({}, props, { type: showPassword ? 'text' : 'password', icon: showPassword ? Eye : EyeOff, iconTooltip: jsx("span", __assign({ className: styles$d['tooltip'] }, { children: PASSWORD_TOOLTIP })), onIconClick: togglePasswordView, isRebrandingEnabled: props.isRebrandingEnabled, handleChange: props.handleChange }))), isAutoCompleteOff && getSecurePasswordField()] }));
};

var BUFFER = 1000;
var MULTIPLIER_REGEXP = /^[0-9]+x$/g;
function getPropertyValue(value) {
    var _a;
    if (value === void 0) { value = ''; }
    if (!((_a = value.match(MULTIPLIER_REGEXP)) === null || _a === void 0 ? void 0 : _a[0]))
        return value;
    return "".concat(Number(value.slice(0, -1)) * 4, "px");
}
function splitProperty(property) {
    if (property === void 0) { property = ''; }
    var _a = property.split('/'), mobileValue = _a[0], tabletValue = _a[1], desktopValue = _a[2];
    var _b = [mobileValue, tabletValue, desktopValue].map(getPropertyValue), mobile = _b[0], tablet = _b[1], desktop = _b[2];
    return [mobile, tablet || mobile, desktop || mobile];
}
function getSplitStyle(className, styleObject) {
    var splitStyleObject = Object.fromEntries(Object.entries(styleObject).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, splitProperty(value)];
    }));
    var keys = Object.keys(styleObject);
    var getStyleString = function (index) {
        return keys.reduce(function (acc, key) { return "".concat(acc).concat(key, ": ").concat(splitStyleObject[key][index], ";\n"); }, '');
    };
    return "\n  @media (max-width: 639px) {\n    .".concat(className, " {\n      ").concat(getStyleString(0), "\n    }\n  }\n  @media (min-width: 640px) and (max-width: 1023px) {\n    .").concat(className, " {\n      ").concat(getStyleString(1), "\n    }\n  }\n  @media (min-width: 1024px) {\n    .").concat(className, " {\n      ").concat(getStyleString(2), "\n    }\n  }\n  ");
}
function getValidDate(dateISOString) {
    if (!dateISOString)
        return undefined;
    var date = Date.parse(dateISOString);
    if (Number.isNaN(date))
        return undefined;
    return date;
}
function getScheduledAlertsWithDateTime(scheduledAlerts) {
    return scheduledAlerts.map(function (scheduledAlert) { return (__assign(__assign({}, scheduledAlert), { from: getValidDate(scheduledAlert.from), to: getValidDate(scheduledAlert.to) })); });
}
function getAlertsForComponent(componentName, scheduledAlertsConfig) {
    var scheduledAlerts = getScheduledAlertsWithDateTime(scheduledAlertsConfig);
    var now = Date.now();
    return scheduledAlerts.filter(function (alert) {
        var _a, _b;
        return ((_b = (_a = alert.components) === null || _a === void 0 ? void 0 : _a.some) === null || _b === void 0 ? void 0 : _b.call(_a, function (component) { return component === componentName; })) &&
            (alert.to ? alert.to > now + BUFFER : true);
    });
}
var ScheduledAlert = function (_a) {
    var id = _a.id, content = _a.content, _b = _a.from, from = _b === void 0 ? undefined : _b, _c = _a.to, to = _c === void 0 ? undefined : _c, _d = _a.icon, icon = _d === void 0 ? '' : _d, _e = _a.iconWidth, iconWidth = _e === void 0 ? '32px' : _e, _f = _a.iconHeight, iconHeight = _f === void 0 ? '32px' : _f, _g = _a.iconGap, iconGap = _g === void 0 ? '12px' : _g, _h = _a.background, background = _h === void 0 ? '#bbb' : _h, _j = _a.color, color = _j === void 0 ? '#000' : _j, _k = _a.border, border = _k === void 0 ? '' : _k, _l = _a.width, width = _l === void 0 ? '100%/100%/100%' : _l, _m = _a.fontSize, fontSize = _m === void 0 ? '14px' : _m, _o = _a.textAlign, textAlign = _o === void 0 ? 'inherit' : _o, _p = _a.alignItems, alignItems = _p === void 0 ? 'center !important' : _p, _q = _a.marginTop, marginTop = _q === void 0 ? '0' : _q, _r = _a.marginBottom, marginBottom = _r === void 0 ? '2x/2x/2x' : _r, _s = _a.marginLeft, marginLeft = _s === void 0 ? '0' : _s, _t = _a.marginRight, marginRight = _t === void 0 ? '0' : _t, _u = _a.paddingTop, paddingTop = _u === void 0 ? '2x/2x/2x' : _u, _v = _a.paddingBottom, paddingBottom = _v === void 0 ? '2x/2x/2x' : _v, _w = _a.paddingLeft, paddingLeft = _w === void 0 ? '4x/4x/4x' : _w, _x = _a.paddingRight, paddingRight = _x === void 0 ? '4x/4x/4x' : _x;
    var containerStyleObject = {
        width: width,
        'font-size': fontSize,
        'text-align': textAlign,
        'align-items': alignItems,
        'line-height': fontSize,
        'margin-top': marginTop,
        'margin-bottom': marginBottom,
        'margin-left': marginLeft,
        'margin-right': marginRight,
        'padding-top': paddingTop,
        'padding-bottom': paddingBottom,
        'padding-left': paddingLeft,
        'padding-right': paddingRight,
    };
    var iconStyleObject = {
        width: iconWidth,
        height: iconHeight,
        'margin-right': iconGap,
    };
    var _y = useState(from ? Date.now() > from : true), visible = _y[0], setVisible = _y[1];
    useEffect(function () {
        var now = Date.now();
        var showTimer = !!from &&
            now <= from &&
            setTimeout(function () {
                setVisible(true);
            }, from - now);
        var hideTimer = to &&
            setTimeout(function () {
                setVisible(false);
            }, to - now);
        return function () {
            if (showTimer)
                clearTimeout(showTimer);
            if (hideTimer)
                clearTimeout(hideTimer);
        };
    }, [from, to]);
    return visible ? (jsxs("div", { children: [jsxs("div", __assign({ className: "alert-container-".concat(id) }, { children: [icon && jsx("img", { className: "icon-".concat(id), src: icon, alt: "" }), jsx("div", { dangerouslySetInnerHTML: { __html: content } })] })), jsx("style", { children: "\n        .alert-container-".concat(id, " {\n          display: flex;\n          flex-direction: row;\n          font-family: Lato, Sans-serif;\n          border-radius: 4px;\n          text-align: justify;\n          background-color: ").concat(background, ";\n          color: ").concat(color, ";\n          border: ").concat(border || 'none', ";\n        }\n        ").concat(getSplitStyle("alert-container-".concat(id), containerStyleObject), "\n        ").concat(icon ? getSplitStyle("icon-".concat(id), iconStyleObject) : '', "\n      ") })] })) : null;
};
var ScheduledAlerts = function (_a) {
    var componentName = _a.componentName, _b = _a.fallback, fallback = _b === void 0 ? null : _b;
    var alertsConfig = useCommerceConfig('configurations.ALERTS');
    var scheduledAlertsConfig = (alertsConfig === null || alertsConfig === void 0 ? void 0 : alertsConfig.scheduledAlerts) || [];
    var alertsForComponent = getAlertsForComponent(componentName, scheduledAlertsConfig);
    if (!alertsForComponent.length)
        return fallback;
    return (jsx("div", __assign({ style: { display: 'flex', flexDirection: 'column', width: '100%' } }, { children: alertsForComponent.map(function (_a) {
            var key = _a.key, content = _a.content, from = _a.from, to = _a.to, icon = _a.icon, iconWidth = _a.iconWidth, iconHeight = _a.iconHeight, iconGap = _a.iconGap, background = _a.background, color = _a.color, border = _a.border, width = _a.width, fontSize = _a.fontSize, textAlign = _a.textAlign, alignItems = _a.alignItems, marginTop = _a.marginTop, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, marginRight = _a.marginRight, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight;
            return (jsx(ScheduledAlert, { id: key, content: content, from: from, to: to, icon: icon, iconWidth: iconWidth, iconHeight: iconHeight, iconGap: iconGap, background: background, color: color, border: border, width: width, fontSize: fontSize, textAlign: textAlign, alignItems: alignItems, marginTop: marginTop, marginBottom: marginBottom, marginLeft: marginLeft, marginRight: marginRight, paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight }, key));
        }) })));
};

var css_248z$c = ".login-form-module_falw-login-form-root__BWZ-s{line-height:20px;padding:42px 30px;position:relative}.login-form-module_falw-login-form-root__BWZ-s *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.login-form-module_falw-login-form-root__BWZ-s *,.login-form-module_falw-login-form-root__BWZ-s :after,.login-form-module_falw-login-form-root__BWZ-s :before{box-sizing:border-box}.login-form-module_falw-login-form-root__BWZ-s blockquote,.login-form-module_falw-login-form-root__BWZ-s dd,.login-form-module_falw-login-form-root__BWZ-s dl,.login-form-module_falw-login-form-root__BWZ-s figure,.login-form-module_falw-login-form-root__BWZ-s h1,.login-form-module_falw-login-form-root__BWZ-s h2,.login-form-module_falw-login-form-root__BWZ-s h3,.login-form-module_falw-login-form-root__BWZ-s h4,.login-form-module_falw-login-form-root__BWZ-s h5,.login-form-module_falw-login-form-root__BWZ-s h6,.login-form-module_falw-login-form-root__BWZ-s hr,.login-form-module_falw-login-form-root__BWZ-s p,.login-form-module_falw-login-form-root__BWZ-s pre{margin:0}.login-form-module_falw-login-form-root__BWZ-s b{font-weight:700}@media (min-width:640px){.login-form-module_falw-login-form-root__BWZ-s{padding:30px 50px}}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_spinner-wrapper__IIEZ6{align-items:center;color:#8fca00;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes login-form-module_spin__C66Yh{to{transform:rotate(1turn)}}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_spinner-wrapper__IIEZ6 .login-form-module_spinner__Dj6nA{animation:login-form-module_spin__C66Yh 1s linear infinite}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx{display:flex}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(20px*(1 - var(--tw-space-x-reverse)));margin-right:calc(20px*var(--tw-space-x-reverse))}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx .login-form-module_header-logo__vzwI7{align-items:center;display:flex;justify-content:center;--tw-text-opacity:1;background-color:#aad500;color:rgb(255 255 255/var(--tw-text-opacity));height:69px;min-width:41px;width:41px}@media (min-width:640px){.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx .login-form-module_header-logo__vzwI7{height:74px;min-width:44px;width:44px}}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE .login-form-module_header-content-title__aqpux{color:#333;font-size:24px;font-weight:400;line-height:29px}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE .login-form-module_header-content-subtitle__elipj{color:#767676;font-size:16px;line-height:19px}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6{color:#767676;padding-top:35px}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6.login-form-module_disabled__Qd1U4{opacity:.3}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6 .login-form-module_help-text__kKntb{font-size:14px;line-height:200%;text-align:center}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6 .login-form-module_help-text__kKntb a{color:#767676;text-decoration-line:underline}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6 .login-form-module_actions-wrapper__xBRFw>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(20px*var(--tw-space-y-reverse));margin-top:calc(20px*(1 - var(--tw-space-y-reverse)))}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_form-content__aTeg6 .login-form-module_actions-wrapper__xBRFw{padding-top:20px;text-align:center}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_separator__oJsGd{align-items:center;display:flex;font-size:14px;height:1px;justify-content:center;margin:10px 0;position:relative}.login-form-module_falw-login-form-root__BWZ-s .login-form-module_separator__oJsGd:after{color:#767676;content:attr(data-char);display:inline-block;padding:0 11px}.login-form-module_white-label-header-content-title__17PFY{color:#333;display:flex;font-size:22px;justify-content:center;line-height:28px;padding-bottom:8px}.login-form-module_white-label-header-content-subtitle__ZuP-U{color:#000;display:flex;font-size:15px;justify-content:center;line-height:22px;padding-bottom:12px}.login-form-module_white-label-help-text__ceMLB{color:#767676;display:flex;font-size:14px;justify-content:center;line-height:16px;text-align:center}.login-form-module_white-label-help-text__ceMLB a{color:#495867;text-decoration-line:underline}.login-form-module_forgot-link__C9PAN{background-color:transparent;border:transparent;color:#495867;display:inline-block;font-size:inherit;padding:0;text-decoration:underline;width:-moz-fit-content;width:fit-content}.login-form-module_falw-login-form-root-rebranded__KQBsg{padding:33px 24px 51px}@media (min-width:640px){.login-form-module_falw-login-form-root-rebranded__KQBsg{padding:37px 50px 34px}}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-header__BoNTx{align-items:center}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-header__BoNTx .login-form-module_header-logo__vzwI7{background-color:transparent;height:61px;min-width:50px;width:50px}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE{margin-left:14px!important}@media (max-width:640px){.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE{margin-left:23px!important}}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE .login-form-module_header-content-title__aqpux{width:-moz-fit-content;width:fit-content}@media (max-width:640px){.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-header__BoNTx .login-form-module_header-content__yNqZE .login-form-module_header-content-title__aqpux{max-width:196px;width:100%}}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6{color:#333;padding-top:15px}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0!important;margin-bottom:calc(8px*var(--tw-space-y-reverse))!important;margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))!important}@media (max-width:640px){.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6{padding-top:40px}}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6 .login-form-module_help-text__kKntb{color:#767676;line-height:17px;margin-top:24px}@media (max-width:640px){.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6 .login-form-module_help-text__kKntb{margin-top:22px!important}}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6 .login-form-module_help-text__kKntb a{border-bottom:1px solid #495867;color:#495867;text-decoration:none}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6 .login-form-module_help-text__kKntb.login-form-module_help-text-left__K6Qrn{text-align:left}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6 .login-form-module_actions-wrapper__xBRFw{padding-top:24px}@media (max-width:640px){.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-content__aTeg6 .login-form-module_actions-wrapper__xBRFw{padding-top:28px}}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_form-alerts__OtY5g{padding-bottom:15px}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_separator__oJsGd{height:0;margin:21px 0 0!important}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_separator__oJsGd+button{margin:21px 0 0!important}.login-form-module_falw-login-form-root-rebranded__KQBsg .login-form-module_spinner-wrapper__IIEZ6 .login-form-module_spinner__Dj6nA{color:#343e49!important}.login-form-module_falw-powered-by-logo-container__lgNVv{display:flex;justify-content:center;padding-top:32px}.login-form-module_falw-powered-by-text__XPw-R{color:#4f6172;font-size:18px;font-weight:400;line-height:20px;padding-right:8px}.login-form-module_logos-wrapper__Jv3Yc{border-bottom:1px solid #f1f1f1;display:flex;margin-bottom:20px!important;padding-bottom:20px}.login-form-module_logo__lUzfS{padding-right:30px}@media (max-width:640px){.login-form-module_logo__lUzfS{padding-right:16px}}.login-form-module_header-content-new__fjSam .login-form-module_new-header-content-title__7anM9{color:#333;font-size:24px;font-weight:400;line-height:29px}";
var styles$c = {"falw-login-form-root":"login-form-module_falw-login-form-root__BWZ-s","spinner-wrapper":"login-form-module_spinner-wrapper__IIEZ6","spinner":"login-form-module_spinner__Dj6nA","spin":"login-form-module_spin__C66Yh","form-header":"login-form-module_form-header__BoNTx","header-logo":"login-form-module_header-logo__vzwI7","header-content":"login-form-module_header-content__yNqZE","header-content-title":"login-form-module_header-content-title__aqpux","header-content-subtitle":"login-form-module_header-content-subtitle__elipj","form-content":"login-form-module_form-content__aTeg6","disabled":"login-form-module_disabled__Qd1U4","help-text":"login-form-module_help-text__kKntb","actions-wrapper":"login-form-module_actions-wrapper__xBRFw","separator":"login-form-module_separator__oJsGd","white-label-header-content-title":"login-form-module_white-label-header-content-title__17PFY","white-label-header-content-subtitle":"login-form-module_white-label-header-content-subtitle__ZuP-U","white-label-help-text":"login-form-module_white-label-help-text__ceMLB","forgot-link":"login-form-module_forgot-link__C9PAN","falw-login-form-root-rebranded":"login-form-module_falw-login-form-root-rebranded__KQBsg","help-text-left":"login-form-module_help-text-left__K6Qrn","form-alerts":"login-form-module_form-alerts__OtY5g","falw-powered-by-logo-container":"login-form-module_falw-powered-by-logo-container__lgNVv","falw-powered-by-text":"login-form-module_falw-powered-by-text__XPw-R","logos-wrapper":"login-form-module_logos-wrapper__Jv3Yc","logo":"login-form-module_logo__lUzfS","header-content-new":"login-form-module_header-content-new__fjSam","new-header-content-title":"login-form-module_new-header-content-title__7anM9"};
styleInject(css_248z$c);

var TranslationContext = createContext(undefined);
TranslationContext.displayName = 'TranslationContext';
function useTranslation() {
    var ctx = useContext(TranslationContext);
    if (!ctx) {
        // eslint-disable-next-line no-console
        console === null || console === void 0 ? void 0 : console.warn('useTranslation: `labels` is undefined. Seems you forgot to wrap the components in `<TranslationContext.Provider />`');
        return undefined;
    }
    return { labels: ctx };
}

var getLogoSequence = function (siteName, tenant) {
    var logos = useCommerceConfig('configurations.logos');
    var falabellaLogoSource = (logos === null || logos === void 0 ? void 0 : logos.default) || DEFAULT_LOGOS.DEFAULT_FALABELLA_LOGO;
    var sodimacLogoSource = (logos === null || logos === void 0 ? void 0 : logos.sodimac) || DEFAULT_LOGOS.DEFAULT_SODIMAC_LOGO;
    var tottusLogoSource = (logos === null || logos === void 0 ? void 0 : logos.tottus) || DEFAULT_LOGOS.DEFAULT_TOTTUS_LOGO;
    var falabellaLogo = {
        id: 'falabella-logo',
        className: 'falabella-logo',
        src: falabellaLogoSource,
        alt: 'falabella',
        width: '93.5px',
    };
    var sodimacLogo = {
        id: 'sodimac-logo',
        className: 'sodimac-logo',
        src: sodimacLogoSource,
        alt: 'sodimac',
        width: '80px',
    };
    var tottusLogo = {
        id: 'tottus-logo',
        className: 'tottus-logo',
        src: tottusLogoSource,
        alt: 'tottus',
        width: '75px',
    };
    var siteMap = {
        sodimac: [sodimacLogo, falabellaLogo, tottusLogo],
        tottus: [tottusLogo, falabellaLogo, sodimacLogo],
        falabella: [falabellaLogo, sodimacLogo, tottusLogo],
    };
    var domainLogoSiteMap = {
        sodimac: [sodimacLogo],
        tottus: [tottusLogo],
        falabella: [falabellaLogo],
    };
    if (tenant === 'co' || tenant === 'mx') {
        return domainLogoSiteMap[siteName] || [falabellaLogo];
    }
    return siteMap[siteName] || [falabellaLogo, sodimacLogo, tottusLogo];
};

var LOGIN_THRESHOLD = 4;
var OTP_TYPE;
(function (OTP_TYPE) {
    OTP_TYPE[OTP_TYPE["SMS"] = 0] = "SMS";
    OTP_TYPE[OTP_TYPE["MAIL"] = 1] = "MAIL";
})(OTP_TYPE || (OTP_TYPE = {}));
var LoginForm = function (props) {
    var baseUrl = props.baseUrl, catalystBaseUrl = props.catalystBaseUrl, doMergeCart = props.doMergeCart, doAssociateAccount = props.doAssociateAccount, _a = props.email, initialEmail = _a === void 0 ? '' : _a, _b = props.flowType, flowType = _b === void 0 ? 'header' : _b, _c = props.readOnly, readOnly = _c === void 0 ? false : _c, id = props.id, onLogin = props.onLogin, _d = props.showOtp, showOtp = _d === void 0 ? false : _d, mailOtpHandler = props.mailOtpHandler, smsOtpHandler = props.smsOtpHandler, tenant = props.tenant, _e = props.isRebrandingEnabled, isRebrandingEnabled = _e === void 0 ? false : _e, onClose = props.onClose;
    var whitelabel = useContext(WhiteLabelContext);
    var _f = useState(0), attempts = _f[0], setAttempts = _f[1];
    var _g = useState(true), readOnlyEmailInput = _g[0], setReadOnlyEmailInput = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(undefined), alert = _j[0], setAlert = _j[1];
    var siteName = getSiteName();
    var toggles = useCommerceConfig('toggles');
    var newDeviceOtpFlow = useCommerceConfig('configurations.loginConfigs').newDeviceOtpFlow;
    var isEnableNewOtpFlow = toggles.ENABLE_NEW_OTP_FLOW || false;
    var isEnableSMSOption = toggles.ENABLE_SMS_OPTION || false;
    var isKioskoFlow = getCookie(COOKIES.KIOSKO_INFO) ? getCookie(COOKIES.KIOSKO_INFO) : '';
    var registrationUrl = getRegisterUserLinkCommerce(baseUrl, tenant, isKioskoFlow);
    var recoverPasswordUrl = getRecoverPasswordLinkCommerce(baseUrl, tenant);
    var lockedPasswordUrl = getLockedPasswordLinkCommerce(baseUrl, tenant);
    var disableAutocompleteKioskFlow = getIsKiosko();
    var logoSequence = getLogoSequence(siteName, tenant);
    var recoverPasswordUrlSms = recoverPasswordUrl.includes('?')
        ? "".concat(recoverPasswordUrl, "&type=sms")
        : "".concat(recoverPasswordUrl, "?type=sms");
    var labels = useTranslation().labels;
    var EMAIL_LABEL = labels.EMAIL_LABEL, EMAIL_PLACEHOLDER = labels.EMAIL_PLACEHOLDER, EMPTY_EMAIL_ERROR = labels.EMPTY_EMAIL_ERROR, EMPTY_PASSWORD_ERROR = labels.EMPTY_PASSWORD_ERROR, INVALID_EMAIL_ERROR = labels.INVALID_EMAIL_ERROR, LOGIN_HEADER_SUBTITLE = labels.LOGIN_HEADER_SUBTITLE, LOGIN_HEADER_TITLE = labels.LOGIN_HEADER_TITLE, NOT_REGISTERED = labels.NOT_REGISTERED, OR = labels.OR, PASSWORD_LABEL = labels.PASSWORD_LABEL, PASSWORD_PLACEHOLDER = labels.PASSWORD_PLACEHOLDER, REBRANDING = labels.REBRANDING, SESSION_STORAGE = labels.SESSION_STORAGE, SIGN_IN = labels.SIGN_IN, SIGN_UP = labels.SIGN_UP, OTP_MESSAGE = labels.OTP_MESSAGE;
    var normalizeLetters = function (letters) {
        return Array.isArray(letters)
            ? letters === null || letters === void 0 ? void 0 : letters.map(function (letter) { return letter === null || letter === void 0 ? void 0 : letter.toLowerCase(); })
            : [letters === null || letters === void 0 ? void 0 : letters.toLowerCase()];
    };
    var shouldOpenModalForEmail = function (allowedLetters, email, whitelistedEmails) {
        if (whitelistedEmails === null || whitelistedEmails === void 0 ? void 0 : whitelistedEmails.includes(email === null || email === void 0 ? void 0 : email.toLowerCase())) {
            return false;
        }
        var normalizedLetters = normalizeLetters(allowedLetters);
        var emailPrefix = email === null || email === void 0 ? void 0 : email.charAt(0).toLowerCase();
        if (!(normalizedLetters === null || normalizedLetters === void 0 ? void 0 : normalizedLetters.includes(emailPrefix))) {
            return false;
        }
        return true;
    };
    var submitHandler = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var allowedEmailLetters, whitelistedEmails, isEmailPrefixEligibleForOtpModal, response, loginStatus, errors, _a, isDeviceRecognised;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    setAlert(undefined);
                    allowedEmailLetters = newDeviceOtpFlow === null || newDeviceOtpFlow === void 0 ? void 0 : newDeviceOtpFlow.allowedEmailLetters;
                    whitelistedEmails = newDeviceOtpFlow === null || newDeviceOtpFlow === void 0 ? void 0 : newDeviceOtpFlow.whitelistedEmails;
                    isEmailPrefixEligibleForOtpModal = shouldOpenModalForEmail(allowedEmailLetters, values.email, whitelistedEmails);
                    return [4 /*yield*/, (!isKioskoFlow
                            ? login({
                                email: values.email,
                                password: values.password,
                                tenantId: tenantId(tenant),
                                doMergeCart: doMergeCart,
                                doAssociateAccount: doAssociateAccount,
                                catalystBaseUrl: catalystBaseUrl,
                                additionalInfo: { whitelabel: whitelabel },
                                isEnableNewOtpFlow: isEnableNewOtpFlow,
                                isEmailPrefixEligibleForOtpModal: isEmailPrefixEligibleForOtpModal,
                            })
                            : impersonationLogin({
                                emailAddress: values.email,
                                tenantId: tenantId(tenant),
                                flow: 'header',
                                additionalInfo: { whitelabel: whitelabel },
                            }))];
                case 1:
                    response = _b.sent();
                    loginStatus = response.loginStatus, errors = response.errors, _a = response.isDeviceRecognised, isDeviceRecognised = _a === void 0 ? true : _a;
                    return [4 /*yield*/, onLogin(response, values.email, isEnableNewOtpFlow, isEmailPrefixEligibleForOtpModal)];
                case 2:
                    _b.sent();
                    if (loginStatus &&
                        (isDeviceRecognised || !isEnableNewOtpFlow || !isEmailPrefixEligibleForOtpModal)) {
                        actions.resetForm();
                    }
                    else if (isKioskoFlow && errors[0].code === 'EMAIL_NOT_FOUND_ERROR') {
                        onClose();
                    }
                    else if (errors.length > 0) {
                        if (attempts === LOGIN_THRESHOLD) {
                            setItemInSessionStorage(SESSION_STORAGE.EMAIL, values.email);
                            window.location.href = lockedPasswordUrl;
                        }
                        setAttempts(attempts + 1);
                        setAlert({ type: 'warning', children: errors[0].message });
                        setLoading(false);
                    }
                    actions.setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onOTPClick = function (e, otpType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setLoading(true);
                    if (!(otpType === OTP_TYPE.MAIL && mailOtpHandler)) return [3 /*break*/, 2];
                    track('otp_requestmail');
                    return [4 /*yield*/, mailOtpHandler()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(otpType === OTP_TYPE.SMS && smsOtpHandler)) return [3 /*break*/, 4];
                    track('otp_requestsms');
                    return [4 /*yield*/, smsOtpHandler()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    if (whitelabel.enabled && !whitelabel.multiSite) {
        return (jsx("div", __assign({ id: id, className: styles$c['falw-login-form-root-rebranded'] }, { children: jsxs("div", __assign({ id: "unified-login-login-form", className: styles$c['form-header'] }, { children: [jsx("div", __assign({ className: styles$c['white-label-header-content-title'] }, { children: "Contin\u00FAa con tu cuenta de falabella.com" })), jsx("div", __assign({ className: styles$c['white-label-header-content-subtitle'] }, { children: "Inicia sesi\u00F3n para que puedas terminar tu compra." })), jsx(Formik, __assign({ initialValues: { email: initialEmail, password: '' }, validationSchema: create({
                            email: create$1().email(INVALID_EMAIL_ERROR).required(EMPTY_EMAIL_ERROR),
                            password: create$1().when('isKioskoFlow', {
                                is: function (isKioskoFlow) { return isKioskoFlow === ''; },
                                then: create$1().required(EMPTY_PASSWORD_ERROR),
                                otherwise: create$1().notRequired(),
                            }),
                        }), onSubmit: submitHandler }, { children: function (_a) {
                            var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty;
                            var disabled = !(isValid && dirty) || isSubmitting;
                            return (jsx(Fragment, { children: jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$c['form-content'], loading && styles$c.disabled) }, { children: [alert && (jsx("div", __assign({ className: clsx(styles$c['form-alerts']) }, { children: jsx(Alert$1, __assign({}, alert)) }))), jsx(FormField, { type: "email", id: id ? "".concat(id, "-email") : undefined, name: "email", label: EMAIL_LABEL, placeholder: EMAIL_PLACEHOLDER, readOnly: disableAutocompleteKioskFlow ? readOnlyEmailInput : readOnly, onFocus: function () { return setReadOnlyEmailInput(false); }, isRebrandingEnabled: isRebrandingEnabled, autoComplete: disableAutocompleteKioskFlow && 'off' }), !isKioskoFlow && (jsxs(Fragment, { children: [jsx(PasswordField, { id: id ? "".concat(id, "-password") : undefined, name: "password", label: PASSWORD_LABEL, placeholder: PASSWORD_PLACEHOLDER, isRebrandingEnabled: isRebrandingEnabled, autoComplete: disableAutocompleteKioskFlow && 'off' }), jsx("div", __assign({ className: styles$c['white-label-help-text'] }, { children: jsx("div", { children: jsxs("p", { children: [OTP_MESSAGE, "\u00A0", jsx("button", __assign({ type: "button", onClick: function (e) { return onOTPClick(e, OTP_TYPE.MAIL); } }, { children: "correo" })), isEnableSMSOption && (jsxs(Fragment, { children: ["\u00A0o\u00A0", jsx("button", __assign({ type: "button", onClick: function (e) { return onOTPClick(e, OTP_TYPE.SMS); } }, { children: "SMS" }))] })), "."] }) }) }))] })), jsxs("div", __assign({ className: styles$c['actions-wrapper'] }, { children: [jsx(Button, { id: id ? "".concat(id, "-submit") : undefined, type: "submit", label: SIGN_IN, color: "primary", block: true, disabled: disabled, uppercased: !isRebrandingEnabled, isRebrandingEnabled: isRebrandingEnabled }), jsxs(Fragment, { children: [jsx("div", { className: styles$c.separator, "data-char": OR }), jsxs("p", __assign({ className: styles$c['white-label-help-text'] }, { children: [REBRANDING.NOT_REGISTERED, jsx("a", __assign({ id: "unified-login-login-form-register-link", href: registrationUrl }, { children: SIGN_UP }))] }))] })] }))] })) }));
                        } })), jsxs("div", __assign({ className: styles$c['falw-powered-by-logo-container'] }, { children: [jsx("span", __assign({ className: styles$c['falw-powered-by-text'] }, { children: " Powered By " })), '  ', isRebrandingEnabled ? jsx(PoweredByFalabellaDotComGreen, {}) : jsx(PoweredByFalabellaDotCom, {})] }))] })) })));
    }
    return (jsxs("div", __assign({ id: id, className: clsx(styles$c['falw-login-form-root'], isRebrandingEnabled && styles$c['falw-login-form-root-rebranded']) }, { children: [loading && (jsx("div", __assign({ className: styles$c['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles$c.spinner }) }))), jsxs("div", __assign({ id: "unified-login-login-form" }, { children: [jsx("div", __assign({ className: styles$c['logos-wrapper'] }, { children: logoSequence.map(function (logo) { return (jsx("div", __assign({ className: styles$c.logo }, { children: jsx("img", { className: logo.className, alt: logo.alt, src: logo.src, width: logo.width }) }), logo.id)); }) })), jsx("div", __assign({ className: styles$c['header-content-new'] }, { children: isRebrandingEnabled ? (jsx(Fragment, { children: jsx("h3", __assign({ className: styles$c['new-header-content-title'] }, { children: REBRANDING.LOGIN_HEADER_TITLE_1 })) })) : (jsxs(Fragment, { children: [jsx("h3", __assign({ className: styles$c['header-content-title'] }, { children: LOGIN_HEADER_TITLE })), jsx("p", __assign({ className: styles$c['header-content-subtitle'] }, { children: LOGIN_HEADER_SUBTITLE }))] })) }))] })), jsx(Formik, __assign({ initialValues: { email: initialEmail, password: '' }, validationSchema: create({
                    email: create$1().email(INVALID_EMAIL_ERROR).required(EMPTY_EMAIL_ERROR),
                    password: create$1().when('isKioskoFlow', {
                        is: function (isKioskoFlow) { return isKioskoFlow === ''; },
                        then: create$1().required(EMPTY_PASSWORD_ERROR),
                        otherwise: create$1().notRequired(),
                    }),
                }), onSubmit: submitHandler }, { children: function (_a) {
                    var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty;
                    var disabled = !(isValid && dirty) || isSubmitting;
                    return (jsxs(Fragment, { children: [jsx(ScheduledAlerts, { componentName: "unified-login-login-form" }), jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$c['form-content'], loading && styles$c.disabled) }, { children: [alert && (jsx("div", __assign({ className: clsx(styles$c['form-alerts']) }, { children: jsx(Alert$1, __assign({}, alert)) }))), jsx(FormField, { type: "email", id: id ? "".concat(id, "-email") : undefined, name: "email", label: EMAIL_LABEL, placeholder: EMAIL_PLACEHOLDER, readOnly: disableAutocompleteKioskFlow ? readOnlyEmailInput : readOnly, isRebrandingEnabled: isRebrandingEnabled, onFocus: function () { return setReadOnlyEmailInput(false); }, autoComplete: disableAutocompleteKioskFlow && 'off' }), !isKioskoFlow && (jsxs(Fragment, { children: [jsx(PasswordField, { id: id ? "".concat(id, "-password") : undefined, name: "password", label: PASSWORD_LABEL, placeholder: PASSWORD_PLACEHOLDER, isRebrandingEnabled: isRebrandingEnabled, autoComplete: disableAutocompleteKioskFlow && 'off' }), flowType !== 'checkout' && (jsxs("p", __assign({ className: clsx(styles$c['help-text'], styles$c['help-text-left']) }, { children: ["\u00BFOlvidaste tu contrase\u00F1a? No te preocupes, pide un c\u00F3digo verificador por\u00A0", jsx("a", __assign({ id: "unified-login-login-form-forgot-password-link", href: recoverPasswordUrl, className: styles$c['forgot-link'] }, { children: "correo" })), isEnableSMSOption && (jsxs(Fragment, { children: ["\u00A0o\u00A0", jsx("a", __assign({ id: "unified-login-login-form-forgot-password-link-sms", href: recoverPasswordUrlSms, className: styles$c['forgot-link'] }, { children: "SMS" }))] })), "\u00A0para cambiar tu contrase\u00F1a."] })))] })), jsx("div", __assign({ className: styles$c['help-text'] }, { children: flowType === 'checkout' && (jsx("div", __assign({ "data-testid": "checkout-forgot-password" }, { children: jsxs("p", { children: [OTP_MESSAGE, "\u00A0", jsx("button", __assign({ id: "unified-login-email-otp-button-checkout", type: "button", onClick: function (e) { return onOTPClick(e, OTP_TYPE.MAIL); }, className: styles$c['forgot-link'] }, { children: "correo" })), showOtp && isEnableSMSOption && (jsxs(Fragment, { children: ["\u00A0o\u00A0", jsx("button", __assign({ id: "unified-login-sms-otp-button-checkout", type: "button", onClick: function (e) { return onOTPClick(e, OTP_TYPE.SMS); }, className: styles$c['forgot-link'] }, { children: "SMS" }))] })), "\u2002para continuar tu compra."] }) }))) })), jsxs("div", __assign({ className: styles$c['actions-wrapper'] }, { children: [jsx(Button, { id: id ? "".concat(id, "-submit") : undefined, type: "submit", label: SIGN_IN, color: "primary", block: true, uppercased: !isRebrandingEnabled, disabled: disabled, isRebrandingEnabled: isRebrandingEnabled }), flowType !== 'checkout' && (jsx(Fragment, { children: jsxs("p", __assign({ className: styles$c['help-text'] }, { children: [isRebrandingEnabled ? REBRANDING.NOT_REGISTERED : NOT_REGISTERED, ' ', jsx("a", __assign({ id: "unified-login-login-form-register-link", href: registrationUrl }, { children: SIGN_UP }))] })) }))] }))] }))] }));
                } }))] })));
};

var css_248z$b = ".notice-module_falw-notice-root__p8T30{align-items:center;display:flex;flex-direction:column}.notice-module_falw-notice-root__p8T30>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(24px*var(--tw-space-y-reverse));margin-top:calc(24px*(1 - var(--tw-space-y-reverse)))}.notice-module_falw-notice-root__p8T30{padding:20px 25px;text-align:center}.notice-module_falw-notice-root__p8T30 *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.notice-module_falw-notice-root__p8T30 *,.notice-module_falw-notice-root__p8T30 :after,.notice-module_falw-notice-root__p8T30 :before{box-sizing:border-box}.notice-module_falw-notice-root__p8T30 blockquote,.notice-module_falw-notice-root__p8T30 dd,.notice-module_falw-notice-root__p8T30 dl,.notice-module_falw-notice-root__p8T30 figure,.notice-module_falw-notice-root__p8T30 h1,.notice-module_falw-notice-root__p8T30 h2,.notice-module_falw-notice-root__p8T30 h3,.notice-module_falw-notice-root__p8T30 h4,.notice-module_falw-notice-root__p8T30 h5,.notice-module_falw-notice-root__p8T30 h6,.notice-module_falw-notice-root__p8T30 hr,.notice-module_falw-notice-root__p8T30 p,.notice-module_falw-notice-root__p8T30 pre{margin:0}.notice-module_falw-notice-root__p8T30 b{font-weight:700}.notice-module_falw-notice-root__p8T30 svg{color:#8fca00}.notice-module_falw-notice-root__p8T30 p{color:#4a4a4a;font-size:14px;line-height:21px;padding:0 17px}.notice-module_falw-notice-root-rebranded__-ONfm{padding:17px 17px 20px}@media (max-width:640px){.notice-module_falw-notice-root-rebranded__-ONfm{padding:121.5px 35px 0 33px}}.notice-module_falw-notice-root-rebranded__-ONfm div{display:flex}.notice-module_falw-notice-root-rebranded__-ONfm svg{color:#495867}.notice-module_falw-notice-root-rebranded__-ONfm p{display:flex;flex-direction:column;font-size:16px;line-height:19px;margin-top:22px!important;padding:0;width:250px}.notice-module_falw-notice-root-rebranded__-ONfm p span{letter-spacing:-.1px}.notice-module_falw-notice-root-rebranded__-ONfm p span b{letter-spacing:-.5px}.notice-module_falw-notice-root-rebranded__-ONfm p span:nth-child(3) b{letter-spacing:-.6px}@media (max-width:640px){.notice-module_falw-notice-root-rebranded__-ONfm p{margin-top:17.5px!important}}.notice-module_falw-notice-root-rebranded__-ONfm button{margin-top:44px!important}@media (max-width:640px){.notice-module_falw-notice-root-rebranded__-ONfm button{margin-top:84px!important}}";
var styles$b = {"falw-notice-root":"notice-module_falw-notice-root__p8T30","falw-notice-root-rebranded":"notice-module_falw-notice-root-rebranded__-ONfm"};
styleInject(css_248z$b);

var Notice = function (_a) {
    var id = _a.id, onClick = _a.onClick, isRebrandingEnabled = _a.isRebrandingEnabled;
    return (jsxs("div", __assign({ id: id, className: clsx(styles$b['falw-notice-root'], isRebrandingEnabled && styles$b['falw-notice-root-rebranded']) }, { children: [jsx("div", { children: jsx(ExclamationFilled, { size: 35 }) }), jsx("p", { children: isRebrandingEnabled ? (jsxs(React__default.Fragment, { children: [jsx("span", { children: "Para poder continuar te invitamos a " }), jsxs("span", { children: [jsx("b", { children: "actualizar tu contrase\u00F1a" }), " y ", jsx("b", { children: "aceptar" })] }), jsx("span", { children: jsx("b", { children: "los nuevos terminos y condiciones" }) }), jsx("span", { children: " de nuestra nueva plataforma." })] })) : (jsxs(React__default.Fragment, { children: [' ', "Para poder continuar te invitamos a ", jsx("b", { children: "actualizar tu contrase\u00F1a" }), " y", ' ', jsx("b", { children: "aceptar los nuevos terminos y condiciones" }), " de nuestra nueva plataforma."] })) }), jsx(Button, { type: "button", label: CONTINUE, color: "primary", block: true, uppercased: !isRebrandingEnabled, onClick: onClick, isRebrandingEnabled: isRebrandingEnabled })] })));
};

var propTypes = {exports: {}};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}
	return Object(val);
}
function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}
		var test1 = new String('abc');
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}
		return true;
	} catch (err) {
		return false;
	}
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;
	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);
		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}
		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}
	return to;
};

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {  }
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

var ReactIs$1 = reactIs$1.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = factoryWithThrowingShims();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0) return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : '';
  var suffix = match ? match[3] : '';
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
    return '0';
  }).join('') + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$now = options.now,
      now = _options$now === void 0 ? Date.now : _options$now,
      _options$precision = options.precision,
      precision = _options$precision === void 0 ? 0 : _options$precision,
      controlled = options.controlled,
      _options$offsetTime = options.offsetTime,
      offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime,
      overtime = options.overtime;
  var startTimestamp;
  if (typeof date === 'string') {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }
  if (!controlled) {
    startTimestamp += offsetTime;
  }
  var timeLeft = controlled ? startTimestamp : startTimestamp - now();
  var clampedPrecision = Math.min(20, Math.max(0, precision));
  var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
  var seconds = Math.abs(total) / 1000;
  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(timeDelta, options) {
  var days = timeDelta.days,
      hours = timeDelta.hours,
      minutes = timeDelta.minutes,
      seconds = timeDelta.seconds;
  var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options),
      daysInHours = _Object$assign.daysInHours,
      zeroPadTime = _Object$assign.zeroPadTime,
      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
  var zeroPadTimeLength = Math.min(2, zeroPadTime);
  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
  return {
    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, zeroPadTimeLength),
    seconds: zeroPad(seconds, zeroPadTimeLength)
  };
}
var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);
  var _super = _createSuper(Countdown);
  function Countdown() {
    var _this;
    _classCallCheck(this, Countdown);
    _this = _super.apply(this, arguments);
    _this.state = {
      count: _this.props.count || 3
    };
    _this.startCountdown = function () {
      _this.interval = window.setInterval(function () {
        var count = _this.state.count - 1;
        if (count === 0) {
          _this.stopCountdown();
          _this.props.onComplete && _this.props.onComplete();
        } else {
          _this.setState(function (prevState) {
            return {
              count: prevState.count - 1
            };
          });
        }
      }, 1000);
    };
    _this.stopCountdown = function () {
      clearInterval(_this.interval);
    };
    _this.addTime = function (seconds) {
      _this.stopCountdown();
      _this.setState(function (prevState) {
        return {
          count: prevState.count + seconds
        };
      }, _this.startCountdown);
    };
    return _this;
  }
  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? cloneElement(this.props.children, {
        count: this.state.count
      }) : null;
    }
  }]);
  return Countdown;
}(Component);
Countdown.propTypes = {
  count: propTypes.exports.number,
  children: propTypes.exports.element,
  onComplete: propTypes.exports.func
};
var Countdown$1 = function (_React$Component) {
  _inherits(Countdown$1, _React$Component);
  var _super = _createSuper(Countdown$1);
  function Countdown$1(props) {
    var _this;
    _classCallCheck(this, Countdown$1);
    _this = _super.call(this, props);
    _this.mounted = false;
    _this.initialTimestamp = _this.calcOffsetStartTimestamp();
    _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
    _this.offsetTime = 0;
    _this.legacyMode = false;
    _this.legacyCountdownRef = createRef();
    _this.tick = function () {
      var timeDelta = _this.calcTimeDelta();
      var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;
      _this.setTimeDeltaState(timeDelta, undefined, callback);
    };
    _this.start = function () {
      if (_this.isStarted()) return;
      var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
      _this.offsetStartTimestamp = 0;
      _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;
      var timeDelta = _this.calcTimeDelta();
      _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);
      if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
        _this.clearTimer();
        _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
      }
    };
    _this.pause = function () {
      if (_this.isPaused()) return;
      _this.clearTimer();
      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
    };
    _this.stop = function () {
      if (_this.isStopped()) return;
      _this.clearTimer();
      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;
      _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
    };
    _this.isStarted = function () {
      return _this.isStatus("STARTED");
    };
    _this.isPaused = function () {
      return _this.isStatus("PAUSED");
    };
    _this.isStopped = function () {
      return _this.isStatus("STOPPED");
    };
    _this.isCompleted = function () {
      return _this.isStatus("COMPLETED");
    };
    _this.handleOnComplete = function (timeDelta) {
      if (_this.props.onComplete) _this.props.onComplete(timeDelta);
    };
    if (props.date) {
      var timeDelta = _this.calcTimeDelta();
      _this.state = {
        timeDelta: timeDelta,
        status: timeDelta.completed ? "COMPLETED" : "STOPPED"
      };
    } else {
      _this.legacyMode = true;
    }
    return _this;
  }
  _createClass(Countdown$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.legacyMode) {
        return;
      }
      this.mounted = true;
      if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
      if (this.props.autoStart) this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.legacyMode) {
        return;
      }
      if (this.props.date !== prevProps.date) {
        this.initialTimestamp = this.calcOffsetStartTimestamp();
        this.offsetStartTimestamp = this.initialTimestamp;
        this.offsetTime = 0;
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.legacyMode) {
        return;
      }
      this.mounted = false;
      this.clearTimer();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props,
          date = _this$props.date,
          now = _this$props.now,
          precision = _this$props.precision,
          controlled = _this$props.controlled,
          overtime = _this$props.overtime;
      return calcTimeDelta(date, {
        now: now,
        precision: precision,
        controlled: controlled,
        offsetTime: this.offsetTime,
        overtime: overtime
      });
    }
  }, {
    key: "calcOffsetStartTimestamp",
    value: function calcOffsetStartTimestamp() {
      return Date.now();
    }
  }, {
    key: "addTime",
    value: function addTime(seconds) {
      this.legacyCountdownRef.current.addTime(seconds);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "isStatus",
    value: function isStatus(status) {
      return this.state.status === status;
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta, status, callback) {
      var _this2 = this;
      if (!this.mounted) return;
      var completedCallback;
      if (!this.state.timeDelta.completed && timeDelta.completed) {
        if (!this.props.overtime) this.clearTimer();
        completedCallback = this.handleOnComplete;
      }
      var onDone = function onDone() {
        if (callback) callback(_this2.state.timeDelta);
        if (completedCallback) completedCallback(_this2.state.timeDelta);
      };
      return this.setState(function (prevState) {
        var newStatus = status || prevState.status;
        if (timeDelta.completed && !_this2.props.overtime) {
          newStatus = "COMPLETED";
        } else if (!status && newStatus === "COMPLETED") {
          newStatus = "STOPPED";
        }
        return {
          timeDelta: timeDelta,
          status: newStatus
        };
      }, onDone);
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        stop: this.stop,
        isStarted: this.isStarted,
        isPaused: this.isPaused,
        isStopped: this.isStopped,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props,
          daysInHours = _this$props2.daysInHours,
          zeroPadTime = _this$props2.zeroPadTime,
          zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign(Object.assign({}, timeDelta), {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours: daysInHours,
          zeroPadTime: zeroPadTime,
          zeroPadDays: zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.legacyMode) {
        var _this$props3 = this.props,
            count = _this$props3.count,
            _children = _this$props3.children,
            onComplete = _this$props3.onComplete;
        return createElement(Countdown, {
          ref: this.legacyCountdownRef,
          count: count,
          onComplete: onComplete
        }, _children);
      }
      var _this$props4 = this.props,
          className = _this$props4.className,
          overtime = _this$props4.overtime,
          children = _this$props4.children,
          renderer = _this$props4.renderer;
      var renderProps = this.getRenderProps();
      if (renderer) {
        return renderer(renderProps);
      }
      if (children && this.state.timeDelta.completed && !overtime) {
        return cloneElement(children, {
          countdown: renderProps
        });
      }
      var _renderProps$formatte = renderProps.formatted,
          days = _renderProps$formatte.days,
          hours = _renderProps$formatte.hours,
          minutes = _renderProps$formatte.minutes,
          seconds = _renderProps$formatte.seconds;
      return createElement("span", {
        className: className
      }, renderProps.total < 0 ? '-' : '', days, days ? ':' : '', hours, ":", minutes, ":", seconds);
    }
  }]);
  return Countdown$1;
}(Component);
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  autoStart: true
});
Countdown$1.propTypes = {
  date: propTypes.exports.oneOfType([propTypes.exports.instanceOf(Date), propTypes.exports.string, propTypes.exports.number]),
  daysInHours: propTypes.exports.bool,
  zeroPadTime: propTypes.exports.number,
  zeroPadDays: propTypes.exports.number,
  controlled: propTypes.exports.bool,
  intervalDelay: propTypes.exports.number,
  precision: propTypes.exports.number,
  autoStart: propTypes.exports.bool,
  overtime: propTypes.exports.bool,
  className: propTypes.exports.string,
  children: propTypes.exports.element,
  renderer: propTypes.exports.func,
  now: propTypes.exports.func,
  onMount: propTypes.exports.func,
  onStart: propTypes.exports.func,
  onPause: propTypes.exports.func,
  onStop: propTypes.exports.func,
  onTick: propTypes.exports.func,
  onComplete: propTypes.exports.func
};

var css_248z$a = ".otp-form-module_falw-otp-form-root__AUPIY{line-height:20px;padding:42px 30px;position:relative}.otp-form-module_falw-otp-form-root__AUPIY *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.otp-form-module_falw-otp-form-root__AUPIY *,.otp-form-module_falw-otp-form-root__AUPIY :after,.otp-form-module_falw-otp-form-root__AUPIY :before{box-sizing:border-box}.otp-form-module_falw-otp-form-root__AUPIY blockquote,.otp-form-module_falw-otp-form-root__AUPIY dd,.otp-form-module_falw-otp-form-root__AUPIY dl,.otp-form-module_falw-otp-form-root__AUPIY figure,.otp-form-module_falw-otp-form-root__AUPIY h1,.otp-form-module_falw-otp-form-root__AUPIY h2,.otp-form-module_falw-otp-form-root__AUPIY h3,.otp-form-module_falw-otp-form-root__AUPIY h4,.otp-form-module_falw-otp-form-root__AUPIY h5,.otp-form-module_falw-otp-form-root__AUPIY h6,.otp-form-module_falw-otp-form-root__AUPIY hr,.otp-form-module_falw-otp-form-root__AUPIY p,.otp-form-module_falw-otp-form-root__AUPIY pre{margin:0}.otp-form-module_falw-otp-form-root__AUPIY b{font-weight:700}@media (min-width:640px){.otp-form-module_falw-otp-form-root__AUPIY{padding:30px 50px}}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_disabled__XORZ2{opacity:.3}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-body__NIgcZ>:not([hidden])~:not([hidden]),.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-content__lKxsw>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(16px*var(--tw-space-y-reverse));margin-top:calc(16px*(1 - var(--tw-space-y-reverse)))}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-header__gfEpH>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-header__gfEpH{color:#767676}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-header__gfEpH .otp-form-module_title__noDk9{font-size:24px}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-header__gfEpH .otp-form-module_subtitle__QK8Rw{font-size:16px}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_alert-container__0tmIN>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_help-text__gmuZ6{color:#767676;display:inline-block;font-size:14px;margin-left:50px;margin-right:50px;text-align:left}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_help-text__gmuZ6 a{color:#767676;text-decoration-line:underline}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_spinner-wrapper__xJJm5{align-items:center;color:#8fca00;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes otp-form-module_spin__Qpatk{to{transform:rotate(1turn)}}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_spinner-wrapper__xJJm5 .otp-form-module_spinner__LyneK{animation:otp-form-module_spin__Qpatk 1s linear infinite}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF{color:#767676}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF .otp-form-module_actions-wrapper__A0MHa>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF .otp-form-module_actions-wrapper__A0MHa{text-align:center}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY{padding:30px 50px 32px}@media (max-width:640px){.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY{padding:71px 39px 0 36px}}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-header__gfEpH .otp-form-module_title__noDk9{color:#333;font-size:20px;font-weight:500;line-height:24px}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_otp-form-header__gfEpH .otp-form-module_subtitle__QK8Rw{line-height:19px;margin-top:10px}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_alert-container__0tmIN{color:#333;line-height:16px}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_alert-container__0tmIN .otp-form-module_alert-title__K8gM0{line-height:16px}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_alert-container__0tmIN .otp-form-module_alert-subtitle__uSm49{line-height:16px;margin-top:10px}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF{margin:21px 10px 0!important}@media (max-width:640px){.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF{margin-top:20px!important}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_falw-otp-form-root__AUPIY .otp-form-module_form-content__xEMVF .otp-form-module_actions-wrapper__A0MHa{margin-top:13px!important}}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_help-text__gmuZ6{color:#767676;display:flex;font-size:14px;justify-content:center;line-height:15px;padding-bottom:35px;padding-top:0}@media (max-width:640px){.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_help-text__gmuZ6{background-color:transparent;display:block;padding:42px 39px 18px 36px;text-align:center}}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_help-text__gmuZ6 b{height:-moz-fit-content;height:fit-content}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_help-text__gmuZ6 a{color:#767676;text-decoration-line:underline}.otp-form-module_falw-otp-form-root-rebranded__LA1rL .otp-form-module_spinner-wrapper__xJJm5 .otp-form-module_spinner__LyneK{color:#343e49!important}";
var styles$a = {"falw-otp-form-root":"otp-form-module_falw-otp-form-root__AUPIY","disabled":"otp-form-module_disabled__XORZ2","otp-form-content":"otp-form-module_otp-form-content__lKxsw","form-body":"otp-form-module_form-body__NIgcZ","otp-form-header":"otp-form-module_otp-form-header__gfEpH","title":"otp-form-module_title__noDk9","subtitle":"otp-form-module_subtitle__QK8Rw","alert-container":"otp-form-module_alert-container__0tmIN","help-text":"otp-form-module_help-text__gmuZ6","spinner-wrapper":"otp-form-module_spinner-wrapper__xJJm5","spinner":"otp-form-module_spinner__LyneK","spin":"otp-form-module_spin__Qpatk","form-content":"otp-form-module_form-content__xEMVF","actions-wrapper":"otp-form-module_actions-wrapper__A0MHa","falw-otp-form-root-rebranded":"otp-form-module_falw-otp-form-root-rebranded__LA1rL","alert-title":"otp-form-module_alert-title__K8gM0","alert-subtitle":"otp-form-module_alert-subtitle__uSm49"};
styleInject(css_248z$a);

var ACTION_TYPES$2;
(function (ACTION_TYPES) {
    ACTION_TYPES["setLoading"] = "loading";
    ACTION_TYPES["setError"] = "error";
    ACTION_TYPES["setDate"] = "date";
    ACTION_TYPES["setFinalOtpType"] = "finalOtpType";
    ACTION_TYPES["setPhoneNumber"] = "phoneNumber";
    ACTION_TYPES["setSubmitCount"] = "submitCount";
    ACTION_TYPES["setErrorCount"] = "errorCount";
    ACTION_TYPES["setSmsRequestCount"] = "smsRequestCount";
})(ACTION_TYPES$2 || (ACTION_TYPES$2 = {}));
var initialState$2 = {
    loading: false,
    error: undefined,
    date: Date.now(),
    finalOtpType: '',
    phoneNumber: '',
    submitCount: 0,
    errorCount: 0,
    smsRequestCount: 0,
};
var reducer$2 = function (state, action) {
    var _a;
    switch (action.type) {
        case ACTION_TYPES$2.setLoading:
        case ACTION_TYPES$2.setError:
        case ACTION_TYPES$2.setDate:
        case ACTION_TYPES$2.setFinalOtpType:
        case ACTION_TYPES$2.setPhoneNumber:
        case ACTION_TYPES$2.setSubmitCount:
        case ACTION_TYPES$2.setErrorCount:
        case ACTION_TYPES$2.setSmsRequestCount:
            return __assign(__assign({}, state), (_a = {}, _a[action.type] = action.value, _a));
    }
};

var DEFAULT_TIMER = 120000;
var OtpForm = function (_a) {
    var id = _a.id, user = _a.user, tenant = _a.tenant, catalystBaseUrl = _a.catalystBaseUrl, _b = _a.ms, ms = _b === void 0 ? DEFAULT_TIMER : _b, onLogin = _a.onLogin, doMergeCart = _a.doMergeCart, doAssociateAccount = _a.doAssociateAccount, isRebrandingEnabled = _a.isRebrandingEnabled, _c = _a.otpType, otpType = _c === void 0 ? 'email' : _c, showOtp = _a.showOtp; _a.setConsents; var flowType = _a.flowType;
    var whitelabel = useContext(WhiteLabelContext);
    var toggles = useCommerceConfig('toggles');
    var isEnableSMSOption = toggles.ENABLE_SMS_OPTION || false;
    var _d = useReducer(reducer$2, __assign(__assign({}, initialState$2), { date: Date.now() + ms, finalOtpType: otpType, phoneNumber: user.phoneNumber })), state = _d[0], dispatch = _d[1];
    var otpReqParams = {
        catalystBaseUrl: catalystBaseUrl,
        emailAddress: user.email,
        tenantId: tenantId(tenant),
    };
    var handleErrors = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            errors = response.errors;
            if (errors.length) {
                if (errors[0].code === 'OTP_LOCKED_ERROR' ||
                    (errors[0].code === 'OTP_VALIDATION_ERROR' && state.errorCount >= 5)) {
                    errors[0].message = (jsxs(Fragment, { children: [jsx("b", { children: "Has superado el l\u00EDmite" }), " permitido de intentos no exitosos para iniciar sesi\u00F3n.", ' ', jsxs("b", { children: ["Envi\u00E1mos un correo a ", user.email] }), " con una contrase\u00F1a temporal para entrar a tu cuenta."] }));
                    dispatch({ type: ACTION_TYPES$2.setSmsRequestCount, value: 6 });
                }
                dispatch({ type: ACTION_TYPES$2.setError, value: errors[0].message });
            }
            return [2 /*return*/];
        });
    }); };
    var sendOtpHandler = function (e, overrideOtpType) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    dispatch({ type: ACTION_TYPES$2.setLoading, value: true });
                    dispatch({ type: ACTION_TYPES$2.setFinalOtpType, value: overrideOtpType });
                    dispatch({ type: ACTION_TYPES$2.setError, value: undefined });
                    _a = overrideOtpType;
                    switch (_a) {
                        case 'email': return [3 /*break*/, 1];
                        case 'sms': return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    if (window.s) {
                        window.s.events = 'event223';
                        window.s.tl();
                    }
                    return [4 /*yield*/, getOTPByEmailURL(otpReqParams)];
                case 2:
                    response = _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (window.s) {
                        window.s.events = 'event224';
                        window.s.tl();
                    }
                    return [4 /*yield*/, getOTPBySMSURL(otpReqParams)];
                case 4:
                    response = _c.sent();
                    dispatch({
                        type: ACTION_TYPES$2.setPhoneNumber,
                        value: (_b = response.data) === null || _b === void 0 ? void 0 : _b.phoneNumber,
                    });
                    dispatch({
                        type: ACTION_TYPES$2.setSmsRequestCount,
                        value: state.smsRequestCount + 1,
                    });
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, handleErrors(response)];
                case 6:
                    _c.sent();
                    dispatch({ type: ACTION_TYPES$2.setDate, value: Date.now() + ms });
                    dispatch({ type: ACTION_TYPES$2.setLoading, value: false });
                    return [2 /*return*/];
            }
        });
    }); };
    var submitHandler = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var otpParams, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: ACTION_TYPES$2.setLoading, value: true });
                    otpParams = {
                        email: user.email,
                        otp: values.otp,
                        tenantId: tenantId(tenant),
                        catalystBaseUrl: catalystBaseUrl,
                        doMergeCart: doMergeCart,
                        doAssociateAccount: doAssociateAccount,
                        otpType: state.finalOtpType,
                        additionalInfo: { whitelabel: whitelabel },
                    };
                    return [4 /*yield*/, loginWithOTP(otpParams)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, onLogin(response)];
                case 2:
                    _a.sent();
                    if (!(response.errors.length > 0)) return [3 /*break*/, 4];
                    if (response.errors[0].code === 'OTP_VALIDATION_ERROR') {
                        dispatch({
                            type: ACTION_TYPES$2.setErrorCount,
                            value: state.errorCount + 1,
                        });
                    }
                    return [4 /*yield*/, handleErrors(response)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    track('login_otp');
                    _a.label = 5;
                case 5:
                    dispatch({ type: ACTION_TYPES$2.setLoading, value: false });
                    actions.resetForm();
                    dispatch({
                        type: ACTION_TYPES$2.setSubmitCount,
                        value: state.submitCount + 1,
                    });
                    actions.setFieldTouched('otp', true);
                    actions.setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderCountdown = function () {
        return (jsx(Countdown$1, { date: state.date, precision: 0, zeroPadTime: 2, renderer: function (_a) {
                var _b = _a.formatted, minutes = _b.minutes, seconds = _b.seconds, completed = _a.completed;
                return (jsxs("p", __assign({ className: styles$a['help-text'] }, { children: ["\u00BFA\u00FAn no te llega? En\u00A0", jsxs("b", { children: [minutes, ":", seconds] }), "\u00A0", !isRebrandingEnabled && 'segundos ', "puedes pedir un nuevo c\u00F3digo por", completed ? (jsxs(Fragment, { children: ["\u00A0", jsx("a", __assign({ href: "#", onClick: function (e) { return sendOtpHandler(e, 'email'); } }, { children: "correo" })), state.smsRequestCount < 5 && showOtp && isEnableSMSOption ? (jsxs(Fragment, { children: ["\u00A0o\u00A0", jsx("a", __assign({ href: "#", onClick: function (e) { return sendOtpHandler(e, 'sms'); } }, { children: "SMS" }))] })) : null, "."] })) : (jsxs(Fragment, { children: ["\u00A0", jsx("span", { children: "correo" }), state.smsRequestCount < 5 && showOtp && isEnableSMSOption && (jsxs(Fragment, { children: ["\u00A0o\u00A0", jsx("span", { children: "SMS" })] })), "."] }))] })));
            } }, "otp-countdown-".concat(state.date)));
    };
    var renderOtpForm = function () {
        var title;
        if (state.finalOtpType === 'sms') {
            var maskedNumber = typeof state.phoneNumber === 'string'
                ? "".concat(state.phoneNumber.slice(0, -4).slice(0, 4), " ").concat(state.phoneNumber
                    .slice(0, -4)
                    .slice(4), " ****")
                : '';
            title = "Te enviamos tu c\u00F3digo por SMS al ".concat(maskedNumber);
        }
        if (state.finalOtpType === 'email') {
            title = "Revisa el c\u00F3digo que enviamos a ".concat(user.email);
        }
        return (jsxs("div", __assign({ id: id, className: styles$a['falw-otp-form-root'] }, { children: [state.loading && (jsx("div", __assign({ className: styles$a['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles$a.spinner }) }))), jsxs("div", __assign({ className: styles$a['otp-form-content'] }, { children: [jsx("div", __assign({ className: styles$a['otp-form-header'] }, { children: jsx("p", __assign({ className: styles$a.title }, { children: "Ingresa tu c\u00F3digo verificador" })) })), jsx(ScheduledAlerts, { componentName: "unified-login-otp-form" }), jsxs("div", __assign({ className: styles$a['alert-container'] }, { children: [tenant === 'cl' && flowType === 'checkout' ? (jsx(ScheduledAlerts, { componentName: "unified-login-otp-form-checkout-flow" })) : (jsx(ScheduledAlerts, { componentName: "unified-login-otp-form-non-checkout-flow" })), state.error && (jsx(Alert$1, __assign({ type: "warning", isRebrandingEnabled: isRebrandingEnabled }, { children: jsx("p", { children: state.error }) }))), !state.error && (jsx(Alert$1, __assign({ type: "", icon: jsx(CheckCircle, { size: 20, color: "#186F07" }), isRebrandingEnabled: isRebrandingEnabled }, { children: jsx("p", __assign({ className: styles$a['alert-title'] }, { children: title })) })))] })), jsx(Formik, __assign({ initialValues: { otp: '' }, validationSchema: create({
                                otp: create$1()
                                    .required(state.submitCount === 0 ? EMPTY_OTP_CODE_ERROR : OTP_CODE_INVALID_ERROR)
                                    .min(4, EMPTY_OTP_CODE_MIN_LENGTH),
                            }), onSubmit: submitHandler }, { children: function (_a) {
                                var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty;
                                var disabled = !(isValid && dirty) || isSubmitting;
                                return (jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$a['form-content'], state.loading && styles$a.disabled) }, { children: [jsx(PasswordField, { name: "otp", placeholder: OTP_CODE_PLACEHOLDER, maxLength: 6, isRebrandingEnabled: isRebrandingEnabled, label: undefined }), jsxs("div", __assign({ className: styles$a['actions-wrapper'] }, { children: [jsx(Button, { id: id ? "".concat(id, "-submit") : undefined, type: "submit", label: SIGN_IN, color: "primary", block: true, uppercased: !isRebrandingEnabled, disabled: disabled, isRebrandingEnabled: isRebrandingEnabled }), !isRebrandingEnabled && renderCountdown()] }))] })));
                            } }))] }))] })));
    };
    return !isRebrandingEnabled ? (renderOtpForm()) : (jsxs("div", __assign({ className: styles$a['falw-otp-form-root-rebranded'] }, { children: [renderOtpForm(), renderCountdown()] })));
};

var css_248z$9 = ".personal-data-module_falw-personal-data-form-root__aefVl{line-height:20px;padding:42px 30px;position:relative}.personal-data-module_falw-personal-data-form-root__aefVl *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.personal-data-module_falw-personal-data-form-root__aefVl *,.personal-data-module_falw-personal-data-form-root__aefVl :after,.personal-data-module_falw-personal-data-form-root__aefVl :before{box-sizing:border-box}.personal-data-module_falw-personal-data-form-root__aefVl blockquote,.personal-data-module_falw-personal-data-form-root__aefVl dd,.personal-data-module_falw-personal-data-form-root__aefVl dl,.personal-data-module_falw-personal-data-form-root__aefVl figure,.personal-data-module_falw-personal-data-form-root__aefVl h1,.personal-data-module_falw-personal-data-form-root__aefVl h2,.personal-data-module_falw-personal-data-form-root__aefVl h3,.personal-data-module_falw-personal-data-form-root__aefVl h4,.personal-data-module_falw-personal-data-form-root__aefVl h5,.personal-data-module_falw-personal-data-form-root__aefVl h6,.personal-data-module_falw-personal-data-form-root__aefVl hr,.personal-data-module_falw-personal-data-form-root__aefVl p,.personal-data-module_falw-personal-data-form-root__aefVl pre{margin:0}.personal-data-module_falw-personal-data-form-root__aefVl b{font-weight:700}@media (min-width:640px){.personal-data-module_falw-personal-data-form-root__aefVl{padding:30px 50px}}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_disabled__yC6kR{opacity:.3}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-body__4sBp5>:not([hidden])~:not([hidden]),.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_personal-data-form-content__xDJfL>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(16px*var(--tw-space-y-reverse));margin-top:calc(16px*(1 - var(--tw-space-y-reverse)))}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_personal-data-form-header__PCqkI>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_personal-data-form-header__PCqkI .personal-data-module_title__yuzz1{font-size:24px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_personal-data-form-header__PCqkI .personal-data-module_subtitle__EHI4w{display:inline-block;font-size:16px;padding-bottom:15px;padding-top:15px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_alert-container__zmTF7>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_alert-container__zmTF7{font-size:14px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_alert-container__zmTF7 .personal-data-module_alert-title__i0OnA{color:#767676;line-height:20px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_alert-container__zmTF7 .personal-data-module_alert-subtitle__CQd3g{color:#767676;font-size:13px;font-weight:700;line-height:20px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_help-text__nMOCz{color:#767676;display:inline-block;font-size:14px;text-align:left}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_help-text__nMOCz a{color:#767676;text-decoration-line:underline}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_spinner-wrapper__NbztC{align-items:center;color:#343e49;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes personal-data-module_spin__6XEix{to{transform:rotate(1turn)}}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_spinner-wrapper__NbztC .personal-data-module_spinner__9-Npp{animation:personal-data-module_spin__6XEix 1s linear infinite}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F{color:#767676}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F .personal-data-module_actions-wrapper__JGsdV>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F .personal-data-module_actions-wrapper__JGsdV{text-align:center}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F>.personal-data-module_consent-item__yWv0n:nth-child(4){margin-top:35px!important}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F>.personal-data-module_consent-item__yWv0n:nth-child(5){margin-top:10px!important}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F .personal-data-module_consent-item__yWv0n{align-items:center}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F .personal-data-module_consent-item__yWv0n .personal-data-module_consent-label__MWZZn{color:#333;line-height:17px;margin-left:9px;text-decoration:none}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-content__n3I8F .personal-data-module_consent-item__yWv0n .personal-data-module_consent-label__MWZZn div{border-bottom:1px solid #495867;color:#495867;display:inline;line-height:17px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-input__-HHI1{margin-bottom:0}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_consent-item__yWv0n{display:flex}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_consent-item__yWv0n .personal-data-module_consent-label__MWZZn{color:#4a8431;flex-grow:1;font-size:14px;text-align:left;text-decoration-line:underline}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_consent-item__yWv0n .personal-data-module_consent-label__MWZZn a{cursor:pointer}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_consent-item__yWv0n .personal-data-module_consent-control__O7P-j{display:flex}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y{display:block;position:relative}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y input{background:none!important;border-radius:0;height:23px;width:23px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y input:checked{opacity:0}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y input:checked~.personal-data-module_checkmark__hRYFV{opacity:1}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y .personal-data-module_checkmark__hRYFV{background-color:#fff;border:1px solid #ff6200;border-radius:3px;display:block;height:23px;left:4px;opacity:0;pointer-events:none;position:absolute;top:3px;width:23px}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y .personal-data-module_checkmark__hRYFV svg path{fill:#ff6200}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y label{display:inline-block;font-size:14px;line-height:20px;line-height:200%;padding-left:7px;vertical-align:top}.personal-data-module_falw-personal-data-form-root__aefVl .personal-data-module_form-check__gHY7Y label a{color:inherit}";
var styles$9 = {"falw-personal-data-form-root":"personal-data-module_falw-personal-data-form-root__aefVl","disabled":"personal-data-module_disabled__yC6kR","personal-data-form-content":"personal-data-module_personal-data-form-content__xDJfL","form-body":"personal-data-module_form-body__4sBp5","personal-data-form-header":"personal-data-module_personal-data-form-header__PCqkI","title":"personal-data-module_title__yuzz1","subtitle":"personal-data-module_subtitle__EHI4w","alert-container":"personal-data-module_alert-container__zmTF7","alert-title":"personal-data-module_alert-title__i0OnA","alert-subtitle":"personal-data-module_alert-subtitle__CQd3g","help-text":"personal-data-module_help-text__nMOCz","spinner-wrapper":"personal-data-module_spinner-wrapper__NbztC","spinner":"personal-data-module_spinner__9-Npp","spin":"personal-data-module_spin__6XEix","form-content":"personal-data-module_form-content__n3I8F","actions-wrapper":"personal-data-module_actions-wrapper__JGsdV","consent-item":"personal-data-module_consent-item__yWv0n","consent-label":"personal-data-module_consent-label__MWZZn","form-input":"personal-data-module_form-input__-HHI1","consent-control":"personal-data-module_consent-control__O7P-j","form-check":"personal-data-module_form-check__gHY7Y","checkmark":"personal-data-module_checkmark__hRYFV"};
styleInject(css_248z$9);

var PersonalDataFormAlert = function (_a) {
    var error = _a.error;
    return (jsx(Alert$1, __assign({ type: error.hasError && 'warning', isRebrandingEnabled: true }, { children: jsxs(Fragment$1, { children: [!error.hasError && (jsx("div", __assign({ className: styles$9['alert-container'] }, { children: jsx("p", __assign({ className: styles$9['alert-title'] }, { children: error.title })) }))), error.hasError && jsx("p", { children: error.message })] }) })));
};

var STAGES;
(function (STAGES) {
    STAGES[STAGES["consent"] = 0] = "consent";
    STAGES[STAGES["legalText"] = 1] = "legalText";
    STAGES[STAGES["login"] = 2] = "login";
    STAGES[STAGES["notice"] = 3] = "notice";
    STAGES[STAGES["otpEmail"] = 4] = "otpEmail";
    STAGES[STAGES["otpSMS"] = 5] = "otpSMS";
    STAGES[STAGES["password"] = 6] = "password";
    STAGES[STAGES["personalData"] = 7] = "personalData";
    STAGES[STAGES["personalDataWithoutConsent"] = 8] = "personalDataWithoutConsent";
    STAGES[STAGES["simplePassword"] = 9] = "simplePassword";
    STAGES[STAGES["feedback"] = 10] = "feedback";
    STAGES[STAGES["newDeviceLogin"] = 11] = "newDeviceLogin";
})(STAGES || (STAGES = {}));
var ACTION_TYPES$1;
(function (ACTION_TYPES) {
    ACTION_TYPES["setStage"] = "stage";
    ACTION_TYPES["setConsents"] = "consents";
    ACTION_TYPES["setLegalText"] = "legalText";
    ACTION_TYPES["setCompleted"] = "completed";
    ACTION_TYPES["setUser"] = "user";
    ACTION_TYPES["setOtpErrors"] = "otpErrors";
    ACTION_TYPES["setOtpTrigger"] = "otpTrigger";
    ACTION_TYPES["setCatalystBaseUrl"] = "catalystBaseUrl";
    ACTION_TYPES["resetState"] = "resetState";
})(ACTION_TYPES$1 || (ACTION_TYPES$1 = {}));
var initialState$1 = {
    stage: undefined,
    consents: [],
    legalText: undefined,
    completed: false,
    user: undefined,
    otpErrors: [],
    otpTrigger: undefined,
    catalystBaseUrl: undefined,
};
var reducer$1 = function (state, action) {
    var _a;
    switch (action.type) {
        case ACTION_TYPES$1.setStage:
        case ACTION_TYPES$1.setConsents:
        case ACTION_TYPES$1.setLegalText:
        case ACTION_TYPES$1.setCompleted:
        case ACTION_TYPES$1.setUser:
        case ACTION_TYPES$1.setOtpErrors:
        case ACTION_TYPES$1.setOtpTrigger:
        case ACTION_TYPES$1.setCatalystBaseUrl:
            return __assign(__assign({}, state), (_a = {}, _a[action.type] = action.value, _a));
        case ACTION_TYPES$1.resetState:
            return initialState$1;
    }
};

function getTenantDetailsFromProps(tenantIDProp) {
    if (!tenantIDProp)
        return null;
    var _a = tenantIDProp.split('-'), countryCode = _a[1];
    return { tenantID: tenantIDProp, countryCode: countryCode };
}
var getTenantDetailsFromBrowser = function () {
    if (!isBrowser$1())
        return null;
    var matches = window.location.href.match(/\w+-(cl|pe|co|ar|mx)/);
    if (!matches)
        return null;
    var urlPrefix = matches[0], countryCode = matches[1];
    if (!urlPrefix)
        return null;
    var sellerExperience = getCookie('seller_experience') || 'MARKETPLACE';
    var tenantID = sellerExperience === 'MARKETPLACE' ? tenantId(countryCode) : urlPrefix;
    return { tenantID: tenantID, countryCode: countryCode };
};
var TenantDetailsContext = createContext(null);
var TenantDetailsProvider = function (props) {
    var children = props.children, tenantId = props.tenantId, tenantID = props.tenantID;
    var tenantIDProp = tenantID || tenantId;
    var _a = useState(getTenantDetailsFromProps(tenantIDProp)), tenantDetails = _a[0], setTenantDetails = _a[1];
    useEffect(function () {
        var tenantIDInRef = tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.tenantID;
        var countryCodeInRef = tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.countryCode;
        if (tenantIDInRef && countryCodeInRef)
            return;
        setTenantDetails(getTenantDetailsFromBrowser());
    }, []);
    return (jsx(TenantDetailsContext.Provider, __assign({ value: tenantDetails }, { children: children })));
};
var withTenantDetails = function (Component) { return function (props) { return (jsx(TenantDetailsContext.Consumer, { children: function (tenantDetails) { return (jsx(Component, __assign({}, props, { tenantID: (props === null || props === void 0 ? void 0 : props.tenantID) || (props === null || props === void 0 ? void 0 : props.tenantId) || (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.tenantID), countryCode: (props === null || props === void 0 ? void 0 : props.countryCode) || (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.countryCode) }))); } })); }; };

var _a$2;
var numeric = /^[0-9]*$/;
var alphabetOrNumber = /^[0-9A-K]$/;
var rutCleanup = /^0+|[^0-9kK]+|s/g;
var rutFormat = /^[1-9]\d?\.?\d{3}\.?\d{3}-[0-9kK]$/;
var invalidRUTs = /^([1-9])\1{6,7}-?(\1|[^\d])$/i;
var dniCleanup = /[^0-9A-K]+|\s/gi;
var multiples = [3, 2, 7, 6, 5, 4, 3, 2];
var dcontrols = {
    numbers: [6, 7, 8, 9, 0, 1, 1, 2, 3, 4, 5],
    letters: ['K', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
};
var DocumentType;
(function (DocumentType) {
    DocumentType["RUT"] = "RUT";
    DocumentType["DNI"] = "DNI";
    DocumentType["CE"] = "CE";
    DocumentType["CC"] = "CC";
})(DocumentType || (DocumentType = {}));
var cleanRUT = function (value) {
    return (value === null || value === void 0 ? void 0 : value.replace(rutCleanup, '').toUpperCase()) || '';
};
var formatRUT = function (value, noDots) {
    if (noDots === void 0) { noDots = false; }
    var fieldValue = cleanRUT(value);
    var rut = fieldValue.length > 1 ? "".concat(fieldValue.slice(-4, -1), "-").concat(fieldValue.slice(-1)) : fieldValue;
    var dot = noDots ? '' : '.';
    for (var i = 4; i < fieldValue.length; i += 3) {
        rut = "".concat(fieldValue.slice(-3 - i, -i)).concat(dot).concat(rut);
    }
    return rut;
};
var isValidRUT = function (value) {
    if (!rutFormat.test(value)) {
        return false;
    }
    var rut = cleanRUT(value);
    if (invalidRUTs.test(rut))
        return false;
    var numericPart = parseInt(rut.slice(0, -1), 10);
    var acc = 1;
    var modifier = 0;
    while (numericPart > 0) {
        acc = (acc + (numericPart % 10) * (9 - (modifier % 6))) % 11;
        modifier += 1;
        numericPart = Math.floor(numericPart / 10);
    }
    return (acc > 0 ? (acc - 1).toString() : 'K') === rut.slice(-1);
};
var cleanDNI = function (value) { return value.replace(dniCleanup, '').toUpperCase(); };
var formatDNI = function (value) {
    var fieldValue = value ? cleanDNI(value) : '';
    return fieldValue.length > 8 ? "".concat(fieldValue.slice(0, -1), "-").concat(fieldValue.slice(-1)) : fieldValue;
};
var isValidDNI = function (dniString) {
    var formattedDNI = formatDNI(dniString);
    var _a = formattedDNI.split('-'), dni = _a[0], dniDv = _a[1];
    if (!dni || dni.length !== 8 || !dniDv)
        return false;
    if (!numeric.test(dni))
        return false;
    if (!alphabetOrNumber.test(dniDv))
        return false;
    var numdni = dni.split('');
    var dsum = numdni.reduce(function (acc, digit, index) {
        return acc + Number.parseInt(digit, 10) * multiples[index];
    }, 0);
    var key = 11 - (dsum % 11);
    var index = key === 11 ? 0 : key;
    if (/^\d{1}/.test(dniDv)) {
        return dcontrols.numbers[index] === parseInt(dniDv, 10);
    }
    return dcontrols.letters[index] === dniDv;
};
var isValidCC = function (value) {
    if (!value)
        return false;
    var valueLength = value.trim().length;
    var validLength = valueLength >= 4 && valueLength <= 10;
    var onlyNumbers = /^[0-9]+$/.test(value.trim());
    return validLength && onlyNumbers;
};
var isValidCE = function (value, tenant) {
    if (!value)
        return false;
    if (tenant === Tenant.Peru)
        return true;
    var valueLength = value.trim().length;
    var startsWithLetterE = value.charAt(0) === 'E' && numeric.test(value.trim().substring(1));
    var validateForDocumentTypeCE = (startsWithLetterE && valueLength === 11) || (numeric.test(value) && valueLength === 10);
    return validateForDocumentTypeCE;
};
var validatorMap = (_a$2 = {},
    _a$2[DocumentType.RUT] = isValidRUT,
    _a$2[DocumentType.DNI] = isValidDNI,
    _a$2[DocumentType.CC] = isValidCC,
    _a$2[DocumentType.CE] = isValidCE,
    _a$2);
var validateDocument = function (type, value) {
    var additionalParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalParams[_i - 2] = arguments[_i];
    }
    return validatorMap[type].apply(null, __spreadArray([value], additionalParams, true));
};

function o$2(){let a=[],i=[],n={enqueue(e){i.push(e);},addEventListener(e,t,r,s){return e.addEventListener(t,r,s),n.add(()=>e.removeEventListener(t,r,s))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return n.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return n.requestAnimationFrame(()=>n.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return n.add(()=>clearTimeout(t))},add(e){return a.push(e),()=>{let t=a.indexOf(e);if(t>=0){let[r]=a.splice(t,1);r();}}},dispose(){for(let e of a.splice(0))e();},async workQueue(){for(let e of i.splice(0))await e();}};return n}

function p$4(){let[e]=useState(o$2);return useEffect(()=>()=>e.dispose(),[e]),e}

const t$2=typeof window!="undefined"?useLayoutEffect:useEffect;

let r$2={serverHandoffComplete:!1};function a$1(){let[e,f]=useState(r$2.serverHandoffComplete);return useEffect(()=>{e!==!0&&f(!0);},[e]),useEffect(()=>{r$2.serverHandoffComplete===!1&&(r$2.serverHandoffComplete=!0);},[]),e}

var u$1;let l$2=0;function r$1(){return ++l$2}let I$1=(u$1=React__default.useId)!=null?u$1:function(){let n=a$1(),[e,o]=React__default.useState(n?r$1:null);return t$2(()=>{e===null&&o(r$1());},[e]),e!=null?""+e:void 0};

function s$4(e){let r=useRef(e);return t$2(()=>{r.current=e;},[e]),r}

function i$3(e,o){let[u,t]=useState(e),r=s$4(e);return t$2(()=>t(r.current),[r,t,...o]),u}

let l$1=Symbol();function T$2(...n){let t=useRef(n);useEffect(()=>{t.current=n;},[n]);let c=useCallback(e=>{for(let u of t.current)u!=null&&(typeof u=="function"?u(e):u.current=e);},[t]);return n.every(e=>e==null||(e==null?void 0:e[l$1]))?void 0:c}

function u(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,u),t}

var b=(n=>(n[n.None=0]="None",n[n.RenderStrategy=1]="RenderStrategy",n[n.Static=2]="Static",n))(b||{}),x$2=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(x$2||{});function A({ourProps:r,theirProps:t,slot:e,defaultTag:n,features:o,visible:a=!0,name:l}){let s=m(t,r);if(a)return p$3(s,e,n,l);let u$1=o!=null?o:0;if(u$1&2){let{static:i=!1,...d}=s;if(i)return p$3(d,e,n,l)}if(u$1&1){let{unmount:i=!0,...d}=s;return u(i?0:1,{[0](){return null},[1](){return p$3({...d,hidden:!0,style:{display:"none"}},e,n,l)}})}return p$3(s,e,n,l)}function p$3(r,t={},e,n){let{as:o=e,children:a,refName:l="ref",...s}=f$4(r,["unmount","static"]),u=r.ref!==void 0?{[l]:r.ref}:{},i=typeof a=="function"?a(t):a;if(s.className&&typeof s.className=="function"&&(s.className=s.className(t)),o===Fragment$1&&Object.keys(y(s)).length>0){if(!isValidElement(i)||Array.isArray(i)&&i.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${n} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(s).map(d=>`  - ${d}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(d=>`  - ${d}`).join(`
`)].join(`
`));return cloneElement(i,Object.assign({},m(i.props,y(f$4(s,["ref"]))),u))}return createElement(o,Object.assign({},f$4(s,["ref"]),o!==Fragment$1&&u),i)}function m(...r){if(r.length===0)return {};if(r.length===1)return r[0];let t={},e={};for(let o of r)for(let a in o)a.startsWith("on")&&typeof o[a]=="function"?((e[a])!=null||(e[a]=[]),e[a].push(o[a])):t[a]=o[a];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(o=>[o,void 0])));for(let o in e)Object.assign(t,{[o](a){let l=e[o];for(let s of l){if(a.defaultPrevented)return;s(a);}}});return t}function H(r){var t;return Object.assign(forwardRef(r),{displayName:(t=r.displayName)!=null?t:r.name})}function y(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function f$4(r,t=[]){let e=Object.assign({},r);for(let n of t)n in e&&delete e[n];return e}

var o$1=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(o$1||{});

function f$3(r){throw new Error("Unexpected object: "+r)}var a=(e=>(e[e.First=0]="First",e[e.Previous=1]="Previous",e[e.Next=2]="Next",e[e.Last=3]="Last",e[e.Specific=4]="Specific",e[e.Nothing=5]="Nothing",e))(a||{});function x$1(r,n){let t=n.resolveItems();if(t.length<=0)return null;let l=n.resolveActiveIndex(),s=l!=null?l:-1,d=(()=>{switch(r.focus){case 0:return t.findIndex(e=>!n.resolveDisabled(e));case 1:{let e=t.slice().reverse().findIndex((i,c,u)=>s!==-1&&u.length-c-1>=s?!1:!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 2:return t.findIndex((e,i)=>i<=s?!1:!n.resolveDisabled(e));case 3:{let e=t.slice().reverse().findIndex(i=>!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 4:return t.findIndex(e=>n.resolveId(e)===r.id);case 5:return null;default:f$3(r);}})();return d===-1?l:d}

function r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&i$2(l)?!1:t}function i$2(n){if(!n)return !1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return !1;e=e.previousElementSibling;}return !0}

function t$1(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}));}

function s$3(e,r,n){let o=s$4(r);useEffect(()=>{function t(i){o.current(i);}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n]);}

var C$2=(r=>(r[r.None=1]="None",r[r.IgnoreScrollbars=2]="IgnoreScrollbars",r))(C$2||{});function w(c,a,r=1){let i=useRef(!1),l=s$4(n=>{if(i.current)return;i.current=!0,t$1(()=>{i.current=!1;});let f=function t(e){return typeof e=="function"?t(e()):Array.isArray(e)||e instanceof Set?e:[e]}(c),o=n.target;if(!!o.ownerDocument.documentElement.contains(o)){if((r&2)===2){let t=20,e=o.ownerDocument.documentElement;if(n.clientX>e.clientWidth-t||n.clientX<t||n.clientY>e.clientHeight-t||n.clientY<t)return}for(let t of f){if(t===null)continue;let e=t instanceof HTMLElement?t:t.current;if(e!=null&&e.contains(o))return}return a(n,o)}});s$3("pointerdown",(...n)=>l.current(...n)),s$3("mousedown",(...n)=>l.current(...n));}

let o=createContext(null);o.displayName="OpenClosedContext";var p$2=(e=>(e[e.Open=0]="Open",e[e.Closed=1]="Closed",e))(p$2||{});function s$2(){return useContext(o)}function C$1({value:t,children:n}){return React__default.createElement(o.Provider,{value:t},n)}

function i$1(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return "button"}function s$1(t,e){let[n,u]=useState(()=>i$1(t));return t$2(()=>{u(i$1(t));},[t.type,t.as]),t$2(()=>{n||!e.current||e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button");},[n,e]),n}

function t(n){return typeof window=="undefined"?null:n instanceof Node?n.ownerDocument:n!=null&&n.hasOwnProperty("current")&&n.current instanceof Node?n.current.ownerDocument:document}

let f$2=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var E=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(E||{}),p$1=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(p$1||{}),L=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(L||{});var T$1=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(T$1||{});function O(e,r=0){var t$1;return e===((t$1=t(e))==null?void 0:t$1.body)?!1:u(r,{[0](){return e.matches(f$2)},[1](){let l=e;for(;l!==null;){if(l.matches(f$2))return !0;l=l.parentElement;}return !1}})}function h$1(e,r=t=>t){return e.slice().sort((t,l)=>{let o=r(t),a=r(l);if(o===null||a===null)return 0;let n=o.compareDocumentPosition(a);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0})}

let i="div",h=H(function(e,r){return A({ourProps:{ref:r,style:{position:"absolute",width:1,height:1,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",display:"none"}},theirProps:e,slot:{},defaultTag:i,name:"VisuallyHidden"})});

function e(n={},r=null,t=[]){for(let[i,o]of Object.entries(n))f$1(t,s(r,i),o);return t}function s(n,r){return n?n+"["+r+"]":r}function f$1(n,r,t){if(Array.isArray(t))for(let[i,o]of t.entries())f$1(n,s(r,i.toString()),o);else t instanceof Date?n.push([r,t.toISOString()]):typeof t=="boolean"?n.push([r,t?"1":"0"]):typeof t=="string"?n.push([r,t]):typeof t=="number"?n.push([r,`${t}`]):t==null?n.push([r,""]):e(t,r,n);}

function f(){let e=useRef(!1);return t$2(()=>(e.current=!0,()=>{e.current=!1;}),[]),e}

var pe=(n=>(n[n.Open=0]="Open",n[n.Closed=1]="Closed",n))(pe||{}),ue=(n=>(n[n.Single=0]="Single",n[n.Multi=1]="Multi",n))(ue||{}),de=(n=>(n[n.Pointer=0]="Pointer",n[n.Other=1]="Other",n))(de||{}),ce=(a=>(a[a.OpenListbox=0]="OpenListbox",a[a.CloseListbox=1]="CloseListbox",a[a.SetDisabled=2]="SetDisabled",a[a.SetOrientation=3]="SetOrientation",a[a.GoToOption=4]="GoToOption",a[a.Search=5]="Search",a[a.ClearSearch=6]="ClearSearch",a[a.RegisterOption=7]="RegisterOption",a[a.UnregisterOption=8]="UnregisterOption",a))(ce||{});function _(t,i=n=>n){let n=t.activeOptionIndex!==null?t.options[t.activeOptionIndex]:null,e=h$1(i(t.options.slice()),p=>p.dataRef.current.domRef.current),o=n?e.indexOf(n):null;return o===-1&&(o=null),{options:e,activeOptionIndex:o}}let fe={[1](t){return t.disabled||t.listboxState===1?t:{...t,activeOptionIndex:null,listboxState:1}},[0](t){if(t.disabled||t.listboxState===0)return t;let i=t.activeOptionIndex,{value:n,mode:e}=t.propsRef.current,o=t.options.findIndex(p=>{let r=p.dataRef.current.value;return u(e,{[1]:()=>n.includes(r),[0]:()=>n===r})});return o!==-1&&(i=o),{...t,listboxState:0,activeOptionIndex:i}},[2](t,i){return t.disabled===i.disabled?t:{...t,disabled:i.disabled}},[3](t,i){return t.orientation===i.orientation?t:{...t,orientation:i.orientation}},[4](t,i){var o;if(t.disabled||t.listboxState===1)return t;let n=_(t),e=x$1(i,{resolveItems:()=>n.options,resolveActiveIndex:()=>n.activeOptionIndex,resolveId:p=>p.id,resolveDisabled:p=>p.dataRef.current.disabled});return {...t,...n,searchQuery:"",activeOptionIndex:e,activationTrigger:(o=i.trigger)!=null?o:1}},[5]:(t,i)=>{if(t.disabled||t.listboxState===1)return t;let e=t.searchQuery!==""?0:1,o=t.searchQuery+i.value.toLowerCase(),r=(t.activeOptionIndex!==null?t.options.slice(t.activeOptionIndex+e).concat(t.options.slice(0,t.activeOptionIndex+e)):t.options).find(u=>{var a;return !u.dataRef.current.disabled&&((a=u.dataRef.current.textValue)==null?void 0:a.startsWith(o))}),s=r?t.options.indexOf(r):-1;return s===-1||s===t.activeOptionIndex?{...t,searchQuery:o}:{...t,searchQuery:o,activeOptionIndex:s,activationTrigger:1}},[6](t){return t.disabled||t.listboxState===1||t.searchQuery===""?t:{...t,searchQuery:""}},[7]:(t,i)=>{let n={id:i.id,dataRef:i.dataRef},e=_(t,o=>[...o,n]);if(t.activeOptionIndex===null){let{value:o,mode:p}=t.propsRef.current,r=i.dataRef.current.value;u(p,{[1]:()=>o.includes(r),[0]:()=>o===r})&&(e.activeOptionIndex=e.options.indexOf(n));}return {...t,...e}},[8]:(t,i)=>{let n=_(t,e=>{let o=e.findIndex(p=>p.id===i.id);return o!==-1&&e.splice(o,1),e});return {...t,...n,activationTrigger:1}}},V=createContext(null);V.displayName="ListboxContext";function I(t){let i=useContext(V);if(i===null){let n=new Error(`<${t} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,I),n}return i}function be$1(t,i){return u(i.type,fe,t,i)}let Te=Fragment$1,xe$1=H(function(i,n){let{value:e$1,name:o,onChange:p,disabled:r=!1,horizontal:s=!1,multiple:u$1=!1,...a}=i;const y$1=s?"horizontal":"vertical";let g=T$2(n),v=useReducer(be$1,{listboxState:1,propsRef:{current:{value:e$1,onChange:p,mode:u$1?1:0}},labelRef:createRef(),buttonRef:createRef(),optionsRef:createRef(),disabled:r,orientation:y$1,options:[],searchQuery:"",activeOptionIndex:null,activationTrigger:1}),[{listboxState:f,propsRef:O$1,optionsRef:S,buttonRef:d},l]=v;O$1.current.value=e$1,O$1.current.mode=u$1?1:0,t$2(()=>{O$1.current.onChange=L=>u(O$1.current.mode,{[0](){return p(L)},[1](){let T=O$1.current.value.slice(),x=T.indexOf(L);return x===-1?T.push(L):T.splice(x,1),p(T)}});},[p,O$1]),t$2(()=>l({type:2,disabled:r}),[r]),t$2(()=>l({type:3,orientation:y$1}),[y$1]),w([d,S],(L,T)=>{var x;f===0&&(l({type:1}),O(T,T$1.Loose)||(L.preventDefault(),(x=d.current)==null||x.focus()));});let c=useMemo(()=>({open:f===0,disabled:r}),[f,r]),P={ref:g};return React__default.createElement(V.Provider,{value:v},React__default.createElement(C$1,{value:u(f,{[0]:p$2.Open,[1]:p$2.Closed})},o!=null&&e$1!=null&&e({[o]:e$1}).map(([L,T])=>React__default.createElement(h,{...y({key:L,as:"input",type:"hidden",hidden:!0,readOnly:!0,name:L,value:T})})),A({ourProps:P,theirProps:a,slot:c,defaultTag:Te,name:"Listbox"})))}),ye="button",Oe=H(function(i,n){var S;let[e,o]=I("Listbox.Button"),p=T$2(e.buttonRef,n),r$1=`headlessui-listbox-button-${I$1()}`,s=p$4(),u=useCallback(d=>{switch(d.key){case o$1.Space:case o$1.Enter:case o$1.ArrowDown:d.preventDefault(),o({type:0}),s.nextFrame(()=>{e.propsRef.current.value||o({type:4,focus:a.First});});break;case o$1.ArrowUp:d.preventDefault(),o({type:0}),s.nextFrame(()=>{e.propsRef.current.value||o({type:4,focus:a.Last});});break}},[o,e,s]),a$1=useCallback(d=>{switch(d.key){case o$1.Space:d.preventDefault();break}},[]),y=useCallback(d=>{if(r(d.currentTarget))return d.preventDefault();e.listboxState===0?(o({type:1}),s.nextFrame(()=>{var l;return (l=e.buttonRef.current)==null?void 0:l.focus({preventScroll:!0})})):(d.preventDefault(),o({type:0}));},[o,s,e]),g=i$3(()=>{if(!!e.labelRef.current)return [e.labelRef.current.id,r$1].join(" ")},[e.labelRef.current,r$1]),v=useMemo(()=>({open:e.listboxState===0,disabled:e.disabled}),[e]),f=i,O={ref:p,id:r$1,type:s$1(i,e.buttonRef),"aria-haspopup":!0,"aria-controls":(S=e.optionsRef.current)==null?void 0:S.id,"aria-expanded":e.disabled?void 0:e.listboxState===0,"aria-labelledby":g,disabled:e.disabled,onKeyDown:u,onKeyUp:a$1,onClick:y};return A({ourProps:O,theirProps:f,slot:v,defaultTag:ye,name:"Listbox.Button"})}),ge$1="label",Re=H(function(i,n){let[e]=I("Listbox.Label"),o=`headlessui-listbox-label-${I$1()}`,p=T$2(e.labelRef,n),r=useCallback(()=>{var y;return (y=e.buttonRef.current)==null?void 0:y.focus({preventScroll:!0})},[e.buttonRef]),s=useMemo(()=>({open:e.listboxState===0,disabled:e.disabled}),[e]);return A({ourProps:{ref:p,id:o,onClick:r},theirProps:i,slot:s,defaultTag:ge$1,name:"Listbox.Label"})}),me="ul",Le=b.RenderStrategy|b.Static,ve$1=H(function(i,n){var d;let[e,o]=I("Listbox.Options"),p=T$2(e.optionsRef,n),r=`headlessui-listbox-options-${I$1()}`,s=p$4(),u$1=p$4(),a$1=s$2(),y=(()=>a$1!==null?a$1===p$2.Open:e.listboxState===0)();useEffect(()=>{var c;let l=e.optionsRef.current;!l||e.listboxState===0&&l!==((c=t(l))==null?void 0:c.activeElement)&&l.focus({preventScroll:!0});},[e.listboxState,e.optionsRef]);let g=useCallback(l=>{switch(u$1.dispose(),l.key){case o$1.Space:if(e.searchQuery!=="")return l.preventDefault(),l.stopPropagation(),o({type:5,value:l.key});case o$1.Enter:if(l.preventDefault(),l.stopPropagation(),e.activeOptionIndex!==null){let{dataRef:c}=e.options[e.activeOptionIndex];e.propsRef.current.onChange(c.current.value);}e.propsRef.current.mode===0&&(o({type:1}),o$2().nextFrame(()=>{var c;return (c=e.buttonRef.current)==null?void 0:c.focus({preventScroll:!0})}));break;case u(e.orientation,{vertical:o$1.ArrowDown,horizontal:o$1.ArrowRight}):return l.preventDefault(),l.stopPropagation(),o({type:4,focus:a.Next});case u(e.orientation,{vertical:o$1.ArrowUp,horizontal:o$1.ArrowLeft}):return l.preventDefault(),l.stopPropagation(),o({type:4,focus:a.Previous});case o$1.Home:case o$1.PageUp:return l.preventDefault(),l.stopPropagation(),o({type:4,focus:a.First});case o$1.End:case o$1.PageDown:return l.preventDefault(),l.stopPropagation(),o({type:4,focus:a.Last});case o$1.Escape:return l.preventDefault(),l.stopPropagation(),o({type:1}),s.nextFrame(()=>{var c;return (c=e.buttonRef.current)==null?void 0:c.focus({preventScroll:!0})});case o$1.Tab:l.preventDefault(),l.stopPropagation();break;default:l.key.length===1&&(o({type:5,value:l.key}),u$1.setTimeout(()=>o({type:6}),350));break}},[s,o,u$1,e]),v=i$3(()=>{var l,c,P;return (P=(l=e.labelRef.current)==null?void 0:l.id)!=null?P:(c=e.buttonRef.current)==null?void 0:c.id},[e.labelRef.current,e.buttonRef.current]),f=useMemo(()=>({open:e.listboxState===0}),[e]),O=i,S={"aria-activedescendant":e.activeOptionIndex===null||(d=e.options[e.activeOptionIndex])==null?void 0:d.id,"aria-multiselectable":e.propsRef.current.mode===1?!0:void 0,"aria-labelledby":v,"aria-orientation":e.orientation,id:r,onKeyDown:g,role:"listbox",tabIndex:0,ref:p};return A({ourProps:S,theirProps:O,slot:f,defaultTag:me,features:Le,visible:y,name:"Listbox.Options"})}),Se$1="li",Ae=H(function(i,n){let{disabled:e=!1,value:o,...p}=i,[r,s]=I("Listbox.Option"),u$1=`headlessui-listbox-option-${I$1()}`,a$1=r.activeOptionIndex!==null?r.options[r.activeOptionIndex].id===u$1:!1,y=u(r.propsRef.current.mode,{[1]:()=>r.propsRef.current.value.includes(o),[0]:()=>r.propsRef.current.value===o}),g=useRef(null),v=T$2(n,g);t$2(()=>{if(r.listboxState!==0||!a$1||r.activationTrigger===0)return;let T=o$2();return T.requestAnimationFrame(()=>{var x,j;(j=(x=g.current)==null?void 0:x.scrollIntoView)==null||j.call(x,{block:"nearest"});}),T.dispose},[g,a$1,r.listboxState,r.activationTrigger,r.activeOptionIndex]);let f=useRef({disabled:e,value:o,domRef:g});t$2(()=>{f.current.disabled=e;},[f,e]),t$2(()=>{f.current.value=o;},[f,o]),t$2(()=>{var T,x;f.current.textValue=(x=(T=g.current)==null?void 0:T.textContent)==null?void 0:x.toLowerCase();},[f,g]);let O=useCallback(()=>r.propsRef.current.onChange(o),[r.propsRef,o]);t$2(()=>(s({type:7,id:u$1,dataRef:f}),()=>s({type:8,id:u$1})),[f,u$1]);let S=useCallback(T=>{if(e)return T.preventDefault();O(),r.propsRef.current.mode===0&&(s({type:1}),o$2().nextFrame(()=>{var x;return (x=r.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})}));},[s,r.buttonRef,e,O]),d=useCallback(()=>{if(e)return s({type:4,focus:a.Nothing});s({type:4,focus:a.Specific,id:u$1});},[e,u$1,s]),l=useCallback(()=>{e||a$1||s({type:4,focus:a.Specific,id:u$1,trigger:0});},[e,a$1,u$1,s]),c=useCallback(()=>{e||!a$1||s({type:4,focus:a.Nothing});},[e,a$1,s]),P=useMemo(()=>({active:a$1,selected:y,disabled:e}),[a$1,y,e]);return A({ourProps:{id:u$1,ref:v,role:"option",tabIndex:e===!0?void 0:-1,"aria-disabled":e===!0?!0:void 0,"aria-selected":y===!0?!0:void 0,disabled:void 0,onClick:S,onFocus:d,onPointerMove:l,onMouseMove:l,onPointerLeave:c,onMouseLeave:c},theirProps:p,slot:P,defaultTag:Se$1,name:"Listbox.Option"})}),et=Object.assign(xe$1,{Button:Oe,Label:Re,Options:ve$1,Option:Ae});

function l(r){let e={called:!1};return (...t)=>{if(!e.called)return e.called=!0,r(...t)}}

function p(t,...e){t&&e.length>0&&t.classList.add(...e);}function v(t,...e){t&&e.length>0&&t.classList.remove(...e);}var g=(n=>(n.Ended="ended",n.Cancelled="cancelled",n))(g||{});function T(t,e){let n=o$2();if(!t)return n.dispose;let{transitionDuration:l,transitionDelay:a}=getComputedStyle(t),[d,s]=[l,a].map(i=>{let[r=0]=i.split(",").filter(Boolean).map(o=>o.includes("ms")?parseFloat(o):parseFloat(o)*1e3).sort((o,E)=>E-o);return r});if(d+s!==0){let i=[];i.push(n.addEventListener(t,"transitionrun",()=>{i.splice(0).forEach(r=>r()),i.push(n.addEventListener(t,"transitionend",()=>{e("ended"),i.splice(0).forEach(r=>r());},{once:!0}),n.addEventListener(t,"transitioncancel",()=>{e("cancelled"),i.splice(0).forEach(r=>r());},{once:!0}));},{once:!0}));}else e("ended");return n.add(()=>e("cancelled")),n.dispose}function C(t,e,n,l$1){let a=n?"enter":"leave",d=o$2(),s=l$1!==void 0?l(l$1):()=>{},m=u(a,{enter:()=>e.enter,leave:()=>e.leave}),i=u(a,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=u(a,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return v(t,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),p(t,...m,...r),d.nextFrame(()=>{v(t,...r),p(t,...i),T(t,o=>(o==="ended"&&(v(t,...m),p(t,...e.entered)),s(o)));}),d.dispose}

function x({container:u$1,direction:o,classes:c,events:t,onStart:d,onStop:l}){let f$1=f(),m=p$4(),e=s$4(o),b=s$4(()=>u(e.current,{enter:()=>t.current.beforeEnter(),leave:()=>t.current.beforeLeave(),idle:()=>{}})),p=s$4(()=>u(e.current,{enter:()=>t.current.afterEnter(),leave:()=>t.current.afterLeave(),idle:()=>{}}));t$2(()=>{let r=o$2();m.add(r.dispose);let s=u$1.current;if(!!s&&e.current!=="idle"&&!!f$1.current)return r.dispose(),b.current(),d.current(e.current),r.add(C(s,c.current,e.current==="enter",v=>{r.dispose(),u(v,{[g.Ended](){p.current(),l.current(e.current);},[g.Cancelled]:()=>{}});})),r.dispose},[o]);}

function c(e=""){return e.split(" ").filter(r=>r.trim().length>1)}let N=createContext(null);N.displayName="TransitionContext";var he=(t=>(t.Visible="visible",t.Hidden="hidden",t))(he||{});function ge(){let e=useContext(N);if(e===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return e}function ve(){let e=useContext(R);if(e===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return e}let R=createContext(null);R.displayName="NestingContext";function F(e){return "children"in e?F(e.children):e.current.filter(({state:r})=>r==="visible").length>0}function X(e){let r=s$4(e),t=useRef([]),n=f(),u$1=s$4((s,o=x$2.Hidden)=>{let i=t.current.findIndex(({id:d})=>d===s);i!==-1&&(u(o,{[x$2.Unmount](){t.current.splice(i,1);},[x$2.Hidden](){t.current[i].state="hidden";}}),t$1(()=>{var d;!F(t)&&n.current&&((d=r.current)==null||d.call(r));}));}),m=s$4(s=>{let o=t.current.find(({id:i})=>i===s);return o?o.state!=="visible"&&(o.state="visible"):t.current.push({id:s,state:"visible"}),()=>u$1.current(s,x$2.Unmount)});return useMemo(()=>({children:t,register:m,unregister:u$1}),[m,u$1,t])}function Ce(){}let be=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function Y(e){var t;let r={};for(let n of be)r[n]=(t=e[n])!=null?t:Ce;return r}function Se(e){let r=useRef(Y(e));return useEffect(()=>{r.current=Y(e);},[e]),r}let xe="div",Z=b.RenderStrategy,$=H(function(r,t){let{beforeEnter:n,afterEnter:u$1,beforeLeave:m,afterLeave:s,enter:o,enterFrom:i,enterTo:d,entered:S,leave:x$1,leaveFrom:E,leaveTo:L,...p}=r,h=useRef(null),y=T$2(h,t),[f,A$1]=useState("visible"),D=p.unmount?x$2.Unmount:x$2.Hidden,{show:g,appear:ee,initial:te}=ge(),{register:P,unregister:H}=ve(),O=useRef(null),a=I$1(),re=useRef(!1),k=X(()=>{re.current||(A$1("hidden"),H.current(a));});useEffect(()=>{if(!!a)return P.current(a)},[P,a]),useEffect(()=>{if(D===x$2.Hidden&&!!a){if(g&&f!=="visible"){A$1("visible");return}u(f,{["hidden"]:()=>H.current(a),["visible"]:()=>P.current(a)});}},[f,a,P,H,g,D]);let ne=s$4({enter:c(o),enterFrom:c(i),enterTo:c(d),entered:c(S),leave:c(x$1),leaveFrom:c(E),leaveTo:c(L)}),ie=Se({beforeEnter:n,afterEnter:u$1,beforeLeave:m,afterLeave:s}),w=a$1();useEffect(()=>{if(w&&f==="visible"&&h.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[h,f,w]);let M=te&&!ee,se=(()=>!w||M||O.current===g?"idle":g?"enter":"leave")();x({container:h,classes:ne,events:ie,direction:se,onStart:s$4(()=>{}),onStop:s$4(le=>{le==="leave"&&!F(k)&&(A$1("hidden"),H.current(a));})}),useEffect(()=>{!M||(D===x$2.Hidden?O.current=null:O.current=g);},[g,M,f]);let oe=p,ae={ref:y};return React__default.createElement(R.Provider,{value:k},React__default.createElement(C$1,{value:u(f,{["visible"]:p$2.Open,["hidden"]:p$2.Closed})},A({ourProps:ae,theirProps:oe,defaultTag:xe,features:Z,visible:f==="visible",name:"Transition.Child"})))}),j=H(function(r,t){let{show:n,appear:u$1=!1,unmount:m,...s}=r,o=T$2(t);a$1();let i=s$2();if(n===void 0&&i!==null&&(n=u(i,{[p$2.Open]:!0,[p$2.Closed]:!1})),![!0,!1].includes(n))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[d,S]=useState(n?"visible":"hidden"),x=X(()=>{S("hidden");}),[E,L]=useState(!0),p=useRef([n]);t$2(()=>{E!==!1&&p.current[p.current.length-1]!==n&&(p.current.push(n),L(!1));},[p,n]);let h=useMemo(()=>({show:n,appear:u$1,initial:E}),[n,u$1,E]);useEffect(()=>{n?S("visible"):F(x)||S("hidden");},[n,x]);let y={unmount:m};return React__default.createElement(R.Provider,{value:x},React__default.createElement(N.Provider,{value:h},A({ourProps:{...y,as:Fragment$1,children:React__default.createElement($,{ref:o,...y,...s})},theirProps:{},defaultTag:Fragment$1,features:Z,visible:d==="visible",name:"Transition"})))});function Ee(e){let r=useContext(N)!==null,t=s$2()!==null;return React__default.createElement(React__default.Fragment,null,!r&&t?React__default.createElement(j,{...e}):React__default.createElement($,{...e}))}let Ge=Object.assign(j,{Child:Ee,Root:j});

var css_248z$8 = ".dropdown-module_dropdown__G8lk1{color:#333;font-size:14px;padding-bottom:24px;position:relative}.dropdown-module_dropdown-button__nZOFm{background-color:#fff;border-color:#767676;border-style:solid;border-width:0 0 1px;display:flex;flex-direction:row;padding:12px 0 4px;text-align:start;width:100%}.dropdown-module_dropdown-options__DZkzK{background-color:#fff;border-radius:.25rem;margin-top:1px;padding:8px 0;position:absolute;width:100%;z-index:10;--tw-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -2px rgba(0,0,0,.1);--tw-shadow-colored:0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.dropdown-module_dropdown-option__T8ETR{padding:8px}.dropdown-module_dropdown-option__T8ETR::marker{content:none}.dropdown-module_active-option__TjfPf{background-color:#e9e9e9}.dropdown-module_selected-option__TFYEe{background-color:#f8f8f8;border-left:3px solid #495867;padding:8px}.dropdown-module_selected-option__TFYEe.dropdown-module_active-option__TjfPf{background-color:#e9e9e9}.dropdown-module_selected-label__yQ7nj{color:#333;flex-grow:1;font-family:Lato,Sans-serif;font-size:14px}.dropdown-module_arrow__ipxdv{height:auto;width:16px}.dropdown-module_disabled__-z43X{opacity:.3}";
var styles$8 = {"dropdown":"dropdown-module_dropdown__G8lk1","dropdown-button":"dropdown-module_dropdown-button__nZOFm","dropdown-options":"dropdown-module_dropdown-options__DZkzK","dropdown-option":"dropdown-module_dropdown-option__T8ETR","active-option":"dropdown-module_active-option__TjfPf","selected-option":"dropdown-module_selected-option__TFYEe","selected-label":"dropdown-module_selected-label__yQ7nj","arrow":"dropdown-module_arrow__ipxdv","disabled":"dropdown-module_disabled__-z43X"};
styleInject(css_248z$8);

var Dropdown = function (_a) {
    var title = _a.title, options = _a.options, _b = _a.disabled, disabled = _b === void 0 ? false : _b, selected = _a.selected, setSelected = _a.setSelected;
    var keys = Object.keys(options);
    if (!keys.length)
        return null;
    useEffect(function () {
        if (!(selected in options))
            setSelected(keys[0]);
    }, [selected]);
    return (jsx("div", __assign({ className: styles$8.dropdown }, { children: jsx(et, __assign({ value: selected, onChange: setSelected, disabled: disabled }, { children: function (_a) {
                var _b;
                var open = _a.open, disabled = _a.disabled;
                return (jsxs("div", __assign({ className: clsx(disabled && styles$8.disabled) }, { children: [title && jsx(et.Label, { children: title }), jsxs(et.Button, __assign({ className: styles$8['dropdown-button'] }, { children: [jsx("div", __assign({ className: styles$8['selected-label'] }, { children: (_b = options[selected]) === null || _b === void 0 ? void 0 : _b.label })), !open && jsx(ArrowDown, { className: styles$8.arrow }), open && jsx(ArrowUp, { className: styles$8.arrow })] })), jsx(et.Options, __assign({ className: styles$8['dropdown-options'] }, { children: keys.map(function (optionKey) {
                                var _a;
                                return (jsx(et.Option, __assign({ value: optionKey, className: function (_a) {
                                        var active = _a.active, selected = _a.selected;
                                        return clsx(styles$8['dropdown-option'], selected && styles$8['selected-option'], active && styles$8['active-option']);
                                    } }, { children: (_a = options[optionKey]) === null || _a === void 0 ? void 0 : _a.label }), optionKey));
                            }) }))] })));
            } })) })));
};

var css_248z$7 = ".password-strength-meter-module_password-strength-meter-root__Nj-2q>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.password-strength-meter-module_password-strength-meter-root__Nj-2q{font-size:12px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#4a4a4a;line-height:18px}.password-strength-meter-module_password-strength-meter-root__Nj-2q *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.password-strength-meter-module_password-strength-meter-root__Nj-2q *,.password-strength-meter-module_password-strength-meter-root__Nj-2q :after,.password-strength-meter-module_password-strength-meter-root__Nj-2q :before{box-sizing:border-box}.password-strength-meter-module_password-strength-meter-root__Nj-2q blockquote,.password-strength-meter-module_password-strength-meter-root__Nj-2q dd,.password-strength-meter-module_password-strength-meter-root__Nj-2q dl,.password-strength-meter-module_password-strength-meter-root__Nj-2q figure,.password-strength-meter-module_password-strength-meter-root__Nj-2q h1,.password-strength-meter-module_password-strength-meter-root__Nj-2q h2,.password-strength-meter-module_password-strength-meter-root__Nj-2q h3,.password-strength-meter-module_password-strength-meter-root__Nj-2q h4,.password-strength-meter-module_password-strength-meter-root__Nj-2q h5,.password-strength-meter-module_password-strength-meter-root__Nj-2q h6,.password-strength-meter-module_password-strength-meter-root__Nj-2q hr,.password-strength-meter-module_password-strength-meter-root__Nj-2q p,.password-strength-meter-module_password-strength-meter-root__Nj-2q pre{margin:0}.password-strength-meter-module_password-strength-meter-root__Nj-2q b{font-weight:700}.password-strength-meter-module_password-strength-meter-root__Nj-2q ol,.password-strength-meter-module_password-strength-meter-root__Nj-2q ul{list-style:none;margin:0;padding:0}.password-strength-meter-module_progress-container__ThQbt>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(2px*var(--tw-space-y-reverse));margin-top:calc(2px*(1 - var(--tw-space-y-reverse)))}.password-strength-meter-module_progress-container__ThQbt .password-strength-meter-module_progress-wrapper__T3qcb{display:flex;height:6px}.password-strength-meter-module_progress-container__ThQbt .password-strength-meter-module_progress-wrapper__T3qcb>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(4px*(1 - var(--tw-space-x-reverse)));margin-right:calc(4px*var(--tw-space-x-reverse))}.password-strength-meter-module_progress-container__ThQbt .password-strength-meter-module_progress-wrapper__T3qcb{overflow:hidden}.password-strength-meter-module_progress-bar__S-1R-{background-color:#c4c4c4;display:flex;flex-direction:column;justify-content:center;overflow:hidden;text-align:center;white-space:nowrap}.password-strength-meter-module_dot__bofv8{background-color:#767676;border-radius:9999px;display:inline-block;height:7px;margin-right:4px;width:7px}.password-strength-meter-module_error-list-wrapper__OSKpG{display:grid;gap:4px;grid-template-columns:repeat(3,minmax(0,1fr));list-style-position:inside}.password-strength-meter-module_error-list-wrapper__OSKpG .password-strength-meter-module_status-error__xdVUL{color:#d60303}.password-strength-meter-module_error-list-wrapper__OSKpG .password-strength-meter-module_status-error__xdVUL .password-strength-meter-module_dot__bofv8{background-color:#d60303}.password-strength-meter-module_error-list-wrapper__OSKpG .password-strength-meter-module_status-success__OvrNT{color:#30871f}.password-strength-meter-module_error-list-wrapper__OSKpG .password-strength-meter-module_status-success__OvrNT .password-strength-meter-module_dot__bofv8{background-color:#30871f}.password-strength-meter-module_text-level-0__btz70,.password-strength-meter-module_text-level-1__PG18N,.password-strength-meter-module_text-level-2__QykCh{color:#d60303;font-weight:700}.password-strength-meter-module_text-level-3__HeRRV,.password-strength-meter-module_text-level-4__teZsS{color:#f7b500;font-weight:700}.password-strength-meter-module_text-level-5__BlLIQ{color:#30871f;font-weight:700}.password-strength-meter-module_progress-bar-1__KA0Fk,.password-strength-meter-module_progress-bar-2__dsF0c{background-color:#d60303}.password-strength-meter-module_progress-bar-3__NFtgL,.password-strength-meter-module_progress-bar-4__rDBJ-{background-color:#f7b500}.password-strength-meter-module_progress-bar-5__FAx65{background-color:#30871f}.password-strength-meter-module_password-strength-meter-root-rebranded__o7sOs{margin-top:10px!important}.password-strength-meter-module_password-strength-meter-root-rebranded__o7sOs>:nth-child(2){margin-top:15px!important}.password-strength-meter-module_password-strength-meter-root-rebranded__o7sOs>:nth-child(2)>:first-child{line-height:22px}.password-strength-meter-module_progress-container-rebranded__tKlCp{color:#333;line-height:14px}.password-strength-meter-module_progress-container-rebranded__tKlCp .password-strength-meter-module_progress-wrapper__T3qcb{height:5px;justify-content:space-between;margin-top:5px!important}.password-strength-meter-module_progress-container-rebranded__tKlCp .password-strength-meter-module_progress-wrapper__T3qcb .password-strength-meter-module_progress-bar__S-1R-{max-width:23%}@media (max-width:640px){.password-strength-meter-module_progress-container-rebranded__tKlCp .password-strength-meter-module_progress-wrapper__T3qcb .password-strength-meter-module_progress-bar__S-1R-{margin-left:0!important;margin-right:0!important;max-width:24%}}.password-strength-meter-module_error-list-container__t-oHi{display:flex;flex-direction:row}.password-strength-meter-module_error-list-container__t-oHi>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(8px*(1 - var(--tw-space-x-reverse)));margin-right:calc(8px*var(--tw-space-x-reverse))}@media (max-width:640px){.password-strength-meter-module_error-list-container__t-oHi{display:flex;flex-direction:column}}.password-strength-meter-module_error-list-wrapper-rebranded__1TU5W{gap:0;line-height:22px}.password-strength-meter-module_error-list-wrapper-rebranded__1TU5W .password-strength-meter-module_status-error__xdVUL .password-strength-meter-module_dot__bofv8,.password-strength-meter-module_error-list-wrapper-rebranded__1TU5W .password-strength-meter-module_status-success__OvrNT .password-strength-meter-module_dot__bofv8{margin-right:5px!important}.password-strength-meter-module_error-list-wrapper-rebranded__1TU5W li{height:100%;max-height:20px}";
var styles$7 = {"password-strength-meter-root":"password-strength-meter-module_password-strength-meter-root__Nj-2q","progress-container":"password-strength-meter-module_progress-container__ThQbt","progress-wrapper":"password-strength-meter-module_progress-wrapper__T3qcb","progress-bar":"password-strength-meter-module_progress-bar__S-1R-","dot":"password-strength-meter-module_dot__bofv8","error-list-wrapper":"password-strength-meter-module_error-list-wrapper__OSKpG","status-error":"password-strength-meter-module_status-error__xdVUL","status-success":"password-strength-meter-module_status-success__OvrNT","text-level-0":"password-strength-meter-module_text-level-0__btz70","text-level-1":"password-strength-meter-module_text-level-1__PG18N","text-level-2":"password-strength-meter-module_text-level-2__QykCh","text-level-3":"password-strength-meter-module_text-level-3__HeRRV","text-level-4":"password-strength-meter-module_text-level-4__teZsS","text-level-5":"password-strength-meter-module_text-level-5__BlLIQ","progress-bar-1":"password-strength-meter-module_progress-bar-1__KA0Fk","progress-bar-2":"password-strength-meter-module_progress-bar-2__dsF0c","progress-bar-3":"password-strength-meter-module_progress-bar-3__NFtgL","progress-bar-4":"password-strength-meter-module_progress-bar-4__rDBJ-","progress-bar-5":"password-strength-meter-module_progress-bar-5__FAx65","password-strength-meter-root-rebranded":"password-strength-meter-module_password-strength-meter-root-rebranded__o7sOs","progress-container-rebranded":"password-strength-meter-module_progress-container-rebranded__tKlCp","error-list-container":"password-strength-meter-module_error-list-container__t-oHi","error-list-wrapper-rebranded":"password-strength-meter-module_error-list-wrapper-rebranded__1TU5W"};
styleInject(css_248z$7);

var PasswordStrengthMeter = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var value = _a.value, touched = _a.touched, _h = _a.showMeter, showMeter = _h === void 0 ? true : _h, isRebrandingEnabled = _a.isRebrandingEnabled;
    var meta = !touched
        ? {}
        : {
            digit: /\d/.test(value) ? 1 : -1,
            length: value.length >= 8 ? 1 : -1,
            mayus: /[A-Z]/.test(value) ? 1 : -1,
            minus: /[a-z]/.test(value) ? 1 : -1,
            no_space: / /.test(value) || value === '' ? -1 : 1,
        };
    var level = Object.values(meta)
        .filter(function (v) { return v > 0; })
        .reduce(function (acc, current) { return acc + current; }, 0);
    var getText = function (level) {
        if (!touched) {
            return '';
        }
        switch (level) {
            case 0:
            case 1:
                return 'Muy Baja';
            case 2:
                return 'Baja';
            case 3:
                return 'Moderada';
            case 4:
                return isRebrandingEnabled ? 'Media' : 'Moderada';
            case 5:
                return 'Excelente';
        }
    };
    var barWidth = isRebrandingEnabled ? '100%' : '20%';
    var thresholds = (_b = {},
        _b['1'] = isRebrandingEnabled ? 1 : 0,
        _b['2'] = isRebrandingEnabled ? 2 : 1,
        _b['3'] = isRebrandingEnabled ? 3 : 2,
        _b['4'] = isRebrandingEnabled ? 4 : 3,
        _b['5'] = isRebrandingEnabled ? 4 : 4,
        _b);
    return (jsxs("div", __assign({ className: clsx(styles$7['password-strength-meter-root'], isRebrandingEnabled && styles$7['password-strength-meter-root-rebranded']) }, { children: [jsx("div", __assign({ className: clsx(styles$7['progress-container'], isRebrandingEnabled && styles$7['progress-container-rebranded']) }, { children: showMeter && (jsxs(Fragment, { children: [jsxs("div", { children: ["Fuerza Contrase\u00F1a:", ' ', jsx("span", __assign({ className: styles$7["text-level-".concat(level)] }, { children: getText(level) }))] }), jsxs("div", __assign({ className: styles$7['progress-wrapper'] }, { children: [jsx("div", { className: clsx(styles$7['progress-bar'], level > thresholds['1'] && styles$7["progress-bar-".concat(level)]), style: { width: barWidth } }), jsx("div", { className: clsx(styles$7['progress-bar'], level > thresholds['2'] && styles$7["progress-bar-".concat(level)]), style: { width: barWidth } }), jsx("div", { className: clsx(styles$7['progress-bar'], level > thresholds['3'] && styles$7["progress-bar-".concat(level)]), style: { width: barWidth } }), jsx("div", { className: clsx(styles$7['progress-bar'], level > thresholds['4'] && styles$7["progress-bar-".concat(level)]), style: { width: barWidth } }), !isRebrandingEnabled && (jsx("div", { className: clsx(styles$7['progress-bar'], level > thresholds['5'] && styles$7["progress-bar-".concat(level)]), style: { width: barWidth } }))] }))] })) })), jsx("div", __assign({ className: clsx(isRebrandingEnabled && styles$7['error-list-container']) }, { children: jsx("div", { children: jsxs("ul", __assign({ className: clsx(styles$7['error-list-wrapper'], isRebrandingEnabled && styles$7['error-list-wrapper-rebranded']) }, { children: [jsxs("li", __assign({ className: clsx((_c = {},
                                    _c[styles$7['status-success']] = meta.digit > 0,
                                    _c[styles$7['status-error']] = meta.digit < 0,
                                    _c)) }, { children: [jsx("span", { className: styles$7['dot'] }), "1 n\u00FAmero"] })), jsxs("li", __assign({ className: clsx((_d = {},
                                    _d[styles$7['status-success']] = meta.mayus > 0,
                                    _d[styles$7['status-error']] = meta.mayus < 0,
                                    _d)) }, { children: [jsx("span", { className: styles$7['dot'] }), "1 may\u00FAscula"] })), jsxs("li", __assign({ className: clsx((_e = {},
                                    _e[styles$7['status-success']] = meta.minus > 0,
                                    _e[styles$7['status-error']] = meta.minus < 0,
                                    _e)) }, { children: [jsx("span", { className: styles$7['dot'] }), "1 min\u00FAscula"] })), jsxs("li", __assign({ className: clsx((_f = {},
                                    _f[styles$7['status-success']] = meta.length > 0,
                                    _f[styles$7['status-error']] = meta.length < 0,
                                    _f)) }, { children: [jsx("span", { className: styles$7['dot'] }), "8 caracteres"] })), jsxs("li", __assign({ className: clsx((_g = {},
                                    _g[styles$7['status-success']] = meta.no_space > 0,
                                    _g[styles$7['status-error']] = meta.no_space < 0,
                                    _g)) }, { children: [jsx("span", { className: styles$7['dot'] }), "Ning\u00FAn espacio"] }))] })) }) }))] })));
};

var css_248z$6 = ".consents-module_consent-item__q8Wtt{display:flex;flex-direction:row}.consents-module_consent-item__q8Wtt .consents-module_consent-label__QxSVw{flex-grow:1;font-size:14px;padding-left:8px;text-align:left}.consents-module_consent-item__q8Wtt .consents-module_consent-label__QxSVw *{display:inline}.consents-module_consent-item__q8Wtt .consents-module_consent-label__QxSVw div{color:#4a8431;cursor:pointer;text-decoration-line:underline}.consents-module_consent-item__q8Wtt .consents-module_consent-control__AzQRi{display:flex}";
var styles$6 = {"consent-item":"consents-module_consent-item__q8Wtt","consent-label":"consents-module_consent-label__QxSVw","consent-control":"consents-module_consent-control__AzQRi"};
styleInject(css_248z$6);

function groupConsents(consents) {
    var groupedConsentMap = {};
    var consentGroups = new Set();
    var ungroupedConsents = [];
    var atomicConsents = consents.filter(function (_a) {
        var templateAtomic = _a.templateAtomic;
        return !!templateAtomic;
    });
    atomicConsents.forEach(function (consent) {
        var templateGroup = consent.templateGroup;
        if (!templateGroup || Number.isNaN(templateGroup)) {
            ungroupedConsents.push([consent]);
            return;
        }
        groupedConsentMap[templateGroup] = __spreadArray(__spreadArray([], (groupedConsentMap[templateGroup] || []), true), [consent], false);
        consentGroups.add(templateGroup);
    });
    var sortedConsentGroups = Array.from(consentGroups).sort(function (a, b) { return Number(a) - Number(b); });
    return __spreadArray(__spreadArray([], sortedConsentGroups.reduce(function (acc, group) { return __spreadArray(__spreadArray([], acc, true), [groupedConsentMap[group]], false); }, []), true), ungroupedConsents, true);
}
var linksRegExp = /(\[[^[\]]+|\][^[\]]+|[^[\]]+)/g;
var typeMap = {
    '[': 'link',
    ']': 'text',
};
function getDisplayTextsWithType(text) {
    var matches = "]".concat(text).match(linksRegExp);
    return matches.map(function (match) {
        var _a = [match.slice(0, 1), match.slice(1)], typeSymbol = _a[0], displayText = _a[1];
        return [typeMap[typeSymbol], displayText];
    });
}
var ConsentText = function (_a) {
    var text = _a.text;
    return (jsxs(Fragment, { children: [jsx("span", { children: text }), "\u00A0"] }));
};
var ConsentLink = function (_a) {
    var consent = _a.consent, text = _a.text, headerText = _a.headerText, onConsentClickHandler = _a.onConsentClickHandler;
    return (jsx("div", __assign({ onClick: function () { return onConsentClickHandler(consent, headerText); }, onKeyDown: function (event) {
            if (event.key === ' ') {
                event.preventDefault();
                event.stopPropagation();
                onConsentClickHandler(consent, headerText);
            }
        }, role: "button", tabIndex: 0 }, { children: text })));
};
var CombinedConsent = function (_a) {
    var combinedConsent = _a.combinedConsent, getFieldProps = _a.getFieldProps, onConsentClickHandler = _a.onConsentClickHandler;
    var consentNames = combinedConsent.map(function (consent) { return consent.templateName; });
    var firstConsentName = consentNames[0];
    var _b = getFieldProps(firstConsentName), name = _b.name, value = _b.value, checked = _b.checked, multiple = _b.multiple;
    var _c = useFormikContext(), values = _c.values, setValues = _c.setValues;
    var onChangeHandler = function (event) {
        var consentValues = consentNames.reduce(function (acc, consentName) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[consentName] = event.target.checked, _a)));
        }, {});
        setValues(__assign(__assign({}, values), consentValues), true);
    };
    var tncArray = combinedConsent
        .map(function (consent) {
        var displayTextsWithType = getDisplayTextsWithType(consent.displayText);
        return displayTextsWithType.map(function (_a, index) {
            var type = _a[0], displayText = _a[1];
            return ({
                link: (jsx(ConsentLink, { text: displayText, headerText: consent.title, consent: consent, onConsentClickHandler: onConsentClickHandler }, "consentLink-".concat(index))),
                text: jsx(ConsentText, { text: displayText }),
            })[type];
        });
    })
        .reduce(function (acc, tncElements) { return __spreadArray(__spreadArray(__spreadArray([], acc, true), tncElements, true), [jsx(Fragment, { children: "\u00A0" })], false); }, []);
    return (jsxs("div", __assign({ className: styles$6['consent-item'] }, { children: [jsxs("div", __assign({ className: styles$6['consent-control'] }, { children: [jsx("input", { id: firstConsentName, type: "checkbox", name: name, value: value, checked: checked, multiple: multiple, onBlur: onChangeHandler, onChange: onChangeHandler, tabIndex: 0, className: "square-checkbox" }), jsx("label", { htmlFor: firstConsentName })] })), jsx("div", __assign({ className: styles$6['consent-label'] }, { children: tncArray }))] }), firstConsentName));
};
var Consents = function (_a) {
    var consents = _a.consents, getFieldProps = _a.getFieldProps, onConsentClickHandler = _a.onConsentClickHandler;
    var combinedConsents = groupConsents(consents);
    return (jsx(Fragment, { children: combinedConsents.map(function (consentGroup, index) { return (jsx(CombinedConsent, { combinedConsent: consentGroup, getFieldProps: getFieldProps, onConsentClickHandler: onConsentClickHandler }, "consent-group-".concat(index))); }) }));
};

var _a$1, _b$1, _c, _d, _e, _f;
var validationMap = {
    password: create$1()
        .required()
        .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/, 'Debes usar al menos: 1 número, 1 mayúscula, 1 minúscula, 8 caracteres, ningún espacio')
        .matches(/^[^\\'¡¿"ºª·`´çÇñÑ]*$/, 'Ingresa una contraseña válida, sin usar símbolos (\'\\¡¿"ºª·`´çñÑ)'),
    firstName: (_a$1 = {},
        _a$1[Tenant.Chile] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.FIRST_NAME_EMPTY)
            .matches(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/i, USER_PERSONAL_DATA_ERROR.FIRST_NAME_INVALID)
            .min(4, USER_PERSONAL_DATA_ERROR.FIRST_NAME_LENGTH),
        _a$1[Tenant.Peru] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.FIRST_NAME_EMPTY_PERU)
            .matches(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/i, USER_PERSONAL_DATA_ERROR.FIRST_NAME_INVALID)
            .min(2, USER_PERSONAL_DATA_ERROR.FIRST_NAME_LENGTH_PERU),
        _a$1[Tenant.Colombia] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.FIRST_NAME_EMPTY_PERU)
            .matches(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/i, USER_PERSONAL_DATA_ERROR.FIRST_NAME_INVALID)
            .min(2, USER_PERSONAL_DATA_ERROR.FIRST_NAME_LENGTH_PERU),
        _a$1),
    lastName: (_b$1 = {},
        _b$1[Tenant.Chile] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.LAST_NAME_EMPTY)
            .matches(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/i, USER_PERSONAL_DATA_ERROR.LAST_NAME_INVALID)
            .min(4, USER_PERSONAL_DATA_ERROR.LAST_NAME_LENGTH),
        _b$1[Tenant.Peru] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.LAST_NAME_EMPTY_PERU)
            .matches(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/i, USER_PERSONAL_DATA_ERROR.LAST_NAME_INVALID)
            .min(2, USER_PERSONAL_DATA_ERROR.LAST_NAME_LENGTH_PERU),
        _b$1[Tenant.Colombia] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.LAST_NAME_EMPTY_PERU)
            .matches(/^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/i, USER_PERSONAL_DATA_ERROR.LAST_NAME_INVALID)
            .min(2, USER_PERSONAL_DATA_ERROR.LAST_NAME_LENGTH_PERU),
        _b$1),
    document: (_c = {},
        _c[Tenant.Chile] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.RUT_EMPTY)
            .test('rut', USER_PERSONAL_DATA_ERROR.RUT_INVALID, function (value) {
            return validateDocument(DocumentType.RUT, value);
        }),
        _c[Tenant.Peru] = (_d = {},
            _d[DocumentType.DNI] = create$1()
                .required(USER_PERSONAL_DATA_ERROR.DNI_EMPTY)
                .test('dni', USER_PERSONAL_DATA_ERROR.DNI_INVALID, function (value) {
                return validateDocument(DocumentType.DNI, value);
            }),
            _d[DocumentType.CE] = create$1()
                .required(USER_PERSONAL_DATA_ERROR.CE_EMPTY)
                .matches(/^[a-zA-Z0-9]*$/i, USER_PERSONAL_DATA_ERROR.CE_INVALID)
                .min(4, USER_PERSONAL_DATA_ERROR.CE_INVALID)
                .max(12, USER_PERSONAL_DATA_ERROR.CE_INVALID),
            _d),
        _c[Tenant.Colombia] = (_e = {},
            _e[DocumentType.CC] = create$1()
                .required(USER_PERSONAL_DATA_ERROR.CC_EMPTY)
                .test('cc', USER_PERSONAL_DATA_ERROR.CC_INVALID, function (value) {
                return validateDocument(DocumentType.CC, value);
            }),
            _e[DocumentType.CE] = create$1()
                .required(USER_PERSONAL_DATA_ERROR.COLOMBIA.CE_EMPTY)
                .test('ce', USER_PERSONAL_DATA_ERROR.COLOMBIA.CE_INVALID, function (value) {
                return validateDocument(DocumentType.CE, value, Tenant.Colombia);
            }),
            _e),
        _c),
    phoneNumber: (_f = {},
        _f[Tenant.Chile] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.PHONE_EMPTY)
            .length(8, USER_PERSONAL_DATA_ERROR.PHONE_LENGTH),
        _f[Tenant.Peru] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.PHONE_EMPTY_PERU)
            .length(9, USER_PERSONAL_DATA_ERROR.PHONE_LENGTH_PERU),
        _f[Tenant.Colombia] = create$1()
            .required(USER_PERSONAL_DATA_ERROR.PHONE_EMPTY_COLOMBIA)
            .length(10, USER_PERSONAL_DATA_ERROR.PHONE_LENGTH_COLOMBIA),
        _f),
};
var getValidationSchema = function (field, tenant) {
    var additionalArgs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArgs[_i - 2] = arguments[_i];
    }
    return __spreadArray([field, tenant], additionalArgs, true).reduce(function (acc, key) { return (key in acc ? acc[key] : acc); }, validationMap);
};

var _a, _b;
var documentOptionsMap = (_a = {},
    _a[Tenant.Chile] = {},
    _a[Tenant.Peru] = {
        DNI: { label: 'DNI' },
        CE: { label: 'Carnet de Extranjería' },
    },
    _a[Tenant.Colombia] = {
        CE: { label: 'Cédula de Extranjería' },
        CC: { label: 'Cédula de Ciudadanía' },
    },
    _a);
var countryOptions = (_b = {},
    _b[Tenant.Chile] = {
        preferredDocument: DocumentType.RUT,
        maxLength: function () { return 10; },
        prefix: '(+56 9)',
        phoneMaxLength: 8,
        getFormattedDocument: function (documentType, value) { return formatRUT(value, true); },
    },
    _b[Tenant.Peru] = {
        preferredDocument: DocumentType.DNI,
        maxLength: function (documentType) { return (documentType === 'CE' ? 12 : 10); },
        prefix: '+51',
        phoneMaxLength: 9,
        getFormattedDocument: function (documentType, value) {
            return documentType === DocumentType.DNI ? formatDNI : value;
        },
    },
    _b[Tenant.Colombia] = {
        preferredDocument: DocumentType.CC,
        maxLength: function (documentType) { return (documentType === DocumentType.CE ? 12 : 10); },
        prefix: '+57',
        phoneMaxLength: 10,
        getFormattedDocument: function (documentType, value) { return value; },
    },
    _b);
var PersonalDataForm = function (_a) {
    var _b, _c, _d, _e, _f;
    var id = _a.id, isLoading = _a.isLoading, setLoading = _a.setLoading, setError = _a.setError, user = _a.user, tenantID = _a.tenantID, countryCode = _a.countryCode, catalystBaseUrl = _a.catalystBaseUrl, _g = _a.requiredFields, requiredFields = _g === void 0 ? [] : _g, changeStage = _a.changeStage; _a.onComplete; var consents = _a.consents, onConsentClick = _a.onConsentClick;
    var _h = useState(false), errorState = _h[0], setErrorState = _h[1];
    var noConsents = !consents;
    var _j = user.originalData, originalData = _j === void 0 ? {} : _j;
    var preferredDocument = countryOptions[countryCode].preferredDocument;
    var originalDocumentType = ((_b = originalData === null || originalData === void 0 ? void 0 : originalData.document) === null || _b === void 0 ? void 0 : _b.type)
        ? originalData.document.type.toUpperCase()
        : preferredDocument;
    var _k = useState(originalDocumentType in DocumentType
        ? originalDocumentType
        : preferredDocument), documentTypeState = _k[0], setDocumentTypeState = _k[1];
    var validationSchema = {
        password: getValidationSchema('password'),
        firstName: requiredFields.includes('userName') && getValidationSchema('firstName', countryCode),
        lastName: requiredFields.includes('userName') && getValidationSchema('lastName', countryCode),
        document: requiredFields.includes('document') &&
            getValidationSchema('document', countryCode, documentTypeState),
        phoneNumber: requiredFields.includes('primaryPhone') && getValidationSchema('phoneNumber', countryCode),
    };
    var consentValidations = consents
        .filter(function (consent) { return consent.templateAtomic === true && consent.isMandatory; })
        .reduce(function (acc, template) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[template.templateName] = create$2().required().isTrue('Debe aceptar el consentimiento'), _a)));
    }, {});
    validationSchema = __assign(__assign({}, validationSchema), consentValidations);
    var errorHandler = function (actions, alertError) {
        if (alertError === void 0) { alertError = 'Ha ocurrido un error.'; }
        setLoading(false);
        setError(alertError);
        actions.setSubmitting(false);
    };
    var onConsentClickHandler = function (template, title) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, onConsentClick(template, title)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onChange = function (value) {
        var passwordRegexInvalidChars = /['\\¡¿"ºª·`´çÇñÑ]/;
        setErrorState(passwordRegexInvalidChars.test(value));
    };
    return (jsx(Formik, __assign({ initialTouched: {
            firstName: requiredFields.includes('userName'),
            lastName: requiredFields.includes('userName'),
            document: requiredFields.includes('document'),
            phoneNumber: requiredFields.includes('primaryPhone'),
        }, initialValues: {
            firstName: (_c = originalData.userName) === null || _c === void 0 ? void 0 : _c.firstName,
            lastName: (_d = originalData.userName) === null || _d === void 0 ? void 0 : _d.lastName1,
            document: countryOptions[countryCode].getFormattedDocument(documentTypeState, (_e = originalData.document) === null || _e === void 0 ? void 0 : _e.id),
            phoneNumber: (_f = originalData.primaryPhone) === null || _f === void 0 ? void 0 : _f.number,
            password: '',
        }, validationSchema: create().shape(validationSchema), onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            var firstName, lastName, phoneNumber, document, userData, updateResponse, date;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!noConsents && !consents.length) {
                            errorHandler(actions);
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        firstName = values.firstName, lastName = values.lastName, phoneNumber = values.phoneNumber, document = values.document;
                        userData = {
                            email: {
                                emailId: user === null || user === void 0 ? void 0 : user.email,
                            },
                            userName: {
                                firstName: firstName,
                                lastName1: lastName,
                            },
                            primaryPhone: {
                                number: phoneNumber,
                                countryCode: ((_a = originalData.primaryPhone) === null || _a === void 0 ? void 0 : _a.countryCode) || countryCode.toUpperCase(),
                            },
                            document: {
                                id: document,
                                type: countryCode !== Tenant.Chile ? documentTypeState : 'RUT',
                                category: 'Individual',
                                country: countryCode.toUpperCase(),
                            },
                            customInfo: originalData.customInfo,
                        };
                        return [4 /*yield*/, updateUser({
                                userData: userData,
                                tenantId: tenantID,
                                catalystBaseUrl: catalystBaseUrl,
                            })];
                    case 1:
                        updateResponse = _d.sent();
                        if (!updateResponse || ((_b = updateResponse === null || updateResponse === void 0 ? void 0 : updateResponse.errors) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            errorHandler(actions, (_c = updateResponse === null || updateResponse === void 0 ? void 0 : updateResponse.errors[0]) === null || _c === void 0 ? void 0 : _c.message);
                            return [2 /*return*/];
                        }
                        date = new Date();
                        ({
                            consentTemplateId: consents.find(function (consent) { return consent.templateAtomic === false; }).templateId,
                            consentStatusId: '1',
                            relatedConsentStatus: consents
                                .filter(function (consent) { return consent.templateAtomic === true; })
                                .map(function (template) { return ({
                                consentTemplateId: template.templateId,
                                consentStatusId: values[template.templateName] ? '1' : '2',
                                templateCategoryType: template.templateCategoryType,
                            }); }),
                            context: {
                                dateTimeChannel: date.toISOString(),
                                experience: 'LOG',
                            },
                            evidence: {
                                deviceIdentifier: generateDeviceIdentifier(),
                                version: '001',
                            },
                            consentDate: getConsentDateInLocalTimeFormatWithTimeZone(),
                        });
                        actions.setSubmitting(false);
                        setLoading(false);
                        return [2 /*return*/, changeStage(STAGES.feedback)];
                }
            });
        }); } }, { children: function (_a) {
            var _b, _c, _d, _e;
            var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty, getFieldProps = _a.getFieldProps, values = _a.values, touched = _a.touched;
            var disabled = !(isValid && dirty) || isSubmitting;
            return (jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$9['form-content'], isLoading && styles$9.disabled) }, { children: [jsx(FormField, { name: "firstName", placeholder: "Ingresa tu nombre", type: "text", label: "Nombre", overrideStyle: styles$9['form-input'], isRebrandingEnabled: true, disabled: !requiredFields.includes('userName') }), jsx(FormField, { name: "lastName", placeholder: "Ingresa tu apellido", type: "text", label: countryCode !== Tenant.Chile ? 'Apellido Paterno' : 'Primer apellido', overrideStyle: styles$9['form-input'], isRebrandingEnabled: true, disabled: !requiredFields.includes('userName') }), countryCode !== Tenant.Chile && (jsx(Dropdown, { title: "Tipo de Documento", options: documentOptionsMap[countryCode], disabled: !requiredFields.includes('document'), selected: documentTypeState, setSelected: setDocumentTypeState })), jsx(FormField, { name: "document", placeholder: countryCode !== Tenant.Chile
                            ? "Ingresa tu ".concat((_b = documentOptionsMap[countryCode][documentTypeState]) === null || _b === void 0 ? void 0 : _b.label)
                            : '11111111-1', type: "text", label: countryCode !== Tenant.Chile ? 'N° de documento' : 'Rut', maxLength: ((_c = countryOptions[countryCode]) === null || _c === void 0 ? void 0 : _c.maxLength(documentTypeState)) || 10, overrideStyle: styles$9['form-input'], parser: function (value) { var _a; return (_a = countryOptions[countryCode]) === null || _a === void 0 ? void 0 : _a.getFormattedDocument(documentTypeState, value); }, isRebrandingEnabled: true, disabled: !requiredFields.includes('document') }), jsx(FormField, { name: "phoneNumber", placeholder: "Ingresa tu celular", type: "text", label: "Celular", maxLength: (_d = countryOptions[countryCode]) === null || _d === void 0 ? void 0 : _d.phoneMaxLength, overrideStyle: styles$9['form-input'], isRebrandingEnabled: true, parser: function (value) { return value.replace(/\D/g, ''); }, disabled: !requiredFields.includes('primaryPhone'), prefix: jsx("span", __assign({ style: {
                                width: countryCode !== Tenant.Chile ? '32px' : '55px',
                                fontSize: '14px',
                            } }, { children: (_e = countryOptions[countryCode]) === null || _e === void 0 ? void 0 : _e.prefix })) }), jsxs(Fragment, { children: [jsx(PasswordField, { name: "password", placeholder: "Ingresa una contrase\u00F1a", maxLength: 32, isRebrandingEnabled: true, showError: errorState, label: "Crea una contrase\u00F1a para falabella.com", handleChange: onChange }), jsx(PasswordStrengthMeter, { touched: (values.password !== '' || touched.password), value: values.password, isRebrandingEnabled: true, showMeter: false })] }), jsx(Consents, { consents: consents, getFieldProps: getFieldProps, onConsentClickHandler: onConsentClickHandler }), jsx(Button, { id: id ? "".concat(id, "-submit") : undefined, type: "submit", label: "Actualizar datos", color: "primary", block: true, disabled: disabled, isRebrandingEnabled: true })] })));
        } })));
};
var PersonalDataFormWithTenantDetails = withTenantDetails(PersonalDataForm);

var PersonalDataContainer = function (_a) {
    var id = _a.id, user = _a.user, catalystBaseUrl = _a.catalystBaseUrl, _b = _a.requiredFields, requiredFields = _b === void 0 ? [] : _b, changeStage = _a.changeStage, onComplete = _a.onComplete, consents = _a.consents, onConsentClick = _a.onConsentClick;
    var _c = useState({
        hasError: false,
        title: '',
        message: '',
    }), error = _c[0], setError = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    return (jsxs("div", __assign({ id: id, className: styles$9['falw-personal-data-form-root'] }, { children: [loading && (jsx("div", __assign({ className: styles$9['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles$9.spinner }) }))), jsxs("div", __assign({ className: styles$9['personal-data-form-content'] }, { children: [jsx("div", __assign({ className: styles$9['personal-data-form-header'] }, { children: jsx("p", __assign({ className: styles$9.title }, { children: "Actualiza tus datos" })) })), error.hasError && jsx(PersonalDataFormAlert, { error: error }), jsx(PersonalDataFormWithTenantDetails, { id: id, isLoading: loading, setLoading: function (loading) {
                            setLoading(loading);
                        }, setError: function (error) {
                            setError({
                                hasError: true,
                                title: '',
                                message: error,
                            });
                        }, user: user, catalystBaseUrl: catalystBaseUrl, requiredFields: requiredFields, changeStage: changeStage, onComplete: onComplete, consents: consents, onConsentClick: onConsentClick })] }))] })));
};

var css_248z$5 = ".pure-material-switch{align-self:center;color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.87);display:inline-block;font-family:var(--pure-material-font,\"Roboto\",\"Segoe UI\",BlinkMacSystemFont,system-ui,-apple-system);font-size:16px;line-height:1.5;position:relative;z-index:0}.pure-material-switch>input{align-self:center;appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:50%;display:block;height:40px;margin:0;opacity:0;outline:none;pointer-events:none;position:absolute;right:6px;top:-8px;transform:scale(1);transition:opacity .3s .1s,transform .2s .1s;width:40px;z-index:-1}.pure-material-switch>span{cursor:pointer;display:inline-block;width:100%}.pure-material-switch>span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:7px;content:\"\";display:inline-block;float:right;height:14px;margin:5px 0 5px 10px;transition:background-color .2s,opacity .2s;vertical-align:top;width:36px}.pure-material-switch>span:after{background-color:#f8f8f8;border-radius:50%;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);content:\"\";height:20px;position:absolute;right:16px;top:1px;transition:background-color .2s,transform .2s;width:20px}.pure-material-switch>input:checked{background-color:#8fca00!important;right:-10px}.pure-material-switch>input:checked+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:checked+span:after{background-color:#8fca00;transform:translateX(16px)}.pure-material-switch:hover>input{opacity:.04}.pure-material-switch>input:focus{opacity:.12}.pure-material-switch:hover>input:focus{opacity:.16}.pure-material-switch>input:active{opacity:1;transform:scale(0);transition:transform 0s,opacity 0s}.pure-material-switch>input:active+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:disabled{opacity:0}.pure-material-switch>input:disabled+span{color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);cursor:default}.pure-material-switch>input:disabled+span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38)}.pure-material-switch>input:checked:disabled+span:before{background-color:#8fca00;opacity:.6}.square-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-checkbox+label,.square-checkbox+label:before{cursor:pointer;position:relative}.square-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:2px solid #bfc4c9;box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);content:\"\";display:inline-block;padding:10px;vertical-align:middle}.square-checkbox:checked+label:before{border:2px solid #343e49}.square-checkbox:checked+label:after{border:solid #343e49;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.square-round-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-round-checkbox+label{cursor:pointer;position:relative}.square-round-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:1px solid #bfc4c9;border-radius:6px;content:\"\";cursor:pointer;display:inline-block;padding:10px;position:relative;vertical-align:middle}.square-round-checkbox:checked+label:before{background-color:#343e49;border:2px solid #343e49}.square-round-checkbox:checked+label:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.simple-password-form-module_falw-simple-password-form-root__yEfuc{line-height:20px;padding:42px 30px;position:relative}.simple-password-form-module_falw-simple-password-form-root__yEfuc *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.simple-password-form-module_falw-simple-password-form-root__yEfuc *,.simple-password-form-module_falw-simple-password-form-root__yEfuc :after,.simple-password-form-module_falw-simple-password-form-root__yEfuc :before{box-sizing:border-box}.simple-password-form-module_falw-simple-password-form-root__yEfuc blockquote,.simple-password-form-module_falw-simple-password-form-root__yEfuc dd,.simple-password-form-module_falw-simple-password-form-root__yEfuc dl,.simple-password-form-module_falw-simple-password-form-root__yEfuc figure,.simple-password-form-module_falw-simple-password-form-root__yEfuc h1,.simple-password-form-module_falw-simple-password-form-root__yEfuc h2,.simple-password-form-module_falw-simple-password-form-root__yEfuc h3,.simple-password-form-module_falw-simple-password-form-root__yEfuc h4,.simple-password-form-module_falw-simple-password-form-root__yEfuc h5,.simple-password-form-module_falw-simple-password-form-root__yEfuc h6,.simple-password-form-module_falw-simple-password-form-root__yEfuc hr,.simple-password-form-module_falw-simple-password-form-root__yEfuc p,.simple-password-form-module_falw-simple-password-form-root__yEfuc pre{margin:0}.simple-password-form-module_falw-simple-password-form-root__yEfuc b{font-weight:700}@media (min-width:640px){.simple-password-form-module_falw-simple-password-form-root__yEfuc{padding:30px 50px}}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_spinner-wrapper__ewEpm{align-items:center;color:#8fca00;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes simple-password-form-module_spin__uFZb1{to{transform:rotate(1turn)}}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_spinner-wrapper__ewEpm .simple-password-form-module_spinner__d2HxB{animation:simple-password-form-module_spin__uFZb1 1s linear infinite}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU{display:flex}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(20px*(1 - var(--tw-space-x-reverse)));margin-right:calc(20px*var(--tw-space-x-reverse))}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_header-content-title__LCFLV{color:#333;font-size:24px;font-weight:400;letter-spacing:-.208333px;line-height:29px}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_header-content-title__LCFLV{font-size:18px;line-height:22px}}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_subtitle-section__HssUK{display:flex;margin-top:20px;width:75%}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_subtitle-section__HssUK{width:100%}}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_subtitle-section__HssUK span{color:#333;font-size:16px;letter-spacing:-.133333px;line-height:19px}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_subtitle-section__HssUK span{font-size:14px;line-height:17px}}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3{color:#767676;padding-top:35px}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3.simple-password-form-module_disabled__1nzjU{opacity:.3}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_actions-wrapper__aGznp{padding-top:8px;text-align:center}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT{display:flex}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT .simple-password-form-module_consent-label__EH-FQ{color:#4a8431;flex-grow:1;font-size:14px;text-align:left;text-decoration-line:underline}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT .simple-password-form-module_consent-label__EH-FQ a{cursor:pointer}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT .simple-password-form-module_consent-control__DDLv4{display:flex}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_separator__kBdog{align-items:center;display:flex;font-size:14px;height:1px;justify-content:center;margin:10px 0;position:relative}.simple-password-form-module_falw-simple-password-form-root__yEfuc .simple-password-form-module_separator__kBdog:after{color:#767676;content:attr(data-char);display:inline-block;padding:0 11px}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc{padding:49px 50px 30px}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc{padding:74px 30px 40px}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-header__g7nBU{align-items:center}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-header__g7nBU{padding-left:2px;padding-right:0}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-logo__OCRdg{background-color:transparent;height:61px;width:50px}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_header-content-title__LCFLV{width:-moz-fit-content;width:fit-content}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-header__g7nBU .simple-password-form-module_header-content__4mMPJ .simple-password-form-module_header-content-title__LCFLV{width:100%}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3{color:#333;padding-top:30px}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3>div:not(:last-child){padding-left:9px;padding-right:2px}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3>:nth-child(2){margin-top:10px!important}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3>:nth-child(3){margin-top:20px!important}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3{padding-top:19px}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3>:nth-child(2){margin-top:16px!important}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3>:nth-child(3){margin-top:26px!important}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_password-field__Nua0X{margin-bottom:0}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_password-field__Nua0X{margin-bottom:70px}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT{align-items:center}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT .simple-password-form-module_consent-label__EH-FQ{color:#333;line-height:17px;margin-left:9px;text-decoration:none}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_consent-item__-SLYT .simple-password-form-module_consent-label__EH-FQ a{border-bottom:1px solid #495867;color:#495867;line-height:17px}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_actions-wrapper__aGznp{margin-top:28px!important}@media (max-width:640px){.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_form-content__-YPP3 .simple-password-form-module_actions-wrapper__aGznp{margin-top:23px!important}}.simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc .simple-password-form-module_spinner-wrapper__ewEpm .simple-password-form-module_spinner__d2HxB{color:#343e49!important}";
var styles$5 = {"falw-simple-password-form-root":"simple-password-form-module_falw-simple-password-form-root__yEfuc","spinner-wrapper":"simple-password-form-module_spinner-wrapper__ewEpm","spinner":"simple-password-form-module_spinner__d2HxB","spin":"simple-password-form-module_spin__uFZb1","form-header":"simple-password-form-module_form-header__g7nBU","header-content":"simple-password-form-module_header-content__4mMPJ","header-content-title":"simple-password-form-module_header-content-title__LCFLV","subtitle-section":"simple-password-form-module_subtitle-section__HssUK","form-content":"simple-password-form-module_form-content__-YPP3","disabled":"simple-password-form-module_disabled__1nzjU","actions-wrapper":"simple-password-form-module_actions-wrapper__aGznp","consent-item":"simple-password-form-module_consent-item__-SLYT","consent-label":"simple-password-form-module_consent-label__EH-FQ","consent-control":"simple-password-form-module_consent-control__DDLv4","separator":"simple-password-form-module_separator__kBdog","falw-simple-password-form-root-rebranded":"simple-password-form-module_falw-simple-password-form-root-rebranded__hbAdc","header-logo":"simple-password-form-module_header-logo__OCRdg","password-field":"simple-password-form-module_password-field__Nua0X"};
styleInject(css_248z$5);

var SimpleUpdatePasswordForm = function (_a) {
    var id = _a.id, onConsentClick = _a.onConsentClick, _b = _a.consents, consents = _b === void 0 ? [] : _b, _c = _a.isRebrandingEnabled, isRebrandingEnabled = _c === void 0 ? false : _c, changeStage = _a.changeStage;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(undefined), alert = _e[0], setAlert = _e[1];
    var _f = useState(false), errorState = _f[0], setErrorState = _f[1];
    var _g = useState(create({})), schema = _g[0], setSchema = _g[1];
    useEffect(function () {
        var passwordSchema = {
            newPassword: create$1()
                .required(EMPTY_PASSWORD_ERROR)
                .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/, 'Debes usar al menos: 1 número, 1 mayúscula, 1 minúscula, 8 caracteres, ningún espacio')
                .required('Ingresa una contraseña válida, sin usar símbolos (\'\\¡¿"ºª·`´çñÑ)')
                .matches(/^[^\\'¡¿"ºª·`´çÇñÑ]*$/, 'Ingresa una contraseña válida, sin usar símbolos (\'\\¡¿"ºª·`´çñÑ)'),
        };
        var consentSchema = consents
            .filter(function (consent) { return consent.templateAtomic === true && consent.isMandatory; })
            .reduce(function (acc, consent) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[consent.templateName] = create$2().required().isTrue('Debe aceptar el consentimiento'), _a)));
        }, {});
        setSchema(create(__assign(__assign({}, passwordSchema), consentSchema)));
    }, [consents]);
    var submitHandler = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var date;
        return __generator(this, function (_a) {
            setLoading(true);
            setAlert(undefined);
            date = new Date();
            ({
                consentTemplateId: consents.find(function (consent) { return consent.templateAtomic === false; }).templateId,
                relatedConsentStatus: consents
                    .filter(function (consent) { return consent.templateAtomic === true; })
                    .map(function (template) { return ({
                    consentTemplateId: template.templateId,
                    consentStatusId: values[template.templateName] ? '1' : '2',
                    templateCategoryType: template.templateCategoryType,
                }); }),
                context: {
                    dateTimeChannel: date.toISOString(),
                    experience: 'LOG',
                },
                evidence: {
                    deviceIdentifier: generateDeviceIdentifier(),
                    version: '001',
                },
                consentDate: getConsentDateInLocalTimeFormatWithTimeZone(),
            });
            setLoading(false);
            actions.setSubmitting(false);
            changeStage(STAGES.feedback);
            return [2 /*return*/];
        });
    }); };
    var onConsentClickHandler = function (template) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, onConsentClick(template)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onChange = function (value) {
        var passwordRegexInvalidChars = /['\\¡¿"ºª·`´çÇñÑ]/;
        setErrorState(passwordRegexInvalidChars.test(value));
    };
    return (jsxs("div", __assign({ id: id, className: clsx(styles$5['falw-simple-password-form-root'], isRebrandingEnabled && styles$5['falw-simple-password-form-root-rebranded']) }, { children: [loading && (jsx("div", __assign({ className: styles$5['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles$5.spinner }) }))), jsx("div", __assign({ className: styles$5['form-header'] }, { children: jsxs("section", __assign({ className: styles$5['header-content'] }, { children: [jsx("h3", __assign({ className: styles$5['header-content-title'] }, { children: REBRANDING.SIMPLE_PASSWORD_HEADER_TITLE })), jsx("section", __assign({ className: styles$5['subtitle-section'] }, { children: jsxs("span", { children: [jsx("b", { children: REBRANDING.SIMPLE_PASSWORD_HEADER_SUBTITLE[0] }), ' ', REBRANDING.SIMPLE_PASSWORD_HEADER_SUBTITLE[1]] }) }))] })) })), jsx(Formik, __assign({ initialValues: { newPassword: '' }, validationSchema: schema, onSubmit: submitHandler }, { children: function (_a) {
                    var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty, getFieldProps = _a.getFieldProps, values = _a.values, touched = _a.touched;
                    var disabled = !(isValid && dirty) || isSubmitting;
                    return (jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$5['form-content'], loading && styles$5.disabled) }, { children: [alert && jsx(Alert$1, __assign({}, alert)), jsx(PasswordField, { name: "newPassword", label: "Crea una contrase\u00F1a para falabella.com", placeholder: SIMPLE_PASSWORD_PLACEHOLDER, showError: errorState, overrideStyle: styles$5['password-field'], isRebrandingEnabled: isRebrandingEnabled, handleChange: onChange }), jsx(PasswordStrengthMeter, { touched: (values.newPassword !== '' || touched.newPassword), value: values.newPassword, showMeter: false, isRebrandingEnabled: isRebrandingEnabled }), jsx(Consents, { consents: consents, getFieldProps: getFieldProps, onConsentClickHandler: onConsentClickHandler }), jsx("div", __assign({ className: styles$5['actions-wrapper'] }, { children: jsx(Button, { id: id ? "".concat(id, "-submit") : undefined, type: "submit", label: CHANGE_PASSWORD, color: "primary", block: true, uppercased: !isRebrandingEnabled, disabled: disabled, isRebrandingEnabled: isRebrandingEnabled }) }))] })));
                } }))] })));
};
var SimpleUpdatePasswordFormWithTenantDetails = withTenantDetails(SimpleUpdatePasswordForm);

var css_248z$4 = ".pure-material-switch{align-self:center;color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.87);display:inline-block;font-family:var(--pure-material-font,\"Roboto\",\"Segoe UI\",BlinkMacSystemFont,system-ui,-apple-system);font-size:16px;line-height:1.5;position:relative;z-index:0}.pure-material-switch>input{align-self:center;appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:50%;display:block;height:40px;margin:0;opacity:0;outline:none;pointer-events:none;position:absolute;right:6px;top:-8px;transform:scale(1);transition:opacity .3s .1s,transform .2s .1s;width:40px;z-index:-1}.pure-material-switch>span{cursor:pointer;display:inline-block;width:100%}.pure-material-switch>span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:7px;content:\"\";display:inline-block;float:right;height:14px;margin:5px 0 5px 10px;transition:background-color .2s,opacity .2s;vertical-align:top;width:36px}.pure-material-switch>span:after{background-color:#f8f8f8;border-radius:50%;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);content:\"\";height:20px;position:absolute;right:16px;top:1px;transition:background-color .2s,transform .2s;width:20px}.pure-material-switch>input:checked{background-color:#8fca00!important;right:-10px}.pure-material-switch>input:checked+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:checked+span:after{background-color:#8fca00;transform:translateX(16px)}.pure-material-switch:hover>input{opacity:.04}.pure-material-switch>input:focus{opacity:.12}.pure-material-switch:hover>input:focus{opacity:.16}.pure-material-switch>input:active{opacity:1;transform:scale(0);transition:transform 0s,opacity 0s}.pure-material-switch>input:active+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:disabled{opacity:0}.pure-material-switch>input:disabled+span{color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);cursor:default}.pure-material-switch>input:disabled+span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38)}.pure-material-switch>input:checked:disabled+span:before{background-color:#8fca00;opacity:.6}.square-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-checkbox+label,.square-checkbox+label:before{cursor:pointer;position:relative}.square-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:2px solid #bfc4c9;box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);content:\"\";display:inline-block;padding:10px;vertical-align:middle}.square-checkbox:checked+label:before{border:2px solid #343e49}.square-checkbox:checked+label:after{border:solid #343e49;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.square-round-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-round-checkbox+label{cursor:pointer;position:relative}.square-round-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:1px solid #bfc4c9;border-radius:6px;content:\"\";cursor:pointer;display:inline-block;padding:10px;position:relative;vertical-align:middle}.square-round-checkbox:checked+label:before{background-color:#343e49;border:2px solid #343e49}.square-round-checkbox:checked+label:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}@keyframes success-feedback-module_spin__tWBoi{to{transform:rotate(1turn)}}.success-feedback-module_falw-success-notice-root__ff9vo>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(16px*var(--tw-space-y-reverse));margin-top:calc(16px*(1 - var(--tw-space-y-reverse)))}.success-feedback-module_falw-success-notice-root__ff9vo{padding:25px 40px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-header__wkfhH{display:flex}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-header__wkfhH>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(8px*(1 - var(--tw-space-x-reverse)));margin-right:calc(8px*var(--tw-space-x-reverse))}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-header__wkfhH svg{color:#186f07}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-header__wkfhH .success-feedback-module_title__vQ-kS{color:#333;font-size:24px;font-weight:700;line-height:29px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_subtitle__XymFP{color:#333;font-size:15px;line-height:18px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-content__eYkYl{display:flex;flex-direction:column}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-content__eYkYl>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(16px*var(--tw-space-y-reverse));margin-top:calc(16px*(1 - var(--tw-space-y-reverse)))}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-content__eYkYl .success-feedback-module_help-text__c-OwN{color:#7a7a7a;font-size:14px;font-weight:400;line-height:15px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-content__eYkYl .success-feedback-module_from-now-content__cbzHr{font-size:14px;line-height:16px;padding:0 10px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-content__eYkYl .success-feedback-module_from-now-content__cbzHr ul{list-style-type:none;margin-bottom:10px;margin-top:20px;padding-left:40px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_notice-content__eYkYl .success-feedback-module_from-now-content__cbzHr ul li:not(:last-child){padding-bottom:25px}.success-feedback-module_falw-success-notice-root__ff9vo .success-feedback-module_button-container__hHvmg{padding:5px 10px 0}";
var styles$4 = {"falw-success-notice-root":"success-feedback-module_falw-success-notice-root__ff9vo","notice-header":"success-feedback-module_notice-header__wkfhH","title":"success-feedback-module_title__vQ-kS","subtitle":"success-feedback-module_subtitle__XymFP","notice-content":"success-feedback-module_notice-content__eYkYl","help-text":"success-feedback-module_help-text__c-OwN","from-now-content":"success-feedback-module_from-now-content__cbzHr","button-container":"success-feedback-module_button-container__hHvmg","spin":"success-feedback-module_spin__tWBoi"};
styleInject(css_248z$4);

var SuccessFeedback = function (_a) {
    var id = _a.id, email = _a.email, _b = _a.isRebrandingEnabled, isRebrandingEnabled = _b === void 0 ? false : _b, onComplete = _a.onComplete, tenant = _a.tenant;
    var hideEmail = function (email) {
        var _a = email.split('@'), username = _a[0], domain = _a[1];
        return ["".concat(username.substring(0, 3), "*****"), domain].join('@');
    };
    return (jsxs("div", __assign({ id: id, className: styles$4['falw-success-notice-root'] }, { children: [jsx("section", { children: jsxs("div", __assign({ className: styles$4['notice-header'] }, { children: [jsx("div", { children: jsx(CheckCircle, { size: 28, color: "#186F07" }) }), jsx("span", __assign({ className: styles$4['title'] }, { children: "\u00A1Listo! Actualizamos tus datos" }))] })) }), jsxs("section", __assign({ className: styles$4['notice-content'] }, { children: [jsx(ScheduledAlerts, { componentName: "unified-login-success-feedback" }), tenant !== 'co' && (jsxs("p", __assign({ className: styles$4['from-now-content'] }, { children: ["Desde ahora podr\u00E1s:", jsx(ScheduledAlerts, { componentName: "unified-login-success-feedback-content", fallback: jsxs("ul", { children: [jsxs("li", { children: [jsx("b", { children: "Revisar tus pedidos" }), " de Sodimac en falabella.com."] }), jsxs("li", { children: [jsx("b", { children: "Seguir y gestionar" }), " todas tus compras en falabella.com."] }), jsxs("li", { children: ["Encontrar ", jsx("b", { children: "miles de productos de Sodimac" }), " en falabella.com."] })] }) })] }))), jsxs(Alert$1, { children: ["Te enviamos la confirmaci\u00F3n a ", jsx("b", { children: hideEmail(email) })] })] })), jsx("section", __assign({ className: styles$4['button-container'] }, { children: jsx(Button, { type: "button", label: "Cerrar", color: isRebrandingEnabled ? 'secondary' : 'primary', block: true, uppercased: !isRebrandingEnabled, isRebrandingEnabled: isRebrandingEnabled, onClick: onComplete }) }))] })));
};

var img$1 = "data:image/png;base64,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";

function FalabellaGreen() {
    return jsx("img", { src: img$1, alt: "Falabella Green" });
}

var css_248z$3 = ".pure-material-switch{align-self:center;color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.87);display:inline-block;font-family:var(--pure-material-font,\"Roboto\",\"Segoe UI\",BlinkMacSystemFont,system-ui,-apple-system);font-size:16px;line-height:1.5;position:relative;z-index:0}.pure-material-switch>input{align-self:center;appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:50%;display:block;height:40px;margin:0;opacity:0;outline:none;pointer-events:none;position:absolute;right:6px;top:-8px;transform:scale(1);transition:opacity .3s .1s,transform .2s .1s;width:40px;z-index:-1}.pure-material-switch>span{cursor:pointer;display:inline-block;width:100%}.pure-material-switch>span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);border-radius:7px;content:\"\";display:inline-block;float:right;height:14px;margin:5px 0 5px 10px;transition:background-color .2s,opacity .2s;vertical-align:top;width:36px}.pure-material-switch>span:after{background-color:#f8f8f8;border-radius:50%;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);content:\"\";height:20px;position:absolute;right:16px;top:1px;transition:background-color .2s,transform .2s;width:20px}.pure-material-switch>input:checked{background-color:#8fca00!important;right:-10px}.pure-material-switch>input:checked+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:checked+span:after{background-color:#8fca00;transform:translateX(16px)}.pure-material-switch:hover>input{opacity:.04}.pure-material-switch>input:focus{opacity:.12}.pure-material-switch:hover>input:focus{opacity:.16}.pure-material-switch>input:active{opacity:1;transform:scale(0);transition:transform 0s,opacity 0s}.pure-material-switch>input:active+span:before{background-color:#8fca00;opacity:.6}.pure-material-switch>input:disabled{opacity:0}.pure-material-switch>input:disabled+span{color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38);cursor:default}.pure-material-switch>input:disabled+span:before{background-color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.38)}.pure-material-switch>input:checked:disabled+span:before{background-color:#8fca00;opacity:.6}.square-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-checkbox+label,.square-checkbox+label:before{cursor:pointer;position:relative}.square-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:2px solid #bfc4c9;box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);content:\"\";display:inline-block;padding:10px;vertical-align:middle}.square-checkbox:checked+label:before{border:2px solid #343e49}.square-checkbox:checked+label:after{border:solid #343e49;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.square-round-checkbox{cursor:pointer;display:none!important;height:auto;margin-bottom:0;padding:0;width:auto}.square-round-checkbox+label{cursor:pointer;position:relative}.square-round-checkbox+label:before{-webkit-appearance:none;background-color:transparent;border:1px solid #bfc4c9;border-radius:6px;content:\"\";cursor:pointer;display:inline-block;padding:10px;position:relative;vertical-align:middle}.square-round-checkbox:checked+label:before{background-color:#343e49;border:2px solid #343e49}.square-round-checkbox:checked+label:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";display:block;height:15px;left:9px;position:absolute;top:3px;transform:rotate(40deg);width:7px}.update-password-form-module_update-form-root__gnRc9{line-height:20px;padding:42px 30px;position:relative}.update-password-form-module_update-form-root__gnRc9 *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.update-password-form-module_update-form-root__gnRc9 *,.update-password-form-module_update-form-root__gnRc9 :after,.update-password-form-module_update-form-root__gnRc9 :before{box-sizing:border-box}.update-password-form-module_update-form-root__gnRc9 blockquote,.update-password-form-module_update-form-root__gnRc9 dd,.update-password-form-module_update-form-root__gnRc9 dl,.update-password-form-module_update-form-root__gnRc9 figure,.update-password-form-module_update-form-root__gnRc9 h1,.update-password-form-module_update-form-root__gnRc9 h2,.update-password-form-module_update-form-root__gnRc9 h3,.update-password-form-module_update-form-root__gnRc9 h4,.update-password-form-module_update-form-root__gnRc9 h5,.update-password-form-module_update-form-root__gnRc9 h6,.update-password-form-module_update-form-root__gnRc9 hr,.update-password-form-module_update-form-root__gnRc9 p,.update-password-form-module_update-form-root__gnRc9 pre{margin:0}@media (min-width:640px){.update-password-form-module_update-form-root__gnRc9{padding:30px 50px}}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_spinner-wrapper__XCpBM{align-items:center;color:#8fca00;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes update-password-form-module_spin__-Dyg-{to{transform:rotate(1turn)}}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_spinner-wrapper__XCpBM .update-password-form-module_spinner__4yFQG{animation:update-password-form-module_spin__-Dyg- 1s linear infinite}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl{display:flex}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(20px*(1 - var(--tw-space-x-reverse)));margin-right:calc(20px*var(--tw-space-x-reverse))}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-logo__WJVDb{align-items:center;display:flex;justify-content:center;--tw-text-opacity:1;background-color:#aad500;color:rgb(255 255 255/var(--tw-text-opacity));height:69px;min-width:41px;width:41px}@media (min-width:640px){.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-logo__WJVDb{height:74px;min-width:44px;width:44px}}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy .update-password-form-module_header-content-title__bX2e3{color:#333;font-size:24px;font-weight:400;line-height:29px}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy .update-password-form-module_header-content-subtitle__E9Kky{color:#767676;font-size:16px;line-height:19px}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y{color:#767676;padding-top:35px}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y.update-password-form-module_disabled__akCm7{opacity:.3}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y .update-password-form-module_actions-wrapper__Guazh{padding-top:20px;text-align:center}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8{display:flex}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8 .update-password-form-module_consent-label__w8j7r{color:#4a8431;flex-grow:1;font-size:14px;text-align:left;text-decoration-line:underline}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8 .update-password-form-module_consent-label__w8j7r a{cursor:pointer}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8 .update-password-form-module_consent-control__kRI77{display:flex}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_separator__EHDbn{align-items:center;display:flex;font-size:14px;height:1px;justify-content:center;margin:10px 0;position:relative}.update-password-form-module_update-form-root__gnRc9 .update-password-form-module_separator__EHDbn:after{color:#767676;content:attr(data-char);display:inline-block;padding:0 11px}.update-password-form-module_update-form-root-rebranded__MKs56{padding:37px 40px 30px}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56{padding:33px 23px 0 22px}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl{align-items:center;padding-left:4px;padding-right:10px}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl{padding-left:2px;padding-right:0}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-logo__WJVDb{background-color:transparent;height:61px;width:50px}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy{margin-left:11px!important}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy{margin-left:23px!important}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy .update-password-form-module_header-content-title__bX2e3{width:-moz-fit-content;width:fit-content}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-header__d1WEl .update-password-form-module_header-content__OoOZy .update-password-form-module_header-content-title__bX2e3{max-width:196px;width:100%}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y{color:#333;padding-top:43px}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>div:not(:last-child){padding-left:10px;padding-right:10px}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>div:not(:last-child){padding-left:9px;padding-right:2px}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>:nth-child(2){margin-top:30px!important}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y{padding-top:19px}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>:nth-child(2){margin-top:16px!important}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>:nth-child(3){margin-top:26px!important}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>.update-password-form-module_consent-item__0oMw8:nth-child(4){margin-top:35px!important}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y>.update-password-form-module_consent-item__0oMw8:nth-child(5){margin-top:10px!important}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8{align-items:center}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8 .update-password-form-module_consent-label__w8j7r{color:#333;line-height:17px;margin-left:9px;text-decoration:none}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y .update-password-form-module_consent-item__0oMw8 .update-password-form-module_consent-label__w8j7r a{border-bottom:1px solid #495867;color:#495867;font-weight:700;line-height:17px}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y .update-password-form-module_actions-wrapper__Guazh{margin-top:28px!important}@media (max-width:640px){.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_form-content__tgX3Y .update-password-form-module_actions-wrapper__Guazh{margin-top:23px!important}}.update-password-form-module_update-form-root-rebranded__MKs56 .update-password-form-module_spinner-wrapper__XCpBM .update-password-form-module_spinner__4yFQG{color:#343e49!important}";
var styles$3 = {"update-form-root":"update-password-form-module_update-form-root__gnRc9","spinner-wrapper":"update-password-form-module_spinner-wrapper__XCpBM","spinner":"update-password-form-module_spinner__4yFQG","spin":"update-password-form-module_spin__-Dyg-","form-header":"update-password-form-module_form-header__d1WEl","header-logo":"update-password-form-module_header-logo__WJVDb","header-content":"update-password-form-module_header-content__OoOZy","header-content-title":"update-password-form-module_header-content-title__bX2e3","header-content-subtitle":"update-password-form-module_header-content-subtitle__E9Kky","form-content":"update-password-form-module_form-content__tgX3Y","disabled":"update-password-form-module_disabled__akCm7","actions-wrapper":"update-password-form-module_actions-wrapper__Guazh","consent-item":"update-password-form-module_consent-item__0oMw8","consent-label":"update-password-form-module_consent-label__w8j7r","consent-control":"update-password-form-module_consent-control__kRI77","separator":"update-password-form-module_separator__EHDbn","update-form-root-rebranded":"update-password-form-module_update-form-root-rebranded__MKs56"};
styleInject(css_248z$3);

var UpdatePasswordForm = function (_a) {
    var onConsentClick = _a.onConsentClick, onConsentsUpdate = _a.onConsentsUpdate, onPasswordUpdate = _a.onPasswordUpdate, tenant = _a.tenant, catalystBaseUrl = _a.catalystBaseUrl, _b = _a.consents, consents = _b === void 0 ? [] : _b, id = _a.id, _c = _a.isRebrandingEnabled, isRebrandingEnabled = _c === void 0 ? false : _c;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(), alert = _e[0], setAlert = _e[1];
    var _f = useState(create({
        actualPassword: create$1().required(EMPTY_PASSWORD_ERROR),
        newPassword: create$1()
            .required(EMPTY_PASSWORD_ERROR)
            .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/, 'Debes usar al menos: 1 número, 1 mayúscula, 1 minúscula, 8 caracteres, ningún espacio'),
    })), schema = _f[0], setSchema = _f[1];
    useEffect(function () {
        var obj = {};
        consents
            .filter(function (consent) { return consent.templateAtomic === true; })
            .forEach(function (t) {
            obj[t.templateName] = create$2()
                .required()
                .oneOf([true], 'Debe aceptar el consentimiento');
        });
        setSchema(schema.concat(create(obj)));
    }, []);
    var validate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, schema.validate(values, { abortEarly: false })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {}];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, err_1.inner.reduce(function (acc, current) {
                            acc[current.path] = current.message;
                            return acc;
                        }, {})];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var submitHandler = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var passwordResponse, data, errors, consentsParams, consentsResponse, consentErrors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setAlert(undefined);
                    return [4 /*yield*/, resetPasswordWithCurrent({
                            currentPassword: values.actualPassword,
                            newPassword: values.newPassword,
                            tenantId: tenantId(tenant),
                            catalystBaseUrl: catalystBaseUrl,
                        })];
                case 1:
                    passwordResponse = _a.sent();
                    if (!onPasswordUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, onPasswordUpdate(passwordResponse)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    data = passwordResponse.data, errors = passwordResponse.errors;
                    if (!((data === null || data === void 0 ? void 0 : data.success) === true && consents.length > 0)) return [3 /*break*/, 7];
                    consentsParams = {
                        consentTemplateId: consents.find(function (consent) { return consent.templateAtomic === false; }).templateId,
                        consentStatusId: '1',
                        relatedConsentStatus: consents
                            .filter(function (consent) { return consent.templateAtomic === true; })
                            .map(function (template) { return ({
                            consentTemplateId: template.templateId,
                            consentStatusId: '1',
                            templateCategoryType: template.templateCategoryType,
                        }); }),
                    };
                    return [4 /*yield*/, saveUserConsent({
                            consent: consentsParams,
                            tenantId: tenantId(tenant),
                            catalystBaseUrl: catalystBaseUrl,
                        })];
                case 4:
                    consentsResponse = _a.sent();
                    if (!onConsentsUpdate) return [3 /*break*/, 6];
                    return [4 /*yield*/, onConsentsUpdate(consentsResponse)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    consentErrors = consentsResponse.errors;
                    if (consentErrors.length > 0) {
                        setAlert({ type: 'warning', children: consentErrors[0].message });
                    }
                    return [3 /*break*/, 10];
                case 7:
                    if (!errors.length) return [3 /*break*/, 8];
                    setAlert({ type: 'warning', children: errors[0].message });
                    return [3 /*break*/, 10];
                case 8:
                    if (!(consents.length === 0)) return [3 /*break*/, 10];
                    if (!onConsentsUpdate) return [3 /*break*/, 10];
                    return [4 /*yield*/, onConsentsUpdate({ data: { success: true } })];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10:
                    setLoading(false);
                    actions.setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onConsentClickHandler = function (template) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, onConsentClick(template)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (jsxs("div", __assign({ id: id, className: clsx(styles$3['update-form-root'], isRebrandingEnabled && styles$3['update-form-root-rebranded']) }, { children: [loading && (jsx("div", __assign({ className: styles$3['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles$3['spinner'] }) }))), jsxs("div", __assign({ className: styles$3['form-header'] }, { children: [jsx("div", __assign({ className: styles$3['header-logo'] }, { children: isRebrandingEnabled ? jsx(FalabellaGreen, {}) : jsx(FalabellaLogo, {}) })), jsx("div", __assign({ className: styles$3['header-content'] }, { children: isRebrandingEnabled ? (jsx("h3", __assign({ className: styles$3['header-content-title'] }, { children: REBRANDING.LOGIN_HEADER_TITLE }))) : (jsxs(React__default.Fragment, { children: [jsx("h3", __assign({ className: styles$3['header-content-title'] }, { children: LOGIN_HEADER_TITLE })), jsx("p", __assign({ className: styles$3['header-content-subtitle'] }, { children: LOGIN_HEADER_SUBTITLE }))] })) }))] })), jsx(Formik, __assign({ initialValues: { actualPassword: '', newPassword: '' }, validate: validate, onSubmit: submitHandler }, { children: function (_a) {
                    var isValid = _a.isValid, isSubmitting = _a.isSubmitting, dirty = _a.dirty, getFieldProps = _a.getFieldProps, values = _a.values, touched = _a.touched;
                    var disabled = !(isValid && dirty) || isSubmitting;
                    return (jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles$3['form-content'], loading && styles$3['disabled']) }, { children: [alert && jsx(Alert$1, __assign({}, alert)), jsx(PasswordField, { name: "actualPassword", label: PASSWORD_ACTUAL_LABEL, placeholder: PASSWORD_PLACEHOLDER, isRebrandingEnabled: isRebrandingEnabled, showError: !isRebrandingEnabled }), jsx(PasswordField, { name: "newPassword", label: PASSWORD_NEW_LABEL, placeholder: PASSWORD_PLACEHOLDER, showError: false, isRebrandingEnabled: isRebrandingEnabled }), jsx(PasswordStrengthMeter, { touched: (values.newPassword !== '' || touched.newPassword), value: values.newPassword, isRebrandingEnabled: isRebrandingEnabled }), consents
                                .filter(function (c) { return c.templateAtomic === true; })
                                .map(function (t) {
                                var termsAndConditionsText = 'términos y condiciones';
                                var personalDataText = 'tratamiento de mis datos personales';
                                var labelTexts = [];
                                if (t.displayText.includes(termsAndConditionsText)) {
                                    var tacIndex = t.displayText.indexOf(termsAndConditionsText);
                                    labelTexts[0] = t.displayText.slice(0, tacIndex);
                                    labelTexts[1] = t.displayText.slice(tacIndex);
                                }
                                if (t.displayText.includes(personalDataText)) {
                                    var pdIndex = t.displayText.indexOf(personalDataText);
                                    labelTexts[0] = t.displayText.slice(0, pdIndex);
                                    labelTexts[1] = t.displayText.slice(pdIndex);
                                }
                                var renderLabel = function () { return (jsx("div", __assign({ className: styles$3['consent-label'] }, { children: isRebrandingEnabled && labelTexts.length > 0 ? (jsxs(React__default.Fragment, { children: [jsx("span", { children: labelTexts[0] }), jsx("a", __assign({ onClick: function () { return onConsentClickHandler(t); } }, { children: labelTexts[1] }))] })) : (jsx("a", __assign({ onClick: function () { return onConsentClickHandler(t); } }, { children: t.displayText }))) }))); };
                                var renderControl = function () {
                                    return isRebrandingEnabled ? (jsxs("div", __assign({ className: styles$3['consent-control'] }, { children: [jsx("input", __assign({ id: t.templateName, name: t.templateName, type: "checkbox" }, getFieldProps(t.templateName), { className: "square-checkbox" })), jsx("label", { htmlFor: t.templateName })] }))) : (jsx("div", __assign({ className: styles$3['consent-control'] }, { children: jsxs("label", __assign({ htmlFor: t.templateName, className: "pure-material-switch" }, { children: [jsx("input", __assign({ id: t.templateName, name: t.templateName, type: "checkbox" }, getFieldProps(t.templateName))), jsx("span", { className: styles$3['consent-label'] })] })) })));
                                };
                                return (jsx("div", __assign({ className: styles$3['consent-item'] }, { children: isRebrandingEnabled ? (jsxs(React__default.Fragment, { children: [renderControl(), renderLabel()] })) : (jsxs(React__default.Fragment, { children: [renderLabel(), renderControl()] })) }), t.templateName));
                            }), jsx("div", __assign({ className: styles$3['actions-wrapper'] }, { children: jsx(Button, { id: id ? "".concat(id, "-submit") : undefined, type: "submit", label: SIGN_IN, color: "primary", block: true, uppercased: !isRebrandingEnabled, disabled: disabled, isRebrandingEnabled: isRebrandingEnabled }) }))] })));
                } }))] })));
};

var name = "@digital-retail/falabella-unified-login";
var version = "5.4.65";

var css_248z$2 = ".modal-module_falw-modal-root__tDbT1{inset:0;line-height:20px;overflow-y:auto;position:fixed;z-index:9000}.modal-module_falw-modal-root__tDbT1 *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.modal-module_falw-modal-root__tDbT1 *,.modal-module_falw-modal-root__tDbT1 :after,.modal-module_falw-modal-root__tDbT1 :before{box-sizing:border-box}.modal-module_falw-modal-root__tDbT1 blockquote,.modal-module_falw-modal-root__tDbT1 dd,.modal-module_falw-modal-root__tDbT1 dl,.modal-module_falw-modal-root__tDbT1 figure,.modal-module_falw-modal-root__tDbT1 h1,.modal-module_falw-modal-root__tDbT1 h2,.modal-module_falw-modal-root__tDbT1 h3,.modal-module_falw-modal-root__tDbT1 h4,.modal-module_falw-modal-root__tDbT1 h5,.modal-module_falw-modal-root__tDbT1 h6,.modal-module_falw-modal-root__tDbT1 hr,.modal-module_falw-modal-root__tDbT1 p,.modal-module_falw-modal-root__tDbT1 pre{margin:0}.modal-module_falw-modal-root__tDbT1 b{font-weight:700}.modal-module_falw-modal-root__tDbT1.modal-module_opened__U2eAS{z-index:9005}.modal-module_falw-modal-wrapper__TxnM1{align-items:center;display:flex;justify-content:center;min-height:100vh;padding:16px 16px 40px;text-align:center}@media (min-width:640px){.modal-module_falw-modal-wrapper__TxnM1{display:block;padding:0}}.modal-module_falw-modal-wrapper-rebranded__pvLWR{align-items:flex-end;padding:0!important;width:100%}.modal-module_falw-modal-backdrop-wrapper__lH6zm{inset:0;position:fixed;transition-duration:.15s;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1)}.modal-module_falw-modal-backdrop__BE2ZM{background:#4a4a4a;inset:0;opacity:.5;position:absolute}.modal-module_falw-modal-spacer__-yqov{display:none}@media (min-width:640px){.modal-module_falw-modal-spacer__-yqov{display:inline-block;height:100vh;vertical-align:middle}}.modal-module_falw-modal-content__JrNDY{border-radius:.375rem;border-width:1px;box-shadow:3px 4px 10px hsla(0,0%,64%,.1),-3px -1px 10px hsla(0,3%,86%,.1);max-width:100vw;overflow:hidden;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));text-align:left;transition-duration:.15s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}@media (min-width:640px){.modal-module_falw-modal-content__JrNDY{display:inline-block;margin-bottom:32px;margin-top:32px;position:relative;vertical-align:middle}}.modal-module_falw-modal-content__JrNDY{z-index:1}.modal-module_falw-modal-content__JrNDY.modal-module_responsive__ThZAo{border-radius:0;border-radius:10px 10px 0 0;border-width:0;bottom:0;left:0;position:absolute;top:0;width:100%}@media (min-width:640px){.modal-module_falw-modal-content__JrNDY.modal-module_responsive__ThZAo{border-radius:.375rem;border-width:1px;display:inline-block;margin-bottom:32px;margin-top:32px;position:relative;vertical-align:middle}}@keyframes modal-module_slideIn__ZKxH1{0%{margin-top:1000px}to{margin-top:100px}}@keyframes modal-module_slideOut__kNNbn{0%{margin-top:100px}to{margin-top:1000px}}@media (max-width:640px){.modal-module_falw-modal-content-rebranded-slidein__lpa49{animation-duration:.3s;animation-name:modal-module_slideIn__ZKxH1;animation-timing-function:ease-out;margin-top:100px}.modal-module_falw-modal-content-rebranded-slideout__RWA8i{animation-duration:.3s;animation-name:modal-module_slideOut__kNNbn;animation-timing-function:ease-in;margin-top:1000px}}.modal-module_falw-modal-content-rebranded__IOOIK{border-radius:6px!important}@media (max-width:640px){.modal-module_falw-modal-content-rebranded__IOOIK{height:100vh;max-height:581px;overflow:scroll;position:relative!important;width:100%!important}}.modal-module_falw-modal-close-button__xJSKv{background-color:transparent;border-width:0;cursor:pointer;padding:4px;position:absolute;z-index:10;--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.modal-module_falw-modal-close-button__xJSKv:focus{outline:2px solid transparent;outline-offset:2px}.modal-module_falw-modal-close-button__xJSKv{right:30px;top:30px}.modal-module_falw-modal-close-button-rebranded__MYmok{right:15px;top:15px}@media (max-width:640px){.modal-module_falw-modal-close-button-rebranded__MYmok{right:30px;top:30px}}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.translate-y-0{--tw-translate-y:0px}.translate-y-4{--tw-translate-y:1rem}.opacity-0{opacity:0}.opacity-100{opacity:1}.modal-module_falw-modal-consent-stage__kGH0E{border-radius:12px!important}@media (max-width:639px){.modal-module_falw-modal-consent-stage__kGH0E{border-radius:12px 12px 0 0!important}}";
var styles$2 = {"falw-modal-root":"modal-module_falw-modal-root__tDbT1","opened":"modal-module_opened__U2eAS","falw-modal-wrapper":"modal-module_falw-modal-wrapper__TxnM1","falw-modal-wrapper-rebranded":"modal-module_falw-modal-wrapper-rebranded__pvLWR","falw-modal-backdrop-wrapper":"modal-module_falw-modal-backdrop-wrapper__lH6zm","falw-modal-backdrop":"modal-module_falw-modal-backdrop__BE2ZM","falw-modal-spacer":"modal-module_falw-modal-spacer__-yqov","falw-modal-content":"modal-module_falw-modal-content__JrNDY","responsive":"modal-module_responsive__ThZAo","falw-modal-content-rebranded-slidein":"modal-module_falw-modal-content-rebranded-slidein__lpa49","slideIn":"modal-module_slideIn__ZKxH1","falw-modal-content-rebranded-slideout":"modal-module_falw-modal-content-rebranded-slideout__RWA8i","slideOut":"modal-module_slideOut__kNNbn","falw-modal-content-rebranded":"modal-module_falw-modal-content-rebranded__IOOIK","falw-modal-close-button":"modal-module_falw-modal-close-button__xJSKv","falw-modal-close-button-rebranded":"modal-module_falw-modal-close-button-rebranded__MYmok","falw-modal-consent-stage":"modal-module_falw-modal-consent-stage__kGH0E"};
styleInject(css_248z$2);

var BrowserType;
(function (BrowserType) {
    BrowserType["Safari"] = "Safari";
    BrowserType["IE"] = "IE";
    BrowserType["Chrome"] = "Chrome";
    BrowserType["Opera"] = "Opera";
    BrowserType["Firefox"] = "Firefox";
})(BrowserType || (BrowserType = {}));
function getIsClientSide() {
    return Boolean(typeof window !== 'undefined' && window.document);
}
function getBrowserType() {
    var isClientSide = getIsClientSide();
    if (!isClientSide)
        return BrowserType.Chrome;
    var userAgentString = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent;
    var chromeAgent = userAgentString.includes('Chrome');
    var IExplorerAgent = userAgentString.includes('MSIE') || userAgentString.includes('rv:');
    var firefoxAgent = userAgentString.includes('Firefox');
    var safariAgent = userAgentString.includes('Safari');
    if (chromeAgent && safariAgent)
        safariAgent = false;
    var operaAgent = userAgentString.includes('OP');
    if (chromeAgent && operaAgent)
        chromeAgent = false;
    if (safariAgent)
        return BrowserType.Safari;
    if (chromeAgent)
        return BrowserType.Chrome;
    if (IExplorerAgent)
        return BrowserType.IE;
    if (operaAgent)
        return BrowserType.Opera;
    if (firefoxAgent)
        return BrowserType.Firefox;
    return BrowserType.Chrome;
}

var Modal = function (props) {
    var _a;
    var ref = useRef();
    var _b = useState(false), mounted = _b[0], setMounted = _b[1];
    var _c = useState(false), isSafariOrChromeMobile = _c[0], setIsSafariOrChromeMobile = _c[1];
    var _d = props.backdrop, backdrop = _d === void 0 ? true : _d, _e = props.backdropClick, backdropClick = _e === void 0 ? true : _e, children = props.children, _f = props.closeButton, closeButton = _f === void 0 ? true : _f, closeButtonStyles = props.closeButtonStyles, _g = props.container, container = _g === void 0 ? 'body' : _g, onClose = props.onClose, _h = props.responsive, responsive = _h === void 0 ? true : _h, show = props.show, _j = props.width, width = _j === void 0 ? 500 : _j, id = props.id, _k = props.stage, stage = _k === void 0 ? null : _k;
    useEffect(function () {
        ref.current = document === null || document === void 0 ? void 0 : document.querySelector(container);
        setMounted(true);
    }, [container]);
    useEffect(function () {
        var isMobile = (document === null || document === void 0 ? void 0 : document.documentElement.clientWidth) < ScreenSizes.TAILWIND_SM;
        var isSafariMobile = isMobile && getBrowserType() === BrowserType.Safari;
        var isChromeMobile = isMobile && getBrowserType() === BrowserType.Chrome;
        setIsSafariOrChromeMobile(isSafariMobile || isChromeMobile);
    }, []);
    return mounted
        ? createPortal(jsx(Ge, __assign({ show: show, id: id, "data-package": "".concat(name, "@").concat(version) }, { children: (!isSafariOrChromeMobile || show) && (jsx("div", __assign({ className: styles$2['falw-modal-root'] }, { children: jsxs("div", __assign({ className: clsx(styles$2['falw-modal-wrapper'], props.isRebrandingEnabled && styles$2['falw-modal-wrapper-rebranded']) }, { children: [backdrop && (jsx(Ge.Child, __assign({ enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0", className: styles$2['falw-modal-backdrop-wrapper'], "aria-hidden": "true" }, { children: jsx("div", { className: styles$2['falw-modal-backdrop'], onClick: function () {
                                    backdropClick ? onClose(true) : null;
                                } }) }))), jsx("span", __assign({ className: styles$2['falw-modal-spacer'], "aria-hidden": "true" }, { children: "\u200B" })), jsxs(Ge.Child, __assign({ enter: "ease-out duration-300", enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95", enterTo: "opacity-100 translate-y-0 sm:scale-100", leave: "ease-in ".concat(props.isRebrandingEnabled ? 'duration-300' : 'duration-200'), leaveFrom: "opacity-100 translate-y-0 sm:scale-100", leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95", className: clsx(styles$2['falw-modal-content'], responsive && styles$2.responsive, props.isRebrandingEnabled && styles$2['modal-content-rebranded'], (_a = {},
                                _a["".concat(styles$2['falw-modal-content-rebranded-slidein'])] = props.isRebrandingEnabled && show,
                                _a["".concat(styles$2['falw-modal-content-rebranded-slideout'])] = props.isRebrandingEnabled && !show,
                                _a), stage === STAGES.consent && styles$2['falw-modal-consent-stage']), style: { width: width }, role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-headline" }, { children: [closeButton && (jsx("button", __assign({ id: id ? "".concat(id, "-close-button") : undefined, className: clsx(styles$2['falw-modal-close-button'], props.isRebrandingEnabled && styles$2['falw-modal-close-button-rebranded']), style: closeButtonStyles, onClick: function () {
                                        onClose(true);
                                    } }, { children: jsx(X$1, { size: 16 }) }))), children] }))] })) }))) })), document.body, ref.current)
        : null;
};

var finalHandlerSteps = function (props, dispatch, isNewDeviceOtpFlow) {
    if (isNewDeviceOtpFlow === void 0) { isNewDeviceOtpFlow = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.onComplete) return [3 /*break*/, 2];
                    return [4 /*yield*/, props.onComplete()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!props.onClose) return [3 /*break*/, 4];
                    return [4 /*yield*/, props.onClose()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setTimeout(function () {
                        dispatch({ type: ACTION_TYPES$1.setLegalText, value: undefined });
                        if (props.flowType === 'header' && !isNewDeviceOtpFlow) {
                            dispatch({ type: ACTION_TYPES$1.setStage, value: STAGES.login });
                        }
                        dispatch({ type: ACTION_TYPES$1.setCompleted, value: true });
                    }, 500);
                    return [2 /*return*/];
            }
        });
    });
};

var createRoot = null;
try {
    // Dynamically import `createRoot` only if available (React 18)
    createRoot = require('react-dom/client').createRoot;
}
catch (error) {
    createRoot = null; // Fallback for React 16/17
}
var renderReactApp = function (component, container) {
    if (createRoot) {
        createRoot(container).render(component); // React 18+
    }
    else {
        // React 16/17 fallback (use legacy render method)
        require('react-dom').render(component, container);
    }
};

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var injectStyles = function () {
    if (!isBrowser || document.getElementById('custom-toast-styles'))
        return;
    // Check if styles already exist
    var style = document.createElement('style');
    style.id = 'custom-toast-styles'; // Unique ID to avoid removing other styles
    style.innerHTML = ".custom-toast-container {\n      position: fixed;\n      z-index: 10000;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n    }\n  \n    .custom-top-left { top: 10px; left: 10px; align-items: flex-start; }\n    .custom-top-right { top: 10px; right: 10px; align-items: flex-end; }\n    .custom-top-center { top: 10px; left: 50%; transform: translateX(-50%); align-items: center; }\n    .custom-bottom-left { bottom: 10px; left: 10px; align-items: flex-start; }\n    .custom-bottom-right { bottom: 10px; right: 10px; align-items: flex-end; }\n    .custom-bottom-center { bottom: 10px; left: 50%; transform: translateX(-50%); align-items: center; }\n  \n    .custom-toast {\n      padding: 12px;\n      border-radius: 8px;\n      font-family: Lato, Sans-serif;\n      font-size: 14px;\n      min-width: 280px;\n      min-height: 32px;\n      text-align: left;\n      display: flex;\n      align-items: center;\n      opacity: 1;\n      animation: custom-toast-fadeIn 0.5s ease-out;\n    }\n  \n    .custom-toast-success { background-color: #DAFEE3; color: #333; }\n    .custom-toast-error { background-color: #FFDDE4; color: #333; }\n    .custom-toast-warning { background-color: orange; color: #333; }\n    .custom-toast-info { background-color: gray; color: white; }\n  \n    @keyframes custom-toast-fadeIn {\n      from { opacity: 0; transform: translateY(-10px); }\n      to { opacity: 1; transform: translateY(0); }\n    }\n  \n    .custom-toast-fade-out {\n      animation: custom-toast-fadeOut 0.5s ease-out forwards;\n    }\n  \n    @keyframes custom-toast-fadeOut {\n      from { opacity: 1; transform: translateY(0); }\n      to { opacity: 0; transform: translateY(-10px); }\n    }";
    document.head.appendChild(style);
};
var removeStyles = function () {
    var _a;
    (_a = document.getElementById('custom-toast-styles')) === null || _a === void 0 ? void 0 : _a.remove();
};
var ToastContainer = function () {
    var _a = useState([]), toasts = _a[0], setToasts = _a[1];
    var toastRef = useRef();
    var toastRefs = useRef({});
    var showToast = useCallback(function (message, type, position, duration) {
        if (type === void 0) { type = 'info'; }
        if (position === void 0) { position = 'top-right'; }
        if (duration === void 0) { duration = 3000; }
        var id = Date.now().toString();
        setToasts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ id: id, type: type, message: message, position: position }], false); });
        setTimeout(function () {
            var toastEl = toastRefs.current[id];
            if (toastEl) {
                toastEl.classList.add('custom-toast-fade-out'); // Start custom-toast-fade-out animation
                toastEl.addEventListener('animationend', function () {
                    setToasts(function (prev) { return prev.filter(function (toast) { return toast.id !== id; }); });
                });
            }
            else {
                setToasts(function (prev) { return prev.filter(function (toast) { return toast.id !== id; }); });
            }
        }, duration);
    }, []);
    useEffect(function () {
        injectStyles();
        return function () {
            removeStyles();
        };
    }, []);
    useEffect(function () {
        if (isBrowser) {
            if (!toastRef.current) {
                toastRef.current = showToast;
                window.__custom_toast = toastRef.current;
            }
        }
    }, [showToast]);
    return (jsx(Fragment, { children: ['top-left', 'top-right', 'top-center', 'bottom-center', 'bottom-left', 'bottom-right'].map(function (pos) { return (jsx("div", __assign({ className: "custom-toast-container custom-".concat(pos) }, { children: toasts
                .filter(function (toast) { return toast.position === pos; })
                .map(function (toast) { return (jsx(ToastItem, { toast: toast, ref: function (el) { return (toastRefs.current[toast.id] = el); } }, toast.id)); }) }), pos)); }) }));
};
// Extracted ToastItem Component
var ToastItem = React__default.forwardRef(function (_a, ref) {
    var toast = _a.toast;
    return (jsx("div", __assign({ ref: ref, className: "custom-toast custom-toast-".concat(toast.type) }, { children: toast.message })));
});
if (isBrowser) {
    // Mount toast container safely
    var toastRoot = document.createElement('div');
    document.body.appendChild(toastRoot);
    renderReactApp(jsx(ToastContainer, {}), toastRoot);
}
// Export standalone toast function
var createStandaloneToast = function (message, type, position, duration) {
    var _a, _b;
    if (type === void 0) { type = 'info'; }
    if (position === void 0) { position = 'top-right'; }
    if (duration === void 0) { duration = 5000; }
    if (isBrowser) {
        (_b = (_a = window).__custom_toast) === null || _b === void 0 ? void 0 : _b.call(_a, message, type, position, duration);
    }
};

var css_248z$1 = ".error-modal-module_falw-error-modal-root__uog5I{align-items:flex-start;background:#fff;display:flex;flex-direction:column;font-family:Lato;font-style:normal;gap:20px;padding:20px 20px 0}.error-modal-module_falw-error-modal-root__uog5I *,.error-modal-module_falw-error-modal-root__uog5I :after,.error-modal-module_falw-error-modal-root__uog5I :before{box-sizing:border-box}.error-modal-module_falw-error-modal-root__uog5I blockquote,.error-modal-module_falw-error-modal-root__uog5I dd,.error-modal-module_falw-error-modal-root__uog5I dl,.error-modal-module_falw-error-modal-root__uog5I figure,.error-modal-module_falw-error-modal-root__uog5I h1,.error-modal-module_falw-error-modal-root__uog5I h2,.error-modal-module_falw-error-modal-root__uog5I h3,.error-modal-module_falw-error-modal-root__uog5I h4,.error-modal-module_falw-error-modal-root__uog5I h5,.error-modal-module_falw-error-modal-root__uog5I h6,.error-modal-module_falw-error-modal-root__uog5I hr,.error-modal-module_falw-error-modal-root__uog5I p,.error-modal-module_falw-error-modal-root__uog5I pre{margin:0}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_error-header__PKjS1{display:flex}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_error-header__PKjS1 .error-modal-module_header-icon__345KG{margin-right:12px}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_error-header__PKjS1 .error-modal-module_header-title__3ojI7{color:#333;font-size:18px;font-weight:700;line-height:22px}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_error-content__2k2-Z{color:#333;font-size:14px;font-weight:400;line-height:normal}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_button-container-falabella__vDDhF{align-items:center;align-self:stretch;background:#343e49;border-radius:80px;border-width:0;color:#fefeff;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;padding:0 32px}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_button-container-sodimac__mgCb4{align-items:center;align-self:stretch;background:#0072ce;border-radius:4px;border-width:0;color:#fefeff;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;padding:0 32px}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_button-container-tottus__tHthb{align-items:center;align-self:stretch;background:#19ce4d;border-radius:80px;border-width:0;color:#013f48;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;padding:0 32px}.error-modal-module_falw-error-modal-root__uog5I .error-modal-module_errorIdentifierText-container__DG7o-{color:#a6a6a6;font-size:12px;font-weight:400;line-height:16px;margin:8px 0}";
var styles$1 = {"falw-error-modal-root":"error-modal-module_falw-error-modal-root__uog5I","error-header":"error-modal-module_error-header__PKjS1","header-icon":"error-modal-module_header-icon__345KG","header-title":"error-modal-module_header-title__3ojI7","error-content":"error-modal-module_error-content__2k2-Z","button-container-falabella":"error-modal-module_button-container-falabella__vDDhF","button-container-sodimac":"error-modal-module_button-container-sodimac__mgCb4","button-container-tottus":"error-modal-module_button-container-tottus__tHthb","errorIdentifierText-container":"error-modal-module_errorIdentifierText-container__DG7o-"};
styleInject(css_248z$1);

var getCurrentDateFormatError = function () {
    var date = new Date();
    var formatDigitTime = function (number) { return "0".concat(number).slice(-2); };
    var currentDay = formatDigitTime(date.getDate());
    var currentMonth = formatDigitTime(date.getMonth() + 1);
    var currentYear = date.getFullYear();
    var currentHour = formatDigitTime(date.getHours());
    var currentMinute = formatDigitTime(date.getMinutes());
    var currentSecond = formatDigitTime(date.getSeconds());
    return "".concat(currentDay, "-").concat(currentMonth, "-").concat(currentYear, ", ").concat(currentHour, ":").concat(currentMinute, ":").concat(currentSecond);
};

var ErrorModal = function (_a) {
    var onClick = _a.onClick;
    var labels = useTranslation().labels;
    var siteName = getSiteName();
    var ERROR_MODAL_TITLE = labels.ERROR_MODAL_TITLE, ERROR_MODAL_CONTENT = labels.ERROR_MODAL_CONTENT, FORWARD = labels.FORWARD;
    var date = getCurrentDateFormatError();
    var errorIdentifierText = getCookie(CART_ID) ? "".concat(getCookie(CART_ID), " - ").concat(date) : '';
    return (jsxs("div", __assign({ className: styles$1['falw-error-modal-root'] }, { children: [jsxs("section", __assign({ className: styles$1['error-header'] }, { children: [jsx("div", __assign({ className: styles$1['header-icon'] }, { children: jsx(WarningCircle, { size: 26 }) })), jsx("span", __assign({ className: styles$1['header-title'] }, { children: ERROR_MODAL_TITLE }))] })), jsx("section", __assign({ className: styles$1['error-content'] }, { children: jsx("p", { children: ERROR_MODAL_CONTENT }) })), jsx("button", __assign({ className: styles$1["button-container-".concat(siteName)], onClick: function () {
                    onClick();
                } }, { children: jsx("p", { children: FORWARD }) })), jsx("section", __assign({ className: styles$1['errorIdentifierText-container'] }, { children: errorIdentifierText && errorIdentifierText }))] })));
};

var css_248z = ".new-device-otp-form-module_falw-new-device-otp-form__J6ZN9{font-family:Lato;font-style:normal;line-height:20px;padding:32px;position:relative}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 *{font-family:Lato,Sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 *,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 :after,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 :before{box-sizing:border-box}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 blockquote,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 dd,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 dl,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 figure,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 h1,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 h2,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 h3,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 h4,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 h5,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 h6,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 hr,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 p,.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 pre{margin:0}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 b{font-weight:700}@media (min-width:640px){.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9{padding:30px 50px}}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_spinner-wrapper__ExgZR{align-items:center;color:#343e49;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_spinner-wrapper__ExgZR .new-device-otp-form-module_spinner__p5i1p{animation:new-device-otp-form-module_spin__fplNZ 1s linear infinite}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_form-content__A9BtP{color:#767676}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_form-content__A9BtP>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(12px*var(--tw-space-y-reverse));margin-top:calc(12px*(1 - var(--tw-space-y-reverse)))}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_form-content__A9BtP.new-device-otp-form-module_disabled__fotR7{opacity:.1}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_alert-warning__jDetd{background-color:#fff1c9;border-radius:6px;display:flex;height:48px;margin-bottom:10px;padding:12px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_alert-warning__jDetd .new-device-otp-form-module_alert-message__ES6Ma{font-size:12px;margin-left:10px}@media (max-width:620px){.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_alert-warning__jDetd .new-device-otp-form-module_alert-message__ES6Ma{font-size:14px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_alert-warning__jDetd{margin-top:22px}}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_spinner-wrapper__ExgZR{align-items:center;color:#343e49!important;display:flex;inset:0;justify-content:center;position:absolute;z-index:9010}@keyframes new-device-otp-form-module_spin__fplNZ{to{transform:rotate(1turn)}}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_spinner-wrapper__ExgZR .new-device-otp-form-module_spinner__p5i1p{animation:new-device-otp-form-module_spin__fplNZ 1s linear infinite}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_new-device-otp-form-icon__MyqOZ{text-align:center}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_new-device-otp-form-icon__MyqOZ svg{margin:auto}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_new-device-otp-form-title__HgBbY{font-size:24px;font-weight:400;line-height:28px;margin-bottom:24px;text-align:center}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_title__ScCO-{font-size:16px;font-weight:400;line-height:24px;margin-bottom:20px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_hr-style__MJ-EH{align-items:flex-start;align-self:stretch;color:#cac4d0;flex-direction:column;height:1px;justify-content:center;opacity:.5}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_verification-method-button__xivcj{background-color:#fff;border:none;cursor:pointer;margin-right:10px;padding:16px 16px 16px 4px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_verification-method-button-container__CR-G8{color:#333;display:flex;font-size:16px;font-weight:400;line-height:24px;text-align:left}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_verification-method-button-text__jmf0-{width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_verification-method__FfGN5{color:#343e49!important;font-size:14px;line-height:20px;padding-right:60px;text-align:left}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-new-device-otp-form-root__jBr26 .new-device-otp-form-module_right-arrow__V-DUx{height:24px;width:24px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_new-device-otp-form-header__birTP{align-items:flex-start;align-self:stretch;color:#333;display:flex;flex-direction:column;font-size:16px;font-weight:400;gap:4px;line-height:24px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_email__szSjw{font-weight:700;margin-bottom:12px;margin-top:12px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_otp-input-container__wkcEC{align-items:center;display:flex;gap:8px;height:44px;padding:8px 0;width:40px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_empty-otp__octX2{color:#bc001c}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_otp-input__kqMtx{background:#fefeff;border:solid #a6a6a6;border-radius:0;border-width:0 0 1px;font-size:24px;font-weight:700;line-height:28px;outline:none;text-align:center;width:40px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_otp-input-error__IGYUI{background:#fefeff;border:solid #bc001c;border-radius:0;border-width:0 0 1px;font-size:24px;font-weight:700;line-height:28px;outline:none;text-align:center;width:40px}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_countdown-timer__oaflG{color:#a6a6a6;font-size:16px;font-weight:400;line-height:24px;margin:24px 0}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_confirm-button-falabella-enabled__YoPgq{align-items:center;align-self:stretch;background:#343e49;border-radius:80px;border-width:0;color:#fefeff;cursor:pointer;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;max-width:343px;padding:0 32px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_confirm-button-falabella-disabled__igXyc{align-items:center;align-self:stretch;background-color:#f9f9f9;border:none;border-radius:80px;color:#c2c2c2;cursor:not-allowed;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;max-width:343px;padding:0 32px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_confirm-button-sodimac-enabled__WiSJh{align-items:center;align-self:stretch;background:#0072ce;border-color:#0072ce;border-radius:4px;border-width:0;color:#fefeff;cursor:pointer;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;max-width:343px;padding:0 32px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_confirm-button-sodimac-disabled__A3vCx{align-items:center;align-self:stretch;background-color:#f9f9f9;border:none;border-radius:4px;color:#c2c2c2;cursor:not-allowed;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;max-width:343px;padding:0 32px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_confirm-button-tottus-enabled__-jYXm{align-items:center;align-self:stretch;background:#19ce4d;border-color:#19ce4d;border-radius:80px;border-width:0;color:#013f48;cursor:pointer;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;max-width:343px;padding:0 32px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_confirm-button-tottus-disabled__eww3z{align-items:center;align-self:stretch;background-color:#f9f9f9;border:none;border-radius:80px;color:#c2c2c2;cursor:not-allowed;display:flex;font-size:16px;font-weight:700;height:44px;justify-content:center;line-height:20px;max-height:44px;max-width:343px;padding:0 32px;width:100%}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_verification-method-container__IniMo{align-items:center;align-self:stretch;display:flex;flex-direction:column;gap:10px;margin:20px 0}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_verification-method__FfGN5{background-color:#fefeff;border:none;color:#343e49!important;font-size:16px;font-weight:700;line-height:24px;text-decoration-line:underline}.new-device-otp-form-module_falw-new-device-otp-form__J6ZN9 .new-device-otp-form-module_falw-otp-modal__cEI97 .new-device-otp-form-module_resend-link__ry08c{background-color:#fefeff;border:none;color:#343e49;font-size:16px;font-weight:400;line-height:24px;margin:20px 0;text-decoration-line:underline}";
var styles = {"falw-new-device-otp-form":"new-device-otp-form-module_falw-new-device-otp-form__J6ZN9","spinner-wrapper":"new-device-otp-form-module_spinner-wrapper__ExgZR","spinner":"new-device-otp-form-module_spinner__p5i1p","spin":"new-device-otp-form-module_spin__fplNZ","form-content":"new-device-otp-form-module_form-content__A9BtP","disabled":"new-device-otp-form-module_disabled__fotR7","alert-warning":"new-device-otp-form-module_alert-warning__jDetd","alert-message":"new-device-otp-form-module_alert-message__ES6Ma","falw-new-device-otp-form-root":"new-device-otp-form-module_falw-new-device-otp-form-root__jBr26","new-device-otp-form-icon":"new-device-otp-form-module_new-device-otp-form-icon__MyqOZ","new-device-otp-form-title":"new-device-otp-form-module_new-device-otp-form-title__HgBbY","title":"new-device-otp-form-module_title__ScCO-","hr-style":"new-device-otp-form-module_hr-style__MJ-EH","verification-method-button":"new-device-otp-form-module_verification-method-button__xivcj","verification-method-button-container":"new-device-otp-form-module_verification-method-button-container__CR-G8","verification-method-button-text":"new-device-otp-form-module_verification-method-button-text__jmf0-","verification-method":"new-device-otp-form-module_verification-method__FfGN5","right-arrow":"new-device-otp-form-module_right-arrow__V-DUx","falw-otp-modal":"new-device-otp-form-module_falw-otp-modal__cEI97","new-device-otp-form-header":"new-device-otp-form-module_new-device-otp-form-header__birTP","email":"new-device-otp-form-module_email__szSjw","otp-input-container":"new-device-otp-form-module_otp-input-container__wkcEC","empty-otp":"new-device-otp-form-module_empty-otp__octX2","otp-input":"new-device-otp-form-module_otp-input__kqMtx","otp-input-error":"new-device-otp-form-module_otp-input-error__IGYUI","countdown-timer":"new-device-otp-form-module_countdown-timer__oaflG","confirm-button-falabella-enabled":"new-device-otp-form-module_confirm-button-falabella-enabled__YoPgq","confirm-button-falabella-disabled":"new-device-otp-form-module_confirm-button-falabella-disabled__igXyc","confirm-button-sodimac-enabled":"new-device-otp-form-module_confirm-button-sodimac-enabled__WiSJh","confirm-button-sodimac-disabled":"new-device-otp-form-module_confirm-button-sodimac-disabled__A3vCx","confirm-button-tottus-enabled":"new-device-otp-form-module_confirm-button-tottus-enabled__-jYXm","confirm-button-tottus-disabled":"new-device-otp-form-module_confirm-button-tottus-disabled__eww3z","verification-method-container":"new-device-otp-form-module_verification-method-container__IniMo","resend-link":"new-device-otp-form-module_resend-link__ry08c"};
styleInject(css_248z);

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADFSURBVHgB7ZGxDcIwEEVtQnpGyAhGUaSUZCQ2gA1gAkaADdKmsCVvgEegt2xxhyij3Nlu/ZpLpLv/pG8hKpVSJLXQ9/0bZ9u207IsTiSyY+513vt5HMdOJEIKQggTDJcrIStClFJd0zQzSlCWUhdLUCJhC9YkUN/RWvvZuuE+8g8IczDO/1+UnaibJMEwDArGA7+llFdjzIu6YVeE4TFGrOeA4VrrC+eOJcgNZwlKwhHyDSD8mRuO7KkFCL7jhPCbqFTW+AIBPVM6vqCmAwAAAABJRU5ErkJggg==";

var VerificationMethodButton = function (_a) {
    var _b = _a.verificationMethod, verificationMethod = _b === void 0 ? '' : _b, verificationMethodTitle = _a.verificationMethodTitle, verificationMethodText = _a.verificationMethodText, onClick = _a.onClick;
    return (jsx("div", __assign({ className: styles['falw-verification-method-button'] }, { children: jsxs("button", __assign({ className: styles['verification-method-button'], onClick: function () {
                onClick();
            } }, { children: [jsxs("div", __assign({ className: styles['verification-method-button-container'] }, { children: [jsx("p", __assign({ className: styles['verification-method-button-text'] }, { children: verificationMethodTitle })), jsx("img", { className: styles['right-arrow'], src: img, alt: "", title: "" })] })), jsx("div", __assign({ className: styles['verification-method'] }, { children: jsx("p", { children: "".concat(verificationMethodText, " ").concat(verificationMethod) }) }))] })) })));
};

var initialState = {
    loading: false,
    showErrorModal: false,
    emailOtpModal: false,
    phoneOtpModal: false,
    seconds: 120,
    showResendButon: false,
    confirmClickCount: 0,
    otpError: '',
    challengeId: '',
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["setLoading"] = "loading";
    ACTION_TYPES["setshowErrorModal"] = "showErrorModal";
    ACTION_TYPES["setEmailOtpModal"] = "emailOtpModal";
    ACTION_TYPES["setPhoneOtpModal"] = "phoneOtpModal";
    ACTION_TYPES["setSeconds"] = "seconds";
    ACTION_TYPES["setShowResendButon"] = "showResendButon";
    ACTION_TYPES["setConfirmClickCount"] = "confirmClickCount";
    ACTION_TYPES["setOtpError"] = "otpError";
    ACTION_TYPES["setChallengeId"] = "challengeId";
})(ACTION_TYPES || (ACTION_TYPES = {}));
var reducer = function (state, action) {
    var _a;
    switch (action.type) {
        case ACTION_TYPES.setLoading:
        case ACTION_TYPES.setEmailOtpModal:
        case ACTION_TYPES.setPhoneOtpModal:
        case ACTION_TYPES.setSeconds:
        case ACTION_TYPES.setshowErrorModal:
        case ACTION_TYPES.setShowResendButon:
        case ACTION_TYPES.setConfirmClickCount:
        case ACTION_TYPES.setOtpError:
        case ACTION_TYPES.setChallengeId:
            return __assign(__assign({}, state), (_a = {}, _a[action.type] = action.value, _a));
    }
};

var AlertIcon = function (_a, svgRef) {
    _a.size; __rest(_a, ["size"]);
    return (jsxs("svg", __assign({ width: "18", height: "18", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10 1.75C5.44365 1.75 1.75 5.44365 1.75 10C1.75 14.5563 5.44365 18.25 10 18.25C14.5563 18.25 18.25 14.5563 18.25 10C18.25 5.44365 14.5563 1.75 10 1.75ZM0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10Z", fill: "#73580D" }), jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10 12.25C10.6213 12.25 11.125 12.7537 11.125 13.375C11.125 13.9963 10.6213 14.5 10 14.5C9.37868 14.5 8.875 13.9963 8.875 13.375C8.875 12.7537 9.37868 12.25 10 12.25ZM10.75 10C10.75 10.4142 10.4142 10.75 10 10.75C9.58579 10.75 9.25 10.4142 9.25 10V6.25C9.25 5.83579 9.58579 5.5 10 5.5C10.4142 5.5 10.75 5.83579 10.75 6.25V10Z", fill: "#73580D" })] })));
};
var Alert = React__default.forwardRef(AlertIcon);

var NewDeviceOtpModalAlert = function (_a) {
    var message = _a.message, type = _a.type;
    var alertClass = "alert-".concat(type);
    return (jsxs("div", __assign({ className: styles[alertClass] }, { children: [jsx(Alert, { className: styles.alert }), jsx("span", __assign({ className: styles['alert-message'] }, { children: message }))] })));
};

var NewDeviceOtpForm = function (_a) {
    var id = _a.id, user = _a.user, catalystBaseUrl = _a.catalystBaseUrl, _b = _a.doAssociateAccount, doAssociateAccount = _b === void 0 ? false : _b, _c = _a.doMergeCart, doMergeCart = _c === void 0 ? false : _c, tenant = _a.tenant, closeModalCount = _a.closeModalCount, onLogin = _a.onLogin, onClose = _a.onClose, setCloseModalCount = _a.setCloseModalCount, handleErrorClose = _a.handleErrorClose;
    var _d = useReducer(reducer, __assign({}, initialState)), state = _d[0], dispatch = _d[1];
    var whitelabel = useContext(WhiteLabelContext);
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var labels = useTranslation().labels;
    var _f = useState(false), showAlert = _f[0], setShowAlert = _f[1];
    var newDeviceOtpFlow = useCommerceConfig('configurations.loginConfigs').newDeviceOtpFlow;
    var toggles = useCommerceConfig('toggles');
    var inputRefs = Array(6)
        .fill()
        .map(function () { return useRef(null); });
    var initialValues = {
        otp: '',
    };
    var validationSchema = create({
        otp: create$1()
            .length(6, 'OTP must be exactly 6 digits')
            .matches(/^\d+$/, 'OTP must be a number')
            .required('OTP is required'),
    });
    var ERROR_TOAST_MESSAGE = labels.ERROR_TOAST_MESSAGE, EXCEED_LIMIT_ERROR = labels.EXCEED_LIMIT_ERROR, INVALID_OTP_ERROR = labels.INVALID_OTP_ERROR, EMAIL_OTP_MODAL_TITLE = labels.EMAIL_OTP_MODAL_TITLE, SMS_OTP_MODAL_TITLE = labels.SMS_OTP_MODAL_TITLE, RESEND_CODE = labels.RESEND_CODE, RESUBMIT_CODE_IN = labels.RESUBMIT_CODE_IN, CONFIRM = labels.CONFIRM, BACK_BUTTON = labels.BACK_BUTTON, OTP_MODAL_TITLE = labels.OTP_MODAL_TITLE, CONFIRM_LOGIN = labels.CONFIRM_LOGIN, ALERT_MESSAGE_TO_CONTINUE_WITHOUT_LOGIN = labels.ALERT_MESSAGE_TO_CONTINUE_WITHOUT_LOGIN, SUCCESS_TOAST_MESSAGE = labels.SUCCESS_TOAST_MESSAGE, PHONE_OTP_MODAL_CONTET = labels.PHONE_OTP_MODAL_CONTET, PHONE = labels.PHONE, CORREO = labels.CORREO, EMAIL_OTP_MODAL_CONTET = labels.EMAIL_OTP_MODAL_CONTET;
    var siteName = getSiteName();
    var showSuccessToast = function () {
        track('successdeviceotpmodal');
        track('loginStatus = Falabella Logged in');
        track('event9');
        createStandaloneToast(SUCCESS_TOAST_MESSAGE, 'success', 'top-center', 5000);
    };
    var showErrorToast = function (message) {
        track('errorsdeviceotpmodal');
        createStandaloneToast(message, 'error', 'top-center', 5000);
    };
    useEffect(function () {
        if (window) {
            window.digitalData = __assign(__assign({}, window.digitalData), { optionselectedotpmodal: state.emailOtpModal ? MAIL : state.phoneOtpModal ? SMS : '' });
        }
    }, [state.emailOtpModal, state.phoneOtpModal]);
    useEffect(function () {
        track('opendeviceotpmodal');
    }, []);
    useEffect(function () {
        if (state.emailOtpModal || state.phoneOtpModal) {
            var countdown_1 = setInterval(function () {
                if (state.seconds > 0) {
                    dispatch({ type: ACTION_TYPES.setSeconds, value: state.seconds - 1 });
                }
                else {
                    clearInterval(countdown_1);
                }
            }, 1000);
            return function () {
                clearInterval(countdown_1);
            };
        }
    }, [state.seconds, state.emailOtpModal, state.phoneOtpModal]);
    var minutes = Math.floor(state.seconds / 60);
    var remainingSeconds = state.seconds % 60;
    var getOtpReqParams = function (isEmailFlow) {
        return {
            tenantId: tenantId(tenant),
            catalystBaseUrl: catalystBaseUrl,
            isEmailFlow: isEmailFlow,
            otpFlow: true,
        };
    };
    var onEmailClickHandler = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var emailOtpReqParams, response, errors;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    emailOtpReqParams = getOtpReqParams(true);
                    dispatch({ type: ACTION_TYPES.setEmailOtpModal, value: true });
                    dispatch({ type: ACTION_TYPES.setPhoneOtpModal, value: false });
                    return [4 /*yield*/, getOTPByChallengeURL(emailOtpReqParams)];
                case 1:
                    response = _b.sent();
                    errors = response.errors;
                    dispatch({ type: ACTION_TYPES.setChallengeId, value: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.challengeId });
                    if (errors === null || errors === void 0 ? void 0 : errors.length) {
                        showErrorToast(ERROR_TOAST_MESSAGE);
                        dispatch({ type: ACTION_TYPES.setEmailOtpModal, value: true });
                        dispatch({ type: ACTION_TYPES.setSeconds, value: 0 });
                        dispatch({ type: ACTION_TYPES.setShowResendButon, value: true }); // check
                    }
                    else {
                        dispatch({ type: ACTION_TYPES.setSeconds, value: 120 });
                        dispatch({ type: ACTION_TYPES.setShowResendButon, value: false });
                        dispatch({ type: ACTION_TYPES.setshowErrorModal, value: false });
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var onPhoneClickHandler = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var smsOtpReqParams, response, errors;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    smsOtpReqParams = getOtpReqParams(false);
                    dispatch({ type: ACTION_TYPES.setEmailOtpModal, value: false });
                    dispatch({ type: ACTION_TYPES.setPhoneOtpModal, value: true });
                    return [4 /*yield*/, getOTPByChallengeURL(smsOtpReqParams)];
                case 1:
                    response = _b.sent();
                    dispatch({ type: ACTION_TYPES.setChallengeId, value: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.challengeId });
                    errors = response.errors;
                    if (errors === null || errors === void 0 ? void 0 : errors.length) {
                        showErrorToast(ERROR_TOAST_MESSAGE);
                        dispatch({ type: ACTION_TYPES.setPhoneOtpModal, value: true });
                        dispatch({ type: ACTION_TYPES.setSeconds, value: 0 });
                        dispatch({ type: ACTION_TYPES.setShowResendButon, value: true });
                    }
                    else {
                        dispatch({ type: ACTION_TYPES.setSeconds, value: 120 });
                        dispatch({ type: ACTION_TYPES.setShowResendButon, value: false });
                        dispatch({ type: ACTION_TYPES.setshowErrorModal, value: false });
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var onClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!state.emailOtpModal) return [3 /*break*/, 2];
                    return [4 /*yield*/, onEmailClickHandler()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!state.phoneOtpModal) return [3 /*break*/, 4];
                    return [4 /*yield*/, onPhoneClickHandler()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var clearOtp = function (setFieldValue) {
        setFieldValue('otp', '');
        inputRefs.forEach(function (ref) { return ref.current && (ref.current.value = ''); });
    };
    var onResendClick = function (setFieldValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clearOtp(setFieldValue);
                    dispatch({ type: ACTION_TYPES.setOtpError, value: '' });
                    return [4 /*yield*/, onClick()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e, index, setFieldValue, values) {
        dispatch({ type: ACTION_TYPES.setOtpError, value: '' });
        var value = e.target.value;
        var otp = values.otp.split('');
        otp[index] = value || ' ';
        if (value.length === 1 && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
        setFieldValue('otp', otp.join(''));
    };
    var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track('closedeviceotpmodal');
                    return [4 /*yield*/, logout({
                            tenantId: tenantId(tenant),
                            catalystBaseUrl: catalystBaseUrl,
                            additionalInfo: { whitelabel: whitelabel },
                            otpFlow: true,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleKeyDown = function (event, index) {
        var key = event.key, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
        var isCmdOrCtrl = ctrlKey || metaKey;
        if (isCmdOrCtrl && key.toLowerCase() === 'v') {
            return;
        }
        var allowedKeys = [BACKSPACE, TAB, ARROW_LEFT, ARROW_RIGHT];
        if (key.length === 1 && !/[\d]/.test(key) && !allowedKeys.includes(key)) {
            event.preventDefault();
        }
        if (key === BACKSPACE && index > 0 && event.target.value === '') {
            event.preventDefault();
            inputRefs[index - 1].current.focus();
        }
    };
    var handleErrors = function (errorResponse) { return __awaiter(void 0, void 0, void 0, function () {
        var errors, otpLimitReachedError, otpError, otpExpiredError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    errors = errorResponse || [];
                    otpLimitReachedError = errors.find(function (error) { return error.code === CHALLENGE_OTP_LIMIT_REACHED; });
                    otpError = errors.find(function (error) { return error.code === INVALID_CHALLENGE_OTP; });
                    otpExpiredError = errors.find(function (error) { return error.code === CHALLENGE_TOKEN_EXPIRED; });
                    if (!otpError) return [3 /*break*/, 1];
                    dispatch({ type: ACTION_TYPES.setOtpError, value: INVALID_OTP_ERROR });
                    return [3 /*break*/, 5];
                case 1:
                    if (!otpExpiredError) return [3 /*break*/, 2];
                    dispatch({ type: ACTION_TYPES.setshowErrorModal, value: true });
                    return [3 /*break*/, 5];
                case 2:
                    if (!otpLimitReachedError) return [3 /*break*/, 4];
                    showErrorToast(EXCEED_LIMIT_ERROR);
                    return [4 /*yield*/, handleLogout()];
                case 3:
                    _a.sent();
                    handleErrorClose();
                    return [3 /*break*/, 5];
                case 4:
                    if (errors.length > 0 && state.confirmClickCount !== 4) {
                        showErrorToast(ERROR_TOAST_MESSAGE);
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handlePaste = function (e, setFieldValue) {
        var _a, _b;
        e.preventDefault();
        var pasteData = e.clipboardData.getData('text').trim();
        var hasNumbers = /\d/.test(pasteData);
        var hasAlphabets = /[a-zA-Z]/.test(pasteData);
        if (hasAlphabets && !hasNumbers) {
            return;
        }
        var numericData = pasteData.replace(/\D/g, '').slice(0, inputRefs.length);
        if (numericData.length === 0)
            return;
        numericData.split('').forEach(function (char, i) {
            var _a;
            ((_a = inputRefs[i]) === null || _a === void 0 ? void 0 : _a.current) && (inputRefs[i].current.value = char);
        });
        var lastIndex = numericData.length - 1;
        if (inputRefs[lastIndex] && inputRefs[lastIndex].current) {
            (_b = (_a = inputRefs[lastIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        setFieldValue('otp', numericData);
    };
    var handleSubmit = function (values, _a) {
        var setSubmitting = _a.setSubmitting;
        return __awaiter(void 0, void 0, void 0, function () {
            var otpValidationReqParams, response, validationErrors;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        otpValidationReqParams = {
                            tenantId: tenantId(tenant),
                            challengeId: state.challengeId,
                            otp: values.otp,
                            catalystBaseUrl: catalystBaseUrl,
                            doAssociateAccount: doAssociateAccount,
                            doMergeCart: doMergeCart,
                            isEmailFlow: !!state.emailOtpModal,
                            otpFlow: true,
                            additionalInfo: { whitelabel: whitelabel },
                        };
                        return [4 /*yield*/, getOTPChallengeValidationURL(otpValidationReqParams)];
                    case 1:
                        response = _b.sent();
                        validationErrors = (response || {}).validationErrors;
                        if (!(validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length)) return [3 /*break*/, 2];
                        handleErrors(validationErrors);
                        return [3 /*break*/, 4];
                    case 2:
                        showSuccessToast();
                        setCloseModalCount(0);
                        setTimeout(function () {
                            onClose();
                        }, 2000);
                        setSubmitting(false);
                        return [4 /*yield*/, onLogin(response)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var renderOtpModal = function () {
        return (jsxs("div", __assign({ id: id, className: styles['falw-otp-modal'] }, { children: [loading && (jsx("div", __assign({ className: styles['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles.spinner }) }))), jsxs("div", __assign({ className: styles['new-device-otp-form-header'] }, { children: [jsx("p", __assign({ className: styles.title }, { children: state.emailOtpModal ? EMAIL_OTP_MODAL_TITLE : SMS_OTP_MODAL_TITLE })), state.emailOtpModal && jsx("p", __assign({ className: styles.email }, { children: user.email }))] })), jsx(Formik, __assign({ initialValues: initialValues, validationSchema: validationSchema, onSubmit: handleSubmit }, { children: function (_a) {
                        var setFieldValue = _a.setFieldValue, values = _a.values, isValid = _a.isValid, dirty = _a.dirty;
                        return (jsxs(Form, __assign({ autoComplete: "off", className: clsx(styles['form-content'], loading && styles.disabled), style: { paddingTop: loading ? '30px' : '0px' } }, { children: [jsxs("div", __assign({ className: styles['form-group'] }, { children: [jsx("div", __assign({ className: styles['otp-input-container'] }, { children: __spreadArray([], Array(6), true).map(function (_, index) { return (jsx("input", { ref: inputRefs[index], type: "text", id: "otp-".concat(index), name: "otp[".concat(index, "]"), maxLength: 1, inputMode: "numeric", pattern: "[0-9]*", className: styles["otp-input".concat(state.otpError ? '-error' : '')], onChange: function (e) {
                                                    handleChange(e, index, setFieldValue, values);
                                                }, onKeyDown: function (e) {
                                                    handleKeyDown(e, index);
                                                }, onPaste: function (e) {
                                                    handlePaste(e, setFieldValue);
                                                } }, index)); }) })), state.otpError !== '' ? (jsx("div", __assign({ className: styles['empty-otp'] }, { children: state.otpError }))) : null] })), state.seconds === 0 || state.showResendButon ? (jsx("div", __assign({ className: styles['resend-link-container'] }, { children: jsx("button", __assign({ className: styles['resend-link'], onClick: function () { return onResendClick(setFieldValue); } }, { children: jsx("p", { children: RESEND_CODE }) })) }))) : (jsxs("p", __assign({ className: styles['countdown-timer'] }, { children: [RESUBMIT_CODE_IN, " ", minutes, ":", remainingSeconds < 10 ? "0".concat(remainingSeconds, "s") : "".concat(remainingSeconds, "s")] }))), jsx("button", __assign({ type: "submit", className: styles["confirm-button-".concat(siteName, "-").concat(!(isValid && dirty) || state.otpError !== '' ? 'disabled' : 'enabled')], disabled: !(isValid && dirty) || state.otpError !== '' }, { children: CONFIRM }))] })));
                    } })), jsx("div", __assign({ className: styles['verification-method-container'] }, { children: jsx("button", __assign({ className: styles['verification-method'], onClick: function () {
                            dispatch({ type: ACTION_TYPES.setEmailOtpModal, value: false });
                            dispatch({ type: ACTION_TYPES.setPhoneOtpModal, value: false });
                            dispatch({ type: ACTION_TYPES.setSeconds, value: 120 });
                            dispatch({ type: ACTION_TYPES.setOtpError, value: '' });
                        } }, { children: jsx("p", { children: BACK_BUTTON }) })) }))] })));
    };
    var renderVerficationMethod = function () {
        var country = getUserCountryFromSessionStorage();
        var isEnableSMSOption = toggles.ENABLE_SMS_OPTION || false;
        var smsOptionHiddenForCountries = newDeviceOtpFlow === null || newDeviceOtpFlow === void 0 ? void 0 : newDeviceOtpFlow.smsOptionHiddenForCountries;
        var shouldShowSmsOption = isEnableSMSOption && !(smsOptionHiddenForCountries === null || smsOptionHiddenForCountries === void 0 ? void 0 : smsOptionHiddenForCountries.includes(country));
        return (jsxs("div", __assign({ id: id, className: styles['falw-verification-method-root'] }, { children: [jsx("p", __assign({ className: styles.title }, { children: OTP_MODAL_TITLE })), jsxs("div", __assign({ className: styles['verification-method-content'] }, { children: [jsx(VerificationMethodButton, { verificationMethod: user.email, verificationMethodTitle: CORREO, verificationMethodText: EMAIL_OTP_MODAL_CONTET, onClick: onEmailClickHandler }), shouldShowSmsOption && (jsxs(Fragment, { children: [jsx("hr", { className: styles['hr-style'] }), jsx(VerificationMethodButton, { verificationMethodTitle: PHONE, verificationMethodText: PHONE_OTP_MODAL_CONTET, onClick: onPhoneClickHandler })] }))] }))] })));
    };
    var renderNewDeviceOtpForm = function () {
        return (jsxs("div", __assign({ id: id, className: styles['falw-new-device-otp-form-root'] }, { children: [state.loading && (jsx("div", __assign({ className: styles['spinner-wrapper'] }, { children: jsx(Spinner, { size: 45, className: styles.spinner }) }))), jsxs("div", __assign({ className: styles['new-device-otp-form-content'] }, { children: [jsx("div", __assign({ className: styles['new-device-otp-form-icon'] }, { children: jsx(UserCrossCheck, {}) })), jsx("p", __assign({ className: styles['new-device-otp-form-title'] }, { children: CONFIRM_LOGIN })), !state.emailOtpModal && !state.phoneOtpModal && renderVerficationMethod()] }))] })));
    };
    useEffect(function () {
        if (closeModalCount === 1) {
            setShowAlert(true);
        }
        var timer = setTimeout(function () {
            setShowAlert(false);
        }, 10000);
        return function () {
            clearTimeout(timer);
        };
    }, [closeModalCount]);
    return (jsx(Fragment, { children: state.showErrorModal ? (jsx(ErrorModal, { onClick: onClick })) : (jsxs("div", __assign({ className: styles['falw-new-device-otp-form'] }, { children: [closeModalCount === 1 && showAlert && (jsx(NewDeviceOtpModalAlert, { message: ALERT_MESSAGE_TO_CONTINUE_WITHOUT_LOGIN, type: "warning" })), renderNewDeviceOtpForm(), (state.emailOtpModal || state.phoneOtpModal) && renderOtpModal()] }))) }));
};

var LoginWizard = function (props) {
    var _a, _b, _c;
    var _d = useReducer(reducer$1, initialState$1), state = _d[0], dispatch = _d[1];
    var isLoggedIn = useRef(false);
    var _e = useState(''), userEmail = _e[0], setUserEmail = _e[1];
    var _f = useState(false), isOnlyOptional = _f[0], setIsOnlyOptional = _f[1];
    var _g = useState(0), closeModalCount = _g[0], setCloseModalCount = _g[1];
    var catalystBaseUrl = props.catalystBaseUrl;
    var defaultTranslations = LABELS;
    var configTranslations = (_c = (_b = (_a = props.commerceConfig) === null || _a === void 0 ? void 0 : _a.configurations) === null || _b === void 0 ? void 0 : _b.LOGIN_TRANSLATIONS) !== null && _c !== void 0 ? _c : {};
    var translations = __assign(__assign({}, defaultTranslations), configTranslations);
    var whiteLabelValue = props.whitelabel || defaultState;
    var fetchconsent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var consentsTemplates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, consentTemplateV2({
                        userEmail: getEmailFromSessionStorage(),
                        purpose: 'Registro',
                        tenantId: tenantId(props.tenant),
                        catalystBaseUrl: catalystBaseUrl,
                    })];
                case 1:
                    consentsTemplates = _a.sent();
                    dispatch({ type: ACTION_TYPES$1.setConsents, value: consentsTemplates === null || consentsTemplates === void 0 ? void 0 : consentsTemplates.data });
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (((props === null || props === void 0 ? void 0 : props.flowType) === 'checkout' || (props === null || props === void 0 ? void 0 : props.flowType) === 'header') && (props === null || props === void 0 ? void 0 : props.show)) {
            track('login_popup');
        }
    }, [props === null || props === void 0 ? void 0 : props.flowType, props === null || props === void 0 ? void 0 : props.show]);
    var postLoginFlow = function (isNewDeviceOtpFlow) {
        if (isNewDeviceOtpFlow === void 0) { isNewDeviceOtpFlow = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _consentRequired, hasCookie, consentsTemplates, thirdPartyTemplate;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _consentRequired = false;
                        hasCookie = isOptionalConsentModalCookie();
                        return [4 /*yield*/, consentTemplateV2({
                                userEmail: getEmailFromSessionStorage(),
                                purpose: 'Registro',
                                tenantId: tenantId(props.tenant),
                                catalystBaseUrl: catalystBaseUrl,
                            })];
                    case 1:
                        consentsTemplates = _e.sent();
                        if ((_a = consentsTemplates === null || consentsTemplates === void 0 ? void 0 : consentsTemplates.consentMetadata) === null || _a === void 0 ? void 0 : _a.hasMandatory) {
                            _consentRequired = true;
                            dispatch({ type: ACTION_TYPES$1.setConsents, value: consentsTemplates.data });
                        }
                        else if (((_c = (_b = consentsTemplates === null || consentsTemplates === void 0 ? void 0 : consentsTemplates.consentMetadata) === null || _b === void 0 ? void 0 : _b.hasOptional) === null || _c === void 0 ? void 0 : _c.third_party) && !hasCookie) {
                            thirdPartyTemplate = (_d = consentsTemplates === null || consentsTemplates === void 0 ? void 0 : consentsTemplates.data) === null || _d === void 0 ? void 0 : _d.find(function (_itemOpt) {
                                return (_itemOpt === null || _itemOpt === void 0 ? void 0 : _itemOpt.templateCategoryType) === ConsentsTemplatesCategoryType.THIRD_PARTY_CONSENTS;
                            });
                            if (thirdPartyTemplate) {
                                _consentRequired = true;
                                setIsOnlyOptional(true);
                                dispatch({ type: ACTION_TYPES$1.setConsents, value: consentsTemplates.data });
                            }
                        }
                        _consentRequired
                            ? dispatch({ type: ACTION_TYPES$1.setStage, value: STAGES.consent })
                            : finalHandlerSteps(props, dispatch, isNewDeviceOtpFlow);
                        return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        var mailId = getEmailFromSessionStorage();
        setUserEmail(mailId);
        var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = props.flowType;
                        switch (_a) {
                            case 'checkout': return [3 /*break*/, 1];
                            case 'header': return [3 /*break*/, 2];
                            case 'simplePassword': return [3 /*break*/, 3];
                            case 'personalData': return [3 /*break*/, 5];
                            case 'thankyou': return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 10];
                    case 1:
                        dispatch({
                            type: ACTION_TYPES$1.setUser,
                            value: {
                                name: getUserNameFromCookie(),
                                email: mailId,
                            },
                        });
                        _b.label = 2;
                    case 2:
                        dispatch({
                            type: ACTION_TYPES$1.setStage,
                            value: STAGES.login,
                        });
                        return [3 /*break*/, 10];
                    case 3:
                        dispatch({
                            type: ACTION_TYPES$1.setUser,
                            value: {
                                name: getUserNameFromCookie(),
                                email: mailId,
                            },
                        });
                        return [4 /*yield*/, fetchconsent()];
                    case 4:
                        _b.sent();
                        dispatch({
                            type: ACTION_TYPES$1.setStage,
                            value: STAGES.simplePassword,
                        });
                        return [3 /*break*/, 10];
                    case 5: return [4 /*yield*/, fetchconsent()];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, getUser({
                                tenantId: tenantId(props.tenant),
                                catalystBaseUrl: catalystBaseUrl,
                            })];
                    case 7:
                        data = (_b.sent()).data;
                        dispatch({
                            type: ACTION_TYPES$1.setUser,
                            value: __assign(__assign({}, state.user), { originalData: data, email: data.email.emailId }),
                        });
                        dispatch({
                            type: ACTION_TYPES$1.setStage,
                            value: STAGES.personalData,
                        });
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, postLoginFlow()];
                    case 9:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        if (props === null || props === void 0 ? void 0 : props.show)
            initialize();
    }, [props === null || props === void 0 ? void 0 : props.show]);
    useEffect(function () {
        if (props.show && !state.completed) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = null;
        }
    }, [props.show, state.completed]);
    useEffect(function () {
        var setUserEmailFromStorage = function () {
            dispatch({
                type: ACTION_TYPES$1.setUser,
                value: __assign(__assign({}, state.user), { email: getEmailFromSessionStorage() }),
            });
        };
        setUserEmailFromStorage();
    }, [props.show]);
    var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track('closedeviceotpmodal');
                    return [4 /*yield*/, logout({
                            tenantId: tenantId(props.tenant),
                            catalystBaseUrl: catalystBaseUrl,
                            additionalInfo: { whiteLabelValue: whiteLabelValue },
                            otpFlow: true,
                        })];
                case 1:
                    _a.sent();
                    dispatch({ type: ACTION_TYPES$1.resetState });
                    setCloseModalCount(0);
                    props.onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (closeModalCount === 2) {
            handleLogout();
        }
    }, [closeModalCount]);
    var onLoginHandler = function (response, email, isEnableNewOtpFlow, isEmailPrefixEligibleForOtpModal) { return __awaiter(void 0, void 0, void 0, function () {
        var showNewDeviceOtpModal, _a, identityValidator, passwordRequired;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        track('login_success');
                    }
                    showNewDeviceOtpModal = !response.isDeviceRecognised &&
                        isEnableNewOtpFlow &&
                        isEmailPrefixEligibleForOtpModal &&
                        (response === null || response === void 0 ? void 0 : response.data) &&
                        !((_b = response === null || response === void 0 ? void 0 : response.errors) === null || _b === void 0 ? void 0 : _b.length);
                    if (!showNewDeviceOtpModal) return [3 /*break*/, 1];
                    dispatch({
                        type: ACTION_TYPES$1.setUser,
                        value: __assign(__assign({}, state.user), { email: email }),
                    });
                    dispatch({
                        type: ACTION_TYPES$1.setStage,
                        value: STAGES.newDeviceLogin,
                    });
                    dispatch({
                        type: ACTION_TYPES$1.setUser,
                        value: __assign(__assign({}, state.user), { email: response.data.user.email.emailId }),
                    });
                    return [3 /*break*/, 7];
                case 1:
                    if (!props.onLogin) return [3 /*break*/, 3];
                    return [4 /*yield*/, props.onLogin(response)];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    if (!response.data)
                        return [2 /*return*/];
                    isLoggedIn.current = true;
                    if (!(props.flowType === 'checkout')) return [3 /*break*/, 5];
                    _a = response.data || {}, identityValidator = _a.identityValidator, passwordRequired = _a.passwordRequired;
                    storeLoginData(identityValidator, passwordRequired);
                    return [4 /*yield*/, finalHandlerSteps(props, dispatch)];
                case 4: 
                // eslint-disable-next-line no-return-await
                return [2 /*return*/, _c.sent()];
                case 5: return [4 /*yield*/, postLoginFlow()];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onNewDeviceLoginHandler = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, identityValidator, passwordRequired;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (props.onLogin)
                        props.onLogin(response);
                    if (!response.data)
                        return [2 /*return*/];
                    isLoggedIn.current = true;
                    if (!(props.flowType === 'checkout')) return [3 /*break*/, 2];
                    _a = response.data || {}, identityValidator = _a.identityValidator, passwordRequired = _a.passwordRequired;
                    storeLoginData(identityValidator, passwordRequired);
                    return [4 /*yield*/, finalHandlerSteps(props, dispatch, true)];
                case 1: 
                // eslint-disable-next-line no-return-await
                return [2 /*return*/, _b.sent()];
                case 2: return [4 /*yield*/, postLoginFlow(true)];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onPasswordUpdateHandler = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.onPasswordUpdate) return [3 /*break*/, 2];
                    return [4 /*yield*/, props.onPasswordUpdate(response)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        sessionStorage.removeItem(LOGIN_WIZARD_DATA);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onConsentsUpdateHandler = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.onConsentsUpdate) return [3 /*break*/, 2];
                    return [4 /*yield*/, props.onConsentsUpdate(response)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, finalHandlerSteps(props, dispatch)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var openLegalText = function (template, title) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, legalTextConsent({
                        consentId: template.templateId,
                        tenantId: tenantId(props.tenant),
                        catalystBaseUrl: catalystBaseUrl,
                    })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch({
                        type: ACTION_TYPES$1.setLegalText,
                        value: {
                            html: data.legalText,
                            title: title || template.title || template.displayText,
                            from: state.stage,
                        },
                    });
                    dispatch({ type: ACTION_TYPES$1.setStage, value: STAGES.legalText });
                    return [2 /*return*/];
            }
        });
    }); };
    var goBack = function () {
        dispatch({ type: ACTION_TYPES$1.setStage, value: state.legalText.from });
    };
    var mailOtpHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window === null || window === void 0 ? void 0 : window.s) {
                        window.s.events = 'event223';
                        window.s.tl();
                    }
                    return [4 /*yield*/, getOTPByEmailURL({
                            catalystBaseUrl: catalystBaseUrl,
                            emailAddress: state.user.email,
                            tenantId: tenantId(props.tenant),
                        })];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        dispatch({ type: ACTION_TYPES$1.setOtpErrors, value: errors });
                    }
                    else {
                        track('login_otp');
                    }
                    setTimeout(function () {
                        dispatch({ type: ACTION_TYPES$1.setStage, value: STAGES.otpEmail });
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); };
    var smsOtpHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (window === null || window === void 0 ? void 0 : window.s) {
                        window.s.events = 'event224';
                        window.s.tl();
                    }
                    return [4 /*yield*/, getOTPBySMSURL({
                            catalystBaseUrl: catalystBaseUrl,
                            emailAddress: state.user.email,
                            tenantId: tenantId(props.tenant),
                        })];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        dispatch({ type: ACTION_TYPES$1.setOtpErrors, value: errors });
                    }
                    else {
                        track('login_otp');
                    }
                    dispatch({
                        type: ACTION_TYPES$1.setUser,
                        value: __assign(__assign({}, state.user), { phoneNumber: data === null || data === void 0 ? void 0 : data.phoneNumber }),
                    });
                    setTimeout(function () {
                        dispatch({ type: ACTION_TYPES$1.setStage, value: STAGES.otpSMS });
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); };
    var getOtpForm = function (otpType) {
        return (jsx(OtpForm, { otpTrigger: state.otpTrigger, showOtp: props.showOtp, otpType: otpType, user: state.user, tenant: props.tenant, catalystBaseUrl: catalystBaseUrl, onLogin: onLoginHandler, doMergeCart: props.doMergeCart, doAssociateAccount: props.doAssociateAccount, isRebrandingEnabled: props.isRebrandingEnabled, flowType: props.flowType, changeStage: function (stage) {
                dispatch({ type: ACTION_TYPES$1.setStage, value: stage });
            }, setConsents: function (consents) {
                dispatch({ type: ACTION_TYPES$1.setConsents, value: consents });
            }, appendUserData: function (data) {
                dispatch({
                    type: ACTION_TYPES$1.setUser,
                    value: __assign(__assign({}, state.user), { originalData: data }),
                });
            } }));
    };
    var getModalContent = function (stage) {
        var _a, _b, _c;
        // eslint-disable-next-line default-case
        switch (stage) {
            case STAGES.login:
                return (jsx(LoginForm, { id: props.id ? "".concat(props.id, "-login-form") : undefined, baseUrl: props.baseUrl, catalystBaseUrl: catalystBaseUrl, tenant: props.tenant, onLogin: onLoginHandler, doMergeCart: props.doMergeCart, doAssociateAccount: props.doAssociateAccount, flowType: props.flowType, showOtp: props.showOtp, mailOtpHandler: mailOtpHandler, smsOtpHandler: smsOtpHandler, email: ((_a = state.user) === null || _a === void 0 ? void 0 : _a.email) || userEmail, isRebrandingEnabled: props.isRebrandingEnabled, dispatch: dispatch, readOnly: props.readOnly, onClose: function () { return finalHandlerSteps(props, dispatch); } }));
            case STAGES.newDeviceLogin:
                return (jsx(NewDeviceOtpForm, { id: props.id ? "".concat(props.id, "-new-device-login-form") : undefined, user: state.user, catalystBaseUrl: catalystBaseUrl, doMergeCart: props.doMergeCart, doAssociateAccount: props.doAssociateAccount, tenant: props.tenant, closeModalCount: closeModalCount, onLogin: onNewDeviceLoginHandler, onClose: function () {
                        dispatch({ type: ACTION_TYPES$1.resetState });
                    }, setCloseModalCount: setCloseModalCount, handleErrorClose: function () {
                        dispatch({ type: ACTION_TYPES$1.resetState });
                        props.onClose();
                    } }));
            case STAGES.otpEmail:
                return getOtpForm('email');
            case STAGES.otpSMS:
                return getOtpForm('sms');
            case STAGES.notice:
                return (jsx(Notice, { id: props.id ? "".concat(props.id, "-notice") : undefined, onClick: function () {
                        dispatch({
                            type: ACTION_TYPES$1.setStage,
                            value: STAGES.password,
                        });
                    }, isRebrandingEnabled: props.isRebrandingEnabled }));
            case STAGES.consent: {
                track("modal-".concat(!isOnlyOptional ? 'mandatory' : 'optional', "-consent"));
                return (jsx(Consents$1, { id: props.id ? "".concat(props.id, "-consents") : undefined, onConsentClick: openLegalText, onConsentsUpdate: onConsentsUpdateHandler, consents: state.consents, tenant: props.tenant, catalystBaseUrl: catalystBaseUrl || props.baseUrl, isRebrandingEnabled: props.isRebrandingEnabled, onCloseConsents: handleCloseModalConsent, isOnlyOptional: isOnlyOptional }));
            }
            case STAGES.password:
                return (jsx(UpdatePasswordForm, { id: props.id ? "".concat(props.id, "-update-password") : undefined, onConsentClick: openLegalText, onConsentsUpdate: onConsentsUpdateHandler, onPasswordUpdate: onPasswordUpdateHandler, catalystBaseUrl: catalystBaseUrl, tenant: props.tenant, consents: state.consents, isRebrandingEnabled: props.isRebrandingEnabled }));
            case STAGES.legalText:
                return (jsx(LegalText, { id: props.id ? "".concat(props.id, "-legal-text") : undefined, html: (_b = state.legalText) === null || _b === void 0 ? void 0 : _b.html, title: (_c = state.legalText) === null || _c === void 0 ? void 0 : _c.title, onBack: goBack, isRebrandingEnabled: props.isRebrandingEnabled }));
            case STAGES.personalData:
                return (jsx(PersonalDataContainer, { id: props.id ? "".concat(props.id, "-update-password") : undefined, user: state.user, catalystBaseUrl: catalystBaseUrl, requiredFields: [''], changeStage: function (stage) {
                        dispatch({ type: ACTION_TYPES$1.setStage, value: stage });
                    }, consents: state.consents, onConsentClick: openLegalText }));
            case STAGES.simplePassword:
                return (jsx(SimpleUpdatePasswordFormWithTenantDetails, { id: props.id ? "".concat(props.id, "-simple-password") : undefined, user: state.user, onConsentClick: openLegalText, catalystBaseUrl: catalystBaseUrl, tenant: props.tenant, consents: state.consents, isRebrandingEnabled: props.isRebrandingEnabled, changeStage: function (stage) {
                        dispatch({ type: ACTION_TYPES$1.setStage, value: stage });
                    } }));
            case STAGES.feedback:
                return (jsx(SuccessFeedback, { id: props.id ? "".concat(props.id, "-feedback") : undefined, baseUrl: props.baseUrl, tenant: props.tenant, email: state.user.email, isRebrandingEnabled: props.isRebrandingEnabled, onComplete: function () { return finalHandlerSteps(props, dispatch); } }));
        }
    };
    var getModalSize = function (stage) {
        switch (stage) {
            case STAGES.notice:
            case STAGES.consent:
                // eslint-disable-next-line no-nested-ternary
                return ModalSizes.CONSENTS;
            case STAGES.otpEmail:
            case STAGES.otpSMS:
            case STAGES.simplePassword:
            case STAGES.feedback:
                return props.isRebrandingEnabled ? 520 : 600;
            case STAGES.newDeviceLogin: {
                if (typeof window === 'undefined')
                    return 400;
                var width = window.screen.width;
                return width < 768 ? '100%' : 400;
            }
            default:
                return ModalSizes.DEFAULT;
        }
    };
    var handleCloseModalConsent = function () {
        track('close-modal-optional-consent');
        setCookie(COOKIES.OPTIONAL_CONSENTS_MODAL.NAME, COOKIES.OPTIONAL_CONSENTS_MODAL.VALUE, props.tenant, COOKIES.OPTIONAL_CONSENTS_MODAL.EXPIRY);
        finalHandlerSteps(props, dispatch);
    };
    if (state.completed) {
        return null;
    }
    var shouldBeDismissable = [
        STAGES.newDeviceLogin,
        STAGES.login,
        STAGES.otpEmail,
        STAGES.otpSMS,
    ].includes(state.stage);
    var handleModalClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setCloseModalCount(function (prevValue) { return prevValue + 1; });
            return [2 /*return*/];
        });
    }); };
    var onCloseHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (![STAGES.newDeviceLogin].includes(state.stage)) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleModalClose()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    track('login_modal_close');
                    dispatch({ type: ACTION_TYPES$1.resetState });
                    props.onClose();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (jsx(TenantDetailsProvider, __assign({ tenantID: props.tenantID || props.tenantId, countryCode: props.countryCode }, { children: jsx(CommerceConfigProvider, __assign({ tenant: props.tenant, countryCode: props.countryCode, commerceConfig: props.commerceConfig }, { children: jsx(WhiteLabelContext.Provider, __assign({ value: whiteLabelValue }, { children: jsx(TranslationContext.Provider, __assign({ value: translations }, { children: jsx(Modal, __assign({ id: props.id ? "".concat(props.id, "-modal") : undefined, show: props.show, width: getModalSize(state.stage), onClose: onCloseHandler, closeButton: shouldBeDismissable, backdropClick: shouldBeDismissable, responsive: [STAGES.newDeviceLogin, STAGES.login].includes(state.stage), isRebrandingEnabled: props.isRebrandingEnabled, stage: state.stage }, { children: getModalContent(state.stage) })) })) })) })) })));
};

export { LoginWizard };
